import * as m from "react";
import uu, { createElement as Pi, createContext as Ti, useState as Au, useContext as k0, useEffect as Xu, useLayoutEffect as ki, Component as Ni } from "react";
import "react-dom";
import Iu from "moment";
import Oi from "@microlink/react";
var Rt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ne(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
function $i(u) {
  if (u.__esModule) return u;
  var e = u.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(u).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(u, n);
    Object.defineProperty(t, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return u[n];
      }
    });
  }), t;
}
var Ye = { exports: {} }, ve = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fn;
function Ri() {
  if (Fn) return ve;
  Fn = 1;
  var u = uu, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(D, o, d) {
    var x, c = {}, h = null, F = null;
    d !== void 0 && (h = "" + d), o.key !== void 0 && (h = "" + o.key), o.ref !== void 0 && (F = o.ref);
    for (x in o) n.call(o, x) && !i.hasOwnProperty(x) && (c[x] = o[x]);
    if (D && D.defaultProps) for (x in o = D.defaultProps, o) c[x] === void 0 && (c[x] = o[x]);
    return { $$typeof: e, type: D, key: h, ref: F, props: c, _owner: s.current };
  }
  return ve.Fragment = t, ve.jsx = a, ve.jsxs = a, ve;
}
var be = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dn;
function Ii() {
  return dn || (dn = 1, process.env.NODE_ENV !== "production" && function() {
    var u = uu, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), D = Symbol.for("react.context"), o = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), x = Symbol.for("react.suspense_list"), c = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), F = Symbol.for("react.offscreen"), C = Symbol.iterator, f = "@@iterator";
    function y(g) {
      if (g === null || typeof g != "object")
        return null;
      var T = C && g[C] || g[f];
      return typeof T == "function" ? T : null;
    }
    var B = u.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function l(g) {
      {
        for (var T = arguments.length, G = new Array(T > 1 ? T - 1 : 0), Q = 1; Q < T; Q++)
          G[Q - 1] = arguments[Q];
        p("error", g, G);
      }
    }
    function p(g, T, G) {
      {
        var Q = B.ReactDebugCurrentFrame, ou = Q.getStackAddendum();
        ou !== "" && (T += "%s", G = G.concat([ou]));
        var pu = G.map(function(iu) {
          return String(iu);
        });
        pu.unshift("Warning: " + T), Function.prototype.apply.call(console[g], console, pu);
      }
    }
    var E = !1, A = !1, b = !1, w = !1, P = !1, q;
    q = Symbol.for("react.module.reference");
    function z(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === n || g === i || P || g === s || g === d || g === x || w || g === F || E || A || b || typeof g == "object" && g !== null && (g.$$typeof === h || g.$$typeof === c || g.$$typeof === a || g.$$typeof === D || g.$$typeof === o || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === q || g.getModuleId !== void 0));
    }
    function k(g, T, G) {
      var Q = g.displayName;
      if (Q)
        return Q;
      var ou = T.displayName || T.name || "";
      return ou !== "" ? G + "(" + ou + ")" : G;
    }
    function I(g) {
      return g.displayName || "Context";
    }
    function O(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && l("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case d:
          return "Suspense";
        case x:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case D:
            var T = g;
            return I(T) + ".Consumer";
          case a:
            var G = g;
            return I(G._context) + ".Provider";
          case o:
            return k(g, g.render, "ForwardRef");
          case c:
            var Q = g.displayName || null;
            return Q !== null ? Q : O(g.type) || "Memo";
          case h: {
            var ou = g, pu = ou._payload, iu = ou._init;
            try {
              return O(iu(pu));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var j = Object.assign, M = 0, J, su, nu, N, v, S, R;
    function V() {
    }
    V.__reactDisabledLog = !0;
    function U() {
      {
        if (M === 0) {
          J = console.log, su = console.info, nu = console.warn, N = console.error, v = console.group, S = console.groupCollapsed, R = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: V,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        M++;
      }
    }
    function Z() {
      {
        if (M--, M === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: j({}, g, {
              value: J
            }),
            info: j({}, g, {
              value: su
            }),
            warn: j({}, g, {
              value: nu
            }),
            error: j({}, g, {
              value: N
            }),
            group: j({}, g, {
              value: v
            }),
            groupCollapsed: j({}, g, {
              value: S
            }),
            groupEnd: j({}, g, {
              value: R
            })
          });
        }
        M < 0 && l("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Y = B.ReactCurrentDispatcher, K;
    function X(g, T, G) {
      {
        if (K === void 0)
          try {
            throw Error();
          } catch (ou) {
            var Q = ou.stack.trim().match(/\n( *(at )?)/);
            K = Q && Q[1] || "";
          }
        return `
` + K + g;
      }
    }
    var L = !1, W;
    {
      var tu = typeof WeakMap == "function" ? WeakMap : Map;
      W = new tu();
    }
    function $(g, T) {
      if (!g || L)
        return "";
      {
        var G = W.get(g);
        if (G !== void 0)
          return G;
      }
      var Q;
      L = !0;
      var ou = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var pu;
      pu = Y.current, Y.current = null, U();
      try {
        if (T) {
          var iu = function() {
            throw Error();
          };
          if (Object.defineProperty(iu.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(iu, []);
            } catch (ju) {
              Q = ju;
            }
            Reflect.construct(g, [], iu);
          } else {
            try {
              iu.call();
            } catch (ju) {
              Q = ju;
            }
            g.call(iu.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ju) {
            Q = ju;
          }
          g();
        }
      } catch (ju) {
        if (ju && Q && typeof ju.stack == "string") {
          for (var ru = ju.stack.split(`
`), bu = Q.stack.split(`
`), hu = ru.length - 1, mu = bu.length - 1; hu >= 1 && mu >= 0 && ru[hu] !== bu[mu]; )
            mu--;
          for (; hu >= 1 && mu >= 0; hu--, mu--)
            if (ru[hu] !== bu[mu]) {
              if (hu !== 1 || mu !== 1)
                do
                  if (hu--, mu--, mu < 0 || ru[hu] !== bu[mu]) {
                    var _u = `
` + ru[hu].replace(" at new ", " at ");
                    return g.displayName && _u.includes("<anonymous>") && (_u = _u.replace("<anonymous>", g.displayName)), typeof g == "function" && W.set(g, _u), _u;
                  }
                while (hu >= 1 && mu >= 0);
              break;
            }
        }
      } finally {
        L = !1, Y.current = pu, Z(), Error.prepareStackTrace = ou;
      }
      var De = g ? g.displayName || g.name : "", Gu = De ? X(De) : "";
      return typeof g == "function" && W.set(g, Gu), Gu;
    }
    function du(g, T, G) {
      return $(g, !1);
    }
    function xu(g) {
      var T = g.prototype;
      return !!(T && T.isReactComponent);
    }
    function Fu(g, T, G) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return $(g, xu(g));
      if (typeof g == "string")
        return X(g);
      switch (g) {
        case d:
          return X("Suspense");
        case x:
          return X("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case o:
            return du(g.render);
          case c:
            return Fu(g.type, T, G);
          case h: {
            var Q = g, ou = Q._payload, pu = Q._init;
            try {
              return Fu(pu(ou), T, G);
            } catch {
            }
          }
        }
      return "";
    }
    var zu = Object.prototype.hasOwnProperty, Ue = {}, Be = B.ReactDebugCurrentFrame;
    function ae(g) {
      if (g) {
        var T = g._owner, G = Fu(g.type, g._source, T ? T.type : null);
        Be.setExtraStackFrame(G);
      } else
        Be.setExtraStackFrame(null);
    }
    function He(g, T, G, Q, ou) {
      {
        var pu = Function.call.bind(zu);
        for (var iu in g)
          if (pu(g, iu)) {
            var ru = void 0;
            try {
              if (typeof g[iu] != "function") {
                var bu = Error((Q || "React class") + ": " + G + " type `" + iu + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[iu] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw bu.name = "Invariant Violation", bu;
              }
              ru = g[iu](T, iu, Q, G, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (hu) {
              ru = hu;
            }
            ru && !(ru instanceof Error) && (ae(ou), l("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Q || "React class", G, iu, typeof ru), ae(null)), ru instanceof Error && !(ru.message in Ue) && (Ue[ru.message] = !0, ae(ou), l("Failed %s type: %s", G, ru.message), ae(null));
          }
      }
    }
    var St = Array.isArray;
    function xe(g) {
      return St(g);
    }
    function Ve(g) {
      {
        var T = typeof Symbol == "function" && Symbol.toStringTag, G = T && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return G;
      }
    }
    function Pt(g) {
      try {
        return We(g), !1;
      } catch {
        return !0;
      }
    }
    function We(g) {
      return "" + g;
    }
    function qe(g) {
      if (Pt(g))
        return l("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ve(g)), We(g);
    }
    var Ge = B.ReactCurrentOwner, Wu = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, qu, ye;
    function Uu(g) {
      if (zu.call(g, "ref")) {
        var T = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (T && T.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function Tt(g) {
      if (zu.call(g, "key")) {
        var T = Object.getOwnPropertyDescriptor(g, "key").get;
        if (T && T.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function Ci(g, T) {
      typeof g.ref == "string" && Ge.current;
    }
    function fi(g, T) {
      {
        var G = function() {
          qu || (qu = !0, l("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
        };
        G.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: G,
          configurable: !0
        });
      }
    }
    function Ai(g, T) {
      {
        var G = function() {
          ye || (ye = !0, l("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
        };
        G.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: G,
          configurable: !0
        });
      }
    }
    var hi = function(g, T, G, Q, ou, pu, iu) {
      var ru = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: g,
        key: T,
        ref: G,
        props: iu,
        // Record the component responsible for creating this element.
        _owner: pu
      };
      return ru._store = {}, Object.defineProperty(ru._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ru, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Q
      }), Object.defineProperty(ru, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ou
      }), Object.freeze && (Object.freeze(ru.props), Object.freeze(ru)), ru;
    };
    function mi(g, T, G, Q, ou) {
      {
        var pu, iu = {}, ru = null, bu = null;
        G !== void 0 && (qe(G), ru = "" + G), Tt(T) && (qe(T.key), ru = "" + T.key), Uu(T) && (bu = T.ref, Ci(T, ou));
        for (pu in T)
          zu.call(T, pu) && !Wu.hasOwnProperty(pu) && (iu[pu] = T[pu]);
        if (g && g.defaultProps) {
          var hu = g.defaultProps;
          for (pu in hu)
            iu[pu] === void 0 && (iu[pu] = hu[pu]);
        }
        if (ru || bu) {
          var mu = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          ru && fi(iu, mu), bu && Ai(iu, mu);
        }
        return hi(g, ru, bu, ou, Q, Ge.current, iu);
      }
    }
    var kt = B.ReactCurrentOwner, nn = B.ReactDebugCurrentFrame;
    function oe(g) {
      if (g) {
        var T = g._owner, G = Fu(g.type, g._source, T ? T.type : null);
        nn.setExtraStackFrame(G);
      } else
        nn.setExtraStackFrame(null);
    }
    var Nt;
    Nt = !1;
    function Ot(g) {
      return typeof g == "object" && g !== null && g.$$typeof === e;
    }
    function sn() {
      {
        if (kt.current) {
          var g = O(kt.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function gi(g) {
      return "";
    }
    var an = {};
    function Bi(g) {
      {
        var T = sn();
        if (!T) {
          var G = typeof g == "string" ? g : g.displayName || g.name;
          G && (T = `

Check the top-level render call using <` + G + ">.");
        }
        return T;
      }
    }
    function on(g, T) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var G = Bi(T);
        if (an[G])
          return;
        an[G] = !0;
        var Q = "";
        g && g._owner && g._owner !== kt.current && (Q = " It was passed a child from " + O(g._owner.type) + "."), oe(g), l('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', G, Q), oe(null);
      }
    }
    function Dn(g, T) {
      {
        if (typeof g != "object")
          return;
        if (xe(g))
          for (var G = 0; G < g.length; G++) {
            var Q = g[G];
            Ot(Q) && on(Q, T);
          }
        else if (Ot(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var ou = y(g);
          if (typeof ou == "function" && ou !== g.entries)
            for (var pu = ou.call(g), iu; !(iu = pu.next()).done; )
              Ot(iu.value) && on(iu.value, T);
        }
      }
    }
    function xi(g) {
      {
        var T = g.type;
        if (T == null || typeof T == "string")
          return;
        var G;
        if (typeof T == "function")
          G = T.propTypes;
        else if (typeof T == "object" && (T.$$typeof === o || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        T.$$typeof === c))
          G = T.propTypes;
        else
          return;
        if (G) {
          var Q = O(T);
          He(G, g.props, "prop", Q, g);
        } else if (T.PropTypes !== void 0 && !Nt) {
          Nt = !0;
          var ou = O(T);
          l("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ou || "Unknown");
        }
        typeof T.getDefaultProps == "function" && !T.getDefaultProps.isReactClassApproved && l("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function yi(g) {
      {
        for (var T = Object.keys(g.props), G = 0; G < T.length; G++) {
          var Q = T[G];
          if (Q !== "children" && Q !== "key") {
            oe(g), l("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Q), oe(null);
            break;
          }
        }
        g.ref !== null && (oe(g), l("Invalid attribute `ref` supplied to `React.Fragment`."), oe(null));
      }
    }
    var ln = {};
    function cn(g, T, G, Q, ou, pu) {
      {
        var iu = z(g);
        if (!iu) {
          var ru = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (ru += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var bu = gi();
          bu ? ru += bu : ru += sn();
          var hu;
          g === null ? hu = "null" : xe(g) ? hu = "array" : g !== void 0 && g.$$typeof === e ? (hu = "<" + (O(g.type) || "Unknown") + " />", ru = " Did you accidentally export a JSX literal instead of a component?") : hu = typeof g, l("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", hu, ru);
        }
        var mu = mi(g, T, G, ou, pu);
        if (mu == null)
          return mu;
        if (iu) {
          var _u = T.children;
          if (_u !== void 0)
            if (Q)
              if (xe(_u)) {
                for (var De = 0; De < _u.length; De++)
                  Dn(_u[De], g);
                Object.freeze && Object.freeze(_u);
              } else
                l("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Dn(_u, g);
        }
        if (zu.call(T, "key")) {
          var Gu = O(g), ju = Object.keys(T).filter(function(Si) {
            return Si !== "key";
          }), $t = ju.length > 0 ? "{key: someKey, " + ju.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ln[Gu + $t]) {
            var _i = ju.length > 0 ? "{" + ju.join(": ..., ") + ": ...}" : "{}";
            l(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, $t, Gu, _i, Gu), ln[Gu + $t] = !0;
          }
        }
        return g === n ? yi(mu) : xi(mu), mu;
      }
    }
    function vi(g, T, G) {
      return cn(g, T, G, !0);
    }
    function bi(g, T, G) {
      return cn(g, T, G, !1);
    }
    var wi = bi, ji = vi;
    be.Fragment = n, be.jsx = wi, be.jsxs = ji;
  }()), be;
}
var pn;
function Ur() {
  return pn || (pn = 1, process.env.NODE_ENV === "production" ? Ye.exports = Ri() : Ye.exports = Ii()), Ye.exports;
}
var r = Ur();
function Li(u) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return e[t] === void 0 && (e[t] = u(t)), e[t];
  };
}
var Mi = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, zi = /* @__PURE__ */ Li(
  function(u) {
    return Mi.test(u) || u.charCodeAt(0) === 111 && u.charCodeAt(1) === 110 && u.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Cu = "-ms-", Ne = "-moz-", au = "-webkit-", N0 = "comm", gt = "rule", Hr = "decl", Ui = "@import", Hi = "@namespace", O0 = "@keyframes", Vi = "@layer", $0 = Math.abs, Vr = String.fromCharCode, br = Object.assign;
function Wi(u, e) {
  return Bu(u, 0) ^ 45 ? (((e << 2 ^ Bu(u, 0)) << 2 ^ Bu(u, 1)) << 2 ^ Bu(u, 2)) << 2 ^ Bu(u, 3) : 0;
}
function R0(u) {
  return u.trim();
}
function Lu(u, e) {
  return (u = e.exec(u)) ? u[0] : u;
}
function eu(u, e, t) {
  return u.replace(e, t);
}
function it(u, e, t) {
  return u.indexOf(e, t);
}
function Bu(u, e) {
  return u.charCodeAt(e) | 0;
}
function Qu(u, e, t) {
  return u.slice(e, t);
}
function Pu(u) {
  return u.length;
}
function I0(u) {
  return u.length;
}
function Se(u, e) {
  return e.push(u), u;
}
function qi(u, e) {
  return u.map(e).join("");
}
function En(u, e) {
  return u.filter(function(t) {
    return !Lu(t, e);
  });
}
var Bt = 1, Ee = 1, L0 = 0, Su = 0, gu = 0, me = "";
function xt(u, e, t, n, s, i, a, D) {
  return { value: u, root: e, parent: t, type: n, props: s, children: i, line: Bt, column: Ee, length: a, return: "", siblings: D };
}
function Hu(u, e) {
  return br(xt("", null, null, "", null, null, 0, u.siblings), u, { length: -u.length }, e);
}
function le(u) {
  for (; u.root; )
    u = Hu(u.root, { children: [u] });
  Se(u, u.siblings);
}
function Gi() {
  return gu;
}
function Yi() {
  return gu = Su > 0 ? Bu(me, --Su) : 0, Ee--, gu === 10 && (Ee = 1, Bt--), gu;
}
function Tu() {
  return gu = Su < L0 ? Bu(me, Su++) : 0, Ee++, gu === 10 && (Ee = 1, Bt++), gu;
}
function Vu() {
  return Bu(me, Su);
}
function at() {
  return Su;
}
function yt(u, e) {
  return Qu(me, u, e);
}
function $e(u) {
  switch (u) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Zi(u) {
  return Bt = Ee = 1, L0 = Pu(me = u), Su = 0, [];
}
function Ki(u) {
  return me = "", u;
}
function It(u) {
  return R0(yt(Su - 1, wr(u === 91 ? u + 2 : u === 40 ? u + 1 : u)));
}
function Ji(u) {
  for (; (gu = Vu()) && gu < 33; )
    Tu();
  return $e(u) > 2 || $e(gu) > 3 ? "" : " ";
}
function Xi(u, e) {
  for (; --e && Tu() && !(gu < 48 || gu > 102 || gu > 57 && gu < 65 || gu > 70 && gu < 97); )
    ;
  return yt(u, at() + (e < 6 && Vu() == 32 && Tu() == 32));
}
function wr(u) {
  for (; Tu(); )
    switch (gu) {
      // ] ) " '
      case u:
        return Su;
      // " '
      case 34:
      case 39:
        u !== 34 && u !== 39 && wr(gu);
        break;
      // (
      case 40:
        u === 41 && wr(u);
        break;
      // \
      case 92:
        Tu();
        break;
    }
  return Su;
}
function Qi(u, e) {
  for (; Tu() && u + gu !== 57; )
    if (u + gu === 84 && Vu() === 47)
      break;
  return "/*" + yt(e, Su - 1) + "*" + Vr(u === 47 ? u : Tu());
}
function ua(u) {
  for (; !$e(Vu()); )
    Tu();
  return yt(u, Su);
}
function ea(u) {
  return Ki(ot("", null, null, null, [""], u = Zi(u), 0, [0], u));
}
function ot(u, e, t, n, s, i, a, D, o) {
  for (var d = 0, x = 0, c = a, h = 0, F = 0, C = 0, f = 1, y = 1, B = 1, l = 0, p = "", E = s, A = i, b = n, w = p; y; )
    switch (C = l, l = Tu()) {
      // (
      case 40:
        if (C != 108 && Bu(w, c - 1) == 58) {
          it(w += eu(It(l), "&", "&\f"), "&\f", $0(d ? D[d - 1] : 0)) != -1 && (B = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        w += It(l);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        w += Ji(C);
        break;
      // \
      case 92:
        w += Xi(at() - 1, 7);
        continue;
      // /
      case 47:
        switch (Vu()) {
          case 42:
          case 47:
            Se(ta(Qi(Tu(), at()), e, t, o), o), ($e(C || 1) == 5 || $e(Vu() || 1) == 5) && Pu(w) && Qu(w, -1, void 0) !== " " && (w += " ");
            break;
          default:
            w += "/";
        }
        break;
      // {
      case 123 * f:
        D[d++] = Pu(w) * B;
      // } ; \0
      case 125 * f:
      case 59:
      case 0:
        switch (l) {
          // \0 }
          case 0:
          case 125:
            y = 0;
          // ;
          case 59 + x:
            B == -1 && (w = eu(w, /\f/g, "")), F > 0 && (Pu(w) - c || f === 0 && C === 47) && Se(F > 32 ? fn(w + ";", n, t, c - 1, o) : fn(eu(w, " ", "") + ";", n, t, c - 2, o), o);
            break;
          // @ ;
          case 59:
            w += ";";
          // { rule/at-rule
          default:
            if (Se(b = Cn(w, e, t, d, x, s, D, p, E = [], A = [], c, i), i), l === 123)
              if (x === 0)
                ot(w, e, b, b, E, i, c, D, A);
              else {
                switch (h) {
                  // c(ontainer)
                  case 99:
                    if (Bu(w, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (Bu(w, 2) === 97) break;
                  default:
                    x = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                x ? ot(u, b, b, n && Se(Cn(u, b, b, 0, 0, s, D, p, s, E = [], c, A), A), s, A, c, D, n ? E : A) : ot(w, b, b, b, [""], A, 0, D, A);
              }
        }
        d = x = F = 0, f = B = 1, p = w = "", c = a;
        break;
      // :
      case 58:
        c = 1 + Pu(w), F = C;
      default:
        if (f < 1) {
          if (l == 123)
            --f;
          else if (l == 125 && f++ == 0 && Yi() == 125)
            continue;
        }
        switch (w += Vr(l), l * f) {
          // &
          case 38:
            B = x > 0 ? 1 : (w += "\f", -1);
            break;
          // ,
          case 44:
            D[d++] = (Pu(w) - 1) * B, B = 1;
            break;
          // @
          case 64:
            Vu() === 45 && (w += It(Tu())), h = Vu(), x = c = Pu(p = w += ua(at())), l++;
            break;
          // -
          case 45:
            C === 45 && Pu(w) == 2 && (f = 0);
        }
    }
  return i;
}
function Cn(u, e, t, n, s, i, a, D, o, d, x, c) {
  for (var h = s - 1, F = s === 0 ? i : [""], C = I0(F), f = 0, y = 0, B = 0; f < n; ++f)
    for (var l = 0, p = Qu(u, h + 1, h = $0(y = a[f])), E = u; l < C; ++l)
      (E = R0(y > 0 ? F[l] + " " + p : eu(p, /&\f/g, F[l]))) && (o[B++] = E);
  return xt(u, e, t, s === 0 ? gt : D, o, d, x, c);
}
function ta(u, e, t, n) {
  return xt(u, e, t, N0, Vr(Gi()), Qu(u, 2, -2), 0, n);
}
function fn(u, e, t, n, s) {
  return xt(u, e, t, Hr, Qu(u, 0, n), Qu(u, n + 1, -1), n, s);
}
function M0(u, e, t) {
  switch (Wi(u, e)) {
    // color-adjust
    case 5103:
      return au + "print-" + u + u;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
      return au + u + u;
    // mask-composite
    case 4855:
      return au + u.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + u;
    // tab-size
    case 4789:
      return Ne + u + u;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return au + u + Ne + u + Cu + u + u;
    // writing-mode
    case 5936:
      switch (Bu(u, e + 11)) {
        // vertical-l(r)
        case 114:
          return au + u + Cu + eu(u, /[svh]\w+-[tblr]{2}/, "tb") + u;
        // vertical-r(l)
        case 108:
          return au + u + Cu + eu(u, /[svh]\w+-[tblr]{2}/, "tb-rl") + u;
        // horizontal(-)tb
        case 45:
          return au + u + Cu + eu(u, /[svh]\w+-[tblr]{2}/, "lr") + u;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return au + u + Cu + u + u;
    // order
    case 6165:
      return au + u + Cu + "flex-" + u + u;
    // align-items
    case 5187:
      return au + u + eu(u, /(\w+).+(:[^]+)/, au + "box-$1$2" + Cu + "flex-$1$2") + u;
    // align-self
    case 5443:
      return au + u + Cu + "flex-item-" + eu(u, /flex-|-self/g, "") + (Lu(u, /flex-|baseline/) ? "" : Cu + "grid-row-" + eu(u, /flex-|-self/g, "")) + u;
    // align-content
    case 4675:
      return au + u + Cu + "flex-line-pack" + eu(u, /align-content|flex-|-self/g, "") + u;
    // flex-shrink
    case 5548:
      return au + u + Cu + eu(u, "shrink", "negative") + u;
    // flex-basis
    case 5292:
      return au + u + Cu + eu(u, "basis", "preferred-size") + u;
    // flex-grow
    case 6060:
      return au + "box-" + eu(u, "-grow", "") + au + u + Cu + eu(u, "grow", "positive") + u;
    // transition
    case 4554:
      return au + eu(u, /([^-])(transform)/g, "$1" + au + "$2") + u;
    // cursor
    case 6187:
      return eu(eu(eu(u, /(zoom-|grab)/, au + "$1"), /(image-set)/, au + "$1"), u, "") + u;
    // background, background-image
    case 5495:
    case 3959:
      return eu(u, /(image-set\([^]*)/, au + "$1$`$1");
    // justify-content
    case 4968:
      return eu(eu(u, /(.+:)(flex-)?(.*)/, au + "box-pack:$3" + Cu + "flex-pack:$3"), /space-between/, "justify") + au + u + u;
    // justify-self
    case 4200:
      if (!Lu(u, /flex-|baseline/)) return Cu + "grid-column-align" + Qu(u, e) + u;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return Cu + eu(u, "template-", "") + u;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return t && t.some(function(n, s) {
        return e = s, Lu(n.props, /grid-\w+-end/);
      }) ? ~it(u + (t = t[e].value), "span", 0) ? u : Cu + eu(u, "-start", "") + u + Cu + "grid-row-span:" + (~it(t, "span", 0) ? Lu(t, /\d+/) : +Lu(t, /\d+/) - +Lu(u, /\d+/)) + ";" : Cu + eu(u, "-start", "") + u;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return t && t.some(function(n) {
        return Lu(n.props, /grid-\w+-start/);
      }) ? u : Cu + eu(eu(u, "-end", "-span"), "span ", "") + u;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return eu(u, /(.+)-inline(.+)/, au + "$1$2") + u;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Pu(u) - 1 - e > 6)
        switch (Bu(u, e + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (Bu(u, e + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return eu(u, /(.+:)(.+)-([^]+)/, "$1" + au + "$2-$3$1" + Ne + (Bu(u, e + 3) == 108 ? "$3" : "$2-$3")) + u;
          // (s)tretch
          case 115:
            return ~it(u, "stretch", 0) ? M0(eu(u, "stretch", "fill-available"), e, t) + u : u;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return eu(u, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(n, s, i, a, D, o, d) {
        return Cu + s + ":" + i + d + (a ? Cu + s + "-span:" + (D ? o : +o - +i) + d : "") + u;
      });
    // position: sticky
    case 4949:
      if (Bu(u, e + 6) === 121)
        return eu(u, ":", ":" + au) + u;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (Bu(u, Bu(u, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return eu(u, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + au + (Bu(u, 14) === 45 ? "inline-" : "") + "box$3$1" + au + "$2$3$1" + Cu + "$2box$3") + u;
        // (inline-)?gri(d)
        case 100:
          return eu(u, ":", ":" + Cu) + u;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return eu(u, "scroll-", "scroll-snap-") + u;
  }
  return u;
}
function dt(u, e) {
  for (var t = "", n = 0; n < u.length; n++)
    t += e(u[n], n, u, e) || "";
  return t;
}
function ra(u, e, t, n) {
  switch (u.type) {
    case Vi:
      if (u.children.length) break;
    case Ui:
    case Hi:
    case Hr:
      return u.return = u.return || u.value;
    case N0:
      return "";
    case O0:
      return u.return = u.value + "{" + dt(u.children, n) + "}";
    case gt:
      if (!Pu(u.value = u.props.join(","))) return "";
  }
  return Pu(t = dt(u.children, n)) ? u.return = u.value + "{" + t + "}" : "";
}
function na(u) {
  var e = I0(u);
  return function(t, n, s, i) {
    for (var a = "", D = 0; D < e; D++)
      a += u[D](t, n, s, i) || "";
    return a;
  };
}
function sa(u) {
  return function(e) {
    e.root || (e = e.return) && u(e);
  };
}
function ia(u, e, t, n) {
  if (u.length > -1 && !u.return)
    switch (u.type) {
      case Hr:
        u.return = M0(u.value, u.length, t);
        return;
      case O0:
        return dt([Hu(u, { value: eu(u.value, "@", "@" + au) })], n);
      case gt:
        if (u.length)
          return qi(t = u.props, function(s) {
            switch (Lu(s, n = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                le(Hu(u, { props: [eu(s, /:(read-\w+)/, ":" + Ne + "$1")] })), le(Hu(u, { props: [s] })), br(u, { props: En(t, n) });
                break;
              // :placeholder
              case "::placeholder":
                le(Hu(u, { props: [eu(s, /:(plac\w+)/, ":" + au + "input-$1")] })), le(Hu(u, { props: [eu(s, /:(plac\w+)/, ":" + Ne + "$1")] })), le(Hu(u, { props: [eu(s, /:(plac\w+)/, Cu + "input-$1")] })), le(Hu(u, { props: [s] })), br(u, { props: En(t, n) });
                break;
            }
            return "";
          });
    }
}
var Lt, Mt;
const ue = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", z0 = "active", U0 = "data-styled-version", vt = "6.4.1", Wr = `/*!sc*/
`, Oe = typeof window < "u" && typeof document < "u";
function An(u) {
  if (typeof process < "u" && process.env !== void 0) {
    const e = process.env[u];
    if (e !== void 0 && e !== "") return e !== "false";
  }
}
const aa = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : (Mt = (Lt = An("REACT_APP_SC_DISABLE_SPEEDY")) !== null && Lt !== void 0 ? Lt : An("SC_DISABLE_SPEEDY")) !== null && Mt !== void 0 ? Mt : typeof process > "u" || process.env === void 0 || process.env.NODE_ENV !== "production"), oa = "sc-keyframes-", Da = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?

`, 18: `Accessing \`useTheme\` hook outside of a \`<ThemeProvider>\` element.

\`\`\`jsx
import { useTheme } from 'styled-components';
export function StyledCompoent({ children }) {
  const theme = useTheme();
  return <div style={{ width: theme.sizes.full }}>{children}</div>;
}

import { StyledComponent } from './StyledComponent';
import { theme } from './theme';
export function App() {
  return (
    <ThemeProvider theme={theme}>
      <StyledComponent />
    </ThemeProvider>
  );
}
\`\`\`

If you need access to the theme in an uncertain composition scenario, \`React.useContext(ThemeContext)\` will not emit an error if there is no \`ThemeProvider\` ancestor.
` } : {};
function Le(u, ...e) {
  return process.env.NODE_ENV === "production" ? new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${u} for more information.${e.length > 0 ? ` Args: ${e.join(", ")}` : ""}`) : new Error(function(...t) {
    let n = t[0];
    const s = [];
    for (let i = 1, a = t.length; i < a; i += 1) s.push(t[i]);
    return s.forEach((i) => {
      n = n.replace(/%[a-z]/, i);
    }), n;
  }(Da[u], ...e).trim());
}
const la = 1 << 30;
let Dt = /* @__PURE__ */ new Map(), pt = /* @__PURE__ */ new Map(), lt = 1;
const Ze = (u) => {
  if (Dt.has(u)) return Dt.get(u);
  for (; pt.has(lt); ) lt++;
  const e = lt++;
  if (process.env.NODE_ENV !== "production" && ((0 | e) < 0 || e > la)) throw Le(16, `${e}`);
  return Dt.set(u, e), pt.set(e, u), e;
}, ca = (u) => pt.get(u), Fa = (u, e) => {
  lt = e + 1, Dt.set(u, e), pt.set(e, u);
}, hn = /invalid hook call/i, Ke = /* @__PURE__ */ new Set(), da = (u, e) => {
  if (process.env.NODE_ENV !== "production") {
    const t = `The component ${u}${e ? ` with the id of "${e}"` : ""} has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.
See https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.
`, n = console.error;
    try {
      let s = !0;
      console.error = (i, ...a) => {
        hn.test(i) ? (s = !1, Ke.delete(t)) : n(i, ...a);
      }, typeof uu.useState == "function" && uu.useState(null), s && !Ke.has(t) && (console.warn(t), Ke.add(t));
    } catch (s) {
      hn.test(s.message) && Ke.delete(t);
    } finally {
      console.error = n;
    }
  }
}, qr = Object.freeze([]), Ce = Object.freeze({});
function pa(u, e, t = Ce) {
  return u.theme !== t.theme && u.theme || e || t.theme;
}
const Ea = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, Ca = /(^-|-$)/g;
function H0(u) {
  return u.replace(Ea, "-").replace(Ca, "");
}
const fa = /(a)(d)/gi, mn = (u) => String.fromCharCode(u + (u > 25 ? 39 : 97));
function V0(u) {
  let e, t = "";
  for (e = Math.abs(u); e > 52; e = e / 52 | 0) t = mn(e % 52) + t;
  return (mn(e % 52) + t).replace(fa, "$1-$2");
}
const jr = 5381, Ku = (u, e) => {
  let t = e.length;
  for (; t; ) u = 33 * u ^ e.charCodeAt(--t);
  return u;
}, W0 = (u) => Ku(jr, u);
function Aa(u) {
  return V0(W0(u) >>> 0);
}
function Gr(u) {
  return process.env.NODE_ENV !== "production" && typeof u == "string" && u || u.displayName || u.name || "Component";
}
function ct(u) {
  return typeof u == "string" && (process.env.NODE_ENV === "production" || u.charAt(0) === u.charAt(0).toLowerCase());
}
function ha(u) {
  return ct(u) ? `styled.${u}` : `Styled(${Gr(u)})`;
}
const q0 = Symbol.for("react.memo"), ma = Symbol.for("react.forward_ref"), ga = { contextType: !0, defaultProps: !0, displayName: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, propTypes: !0, type: !0 }, Ba = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, G0 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, xa = { [ma]: { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, [q0]: G0 };
function gn(u) {
  return ("type" in (e = u) && e.type.$$typeof) === q0 ? G0 : "$$typeof" in u ? xa[u.$$typeof] : ga;
  var e;
}
const ya = Object.defineProperty, va = Object.getOwnPropertyNames, ba = Object.getOwnPropertySymbols, wa = Object.getOwnPropertyDescriptor, ja = Object.getPrototypeOf, _a = Object.prototype;
function Y0(u, e, t) {
  if (typeof e != "string") {
    const n = ja(e);
    n && n !== _a && Y0(u, n, t);
    const s = va(e).concat(ba(e)), i = gn(u), a = gn(e);
    for (let D = 0; D < s.length; ++D) {
      const o = s[D];
      if (!(o in Ba || t && t[o] || a && o in a || i && o in i)) {
        const d = wa(e, o);
        try {
          ya(u, o, d);
        } catch {
        }
      }
    }
  }
  return u;
}
function bt(u) {
  return typeof u == "function";
}
function Z0(u) {
  return typeof u == "object" && "styledComponentId" in u;
}
function Pe(u, e) {
  return u && e ? u + " " + e : u || e || "";
}
function Bn(u, e) {
  return u.join("");
}
function ee(u) {
  return u !== null && typeof u == "object" && u.constructor.name === Object.name && !("props" in u && u.$$typeof);
}
function _r(u, e, t = !1) {
  if (!t && !ee(u) && !Array.isArray(u)) return e;
  if (Array.isArray(e)) for (let n = 0; n < e.length; n++) u[n] = _r(u[n], e[n]);
  else if (ee(e)) for (const n in e) u[n] = _r(u[n], e[n]);
  return u;
}
function K0(u, e) {
  Object.defineProperty(u, "toString", { value: e });
}
const Sa = class {
  constructor(u) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = u, this._cGroup = 0, this._cIndex = 0;
  }
  indexOfGroup(u) {
    if (u === this._cGroup) return this._cIndex;
    let e = this._cIndex;
    if (u > this._cGroup) for (let t = this._cGroup; t < u; t++) e += this.groupSizes[t];
    else for (let t = this._cGroup - 1; t >= u; t--) e -= this.groupSizes[t];
    return this._cGroup = u, this._cIndex = e, e;
  }
  insertRules(u, e) {
    if (u >= this.groupSizes.length) {
      const s = this.groupSizes, i = s.length;
      let a = i;
      for (; u >= a; ) if (a <<= 1, a < 0) throw Le(16, `${u}`);
      this.groupSizes = new Uint32Array(a), this.groupSizes.set(s), this.length = a;
      for (let D = i; D < a; D++) this.groupSizes[D] = 0;
    }
    let t = this.indexOfGroup(u + 1), n = 0;
    for (let s = 0, i = e.length; s < i; s++) this.tag.insertRule(t, e[s]) && (this.groupSizes[u]++, t++, n++);
    n > 0 && this._cGroup > u && (this._cIndex += n);
  }
  clearGroup(u) {
    if (u < this.length) {
      const e = this.groupSizes[u], t = this.indexOfGroup(u), n = t + e;
      this.groupSizes[u] = 0;
      for (let s = t; s < n; s++) this.tag.deleteRule(t);
      e > 0 && this._cGroup > u && (this._cIndex -= e);
    }
  }
  getGroup(u) {
    let e = "";
    if (u >= this.length || this.groupSizes[u] === 0) return e;
    const t = this.groupSizes[u], n = this.indexOfGroup(u), s = n + t;
    for (let i = n; i < s; i++) e += this.tag.getRule(i) + Wr;
    return e;
  }
}, Pa = `style[${ue}][${U0}="${vt}"]`, Ta = new RegExp(`^${ue}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`), xn = (u) => typeof ShadowRoot < "u" && u instanceof ShadowRoot || "host" in u && u.nodeType === 11, Sr = (u) => {
  if (!u) return document;
  if (xn(u)) return u;
  if ("getRootNode" in u) {
    const e = u.getRootNode();
    if (xn(e)) return e;
  }
  return document;
}, ka = (u, e, t) => {
  const n = t.split(",");
  let s;
  for (let i = 0, a = n.length; i < a; i++) (s = n[i]) && u.registerName(e, s);
}, Na = (u, e) => {
  var t;
  const n = ((t = e.textContent) !== null && t !== void 0 ? t : "").split(Wr), s = [];
  for (let i = 0, a = n.length; i < a; i++) {
    const D = n[i].trim();
    if (!D) continue;
    const o = D.match(Ta);
    if (o) {
      const d = 0 | parseInt(o[1], 10), x = o[2];
      d !== 0 && (Fa(x, d), ka(u, x, o[3]), u.getTag().insertRules(d, s)), s.length = 0;
    } else s.push(D);
  }
}, zt = (u) => {
  const e = Sr(u.options.target).querySelectorAll(Pa);
  for (let t = 0, n = e.length; t < n; t++) {
    const s = e[t];
    s && s.getAttribute(ue) !== z0 && (Na(u, s), s.parentNode && s.parentNode.removeChild(s));
  }
};
let we = !1;
function Oa() {
  if (we !== !1) return we;
  if (typeof document < "u") {
    const u = document.head.querySelector('meta[property="csp-nonce"]');
    if (u) return we = u.nonce || u.getAttribute("content") || void 0;
    const e = document.head.querySelector('meta[name="sc-nonce"]');
    if (e) return we = e.getAttribute("content") || void 0;
  }
  return we = typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}
const J0 = (u, e) => {
  const t = document.head, n = u || t, s = document.createElement("style"), i = ((o) => {
    const d = Array.from(o.querySelectorAll(`style[${ue}]`));
    return d[d.length - 1];
  })(n), a = i !== void 0 ? i.nextSibling : null;
  s.setAttribute(ue, z0), s.setAttribute(U0, vt);
  const D = e || Oa();
  return D && s.setAttribute("nonce", D), n.insertBefore(s, a), s;
}, $a = class {
  constructor(u, e) {
    this.element = J0(u, e), this.element.appendChild(document.createTextNode("")), this.sheet = ((t) => {
      var n;
      if (t.sheet) return t.sheet;
      const s = (n = t.getRootNode().styleSheets) !== null && n !== void 0 ? n : document.styleSheets;
      for (let i = 0, a = s.length; i < a; i++) {
        const D = s[i];
        if (D.ownerNode === t) return D;
      }
      throw Le(17);
    })(this.element), this.length = 0;
  }
  insertRule(u, e) {
    try {
      return this.sheet.insertRule(e, u), this.length++, !0;
    } catch {
      return !1;
    }
  }
  deleteRule(u) {
    this.sheet.deleteRule(u), this.length--;
  }
  getRule(u) {
    const e = this.sheet.cssRules[u];
    return e && e.cssText ? e.cssText : "";
  }
}, Ra = class {
  constructor(u, e) {
    this.element = J0(u, e), this.nodes = this.element.childNodes, this.length = 0;
  }
  insertRule(u, e) {
    if (u <= this.length && u >= 0) {
      const t = document.createTextNode(e);
      return this.element.insertBefore(t, this.nodes[u] || null), this.length++, !0;
    }
    return !1;
  }
  deleteRule(u) {
    this.element.removeChild(this.nodes[u]), this.length--;
  }
  getRule(u) {
    return u < this.length ? this.nodes[u].textContent : "";
  }
};
let yn = Oe;
const Ia = { isServer: !Oe, useCSSOMInjection: !aa };
class wt {
  static registerId(e) {
    return Ze(e);
  }
  constructor(e = Ce, t = {}, n) {
    this.options = Object.assign(Object.assign({}, Ia), e), this.gs = t, this.keyframeIds = /* @__PURE__ */ new Set(), this.names = new Map(n), this.server = !!e.isServer, !this.server && Oe && yn && (yn = !1, zt(this)), K0(this, () => ((s) => {
      const i = s.getTag(), { length: a } = i;
      let D = "";
      for (let o = 0; o < a; o++) {
        const d = ca(o);
        if (d === void 0) continue;
        const x = s.names.get(d);
        if (x === void 0 || !x.size) continue;
        const c = i.getGroup(o);
        if (c.length === 0) continue;
        const h = ue + ".g" + o + '[id="' + d + '"]';
        let F = "";
        for (const C of x) C.length > 0 && (F += C + ",");
        D += c + h + '{content:"' + F + '"}' + Wr;
      }
      return D;
    })(this));
  }
  rehydrate() {
    !this.server && Oe && zt(this);
  }
  reconstructWithOptions(e, t = !0) {
    const n = new wt(Object.assign(Object.assign({}, this.options), e), this.gs, t && this.names || void 0);
    return n.keyframeIds = new Set(this.keyframeIds), !this.server && Oe && e.target !== this.options.target && Sr(this.options.target) !== Sr(e.target) && zt(n), n;
  }
  allocateGSInstance(e) {
    return this.gs[e] = (this.gs[e] || 0) + 1;
  }
  getTag() {
    return this.tag || (this.tag = (e = (({ useCSSOMInjection: t, target: n, nonce: s }) => t ? new $a(n, s) : new Ra(n, s))(this.options), new Sa(e)));
    var e;
  }
  hasNameForId(e, t) {
    var n, s;
    return (s = (n = this.names.get(e)) === null || n === void 0 ? void 0 : n.has(t)) !== null && s !== void 0 && s;
  }
  registerName(e, t) {
    Ze(e), e.startsWith(oa) && this.keyframeIds.add(e);
    const n = this.names.get(e);
    n ? n.add(t) : this.names.set(e, /* @__PURE__ */ new Set([t]));
  }
  insertRules(e, t, n) {
    this.registerName(e, t), this.getTag().insertRules(Ze(e), n);
  }
  clearNames(e) {
    this.names.has(e) && this.names.get(e).clear();
  }
  clearRules(e) {
    this.getTag().clearGroup(Ze(e)), this.clearNames(e);
  }
  clearTag() {
    this.tag = void 0;
  }
}
const X0 = /* @__PURE__ */ new WeakSet(), La = { animationIterationCount: 1, aspectRatio: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexShrink: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, scale: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 };
function Ma(u, e) {
  return e == null || typeof e == "boolean" || e === "" ? "" : typeof e != "number" || e === 0 || u in La || u.startsWith("--") ? String(e).trim() : e + "px";
}
const Zu = 47;
function vn(u) {
  if (u.charCodeAt(0) === 45 && u.charCodeAt(1) === 45) return u;
  let e = "";
  for (let t = 0; t < u.length; t++) {
    const n = u.charCodeAt(t);
    e += n >= 65 && n <= 90 ? "-" + String.fromCharCode(n + 32) : u[t];
  }
  return e.startsWith("ms-") ? "-" + e : e;
}
const za = Symbol.for("sc-keyframes");
function Pr(u) {
  return typeof u == "object" && u !== null && za in u;
}
function Q0(u) {
  return bt(u) && !(u.prototype && u.prototype.isReactComponent);
}
const us = (u) => u == null || u === !1 || u === "", Ua = Symbol.for("react.client.reference");
function bn(u) {
  return u.$$typeof === Ua;
}
function wn(u) {
  const e = u.$$id, t = (e && e.includes("#") ? e.split("#").pop() : e) || u.name || "unknown";
  console.warn(`Interpolating a client component (${t}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function es(u, e) {
  for (const t in u) {
    const n = u[t];
    u.hasOwnProperty(t) && !us(n) && (Array.isArray(n) && X0.has(n) || bt(n) ? e.push(vn(t) + ":", n, ";") : ee(n) ? (e.push(t + " {"), es(n, e), e.push("}")) : e.push(vn(t) + ": " + Ma(t, n) + ";"));
  }
}
function Ju(u, e, t, n, s = []) {
  if (us(u)) return s;
  const i = typeof u;
  if (i === "string") return s.push(u), s;
  if (i === "function") {
    if (bn(u)) return process.env.NODE_ENV !== "production" && wn(u), s;
    if (Q0(u) && e) {
      const a = u(e);
      return process.env.NODE_ENV === "production" || typeof a != "object" || Array.isArray(a) || Pr(a) || ee(a) || a === null || console.error(`${Gr(u)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), Ju(a, e, t, n, s);
    }
    return s.push(u), s;
  }
  if (Array.isArray(u)) {
    for (let a = 0; a < u.length; a++) Ju(u[a], e, t, n, s);
    return s;
  }
  return Z0(u) ? (s.push(`.${u.styledComponentId}`), s) : Pr(u) ? (t ? (u.inject(t, n), s.push(u.getName(n))) : s.push(u), s) : bn(u) ? (process.env.NODE_ENV !== "production" && wn(u), s) : ee(u) ? (es(u, s), s) : (s.push(u.toString()), s);
}
const Ha = W0(vt);
class Va {
  constructor(e, t, n) {
    this.rules = e, this.componentId = t, this.baseHash = Ku(Ha, t), this.baseStyle = n, wt.registerId(t);
  }
  generateAndInjectStyles(e, t, n) {
    let s = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
    {
      let i = "";
      for (let a = 0; a < this.rules.length; a++) {
        const D = this.rules[a];
        if (typeof D == "string") i += D;
        else if (D) if (Q0(D)) {
          const o = D(e);
          typeof o == "string" ? i += o : o != null && o !== !1 && (process.env.NODE_ENV === "production" || typeof o != "object" || Array.isArray(o) || Pr(o) || ee(o) || console.error(`${Gr(D)} is not a styled component and cannot be referred to via component selector. See https://styled-components.com/docs/advanced#referring-to-other-components for more details.`), i += Bn(Ju(o, e, t, n)));
        } else i += Bn(Ju(D, e, t, n));
      }
      if (i) {
        this.dynamicNameCache || (this.dynamicNameCache = /* @__PURE__ */ new Map());
        const a = n.hash ? n.hash + i : i;
        let D = this.dynamicNameCache.get(a);
        if (!D) {
          if (D = V0(Ku(Ku(this.baseHash, n.hash), i) >>> 0), this.dynamicNameCache.size >= 200) {
            const o = this.dynamicNameCache.keys().next().value;
            o !== void 0 && this.dynamicNameCache.delete(o);
          }
          this.dynamicNameCache.set(a, D);
        }
        if (!t.hasNameForId(this.componentId, D)) {
          const o = n(i, "." + D, void 0, this.componentId);
          t.insertRules(this.componentId, D, o);
        }
        s = Pe(s, D);
      }
    }
    return s;
  }
}
const Wa = /&/g;
function ts(u, e) {
  let t = 0;
  for (; --e >= 0 && u.charCodeAt(e) === 92; ) t++;
  return !(1 & ~t);
}
function Ut(u) {
  const e = u.length;
  let t = "", n = 0, s = 0, i = 0, a = !1, D = !1;
  for (let o = 0; o < e; o++) {
    const d = u.charCodeAt(o);
    if (i !== 0 || a || d !== Zu || u.charCodeAt(o + 1) !== 42) if (a) d === 42 && u.charCodeAt(o + 1) === Zu && (a = !1, o++);
    else if (d !== 34 && d !== 39 || ts(u, o)) {
      if (i === 0) if (d === 123) s++;
      else if (d === 125) {
        if (s--, s < 0) {
          D = !0;
          let x = o + 1;
          for (; x < e; ) {
            const c = u.charCodeAt(x);
            if (c === 59 || c === 10) break;
            x++;
          }
          x < e && u.charCodeAt(x) === 59 && x++, s = 0, o = x - 1, n = x;
          continue;
        }
        s === 0 && (t += u.substring(n, o + 1), n = o + 1);
      } else d === 59 && s === 0 && (t += u.substring(n, o + 1), n = o + 1);
    } else i === 0 ? i = d : i === d && (i = 0);
    else a = !0, o++;
  }
  return D || s !== 0 || i !== 0 ? (n < e && s === 0 && i === 0 && (t += u.substring(n)), t) : u;
}
function rs(u, e) {
  const t = e + " ", n = "," + t;
  for (let s = 0; s < u.length; s++) {
    const i = u[s];
    if (i.type === "rule") {
      i.value = (t + i.value).replaceAll(",", n);
      const a = i.props, D = [];
      for (let o = 0; o < a.length; o++) D[o] = t + a[o];
      i.props = D;
    }
    Array.isArray(i.children) && i.type !== "@keyframes" && rs(i.children, e);
  }
  return u;
}
function qa({ options: u = Ce, plugins: e = qr } = Ce) {
  let t, n, s;
  const i = (h, F, C) => C.startsWith(n) && C.endsWith(n) && C.replaceAll(n, "").length > 0 ? `.${t}` : h, a = e.slice();
  a.push((h) => {
    h.type === gt && h.value.includes("&") && (s || (s = new RegExp(`\\${n}\\b`, "g")), h.props[0] = h.props[0].replace(Wa, n).replace(s, i));
  }), u.prefix && a.push(ia), a.push(ra);
  let D = [];
  const o = na(a.concat(sa((h) => D.push(h)))), d = (h, F = "", C = "", f = "&") => {
    t = f, n = F, s = void 0;
    const y = function(l) {
      const p = l.indexOf("//") !== -1, E = l.indexOf("}") !== -1;
      if (!p && !E) return l;
      if (!p) return Ut(l);
      const A = l.length;
      let b = "", w = 0, P = 0, q = 0, z = 0, k = 0, I = !1;
      for (; P < A; ) {
        const O = l.charCodeAt(P);
        if (O !== 34 && O !== 39 || ts(l, P)) if (q === 0) if (O === Zu && P + 1 < A && l.charCodeAt(P + 1) === 42) {
          for (P += 2; P + 1 < A && (l.charCodeAt(P) !== 42 || l.charCodeAt(P + 1) !== Zu); ) P++;
          P += 2;
        } else if (O !== 40) if (O !== 41) if (z > 0) P++;
        else if (O === 42 && P + 1 < A && l.charCodeAt(P + 1) === Zu) b += l.substring(w, P), P += 2, w = P, I = !0;
        else if (O === Zu && P + 1 < A && l.charCodeAt(P + 1) === Zu) {
          for (b += l.substring(w, P); P < A && l.charCodeAt(P) !== 10; ) P++;
          w = P, I = !0;
        } else O === 123 ? k++ : O === 125 && k--, P++;
        else z > 0 && z--, P++;
        else z++, P++;
        else P++;
        else q === 0 ? q = O : q === O && (q = 0), P++;
      }
      return I ? (w < A && (b += l.substring(w)), k === 0 ? b : Ut(b)) : k === 0 ? l : Ut(l);
    }(h);
    let B = ea(C || F ? C + " " + F + " { " + y + " }" : y);
    return u.namespace && (B = rs(B, u.namespace)), D = [], dt(B, o), D;
  }, x = u;
  let c = jr;
  for (let h = 0; h < e.length; h++) e[h].name || Le(15), c = Ku(c, e[h].name);
  return x?.namespace && (c = Ku(c, x.namespace)), x?.prefix && (c = Ku(c, "p")), d.hash = c !== jr ? c.toString() : "", d;
}
const Ga = new wt(), Ya = qa(), ns = uu.createContext({ shouldForwardProp: void 0, styleSheet: Ga, stylis: Ya, stylisPlugins: void 0 });
ns.Consumer;
function Za() {
  return uu.useContext(ns);
}
const ss = uu.createContext(void 0);
ss.Consumer;
const jn = Object.prototype.hasOwnProperty, Ht = {};
function Ka(u, e) {
  const t = typeof u != "string" ? "sc" : H0(u);
  Ht[t] = (Ht[t] || 0) + 1;
  const n = t + "-" + Aa(vt + t + Ht[t]);
  return e ? e + "-" + n : n;
}
let Vt;
function Ja(u, e, t) {
  const n = Z0(u), s = u, i = !ct(u), { attrs: a = qr, componentId: D = Ka(e.displayName, e.parentComponentId), displayName: o = ha(u) } = e, d = e.displayName && e.componentId ? H0(e.displayName) + "-" + e.componentId : e.componentId || D, x = n && s.attrs ? s.attrs.concat(a).filter(Boolean) : a;
  let { shouldForwardProp: c } = e;
  if (n && s.shouldForwardProp) {
    const f = s.shouldForwardProp;
    if (e.shouldForwardProp) {
      const y = e.shouldForwardProp;
      c = (B, l) => f(B, l) && y(B, l);
    } else c = f;
  }
  const h = new Va(t, d, n ? s.componentStyle : void 0);
  function F(f, y) {
    return function(B, l, p) {
      const { attrs: E, componentStyle: A, defaultProps: b, foldedComponentIds: w, styledComponentId: P, target: q } = B, z = uu.useContext(ss), k = Za(), I = B.shouldForwardProp || k.shouldForwardProp;
      process.env.NODE_ENV !== "production" && uu.useDebugValue && uu.useDebugValue(P);
      const O = pa(l, z, b) || Ce;
      let j, M;
      {
        const N = uu.useRef(null), v = N.current;
        if (v !== null && v[1] === O && v[2] === k.styleSheet && v[3] === k.stylis && v[7] === A && function(S, R, V) {
          const U = S, Z = R;
          let Y = 0;
          for (const K in Z) if (jn.call(Z, K) && (Y++, U[K] !== Z[K])) return !1;
          return Y === V;
        }(v[0], l, v[4])) j = v[5], M = v[6];
        else {
          j = function(R, V, U) {
            const Z = Object.assign(Object.assign({}, V), { className: void 0, theme: U }), Y = R.length > 1;
            for (let K = 0; K < R.length; K++) {
              const X = R[K], L = bt(X) ? X(Y ? Object.assign({}, Z) : Z) : X;
              for (const W in L) W === "className" ? Z.className = Pe(Z.className, L[W]) : W === "style" ? Z.style = Object.assign(Object.assign({}, Z.style), L[W]) : W in V && V[W] === void 0 || (Z[W] = L[W]);
            }
            return "className" in V && typeof V.className == "string" && (Z.className = Pe(Z.className, V.className)), Z;
          }(E, l, O), M = function(R, V, U, Z) {
            const Y = R.generateAndInjectStyles(V, U, Z);
            return process.env.NODE_ENV !== "production" && uu.useDebugValue && uu.useDebugValue(Y), Y;
          }(A, j, k.styleSheet, k.stylis);
          let S = 0;
          for (const R in l) jn.call(l, R) && S++;
          N.current = [l, O, k.styleSheet, k.stylis, S, j, M, A];
        }
      }
      process.env.NODE_ENV !== "production" && B.warnTooManyClasses && B.warnTooManyClasses(M);
      const J = j.as || q, su = function(N, v, S, R) {
        const V = {};
        for (const U in N) N[U] === void 0 || U[0] === "$" || U === "as" || U === "theme" && N.theme === S || (U === "forwardedAs" ? V.as = N.forwardedAs : R && !R(U, v) || (V[U] = N[U], R || process.env.NODE_ENV !== "development" || zi(U) || (Vt || (Vt = /* @__PURE__ */ new Set())).has(U) || !ct(v) || v.includes("-") || (Vt.add(U), console.warn(`styled-components: it looks like an unknown prop "${U}" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via \`<StyleSheetManager shouldForwardProp={...}>\` (connect an API like \`@emotion/is-prop-valid\`) or consider using transient props (\`$\` prefix for automatic filtering.)`))));
        return V;
      }(j, J, O, I);
      let nu = Pe(w, P);
      return M && (nu += " " + M), j.className && (nu += " " + j.className), su[ct(J) && J.includes("-") ? "class" : "className"] = nu, p && (su.ref = p), Pi(J, su);
    }(C, f, y);
  }
  F.displayName = o;
  let C = uu.forwardRef(F);
  return C.attrs = x, C.componentStyle = h, C.displayName = o, C.shouldForwardProp = c, C.foldedComponentIds = n ? Pe(s.foldedComponentIds, s.styledComponentId) : "", C.styledComponentId = d, C.target = n ? s.target : u, Object.defineProperty(C, "defaultProps", { get() {
    return this._foldedDefaultProps;
  }, set(f) {
    this._foldedDefaultProps = n ? function(y, ...B) {
      for (const l of B) _r(y, l, !0);
      return y;
    }({}, s.defaultProps, f) : f;
  } }), process.env.NODE_ENV !== "production" && (da(o, d), C.warnTooManyClasses = /* @__PURE__ */ ((f, y) => {
    let B = {}, l = !1;
    return (p) => {
      !l && (B[p] = !0, Object.keys(B).length >= 200) && (console.warn(`Over 200 classes were generated for component ${f}${y ? ` with the id of "${y}"` : ""}.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), l = !0, B = {});
    };
  })(o, d)), K0(C, () => `.${C.styledComponentId}`), i && Y0(C, u, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), C;
}
var Xa = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "blockquote", "body", "button", "br", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "menu", "meter", "nav", "object", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "slot", "small", "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use"]);
function _n(u, e) {
  const t = [u[0]];
  for (let n = 0, s = e.length; n < s; n += 1) t.push(e[n], u[n + 1]);
  return t;
}
const Sn = (u) => (X0.add(u), u);
function is(u, ...e) {
  if (bt(u) || ee(u)) return Sn(Ju(_n(qr, [u, ...e])));
  const t = u;
  return e.length === 0 && t.length === 1 && typeof t[0] == "string" ? Ju(t) : Sn(Ju(_n(t, e)));
}
function Tr(u, e, t = Ce) {
  if (!e) throw Le(1, e);
  const n = (s, ...i) => u(e, t, is(s, ...i));
  return n.attrs = (s) => Tr(u, e, Object.assign(Object.assign({}, t), { attrs: Array.prototype.concat(t.attrs, s).filter(Boolean) })), n.withConfig = (s) => Tr(u, e, Object.assign(Object.assign({}, t), s)), n;
}
const as = (u) => Tr(Ja, u), Et = as;
Xa.forEach((u) => {
  Et[u] = as(u);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://styled-components.com/docs/basics#react-native`);
const Je = `__sc-${ue}__`;
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[Je] || (window[Je] = 0), window[Je] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://styled-components.com/docs/faqs#why-am-i-getting-a-warning-about-several-instances-of-module-on-the-page for more info.`), window[Je] += 1);
let os = Et;
!typeof Et.div === "function" && (os = Et.default);
const _ = os, te = _.div`
  font-family: Helvetica Neue;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: -0.025em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 15px;
          letter-spacing: -0.04em;
          `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          white-space: pre-line;
        `;
  }
}};
`;
function Qa(u, e = []) {
  let t = [];
  function n(i, a) {
    const D = m.createContext(a);
    D.displayName = i + "Context";
    const o = t.length;
    t = [...t, a];
    const d = (c) => {
      const { scope: h, children: F, ...C } = c, f = h?.[u]?.[o] || D, y = m.useMemo(() => C, Object.values(C));
      return /* @__PURE__ */ r.jsx(f.Provider, { value: y, children: F });
    };
    d.displayName = i + "Provider";
    function x(c, h) {
      const F = h?.[u]?.[o] || D, C = m.useContext(F);
      if (C) return C;
      if (a !== void 0) return a;
      throw new Error(`\`${c}\` must be used within \`${i}\``);
    }
    return [d, x];
  }
  const s = () => {
    const i = t.map((a) => m.createContext(a));
    return function(D) {
      const o = D?.[u] || i;
      return m.useMemo(
        () => ({ [`__scope${u}`]: { ...D, [u]: o } }),
        [D, o]
      );
    };
  };
  return s.scopeName = u, [n, uo(s, ...e)];
}
function uo(...u) {
  const e = u[0];
  if (u.length === 1) return e;
  const t = () => {
    const n = u.map((s) => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function(i) {
      const a = n.reduce((D, { useScope: o, scopeName: d }) => {
        const c = o(i)[`__scope${d}`];
        return { ...D, ...c };
      }, {});
      return m.useMemo(() => ({ [`__scope${e.scopeName}`]: a }), [a]);
    };
  };
  return t.scopeName = e.scopeName, t;
}
function eo(u) {
  const e = m.useRef(u);
  return m.useEffect(() => {
    e.current = u;
  }), m.useMemo(() => (...t) => e.current?.(...t), []);
}
var kr = globalThis?.document ? m.useLayoutEffect : () => {
};
function Pn(u, e) {
  if (typeof u == "function")
    return u(e);
  u != null && (u.current = e);
}
function to(...u) {
  return (e) => {
    let t = !1;
    const n = u.map((s) => {
      const i = Pn(s, e);
      return !t && typeof i == "function" && (t = !0), i;
    });
    if (t)
      return () => {
        for (let s = 0; s < n.length; s++) {
          const i = n[s];
          typeof i == "function" ? i() : Pn(u[s], null);
        }
      };
  };
}
var ro = Symbol.for("react.lazy"), Ct = m[" use ".trim().toString()];
function no(u) {
  return typeof u == "object" && u !== null && "then" in u;
}
function Ds(u) {
  return u != null && typeof u == "object" && "$$typeof" in u && u.$$typeof === ro && "_payload" in u && no(u._payload);
}
// @__NO_SIDE_EFFECTS__
function so(u) {
  const e = /* @__PURE__ */ io(u), t = m.forwardRef((n, s) => {
    let { children: i, ...a } = n;
    Ds(i) && typeof Ct == "function" && (i = Ct(i._payload));
    const D = m.Children.toArray(i), o = D.find(oo);
    if (o) {
      const d = o.props.children, x = D.map((c) => c === o ? m.Children.count(d) > 1 ? m.Children.only(null) : m.isValidElement(d) ? d.props.children : null : c);
      return /* @__PURE__ */ r.jsx(e, { ...a, ref: s, children: m.isValidElement(d) ? m.cloneElement(d, void 0, x) : null });
    }
    return /* @__PURE__ */ r.jsx(e, { ...a, ref: s, children: i });
  });
  return t.displayName = `${u}.Slot`, t;
}
// @__NO_SIDE_EFFECTS__
function io(u) {
  const e = m.forwardRef((t, n) => {
    let { children: s, ...i } = t;
    if (Ds(s) && typeof Ct == "function" && (s = Ct(s._payload)), m.isValidElement(s)) {
      const a = lo(s), D = Do(i, s.props);
      return s.type !== m.Fragment && (D.ref = n ? to(n, a) : a), m.cloneElement(s, D);
    }
    return m.Children.count(s) > 1 ? m.Children.only(null) : null;
  });
  return e.displayName = `${u}.SlotClone`, e;
}
var ao = Symbol("radix.slottable");
function oo(u) {
  return m.isValidElement(u) && typeof u.type == "function" && "__radixId" in u.type && u.type.__radixId === ao;
}
function Do(u, e) {
  const t = { ...e };
  for (const n in e) {
    const s = u[n], i = e[n];
    /^on[A-Z]/.test(n) ? s && i ? t[n] = (...D) => {
      const o = i(...D);
      return s(...D), o;
    } : s && (t[n] = s) : n === "style" ? t[n] = { ...s, ...i } : n === "className" && (t[n] = [s, i].filter(Boolean).join(" "));
  }
  return { ...u, ...t };
}
function lo(u) {
  let e = Object.getOwnPropertyDescriptor(u.props, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning;
  return t ? u.ref : (e = Object.getOwnPropertyDescriptor(u, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning, t ? u.props.ref : u.props.ref || u.ref);
}
var co = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Yr = co.reduce((u, e) => {
  const t = /* @__PURE__ */ so(`Primitive.${e}`), n = m.forwardRef((s, i) => {
    const { asChild: a, ...D } = s, o = a ? t : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ r.jsx(o, { ...D, ref: i });
  });
  return n.displayName = `Primitive.${e}`, { ...u, [e]: n };
}, {}), Xe = { exports: {} }, Wt = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tn;
function Fo() {
  if (Tn) return Wt;
  Tn = 1;
  var u = uu;
  function e(c, h) {
    return c === h && (c !== 0 || 1 / c === 1 / h) || c !== c && h !== h;
  }
  var t = typeof Object.is == "function" ? Object.is : e, n = u.useState, s = u.useEffect, i = u.useLayoutEffect, a = u.useDebugValue;
  function D(c, h) {
    var F = h(), C = n({ inst: { value: F, getSnapshot: h } }), f = C[0].inst, y = C[1];
    return i(
      function() {
        f.value = F, f.getSnapshot = h, o(f) && y({ inst: f });
      },
      [c, F, h]
    ), s(
      function() {
        return o(f) && y({ inst: f }), c(function() {
          o(f) && y({ inst: f });
        });
      },
      [c]
    ), a(F), F;
  }
  function o(c) {
    var h = c.getSnapshot;
    c = c.value;
    try {
      var F = h();
      return !t(c, F);
    } catch {
      return !0;
    }
  }
  function d(c, h) {
    return h();
  }
  var x = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? d : D;
  return Wt.useSyncExternalStore = u.useSyncExternalStore !== void 0 ? u.useSyncExternalStore : x, Wt;
}
var qt = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kn;
function po() {
  return kn || (kn = 1, process.env.NODE_ENV !== "production" && function() {
    function u(F, C) {
      return F === C && (F !== 0 || 1 / F === 1 / C) || F !== F && C !== C;
    }
    function e(F, C) {
      x || s.startTransition === void 0 || (x = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var f = C();
      if (!c) {
        var y = C();
        i(f, y) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), c = !0);
      }
      y = a({
        inst: { value: f, getSnapshot: C }
      });
      var B = y[0].inst, l = y[1];
      return o(
        function() {
          B.value = f, B.getSnapshot = C, t(B) && l({ inst: B });
        },
        [F, f, C]
      ), D(
        function() {
          return t(B) && l({ inst: B }), F(function() {
            t(B) && l({ inst: B });
          });
        },
        [F]
      ), d(f), f;
    }
    function t(F) {
      var C = F.getSnapshot;
      F = F.value;
      try {
        var f = C();
        return !i(F, f);
      } catch {
        return !0;
      }
    }
    function n(F, C) {
      return C();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var s = uu, i = typeof Object.is == "function" ? Object.is : u, a = s.useState, D = s.useEffect, o = s.useLayoutEffect, d = s.useDebugValue, x = !1, c = !1, h = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? n : e;
    qt.useSyncExternalStore = s.useSyncExternalStore !== void 0 ? s.useSyncExternalStore : h, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), qt;
}
var Nn;
function Eo() {
  return Nn || (Nn = 1, process.env.NODE_ENV === "production" ? Xe.exports = Fo() : Xe.exports = po()), Xe.exports;
}
var Co = Eo();
function fo() {
  return Co.useSyncExternalStore(
    Ao,
    () => !0,
    () => !1
  );
}
function Ao() {
  return () => {
  };
}
var Zr = "Avatar", [ho] = Qa(Zr), [mo, ls] = ho(Zr), cs = m.forwardRef(
  (u, e) => {
    const { __scopeAvatar: t, ...n } = u, [s, i] = m.useState("idle");
    return /* @__PURE__ */ r.jsx(
      mo,
      {
        scope: t,
        imageLoadingStatus: s,
        onImageLoadingStatusChange: i,
        children: /* @__PURE__ */ r.jsx(Yr.span, { ...n, ref: e })
      }
    );
  }
);
cs.displayName = Zr;
var Fs = "AvatarImage", ds = m.forwardRef(
  (u, e) => {
    const { __scopeAvatar: t, src: n, onLoadingStatusChange: s = () => {
    }, ...i } = u, a = ls(Fs, t), D = go(n, i), o = eo((d) => {
      s(d), a.onImageLoadingStatusChange(d);
    });
    return kr(() => {
      D !== "idle" && o(D);
    }, [D, o]), D === "loaded" ? /* @__PURE__ */ r.jsx(Yr.img, { ...i, ref: e, src: n }) : null;
  }
);
ds.displayName = Fs;
var ps = "AvatarFallback", Es = m.forwardRef(
  (u, e) => {
    const { __scopeAvatar: t, delayMs: n, ...s } = u, i = ls(ps, t), [a, D] = m.useState(n === void 0);
    return m.useEffect(() => {
      if (n !== void 0) {
        const o = window.setTimeout(() => D(!0), n);
        return () => window.clearTimeout(o);
      }
    }, [n]), a && i.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ r.jsx(Yr.span, { ...s, ref: e }) : null;
  }
);
Es.displayName = ps;
function On(u, e) {
  return u ? e ? (u.src !== e && (u.src = e), u.complete && u.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function go(u, { referrerPolicy: e, crossOrigin: t }) {
  const n = fo(), s = m.useRef(null), i = n ? (s.current || (s.current = new window.Image()), s.current) : null, [a, D] = m.useState(
    () => On(i, u)
  );
  return kr(() => {
    D(On(i, u));
  }, [i, u]), kr(() => {
    const o = (c) => () => {
      D(c);
    };
    if (!i) return;
    const d = o("loaded"), x = o("error");
    return i.addEventListener("load", d), i.addEventListener("error", x), e && (i.referrerPolicy = e), typeof t == "string" && (i.crossOrigin = t), () => {
      i.removeEventListener("load", d), i.removeEventListener("error", x);
    };
  }, [i, t, e]), a;
}
var Bo = cs, xo = ds, yo = Es;
const vo = _(Bo)`
  display: grid;
  place-content: center;
  height: 100%;

  img {
    width: 100%;
    border-radius: 50%;
  }

  span {
    font-size: 1rem;
  }
`, $u = ({
  src: u,
  alt: e,
  ...t
}) => {
  const n = e.substring(0, 2).toUpperCase();
  return /* @__PURE__ */ r.jsxs(vo, { ...t, children: [
    /* @__PURE__ */ r.jsx(xo, { src: u, alt: e }),
    /* @__PURE__ */ r.jsx(yo, { children: n })
  ] });
}, Cs = ({
  username: u,
  profilePicture: e,
  locationName: t,
  small: n,
  collabs: s
}) => {
  if (Array.isArray(s) && s.length > 1) {
    let a = So(s);
    return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center", children: /* @__PURE__ */ r.jsxs(_o, { children: [
      /* @__PURE__ */ r.jsxs(bo, { children: [
        /* @__PURE__ */ r.jsx(wo, { src: s[1].profilePictureUrl, alt: u }),
        /* @__PURE__ */ r.jsx(jo, { src: s[0].profilePictureUrl, alt: u })
      ] }),
      " ",
      a
    ] }) });
  }
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
      width: "35px",
      height: "35px"
    }, children: /* @__PURE__ */ r.jsx($u, { src: e, alt: u }) }),
    /* @__PURE__ */ r.jsxs("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${n ? "sp-text-white" : ""}`, children: [
      /* @__PURE__ */ r.jsx(te, { $variant: "heading", children: u }),
      t && /* @__PURE__ */ r.jsx(te, { $variant: "subheading", children: t })
    ] })
  ] });
}, bo = _.div`
  overflow: hidden;
  margin-left: 10px;
  margin-right: 4px;
  width: 38px;
  height: 38px;
`, fs = _($u)`
  border: 1px solid white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: relative;
`, wo = _(fs)`
  left: 12px;

  > img {
    max-width: 24px;
    max-height: 24px;
  }
`, jo = _(fs)`
  top: -14px;
  > img {
    max-width: 24px;
    max-height: 24px;
    border: 1px solid white;
  }
`, _o = _.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Inter, Helvetica, Arial, sans-serif;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 14px;
`, $n = _.span`
  color: #000000;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`;
function So(u) {
  return u.length < 2 ? null : u.length === 2 ? /* @__PURE__ */ r.jsx($n, { children: `${u[0].username} and ${u[1].username}` }) : /* @__PURE__ */ r.jsx($n, { children: `${u[0].username} and ${u.length - 1} others` });
}
const Po = (u) => /* @__PURE__ */ m.createElement("svg", { width: 16, height: 20, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("path", { d: "M15.2622 5.61017C15.2411 5.20965 14.9038 4.87236 14.4822 4.87236H11.9526V4.15563C11.9526 1.96327 10.2451 0.0871172 8.0527 0.0027957C5.75494 -0.0815258 3.85771 1.75247 3.85771 4.02915V4.87236H1.30698C1.11726 4.87236 0.927536 4.95668 0.779974 5.08316C0.611331 5.23073 0.527009 5.44153 0.527009 5.63125L0 18.6589C0 18.8697 0.0843216 19.0594 0.231884 19.207C0.379447 19.3546 0.56917 19.4389 0.779974 19.4389H15.22C15.4308 19.4389 15.6206 19.3546 15.7681 19.207C15.9157 19.0594 16 18.8486 16 18.6168L15.2622 5.61017ZM8.11594 1.56274C9.40184 1.68922 10.3505 2.80648 10.3505 4.11347V4.85128H5.43874V4.02915C5.41765 2.5746 6.6614 1.41518 8.11594 1.56274Z", fill: "white" })), To = (u) => /* @__PURE__ */ m.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 108.56 122.88", style: {
  enableBackground: "new 0 0 108.56 122.88"
}, xmlSpace: "preserve", fill: "#fff", ...u }, /* @__PURE__ */ m.createElement("g", null, /* @__PURE__ */ m.createElement("path", { d: "M30.47,16.05h12.47l-6.35-7.16c-1.96-2.21-1.75-5.59,0.46-7.55c2.21-1.96,5.59-1.75,7.55,0.46l9.11,10.27L62.81,1.8 c1.96-2.21,5.34-2.42,7.55-0.46c2.21,1.96,2.42,5.34,0.46,7.55l-6.35,7.16h13.62c8.4,0,16.04,3.43,21.57,8.96 c5.49,5.49,8.9,13.05,8.9,21.35v46.21c0,8.3-3.41,15.86-8.9,21.35c-5.53,5.53-13.16,8.96-21.57,8.96H30.47 c-8.4,0-16.04-3.43-21.57-8.96C3.41,108.43,0,100.87,0,92.57V46.36c0-8.3,3.41-15.86,8.9-21.35 C14.43,19.48,22.07,16.05,30.47,16.05L30.47,16.05z M27.88,75.18c-2.86,0.74-5.78-0.98-6.52-3.84c-0.74-2.86,0.98-5.78,3.84-6.52 l28.8-7.45c2.86-0.74,5.78,0.98,6.52,3.84c0.14,0.53,0.19,1.07,0.17,1.59l-0.32,6.38l19.17-5.52c2.84-0.81,5.79,0.83,6.61,3.67 c0.81,2.84-0.83,5.79-3.67,6.61l-26.02,7.5c-0.64,0.23-1.34,0.34-2.06,0.31c-2.95-0.14-5.23-2.65-5.1-5.6l0.33-6.58L27.88,75.18 L27.88,75.18z M78.09,26.48H30.47c-5.4,0-10.31,2.22-13.88,5.78c-3.6,3.6-5.84,8.59-5.84,14.1v46.21c0,5.51,2.24,10.5,5.84,14.1 c3.57,3.57,8.48,5.78,13.88,5.78h47.61c5.4,0,10.31-2.22,13.88-5.78c3.6-3.6,5.84-8.59,5.84-14.1V46.36c0-5.51-2.24-10.5-5.84-14.1 C88.4,28.69,83.49,26.48,78.09,26.48L78.09,26.48z" }))), ko = (u) => /* @__PURE__ */ m.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 122.14 122.88", style: {
  enableBackground: "new 0 0 122.14 122.88"
}, xmlSpace: "preserve", fill: "#fff", ...u }, /* @__PURE__ */ m.createElement("g", null, /* @__PURE__ */ m.createElement("path", { d: "M35.14,0H87c9.65,0,18.43,3.96,24.8,10.32c6.38,6.37,10.34,15.16,10.34,24.82v52.61c0,9.64-3.96,18.42-10.32,24.79 l-0.02,0.02c-6.38,6.37-15.16,10.32-24.79,10.32H35.14c-9.66,0-18.45-3.96-24.82-10.32l-0.24-0.27C3.86,105.95,0,97.27,0,87.74 V35.14c0-9.67,3.95-18.45,10.32-24.82S25.47,0,35.14,0L35.14,0z M91.51,31.02l0.07,0.11h21.6c-0.87-5.68-3.58-10.78-7.48-14.69 C100.9,11.64,94.28,8.66,87,8.66h-8.87L91.51,31.02L91.51,31.02z M81.52,31.13L68.07,8.66H38.57l13.61,22.47H81.52L81.52,31.13z M42.11,31.13L28.95,9.39c-4.81,1.16-9.12,3.65-12.51,7.05c-3.9,3.9-6.6,9.01-7.48,14.69H42.11L42.11,31.13z M113.48,39.79H8.66 v47.96c0,7.17,2.89,13.7,7.56,18.48l0.22,0.21c4.8,4.8,11.43,7.79,18.7,7.79H87c7.28,0,13.9-2.98,18.69-7.77l0.02-0.02 c4.79-4.79,7.77-11.41,7.77-18.69V39.79L113.48,39.79z M50.95,54.95l26.83,17.45c0.43,0.28,0.82,0.64,1.13,1.08 c1.22,1.77,0.77,4.2-1,5.42L51.19,94.67c-0.67,0.55-1.53,0.88-2.48,0.88c-2.16,0-3.91-1.75-3.91-3.91V58.15h0.02 c0-0.77,0.23-1.55,0.7-2.23C46.76,54.15,49.19,53.72,50.95,54.95L50.95,54.95L50.95,54.95z" }))), No = (u) => /* @__PURE__ */ m.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("path", { d: "M0.003125 15.4988C0.04375 15.1957 0.075 14.8895 0.128125 14.5895C0.5375 12.3863 1.6875 10.6645 3.5125 9.36758C4.775 10.5645 6.2625 11.1957 8 11.1926C9.73125 11.1926 11.2156 10.5676 12.4906 9.36133C12.7438 9.56133 13.0094 9.75195 13.2531 9.96758C14.7906 11.3332 15.6969 13.0363 15.9438 15.0832C15.9594 15.2207 15.9812 15.3613 16 15.4988C16 15.6645 16 15.8332 16 15.9988C10.6656 15.9988 5.33437 15.9988 0 15.9988C0.003125 15.8332 0.003125 15.6645 0.003125 15.4988Z", fill: "white" }), /* @__PURE__ */ m.createElement("path", { d: "M8.37828 -0.000976562C8.69391 0.0615234 9.01578 0.102148 9.32203 0.189648C11.197 0.711523 12.5845 2.3709 12.7783 4.31152C13.047 7.00215 11.072 9.36465 8.36891 9.58652C5.93453 9.78965 3.69391 8.05527 3.28141 5.6459C2.83766 3.0709 4.44703 0.670898 7.00015 0.105273C7.2064 0.0583984 7.41891 0.0333984 7.62828 -0.000976562C7.87828 -0.000976563 8.12828 -0.000976562 8.37828 -0.000976562Z", fill: "white" }));
function je(u, e, t) {
  return e in u ? Object.defineProperty(u, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : u[e] = t, u;
}
const cu = 1, As = 2, hs = 4, yu = 8, Nr = 16, Qe = 32, Nu = 64, Or = {
  a: {
    content: cu | yu,
    self: !1,
    type: cu | yu | Qe | Nu
  },
  address: {
    invalid: ["h1", "h2", "h3", "h4", "h5", "h6", "address", "article", "aside", "section", "div", "header", "footer"],
    self: !1
  },
  audio: {
    children: ["track", "source"]
  },
  br: {
    type: cu | yu,
    void: !0
  },
  body: {
    content: cu | As | hs | yu | Nr | Qe | Nu
  },
  button: {
    content: yu,
    type: cu | yu | Qe | Nu
  },
  caption: {
    content: cu,
    parent: ["table"]
  },
  col: {
    parent: ["colgroup"],
    void: !0
  },
  colgroup: {
    children: ["col"],
    parent: ["table"]
  },
  details: {
    children: ["summary"],
    type: cu | Qe | Nu
  },
  dd: {
    content: cu,
    parent: ["dl"]
  },
  dl: {
    children: ["dt", "dd"],
    type: cu
  },
  dt: {
    content: cu,
    invalid: ["footer", "header"],
    parent: ["dl"]
  },
  figcaption: {
    content: cu,
    parent: ["figure"]
  },
  footer: {
    invalid: ["footer", "header"]
  },
  header: {
    invalid: ["footer", "header"]
  },
  hr: {
    type: cu,
    void: !0
  },
  img: {
    void: !0
  },
  li: {
    content: cu,
    parent: ["ul", "ol", "menu"]
  },
  main: {
    self: !1
  },
  ol: {
    children: ["li"],
    type: cu
  },
  picture: {
    children: ["source", "img"],
    type: cu | yu | Nr
  },
  rb: {
    parent: ["ruby", "rtc"]
  },
  rp: {
    parent: ["ruby", "rtc"]
  },
  rt: {
    content: yu,
    parent: ["ruby", "rtc"]
  },
  rtc: {
    content: yu,
    parent: ["ruby"]
  },
  ruby: {
    children: ["rb", "rp", "rt", "rtc"]
  },
  source: {
    parent: ["audio", "video", "picture"],
    void: !0
  },
  summary: {
    content: yu,
    parent: ["details"]
  },
  table: {
    children: ["caption", "colgroup", "thead", "tbody", "tfoot", "tr"],
    type: cu
  },
  tbody: {
    parent: ["table"],
    children: ["tr"]
  },
  td: {
    content: cu,
    parent: ["tr"]
  },
  tfoot: {
    parent: ["table"],
    children: ["tr"]
  },
  th: {
    content: cu,
    parent: ["tr"]
  },
  thead: {
    parent: ["table"],
    children: ["tr"]
  },
  tr: {
    parent: ["table", "tbody", "thead", "tfoot"],
    children: ["th", "td"]
  },
  track: {
    parent: ["audio", "video"],
    void: !0
  },
  ul: {
    children: ["li"],
    type: cu
  },
  video: {
    children: ["track", "source"]
  },
  wbr: {
    type: cu | yu,
    void: !0
  }
};
function se(u) {
  return (e) => {
    Or[e] = {
      ...u,
      ...Or[e]
    };
  };
}
["address", "main", "div", "figure", "p", "pre"].forEach(se({
  content: cu,
  type: cu | Nu
}));
["abbr", "b", "bdi", "bdo", "cite", "code", "data", "dfn", "em", "i", "kbd", "mark", "q", "ruby", "samp", "strong", "sub", "sup", "time", "u", "var"].forEach(se({
  content: yu,
  type: cu | yu | Nu
}));
["p", "pre"].forEach(se({
  content: yu,
  type: cu | Nu
}));
["s", "small", "span", "del", "ins"].forEach(se({
  content: yu,
  type: cu | yu
}));
["article", "aside", "footer", "header", "nav", "section", "blockquote"].forEach(se({
  content: cu,
  type: cu | As | Nu
}));
["h1", "h2", "h3", "h4", "h5", "h6"].forEach(se({
  content: yu,
  type: cu | hs | Nu
}));
["audio", "canvas", "iframe", "img", "video"].forEach(se({
  type: cu | yu | Nr | Nu
}));
const $r = Object.freeze(Or), Oo = ["applet", "base", "body", "command", "embed", "frame", "frameset", "head", "html", "link", "meta", "noscript", "object", "script", "style", "title"], $o = Object.keys($r).filter((u) => u !== "canvas" && u !== "iframe"), Eu = 1, Ro = 2, Te = 3, ce = 4, ms = 5, Rn = Object.freeze({
  alt: Eu,
  cite: Eu,
  class: Eu,
  colspan: Te,
  controls: ce,
  datetime: Eu,
  default: ce,
  disabled: ce,
  dir: Eu,
  height: Eu,
  href: Eu,
  id: Eu,
  kind: Eu,
  label: Eu,
  lang: Eu,
  loading: Eu,
  loop: ce,
  media: Eu,
  muted: ce,
  poster: Eu,
  rel: Eu,
  role: Eu,
  rowspan: Te,
  scope: Eu,
  sizes: Eu,
  span: Te,
  start: Te,
  style: ms,
  src: Eu,
  srclang: Eu,
  srcset: Eu,
  tabindex: Eu,
  target: Eu,
  title: Eu,
  type: Eu,
  width: Eu
}), Io = Object.freeze({
  class: "className",
  colspan: "colSpan",
  datetime: "dateTime",
  rowspan: "rowSpan",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex"
});
function ft() {
  return ft = Object.assign || function(u) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (u[n] = t[n]);
    }
    return u;
  }, ft.apply(this, arguments);
}
function gs({
  attributes: u = {},
  className: e,
  children: t = null,
  selfClose: n = !1,
  tagName: s
}) {
  const i = s;
  return n ? /* @__PURE__ */ uu.createElement(i, ft({
    className: e
  }, u)) : /* @__PURE__ */ uu.createElement(i, ft({
    className: e
  }, u), t);
}
class Lo {
  /**
   * Filter and clean an HTML attribute value.
   */
  attribute(e, t) {
    return t;
  }
  /**
   * Filter and clean an HTML node.
   */
  node(e, t) {
    return t;
  }
}
function Mo(u, e, t, n = !1) {
  const s = u.match(e instanceof RegExp ? e : new RegExp(e, "i"));
  return s ? {
    match: s[0],
    void: n,
    ...t(s),
    index: s.index,
    length: s[0].length,
    valid: !0
  } : null;
}
class Me {
  constructor(e, t, n) {
    if (je(this, "greedy", !1), je(this, "options", void 0), je(this, "propName", void 0), je(this, "inverseName", void 0), je(this, "factory", void 0), process.env.NODE_ENV !== "production" && (!e || e.toLowerCase() === "html"))
      throw new Error(`The matcher name "${e}" is not allowed.`);
    this.options = {
      ...t
    }, this.propName = e, this.inverseName = `no${e.charAt(0).toUpperCase() + e.slice(1)}`, this.factory = n ?? null;
  }
  /**
   * Attempts to create a React element using a custom user provided factory,
   * or the default matcher factory.
   */
  createElement(e, t) {
    const n = this.factory ? /* @__PURE__ */ uu.createElement(this.factory, t, e) : this.replaceWith(e, t);
    if (process.env.NODE_ENV !== "production" && typeof n != "string" && !/* @__PURE__ */ uu.isValidElement(n))
      throw new Error(`Invalid React element created from ${this.constructor.name}.`);
    return n;
  }
  /**
   * Trigger the actual pattern match and package the matched
   * response through a callback.
   */
  doMatch(e, t, n, s = !1) {
    return Mo(e, t, n, s);
  }
  /**
   * Callback triggered before parsing.
   */
  onBeforeParse(e, t) {
    return e;
  }
  /**
   * Callback triggered after parsing.
   */
  onAfterParse(e, t) {
    return e;
  }
  /**
   * Replace the match with a React element based on the matched token and optional props.
   */
}
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */
var Gt, In;
function zo() {
  if (In) return Gt;
  In = 1;
  var u = /["'&<>]/;
  Gt = e;
  function e(t) {
    var n = "" + t, s = u.exec(n);
    if (!s)
      return n;
    var i, a = "", D = 0, o = 0;
    for (D = s.index; D < n.length; D++) {
      switch (n.charCodeAt(D)) {
        case 34:
          i = "&quot;";
          break;
        case 38:
          i = "&amp;";
          break;
        case 39:
          i = "&#39;";
          break;
        case 60:
          i = "&lt;";
          break;
        case 62:
          i = "&gt;";
          break;
        default:
          continue;
      }
      o !== D && (a += n.substring(o, D)), o = D + 1, a += i;
    }
    return o !== D ? a + n.substring(o, D) : a;
  }
  return Gt;
}
var Uo = zo();
const Ho = /* @__PURE__ */ ne(Uo);
function Ru(u, e, t) {
  return e in u ? Object.defineProperty(u, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : u[e] = t, u;
}
const Vo = /(url|image|image-set)\(/i;
class Wo extends Lo {
  attribute(e, t) {
    return e === "style" && Object.keys(t).forEach((n) => {
      String(t[n]).match(Vo) && delete t[n];
    }), t;
  }
}
const Ln = 1, qo = 3, Go = /^<(!doctype|(html|head|body)(\s|>))/i, Yo = /^(aria-|data-|\w+:)/iu, Zo = /{{{(\w+)\/?}}}/;
function Ko() {
  if (!(typeof window > "u" || typeof document > "u"))
    return document.implementation.createHTMLDocument("Interweave");
}
class Bs {
  constructor(e, t = {}, n = [], s = []) {
    var i;
    if (Ru(this, "allowed", void 0), Ru(this, "banned", void 0), Ru(this, "blocked", void 0), Ru(this, "container", void 0), Ru(this, "content", []), Ru(this, "props", void 0), Ru(this, "matchers", void 0), Ru(this, "filters", void 0), Ru(this, "keyIndex", void 0), process.env.NODE_ENV !== "production" && e && typeof e != "string")
      throw new TypeError("Interweave parser requires a valid string.");
    this.props = t, this.matchers = n, this.filters = [...s, new Wo()], this.keyIndex = -1, this.container = this.createContainer(e || ""), this.allowed = new Set((i = t.allowList) !== null && i !== void 0 ? i : $o), this.banned = new Set(Oo), this.blocked = new Set(t.blockList);
  }
  /**
   * Loop through and apply all registered attribute filters.
   */
  applyAttributeFilters(e, t) {
    return this.filters.reduce((n, s) => n !== null && typeof s.attribute == "function" ? s.attribute(e, n) : n, t);
  }
  /**
   * Loop through and apply all registered node filters.
   */
  applyNodeFilters(e, t) {
    return this.filters.reduce((n, s) => n !== null && typeof s.node == "function" ? s.node(e, n) : n, t);
  }
  /**
   * Loop through and apply all registered matchers to the string.
   * If a match is found, create a React element, and build a new array.
   * This array allows React to interpolate and render accordingly.
   */
  applyMatchers(e, t) {
    const n = {}, {
      props: s
    } = this;
    let i = e, a = 0, D = null;
    return this.matchers.forEach((o) => {
      const d = o.asTag().toLowerCase(), x = this.getTagConfig(d);
      if (s[o.inverseName] || !this.isTagAllowed(d) || !this.canRenderChild(t, x))
        return;
      let c = "";
      for (; i && (D = o.match(i)); ) {
        const {
          index: h,
          length: F,
          match: C,
          valid: f,
          void: y,
          ...B
        } = D, l = o.propName + String(a);
        h > 0 && (c += i.slice(0, h)), f ? (c += y ? `{{{${l}/}}}` : `{{{${l}}}}${C}{{{/${l}}}}`, this.keyIndex += 1, a += 1, n[l] = {
          children: C,
          matcher: o,
          props: {
            ...s,
            ...B,
            key: this.keyIndex
          }
        }) : c += C, o.greedy ? (i = c + i.slice(h + F), c = "") : i = i.slice(h + (F || C.length));
      }
      o.greedy || (i = c + i);
    }), a === 0 ? e : this.replaceTokens(i, n);
  }
  /**
   * Determine whether the child can be rendered within the parent.
   */
  canRenderChild(e, t) {
    return !e.tagName || !t.tagName || e.void ? !1 : e.children.length > 0 ? e.children.includes(t.tagName) : e.invalid.length > 0 && e.invalid.includes(t.tagName) ? !1 : t.parent.length > 0 ? t.parent.includes(e.tagName) : !e.self && e.tagName === t.tagName ? !1 : !!(e && e.content & t.type);
  }
  /**
   * Convert line breaks in a string to HTML `<br/>` tags.
   * If the string contains HTML, we should not convert anything,
   * as line breaks should be handled by `<br/>`s in the markup itself.
   */
  convertLineBreaks(e) {
    const {
      noHtml: t,
      disableLineBreaks: n
    } = this.props;
    if (t || n || e.match(/<((?:\/[ a-z]+)|(?:[ a-z]+\/))>/gi))
      return e;
    let s = e.replace(/\r\n/g, `
`);
    return s = s.replace(/\n{3,}/g, `


`), s = s.replace(/\n/g, "<br/>"), s;
  }
  /**
   * Create a detached HTML document that allows for easy HTML
   * parsing while not triggering scripts or loading external
   * resources.
   */
  createContainer(e) {
    var t;
    const s = (typeof global < "u" && global.INTERWEAVE_SSR_POLYFILL || Ko)();
    if (!s)
      return;
    const i = (t = this.props.containerTagName) !== null && t !== void 0 ? t : "body", a = i === "body" || i === "fragment" ? s.body : s.createElement(i);
    if (e.match(Go)) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("HTML documents as Interweave content are not supported.");
    } else
      a.innerHTML = this.convertLineBreaks(this.props.escapeHtml ? Ho(e) : e);
    return a;
  }
  /**
   * Convert an elements attribute map to an object map.
   * Returns null if no attributes are defined.
   */
  extractAttributes(e) {
    const {
      allowAttributes: t
    } = this.props, n = {};
    let s = 0;
    return e.nodeType !== Ln || !e.attributes || ([...e.attributes].forEach((i) => {
      const {
        name: a,
        value: D
      } = i, o = a.toLowerCase(), d = Rn[o] || Rn[a];
      if (!this.isSafe(e) || !o.match(Yo) && (!t && (!d || d === Ro) || o.startsWith("on") || D.replace(/(\s|\0|&#x0([9AD]);)/, "").match(/(javascript|vbscript|livescript|xss):/i)))
        return;
      let x = o === "style" ? this.extractStyleAttribute(e) : D;
      d === ce ? x = !0 : d === Te ? x = Number.parseFloat(String(x)) : d !== ms && (x = String(x)), n[Io[o] || o] = this.applyAttributeFilters(o, x), s += 1;
    }), s === 0) ? null : n;
  }
  /**
   * Extract the style attribute as an object and remove values that allow for attack vectors.
   */
  extractStyleAttribute(e) {
    const t = {};
    return Array.from(e.style).forEach((n) => {
      const s = e.style[n];
      (typeof s == "string" || typeof s == "number") && (t[n.replace(/-([a-z])/g, (i, a) => String(a).toUpperCase())] = s);
    }), t;
  }
  /**
   * Return configuration for a specific tag.
   */
  getTagConfig(e) {
    const t = {
      children: [],
      content: 0,
      invalid: [],
      parent: [],
      self: !0,
      tagName: "",
      type: 0,
      void: !1
    };
    return $r[e] ? {
      ...t,
      ...$r[e],
      tagName: e
    } : t;
  }
  /**
   * Verify that a node is safe from XSS and injection attacks.
   */
  isSafe(e) {
    if (typeof HTMLAnchorElement < "u" && e instanceof HTMLAnchorElement) {
      const t = e.getAttribute("href");
      if (t != null && t.startsWith("#"))
        return !0;
      const n = e.protocol.toLowerCase();
      return n === ":" || n === "http:" || n === "https:" || n === "mailto:" || n === "tel:";
    }
    return !0;
  }
  /**
   * Verify that an HTML tag is allowed to render.
   */
  isTagAllowed(e) {
    return this.banned.has(e) || this.blocked.has(e) ? !1 : this.props.allowElements || this.allowed.has(e);
  }
  /**
   * Parse the markup by injecting it into a detached document,
   * while looping over all child nodes and generating an
   * array to interpolate into JSX.
   */
  parse() {
    return this.container ? this.parseNode(this.container, this.getTagConfig(this.container.nodeName.toLowerCase())) : [];
  }
  /**
   * Loop over the nodes children and generate a
   * list of text nodes and React elements.
   */
  parseNode(e, t) {
    const {
      noHtml: n,
      noHtmlExceptMatchers: s,
      allowElements: i,
      transform: a,
      transformOnlyAllowList: D
    } = this.props;
    let o = [], d = "";
    return [...e.childNodes].forEach((x) => {
      if (x.nodeType === Ln) {
        const h = x.nodeName.toLowerCase(), F = this.getTagConfig(h);
        d && (o.push(d), d = "");
        const C = this.applyNodeFilters(h, x);
        if (!C)
          return;
        let f;
        if (a && !(D && !this.isTagAllowed(h))) {
          this.keyIndex += 1;
          const y = this.keyIndex;
          f = this.parseNode(C, F);
          const B = a(C, f, F);
          if (B === null)
            return;
          if (typeof B < "u") {
            o.push(/* @__PURE__ */ uu.cloneElement(B, {
              key: y
            }));
            return;
          }
          this.keyIndex = y - 1;
        }
        if (this.banned.has(h))
          return;
        if (!(n || s && h !== "br") && this.isTagAllowed(h) && (i || this.canRenderChild(t, F))) {
          var c;
          this.keyIndex += 1;
          const y = this.extractAttributes(C), B = {
            tagName: h
          };
          y && (B.attributes = y), F.void && (B.selfClose = F.void), o.push(/* @__PURE__ */ uu.createElement(gs, {
            ...B,
            key: this.keyIndex
          }, (c = f) !== null && c !== void 0 ? c : this.parseNode(C, F)));
        } else
          o = [...o, ...this.parseNode(C, F.tagName ? F : t)];
      } else if (x.nodeType === qo) {
        const h = n && !s ? x.textContent : (
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
          this.applyMatchers(x.textContent || "", t)
        );
        Array.isArray(h) ? o = [...o, ...h] : d += h;
      }
    }), d && o.push(d), o;
  }
  /**
   * Deconstruct the string into an array, by replacing custom tokens with React elements,
   * so that React can render it correctly.
   */
  replaceTokens(e, t) {
    if (!e.includes("{{{"))
      return e;
    const n = [];
    let s = e, i = null;
    for (; i = s.match(Zo); ) {
      const [a, D] = i, o = i.index, d = a.includes("/");
      if (process.env.NODE_ENV !== "production" && !t[D])
        throw new Error(`Token "${D}" found but no matching element to replace with.`);
      o > 0 && (n.push(s.slice(0, o)), s = s.slice(o));
      const {
        children: x,
        matcher: c,
        props: h
      } = t[D];
      let F;
      if (d)
        F = a.length, n.push(c.createElement(x, h));
      else {
        const C = s.match(new RegExp(`{{{/${D}}}}`));
        if (process.env.NODE_ENV !== "production" && !C)
          throw new Error(`Closing token missing for interpolated element "${D}".`);
        F = C.index + C[0].length, n.push(c.createElement(this.replaceTokens(s.slice(a.length, C.index), t), h));
      }
      s = s.slice(F);
    }
    return s.length > 0 && n.push(s), n.length === 0 ? "" : n.length === 1 && typeof n[0] == "string" ? n[0] : n;
  }
}
function Jo(u) {
  var e;
  const {
    attributes: t,
    className: n,
    containerTagName: s,
    content: i,
    emptyContent: a,
    parsedContent: D,
    tagName: o,
    noWrap: d
  } = u, x = (e = s ?? o) !== null && e !== void 0 ? e : "span", c = x === "fragment" ? !0 : d;
  let h;
  if (D)
    h = D;
  else {
    const F = new Bs(i ?? "", u).parse();
    F.length > 0 && (h = F);
  }
  return h || (h = a), c ? /* @__PURE__ */ uu.createElement(uu.Fragment, null, h) : /* @__PURE__ */ uu.createElement(gs, {
    attributes: t,
    className: n,
    tagName: x
  }, h);
}
function Xo(u) {
  const {
    attributes: e,
    className: t,
    content: n = "",
    disableFilters: s = !1,
    disableMatchers: i = !1,
    emptyContent: a = null,
    filters: D = [],
    matchers: o = [],
    onAfterParse: d = null,
    onBeforeParse: x = null,
    tagName: c = "span",
    noWrap: h = !1,
    ...F
  } = u, C = i ? [] : o, f = s ? [] : D, y = x ? [x] : [], B = d ? [d] : [];
  C.forEach((A) => {
    A.onBeforeParse && y.push(A.onBeforeParse.bind(A)), A.onAfterParse && B.push(A.onAfterParse.bind(A));
  });
  const l = y.reduce((A, b) => {
    const w = b(A, u);
    if (process.env.NODE_ENV !== "production" && typeof w != "string")
      throw new TypeError("Interweave `onBeforeParse` must return a valid HTML string.");
    return w;
  }, n ?? ""), p = new Bs(l, F, C, f), E = B.reduce((A, b) => {
    const w = b(A, u);
    if (process.env.NODE_ENV !== "production" && !Array.isArray(w))
      throw new TypeError("Interweave `onAfterParse` must return an array of strings and React elements.");
    return w;
  }, p.parse());
  return /* @__PURE__ */ uu.createElement(Jo, {
    attributes: e,
    className: t,
    containerTagName: u.containerTagName,
    emptyContent: a,
    noWrap: h,
    parsedContent: E.length === 0 ? void 0 : E,
    tagName: c
  });
}
function wu(u, e = {}) {
  var t, n;
  let s = u.map((i) => i.source).join((t = e.join) !== null && t !== void 0 ? t : "");
  return e.capture ? s = `(${s})` : e.nonCapture && (s = `(?:${s})`), e.match && (s += e.match), new RegExp(s, (n = e.flags) !== null && n !== void 0 ? n : "");
}
const Mn = /[a-z0-9]/, xs = /(?:[a-zA-Z\u0400-\u04FF0-9\-_~!$&'()[\]\\/*+,;=.%]*)/, ys = /(https?:\/\/)?/, vs = wu([
  /[a-z\u0400-\u04FF0-9\-_~!$&'()*+,;=.:]+/,
  // Includes colon
  /@/
], {
  capture: !0,
  match: "?"
}), bs = wu([
  /(?:(?:[a-z0-9](?:[-a-z0-9_]*[a-z0-9])?)\.)*/,
  // Subdomain
  /(?:(?:[a-z0-9](?:[-a-z0-9]*[a-z0-9])?)\.)/,
  // Domain
  /(?:[a-z](?:[-a-z0-9]*[a-z0-9])?)/
  // TLD
], {
  capture: !0
}), ws = /(?::(\d{1,5}))?/, js = wu([/\//, wu([
  /[-+a-z0-9!*';:=,.$/%[\]_~@|&]*/,
  /[-+a-z0-9/]/
  // Valid ending chars
], {
  match: "*",
  nonCapture: !0
})], {
  capture: !0,
  match: "?"
}), _s = wu([/\?/, wu([
  xs,
  /[a-z0-9_&=]/
  // Valid ending chars
], {
  match: "?",
  nonCapture: !0
})], {
  capture: !0,
  match: "?"
}), Ss = wu([/#/, wu([
  xs,
  /[a-z0-9]/
  // Valid ending chars
], {
  match: "?",
  nonCapture: !0
})], {
  capture: !0,
  match: "?"
}), Qo = wu([ys, vs, bs, ws, js, _s, Ss], {
  flags: "i"
}), ut = /(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/, uD = wu([ut, ut, ut, ut], {
  capture: !0,
  join: "\\."
});
wu([ys, vs, uD, ws, js, _s, Ss], {
  flags: "i"
});
const eD = [
  // Chinese
  /[\d_\u4E00-\u9FFF-]+/,
  // Japanese
  /[\d_\u3000-\u30FF-]+/,
  // Korean
  /[\d_\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7FF-]+/,
  // Thai
  /[\d_\u0E00-\u0E7F-]+/,
  // Russian, Ukrainian
  // eslint-disable-next-line no-misleading-character-class
  /[\d_a-z\u0400-\u052F\u1C80-\u1C8F\u2DE0-\u2DFF\uA640-\uA69F-]+/,
  // Latin based
  /[\d_a-z\u0080-\u00FF\u0100-\u017F\u0180-\u024F-]+/
];
wu([/#/, wu(eD, {
  capture: !0,
  join: "|"
})], {
  flags: "i"
});
const tD = /[.a-z0-9!#$%&?*+=_{|}~-]*/, rD = wu([Mn, tD, Mn], {
  capture: !0
}), zn = wu([rD, bs], {
  flags: "i",
  join: "@"
}), nD = new RegExp(`^${zn.source}$`, zn.flags), sD = [
  // Original
  "com",
  "org",
  "net",
  "int",
  "edu",
  "gov",
  "mil",
  // Sponsored
  "aero",
  "asia",
  "biz",
  "cat",
  "coop",
  "jobs",
  "mobi",
  "museum",
  "post",
  "tel",
  "travel",
  "xxx",
  // Misc
  "app",
  "arpa",
  "test",
  // Countries
  "ac",
  // Ascension Island
  "ad",
  // Andorra
  "ae",
  // United Arab Emirates
  "af",
  // Afghanistan
  "ag",
  // Antigua and Barbuda
  "ai",
  // Anguilla
  "al",
  // Albania
  "am",
  // Armenia
  "an",
  // Netherlands Antilles
  "ao",
  // Angola
  "aq",
  // Antarctica
  "ar",
  // Argentina
  "as",
  // American Samoa
  "at",
  // Austria
  "au",
  // Australia
  "aw",
  // Aruba
  "ax",
  // Aland Islands
  "az",
  // Azerbaijan
  "ba",
  // Bosnia and Herzegovina
  "bb",
  // Barbados
  "bd",
  // Bangladesh
  "be",
  // Belgium
  "bf",
  // Burkina Faso
  "bg",
  // Bulgaria
  "bh",
  // Bahrain
  "bi",
  // Burundi
  "bj",
  // Benin
  "bl",
  // Saint Barthelemy
  "bm",
  // Bermuda
  "bn",
  // Brunei Darussalam
  "bo",
  // Bolivia
  "bq",
  // Bonaire, Sint Eustatius and Saba
  "br",
  // Brazil
  "bs",
  // Bahamas
  "bt",
  // Bhutan
  "bv",
  // Bouvet Island
  "bw",
  // Botswana
  "by",
  // Belarus
  "bz",
  // Belize
  "ca",
  // Canada
  "cc",
  // Cocos (Keeling) Islands
  "cd",
  // Congo, The Democratic Republic of the
  "cf",
  // Central African Republic
  "cg",
  // Congo
  "ch",
  // Switzerland
  "ci",
  // Cote d'Ivoire
  "ck",
  // Cook Islands
  "cl",
  // Chile
  "cm",
  // Cameroon
  "cn",
  // China
  "co",
  // Colombia
  "cr",
  // Costa Rica
  "cu",
  // Cuba
  "cv",
  // Cape Verde
  "cw",
  // Curaçao
  "cx",
  // Christmas Island
  "cy",
  // Cyprus
  "cz",
  // Czech Republic
  "de",
  // Germany
  "dj",
  // Djibouti
  "dk",
  // Denmark
  "dm",
  // Dominica
  "do",
  // Dominican Republic
  "dz",
  // Algeria
  "ec",
  // Ecuador
  "ee",
  // Estonia
  "eg",
  // Egypt
  "eh",
  // Western Sahara
  "er",
  // Eritrea
  "es",
  // Spain
  "et",
  // Ethiopia
  "eu",
  // European Union
  "fi",
  // Finland
  "fj",
  // Fiji
  "fk",
  // Falkland Islands (Malvinas)
  "fm",
  // Micronesia, Federated States of
  "fo",
  // Faroe Islands
  "fr",
  // France
  "ga",
  // Gabon
  "gb",
  // United Kingdom
  "gd",
  // Grenada
  "ge",
  // Georgia
  "gf",
  // French Guiana
  "gg",
  // Guernsey
  "gh",
  // Ghana
  "gi",
  // Gibraltar
  "gl",
  // Greenland
  "gm",
  // Gambia
  "gn",
  // Guinea
  "gp",
  // Guadeloupe
  "gq",
  // Equatorial Guinea
  "gr",
  // Greece
  "gs",
  // South Georgia and the South Sandwich Islands
  "gt",
  // Guatemala
  "gu",
  // Guam
  "gw",
  // Guinea-Bissau
  "gy",
  // Guyana
  "hk",
  // Hong Kong
  "hm",
  // Heard Island and McDonald Islands
  "hn",
  // Honduras
  "hr",
  // Croatia
  "ht",
  // Haiti
  "hu",
  // Hungary
  "id",
  // Indonesia
  "ie",
  // Ireland
  "il",
  // Israel
  "im",
  // Isle of Man
  "in",
  // India
  "io",
  // British Indian Ocean Territory
  "iq",
  // Iraq
  "ir",
  // Iran, Islamic Republic of
  "is",
  // Iceland
  "it",
  // Italy
  "je",
  // Jersey
  "jm",
  // Jamaica
  "jo",
  // Jordan
  "jp",
  // Japan
  "ke",
  // Kenya
  "kg",
  // Kyrgyzstan
  "kh",
  // Cambodia
  "ki",
  // Kiribati
  "km",
  // Comoros
  "kn",
  // Saint Kitts and Nevis
  "kp",
  // Korea, Democratic People's Republic of
  "kr",
  // Korea, Republic of
  "kw",
  // Kuwait
  "ky",
  // Cayman Islands
  "kz",
  // Kazakhstan
  "la",
  // Lao People's Democratic Republic
  "lb",
  // Lebanon
  "lc",
  // Saint Lucia
  "li",
  // Liechtenstein
  "lk",
  // Sri Lanka
  "lr",
  // Liberia
  "ls",
  // Lesotho
  "lt",
  // Lithuania
  "lu",
  // Luxembourg
  "lv",
  // Latvia
  "ly",
  // Libyan Arab Jamahiriya
  "ma",
  // Morocco
  "mc",
  // Monaco
  "md",
  // Moldova, Republic of
  "me",
  // Montenegro
  "mf",
  // Saint Martin (French part)
  "mg",
  // Madagascar
  "mh",
  // Marshall Islands
  "mk",
  // Macedonia, The Former Yugoslav Republic of
  "ml",
  // Mali
  "mm",
  // Myanmar
  "mn",
  // Mongolia
  "mo",
  // Macao
  "mp",
  // Northern Mariana Islands
  "mq",
  // Martinique
  "mr",
  // Mauritania
  "ms",
  // Montserrat
  "mt",
  // Malta
  "mu",
  // Mauritius
  "mv",
  // Maldives
  "mw",
  // Malawi
  "mx",
  // Mexico
  "my",
  // Malaysia
  "mz",
  // Mozambique
  "na",
  // Namibia
  "nc",
  // New Caledonia
  "ne",
  // Niger
  "nf",
  // Norfolk Island
  "ng",
  // Nigeria
  "ni",
  // Nicaragua
  "nl",
  // Netherlands
  "no",
  // Norway
  "np",
  // Nepal
  "nr",
  // Nauru
  "nu",
  // Niue
  "nz",
  // New Zealand
  "om",
  // Oman
  "pa",
  // Panama
  "pe",
  // Peru
  "pf",
  // French Polynesia
  "pg",
  // Papua New Guinea
  "ph",
  // Philippines
  "pk",
  // Pakistan
  "pl",
  // Poland
  "pm",
  // Saint Pierre and Miquelon
  "pn",
  // Pitcairn
  "pr",
  // Puerto Rico
  "ps",
  // Palestinian Territory, Occupied
  "pt",
  // Portugal
  "pw",
  // Palau
  "py",
  // Paraguay
  "qa",
  // Qatar
  "re",
  // Reunion
  "ro",
  // Romania
  "rs",
  // Serbia
  "ru",
  // Russian Federation
  "rw",
  // Rwanda
  "sa",
  // Saudi Arabia
  "sb",
  // Solomon Islands
  "sc",
  // Seychelles
  "sd",
  // Sudan
  "se",
  // Sweden
  "sg",
  // Singapore
  "sh",
  // Saint Helena
  "si",
  // Slovenia
  "sj",
  // Svalbard and Jan Mayen
  "sk",
  // Slovakia
  "sl",
  // Sierra Leone
  "sm",
  // San Marino
  "sn",
  // Senegal
  "so",
  // Somalia
  "sr",
  // Suriname
  "st",
  // Sao Tome and Principe
  "su",
  // Soviet Union (being phased out)
  "sv",
  // El Salvador
  "sx",
  // Sint Maarten (Dutch part)
  "sy",
  // Syrian Arab Republic
  "sz",
  // Swaziland
  "tc",
  // Turks and Caicos Islands
  "td",
  // Chad
  "tf",
  // French Southern Territories
  "tg",
  // Togo
  "th",
  // Thailand
  "tj",
  // Tajikistan
  "tk",
  // Tokelau
  "tl",
  // Timor-Leste
  "tm",
  // Turkmenistan
  "tn",
  // Tunisia
  "to",
  // Tonga
  "tp",
  // Portuguese Timor (being phased out)
  "tr",
  // Turkey
  "tt",
  // Trinidad and Tobago
  "tv",
  // Tuvalu
  "tw",
  // Taiwan, Province of China
  "tz",
  // Tanzania, United Republic of
  "ua",
  // Ukraine
  "ug",
  // Uganda
  "uk",
  // United Kingdom
  "um",
  // United States Minor Outlying Islands
  "us",
  // United States
  "uy",
  // Uruguay
  "uz",
  // Uzbekistan
  "va",
  // Holy See (Vatican City State)
  "vc",
  // Saint Vincent and the Grenadines
  "ve",
  // Venezuela, Bolivarian Republic of
  "vg",
  // Virgin Islands, British
  "vi",
  // Virgin Islands, U.S.
  "vn",
  // Viet Nam
  "vu",
  // Vanuatu
  "wf",
  // Wallis and Futuna
  "ws",
  // Samoa
  "ye",
  // Yemen
  "yt",
  // Mayotte
  "za",
  // South Africa
  "zm",
  // Zambia
  "zw"
  // Zimbabwe
];
function Rr() {
  return Rr = Object.assign || function(u) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (u[n] = t[n]);
    }
    return u;
  }, Rr.apply(this, arguments);
}
function iD({
  children: u,
  href: e,
  onClick: t,
  newWindow: n
}) {
  return /* @__PURE__ */ uu.createElement("a", {
    href: e,
    rel: "noopener noreferrer",
    target: n ? "_blank" : void 0,
    onClick: t
  }, u);
}
function aD({
  children: u,
  url: e,
  urlParts: t,
  ...n
}) {
  let s = e;
  return s.match(/^https?:\/\//) || (s = `http://${s}`), /* @__PURE__ */ uu.createElement(iD, Rr({}, n, {
    href: s
  }), u);
}
class oD extends Me {
  constructor(e, t, n) {
    super(e, {
      customTLDs: [],
      validateTLD: !0,
      ...t
    }, n);
  }
  replaceWith(e, t) {
    return /* @__PURE__ */ uu.createElement(aD, t, e);
  }
  asTag() {
    return "a";
  }
  match(e) {
    const t = this.doMatch(e, Qo, this.handleMatches);
    if (t != null && t.match.match(nD) && (t.valid = !1), t != null && t.valid && this.options.validateTLD) {
      var n;
      const {
        host: s
      } = t.urlParts, i = [...sD, ...(n = this.options.customTLDs) !== null && n !== void 0 ? n : []], a = s.slice(s.lastIndexOf(".") + 1).toLowerCase();
      if (!i.includes(a))
        return null;
    }
    return t;
  }
  /**
   * Package the matched response.
   */
  handleMatches(e) {
    return {
      url: e[0],
      urlParts: {
        auth: e[2] ? e[2].slice(0, -1) : "",
        fragment: e[7] || "",
        host: e[3],
        path: e[5] || "",
        port: e[4] ? e[4] : "",
        query: e[6] || "",
        scheme: e[1] ? e[1].replace("://", "") : "http"
      }
    };
  }
}
/*!
 * XRegExp 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2007-present MIT License
 */
const fu = "xregexp", re = {
  astral: !1,
  namespacing: !0
}, Ou = {};
let ke = /* @__PURE__ */ Object.create(null), Fe = /* @__PURE__ */ Object.create(null);
const Ir = [], pe = "default", Un = "class", DD = {
  // Any native multicharacter token in default scope, or any single character
  default: /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
  // Any native multicharacter token in character class scope, or any single character
  class: /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
}, lD = /\$(?:\{([^\}]+)\}|<([^>]+)>|(\d\d?|[\s\S]?))/g, cD = /()??/.exec("")[1] === void 0, FD = /x/.flags !== void 0;
function ze(u) {
  let e = !0;
  try {
    if (new RegExp("", u), u === "y") {
      const t = "gy";
      ".a".replace(new RegExp("a", t), ".") === ".." && (e = !1);
    }
  } catch {
    e = !1;
  }
  return e;
}
const dD = ze("d"), Kr = ze("s"), Ps = ze("u"), Jr = ze("y"), Ts = {
  d: dD,
  g: !0,
  i: !0,
  m: !0,
  s: Kr,
  u: Ps,
  y: Jr
}, pD = Kr ? /[^dgimsuy]+/g : /[^dgimuy]+/g;
function ks(u, e, t, n, s) {
  if (u[fu] = {
    captureNames: e
  }, s)
    return u;
  if (u.__proto__)
    u.__proto__ = H.prototype;
  else
    for (const i in H.prototype)
      u[i] = H.prototype[i];
  return u[fu].source = t, u[fu].flags = n && n.split("").sort().join(""), u;
}
function Re(u) {
  return u.replace(/([\s\S])(?=[\s\S]*\1)/g, "");
}
function ie(u, e) {
  if (!H.isRegExp(u))
    throw new TypeError("Type RegExp expected");
  const t = u[fu] || {};
  let n = ED(u), s = "", i = "", a = null, D = null;
  return e = e || {}, e.removeG && (i += "g"), e.removeY && (i += "y"), i && (n = n.replace(new RegExp(`[${i}]+`, "g"), "")), e.addG && (s += "g"), e.addY && (s += "y"), s && (n = Re(n + s)), e.isInternalOnly || (t.source !== void 0 && (a = t.source), t.flags != null && (D = s ? Re(t.flags + s) : t.flags)), u = ks(
    new RegExp(e.source || u.source, n),
    CD(u) ? t.captureNames.slice(0) : null,
    a,
    D,
    e.isInternalOnly
  ), u;
}
function Ns(u) {
  return parseInt(u, 16);
}
function Os(u, e, t) {
  const n = u.index + u[0].length, s = u.input[u.index - 1], i = u.input[n];
  return (
    // No need to separate tokens if at the beginning or end of a group, before or after a
    // group, or before or after a `|`
    /^[()|]$/.test(s) || /^[()|]$/.test(i) || // No need to separate tokens if at the beginning or end of the pattern
    u.index === 0 || n === u.input.length || // No need to separate tokens if at the beginning of a noncapturing group or lookaround.
    // Looks only at the last 4 chars (at most) for perf when constructing long regexes.
    /\(\?(?:[:=!]|<[=!])$/.test(u.input.substring(u.index - 4, u.index)) || // Avoid separating tokens when the following token is a quantifier
    fD(u.input, n, t) ? "" : "(?:)"
  );
}
function ED(u) {
  return FD ? u.flags : (
    // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or concatenation
    // with an empty string) allows this to continue working predictably when
    // `XRegExp.proptotype.toString` is overridden
    /\/([a-z]*)$/i.exec(RegExp.prototype.toString.call(u))[1]
  );
}
function CD(u) {
  return !!(u[fu] && u[fu].captureNames);
}
function Xr(u) {
  return parseInt(u, 10).toString(16);
}
function fD(u, e, t) {
  const n = "\\(\\?#[^)]*\\)", s = "#[^#\\n]*", i = "[?*+]|{\\d+(?:,\\d*)?}";
  return (t.includes("x") ? (
    // Ignore any leading whitespace, line comments, and inline comments
    new RegExp(`^(?:\\s|${s}|${n})*(?:${i})`)
  ) : (
    // Ignore any leading inline comments
    new RegExp(`^(?:${n})*(?:${i})`)
  )).test(u.slice(e));
}
function At(u, e) {
  return Object.prototype.toString.call(u) === `[object ${e}]`;
}
function ge(u) {
  if (u == null)
    throw new TypeError("Cannot convert null or undefined to object");
  return u;
}
function Qr(u) {
  for (; u.length < 4; )
    u = `0${u}`;
  return u;
}
function AD(u, e) {
  if (Re(e) !== e)
    throw new SyntaxError(`Invalid duplicate regex flag ${e}`);
  u = u.replace(/^\(\?([\w$]+)\)/, (t, n) => {
    if (/[dgy]/.test(n))
      throw new SyntaxError(`Cannot use flags dgy in mode modifier ${t}`);
    return e = Re(e + n), "";
  });
  for (const t of e)
    if (!Ts[t])
      throw new SyntaxError(`Unknown regex flag ${t}`);
  return {
    pattern: u,
    flags: e
  };
}
function $s(u) {
  const e = {};
  return At(u, "String") ? (H.forEach(u, /[^\s,]+/, (t) => {
    e[t] = !0;
  }), e) : u;
}
function Hn(u) {
  if (!/^[\w$]$/.test(u))
    throw new Error("Flag must be a single character A-Za-z0-9_$");
  Ts[u] = !0;
}
function hD(u, e, t, n, s) {
  let i = Ir.length;
  const a = u[t];
  let D = null, o, d;
  for (; i--; )
    if (d = Ir[i], !(d.leadChar && d.leadChar !== a || d.scope !== n && d.scope !== "all" || d.flag && !e.includes(d.flag)) && (o = H.exec(u, d.regex, t, "sticky"), o)) {
      D = {
        matchLength: o[0].length,
        output: d.handler.call(s, o, n, e),
        reparse: d.reparse
      };
      break;
    }
  return D;
}
function Rs(u) {
  re.astral = u;
}
function Is(u) {
  re.namespacing = u;
}
function H(u, e) {
  if (H.isRegExp(u)) {
    if (e !== void 0)
      throw new TypeError("Cannot supply flags when copying a RegExp");
    return ie(u);
  }
  if (u = u === void 0 ? "" : String(u), e = e === void 0 ? "" : String(e), H.isInstalled("astral") && !e.includes("A") && (e += "A"), Fe[u] || (Fe[u] = {}), !Fe[u][e]) {
    const n = {
      hasNamedCapture: !1,
      captureNames: []
    };
    let s = pe, i = "", a = 0, D;
    const o = AD(u, e);
    let d = o.pattern;
    const x = o.flags;
    for (; a < d.length; ) {
      do
        D = hD(d, x, a, s, n), D && D.reparse && (d = d.slice(0, a) + D.output + d.slice(a + D.matchLength));
      while (D && D.reparse);
      if (D)
        i += D.output, a += D.matchLength || 1;
      else {
        const [c] = H.exec(d, DD[s], a, "sticky");
        i += c, a += c.length, c === "[" && s === pe ? s = Un : c === "]" && s === Un && (s = pe);
      }
    }
    Fe[u][e] = {
      // Use basic cleanup to collapse repeated empty groups like `(?:)(?:)` to `(?:)`. Empty
      // groups are sometimes inserted during regex transpilation in order to keep tokens
      // separated. However, more than one empty group in a row is never needed.
      pattern: i.replace(/(?:\(\?:\))+/g, "(?:)"),
      // Strip all but native flags
      flags: x.replace(pD, ""),
      // `context.captureNames` has an item for each capturing group, even if unnamed
      captures: n.hasNamedCapture ? n.captureNames : null
    };
  }
  const t = Fe[u][e];
  return ks(
    new RegExp(t.pattern, t.flags),
    t.captures,
    u,
    e
  );
}
H.prototype = new RegExp();
H.version = "5.1.2";
H._clipDuplicates = Re;
H._hasNativeFlag = ze;
H._dec = Ns;
H._hex = Xr;
H._pad4 = Qr;
H.addToken = (u, e, t) => {
  t = t || {};
  let { optionalFlags: n } = t;
  if (t.flag && Hn(t.flag), n) {
    n = n.split("");
    for (const s of n)
      Hn(s);
  }
  Ir.push({
    regex: ie(u, {
      addG: !0,
      addY: Jr,
      isInternalOnly: !0
    }),
    handler: e,
    scope: t.scope || pe,
    flag: t.flag,
    reparse: t.reparse,
    leadChar: t.leadChar
  }), H.cache.flush("patterns");
};
H.cache = (u, e) => (ke[u] || (ke[u] = {}), ke[u][e] || (ke[u][e] = H(u, e)));
H.cache.flush = (u) => {
  u === "patterns" ? Fe = /* @__PURE__ */ Object.create(null) : ke = /* @__PURE__ */ Object.create(null);
};
H.escape = (u) => String(ge(u)).replace(/[\\\[\]{}()*+?.^$|]/g, "\\$&").replace(/[\s#\-,]/g, (e) => `\\u${Qr(Xr(e.charCodeAt(0)))}`);
H.exec = (u, e, t, n) => {
  let s = "g", i = !1, a = !1, D;
  i = Jr && !!(n || e.sticky && n !== !1), i ? s += "y" : n && (a = !0, s += "FakeY"), e[fu] = e[fu] || {};
  const o = e[fu][s] || (e[fu][s] = ie(e, {
    addG: !0,
    addY: i,
    source: a ? `${e.source}|()` : void 0,
    removeY: n === !1,
    isInternalOnly: !0
  }));
  return t = t || 0, o.lastIndex = t, D = Ou.exec.call(o, u), a && D && D.pop() === "" && (D = null), e.global && (e.lastIndex = D ? o.lastIndex : 0), D;
};
H.forEach = (u, e, t) => {
  let n = 0, s = -1, i;
  for (; i = H.exec(u, e, n); )
    t(i, ++s, u, e), n = i.index + (i[0].length || 1);
};
H.globalize = (u) => ie(u, { addG: !0 });
H.install = (u) => {
  u = $s(u), !re.astral && u.astral && Rs(!0), !re.namespacing && u.namespacing && Is(!0);
};
H.isInstalled = (u) => !!re[u];
H.isRegExp = (u) => Object.prototype.toString.call(u) === "[object RegExp]";
H.match = (u, e, t) => {
  const n = e.global && t !== "one" || t === "all", s = (n ? "g" : "") + (e.sticky ? "y" : "") || "noGY";
  e[fu] = e[fu] || {};
  const i = e[fu][s] || (e[fu][s] = ie(e, {
    addG: !!n,
    removeG: t === "one",
    isInternalOnly: !0
  })), a = String(ge(u)).match(i);
  return e.global && (e.lastIndex = t === "one" && a ? (
    // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
    a.index + a[0].length
  ) : 0), n ? a || [] : a && a[0];
};
H.matchChain = (u, e) => function t(n, s) {
  const i = e[s].regex ? e[s] : { regex: e[s] }, a = [];
  function D(o) {
    if (i.backref) {
      const d = `Backreference to undefined group: ${i.backref}`, x = isNaN(i.backref);
      if (x && H.isInstalled("namespacing")) {
        if (!(o.groups && i.backref in o.groups))
          throw new ReferenceError(d);
      } else if (!o.hasOwnProperty(i.backref))
        throw new ReferenceError(d);
      const c = x && H.isInstalled("namespacing") ? o.groups[i.backref] : o[i.backref];
      a.push(c || "");
    } else
      a.push(o[0]);
  }
  for (const o of n)
    H.forEach(o, i.regex, D);
  return s === e.length - 1 || !a.length ? a : t(a, s + 1);
}([u], 0);
H.replace = (u, e, t, n) => {
  const s = H.isRegExp(e), i = e.global && n !== "one" || n === "all", a = (i ? "g" : "") + (e.sticky ? "y" : "") || "noGY";
  let D = e;
  s ? (e[fu] = e[fu] || {}, D = e[fu][a] || (e[fu][a] = ie(e, {
    addG: !!i,
    removeG: n === "one",
    isInternalOnly: !0
  }))) : i && (D = new RegExp(H.escape(String(e)), "g"));
  const o = Ou.replace.call(ge(u), D, t);
  return s && e.global && (e.lastIndex = 0), o;
};
H.replaceEach = (u, e) => {
  for (const t of e)
    u = H.replace(u, t[0], t[1], t[2]);
  return u;
};
H.split = (u, e, t) => Ou.split.call(ge(u), e, t);
H.test = (u, e, t, n) => !!H.exec(u, e, t, n);
H.uninstall = (u) => {
  u = $s(u), re.astral && u.astral && Rs(!1), re.namespacing && u.namespacing && Is(!1);
};
H.union = (u, e, t) => {
  t = t || {};
  const n = t.conjunction || "or";
  let s = 0, i, a;
  function D(c, h, F) {
    const C = a[s - i];
    if (h) {
      if (++s, C)
        return `(?<${C}>`;
    } else if (F)
      return `\\${+F + i}`;
    return c;
  }
  if (!(At(u, "Array") && u.length))
    throw new TypeError("Must provide a nonempty array of patterns to merge");
  const o = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, d = [];
  for (const c of u)
    H.isRegExp(c) ? (i = s, a = c[fu] && c[fu].captureNames || [], d.push(H(c.source).source.replace(o, D))) : d.push(H.escape(c));
  const x = n === "none" ? "" : "|";
  return H(d.join(x), e);
};
Ou.exec = function(u) {
  const e = this.lastIndex, t = RegExp.prototype.exec.apply(this, arguments);
  if (t) {
    if (!cD && t.length > 1 && t.includes("")) {
      const n = ie(this, {
        removeG: !0,
        isInternalOnly: !0
      });
      String(u).slice(t.index).replace(n, (...s) => {
        const i = s.length;
        for (let a = 1; a < i - 2; ++a)
          s[a] === void 0 && (t[a] = void 0);
      });
    }
    if (this[fu] && this[fu].captureNames) {
      let n = t;
      H.isInstalled("namespacing") && (t.groups = /* @__PURE__ */ Object.create(null), n = t.groups);
      for (let s = 1; s < t.length; ++s) {
        const i = this[fu].captureNames[s - 1];
        i && (n[i] = t[s]);
      }
    } else !t.groups && H.isInstalled("namespacing") && (t.groups = void 0);
    this.global && !t[0].length && this.lastIndex > t.index && (this.lastIndex = t.index);
  }
  return this.global || (this.lastIndex = e), t;
};
Ou.test = function(u) {
  return !!Ou.exec.call(this, u);
};
Ou.match = function(u) {
  if (!H.isRegExp(u))
    u = new RegExp(u);
  else if (u.global) {
    const e = String.prototype.match.apply(this, arguments);
    return u.lastIndex = 0, e;
  }
  return Ou.exec.call(u, ge(this));
};
Ou.replace = function(u, e) {
  const t = H.isRegExp(u);
  let n, s, i;
  return t ? (u[fu] && ({ captureNames: s } = u[fu]), n = u.lastIndex) : u += "", At(e, "Function") ? i = String(this).replace(u, (...a) => {
    if (s) {
      let D;
      H.isInstalled("namespacing") ? (D = /* @__PURE__ */ Object.create(null), a.push(D)) : (a[0] = new String(a[0]), [D] = a);
      for (let o = 0; o < s.length; ++o)
        s[o] && (D[s[o]] = a[o + 1]);
    }
    return e(...a);
  }) : i = String(ge(this)).replace(u, (...a) => {
    return String(e).replace(lD, D);
    function D(o, d, x, c) {
      d = d || x;
      const h = At(a[a.length - 1], "Object") ? 4 : 3, F = a.length - h;
      if (d) {
        if (/^\d+$/.test(d)) {
          const f = +d;
          if (f <= F)
            return a[f] || "";
        }
        const C = s ? s.indexOf(d) : -1;
        if (C < 0)
          throw new SyntaxError(`Backreference to undefined group ${o}`);
        return a[C + 1] || "";
      }
      if (c === "" || c === " ")
        throw new SyntaxError(`Invalid token ${o}`);
      if (c === "&" || +c == 0)
        return a[0];
      if (c === "$")
        return "$";
      if (c === "`")
        return a[a.length - 1].slice(0, a[a.length - 2]);
      if (c === "'")
        return a[a.length - 1].slice(a[a.length - 2] + a[0].length);
      if (c = +c, !isNaN(c)) {
        if (c > F)
          throw new SyntaxError(`Backreference to undefined group ${o}`);
        return a[c] || "";
      }
      throw new SyntaxError(`Invalid token ${o}`);
    }
  }), t && (u.global ? u.lastIndex = 0 : u.lastIndex = n), i;
};
Ou.split = function(u, e) {
  if (!H.isRegExp(u))
    return String.prototype.split.apply(this, arguments);
  const t = String(this), n = [], s = u.lastIndex;
  let i = 0, a;
  return e = (e === void 0 ? -1 : e) >>> 0, H.forEach(t, u, (D) => {
    D.index + D[0].length > i && (n.push(t.slice(i, D.index)), D.length > 1 && D.index < t.length && Array.prototype.push.apply(n, D.slice(1)), a = D[0].length, i = D.index + a);
  }), i === t.length ? (!u.test("") || a) && n.push("") : n.push(t.slice(i)), u.lastIndex = s, n.length > e ? n.slice(0, e) : n;
};
H.addToken(
  /\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/,
  (u, e) => {
    if (u[1] === "B" && e === pe)
      return u[0];
    throw new SyntaxError(`Invalid escape ${u[0]}`);
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
H.addToken(
  /\\u{([\dA-Fa-f]+)}/,
  (u, e, t) => {
    const n = Ns(u[1]);
    if (n > 1114111)
      throw new SyntaxError(`Invalid Unicode code point ${u[0]}`);
    if (n <= 65535)
      return `\\u${Qr(Xr(n))}`;
    if (Ps && t.includes("u"))
      return u[0];
    throw new SyntaxError("Cannot use Unicode code point above \\u{FFFF} without flag u");
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
H.addToken(
  /\(\?#[^)]*\)/,
  Os,
  { leadChar: "(" }
);
H.addToken(
  /\s+|#[^\n]*\n?/,
  Os,
  { flag: "x" }
);
Kr || H.addToken(
  /\./,
  () => "[\\s\\S]",
  {
    flag: "s",
    leadChar: "."
  }
);
H.addToken(
  /\\k<([^>]+)>/,
  function(u) {
    const e = isNaN(u[1]) ? this.captureNames.indexOf(u[1]) + 1 : +u[1], t = u.index + u[0].length;
    if (!e || e > this.captureNames.length)
      throw new SyntaxError(`Backreference to undefined group ${u[0]}`);
    return `\\${e}${t === u.input.length || isNaN(u.input[t]) ? "" : "(?:)"}`;
  },
  { leadChar: "\\" }
);
H.addToken(
  /\\(\d+)/,
  function(u, e) {
    if (!(e === pe && /^[1-9]/.test(u[1]) && +u[1] <= this.captureNames.length) && u[1] !== "0")
      throw new SyntaxError(`Cannot use octal escape or backreference to undefined group ${u[0]}`);
    return u[0];
  },
  {
    scope: "all",
    leadChar: "\\"
  }
);
H.addToken(
  /\(\?P?<([\p{ID_Start}$_][\p{ID_Continue}$_\u200C\u200D]*)>/u,
  function(u) {
    if (!H.isInstalled("namespacing") && (u[1] === "length" || u[1] === "__proto__"))
      throw new SyntaxError(`Cannot use reserved word as capture name ${u[0]}`);
    if (this.captureNames.includes(u[1]))
      throw new SyntaxError(`Cannot use same name for multiple groups ${u[0]}`);
    return this.captureNames.push(u[1]), this.hasNamedCapture = !0, "(";
  },
  { leadChar: "(" }
);
H.addToken(
  /\((?!\?)/,
  function(u, e, t) {
    return t.includes("n") ? "(?:" : (this.captureNames.push(null), "(");
  },
  {
    optionalFlags: "n",
    leadChar: "("
  }
);
/*!
 * XRegExp.build 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2012-present MIT License
 */
const mD = (u) => {
  const e = "xregexp", t = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, n = u.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, t], "g", {
    conjunction: "or"
  });
  function s(d) {
    const x = /^(?:\(\?:\))*\^/, c = /\$(?:\(\?:\))*$/;
    return x.test(d) && c.test(d) && // Ensure that the trailing `$` isn't escaped
    c.test(d.replace(/\\[\s\S]/g, "")) ? d.replace(x, "").replace(c, "") : d;
  }
  function i(d, x) {
    const c = x ? "x" : "";
    return u.isRegExp(d) ? d[e] && d[e].captureNames ? (
      // Don't recompile, to preserve capture names
      d
    ) : (
      // Recompile as XRegExp
      u(d.source, c)
    ) : (
      // Compile string as XRegExp
      u(d, c)
    );
  }
  function a(d) {
    return d instanceof RegExp ? d : u.escape(d);
  }
  function D(d, x, c) {
    return d[`subpattern${c}`] = x, d;
  }
  function o(d, x, c) {
    const h = x < c.length - 1;
    return d + (h ? `{{subpattern${x}}}` : "");
  }
  u.tag = (d) => (x, ...c) => {
    const h = c.map(a).reduce(D, {}), F = x.raw.map(o).join("");
    return u.build(F, h, d);
  }, u.build = (d, x, c) => {
    c = c || "";
    const h = c.includes("x"), F = /^\(\?([\w$]+)\)/.exec(d);
    F && (c = u._clipDuplicates(c + F[1]));
    const C = {};
    for (const b in x)
      if (x.hasOwnProperty(b)) {
        const w = i(x[b], h);
        C[b] = {
          // Deanchoring allows embedding independently useful anchored regexes. If you
          // really need to keep your anchors, double them (i.e., `^^...$$`).
          pattern: s(w.source),
          names: w[e].captureNames || []
        };
      }
    const f = i(d, h);
    let y = 0, B, l = 0;
    const p = [0], E = f[e].captureNames || [], A = f.source.replace(n, (b, w, P, q, z) => {
      const k = w || P;
      let I, O, j;
      if (k) {
        if (!C.hasOwnProperty(k))
          throw new ReferenceError(`Undefined property ${b}`);
        w ? (I = E[l], p[++l] = ++y, O = `(?<${I || k}>`) : O = "(?:", B = y;
        const M = C[k].pattern.replace(t, (J, su, nu) => {
          if (su) {
            if (I = C[k].names[y - B], ++y, I)
              return `(?<${I}>`;
          } else if (nu)
            return j = +nu - 1, C[k].names[j] ? (
              // Need to preserve the backreference name in case using flag `n`
              `\\k<${C[k].names[j]}>`
            ) : `\\${+nu + B}`;
          return J;
        });
        return `${O}${M})`;
      }
      if (q) {
        if (I = E[l], p[++l] = ++y, I)
          return `(?<${I}>`;
      } else if (z)
        return j = +z - 1, E[j] ? (
          // Need to preserve the backreference name in case using flag `n`
          `\\k<${E[j]}>`
        ) : `\\${p[+z]}`;
      return b;
    });
    return u(A, c);
  };
};
/*!
 * XRegExp.matchRecursive 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2009-present MIT License
 */
const gD = (u) => {
  function e(t, n, s, i) {
    return {
      name: t,
      value: n,
      start: s,
      end: i
    };
  }
  u.matchRecursive = (t, n, s, i, a) => {
    i = i || "", a = a || {};
    const D = i.includes("g"), o = i.includes("y"), d = i.replace(/y/g, "");
    n = u(n, d), s = u(s, d);
    let x, { escapeChar: c } = a;
    if (c) {
      if (c.length > 1)
        throw new Error("Cannot use more than one escape character");
      c = u.escape(c), x = new RegExp(
        `(?:${c}[\\S\\s]|(?:(?!${// Using `XRegExp.union` safely rewrites backreferences in `left` and `right`.
        // Intentionally not passing `basicFlags` to `XRegExp.union` since any syntax
        // transformation resulting from those flags was already applied to `left` and
        // `right` when they were passed through the XRegExp constructor above.
        u.union([n, s], "", { conjunction: "or" }).source})[^${c}])+)+`,
        // Flags `dgy` not needed here
        i.replace(u._hasNativeFlag("s") ? /[^imsu]/g : /[^imu]/g, "")
      );
    }
    let h = 0, F = 0, C = 0, f = 0, y, B, l, p;
    const E = a.valueNames, A = [];
    for (; ; ) {
      if (c && (C += (u.exec(t, x, C, "sticky") || [""])[0].length), l = u.exec(t, n, C), p = u.exec(t, s, C), l && p && (l.index <= p.index ? p = null : l = null), l || p)
        F = (l || p).index, C = F + (l || p)[0].length;
      else if (!h)
        break;
      if (o && !h && F > f)
        break;
      if (l)
        h || (y = F, B = C), h += 1;
      else if (p && h) {
        if (h -= 1, !h && (E ? (E[0] && y > f && A.push(e(E[0], t.slice(f, y), f, y)), E[1] && A.push(e(E[1], t.slice(y, B), y, B)), E[2] && A.push(e(E[2], t.slice(B, F), B, F)), E[3] && A.push(e(E[3], t.slice(F, C), F, C))) : A.push(t.slice(B, F)), f = C, !D))
          break;
      } else {
        const b = a.unbalanced || "error";
        if (b === "skip" || b === "skip-lazy")
          if (p)
            p = null;
          else {
            if (b === "skip") {
              const w = u.exec(t, n, y, "sticky")[0].length;
              C = y + (w || 1);
            } else
              C = y + 1;
            h = 0;
          }
        else if (b === "error") {
          const w = p ? "right" : "left", P = p ? F : y;
          throw new Error(`Unbalanced ${w} delimiter found in string at position ${P}`);
        } else
          throw new Error(`Unsupported value for unbalanced: ${b}`);
      }
      F === C && (C += 1);
    }
    return D && A.length > 0 && !o && E && E[0] && t.length > f && A.push(e(E[0], t.slice(f), f, t.length)), A;
  };
};
/*!
 * XRegExp Unicode Base 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2008-present MIT License
 */
const BD = (u) => {
  const e = {}, t = {}, n = u._dec, s = u._hex, i = u._pad4;
  function a(h) {
    return h.replace(/[- _]+/g, "").toLowerCase();
  }
  function D(h) {
    const F = /^\\[xu](.+)/.exec(h);
    return F ? n(F[1]) : h.charCodeAt(h[0] === "\\" ? 1 : 0);
  }
  function o(h) {
    let F = "", C = -1;
    return u.forEach(
      h,
      /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/,
      (f) => {
        const y = D(f[1]);
        y > C + 1 && (F += `\\u${i(s(C + 1))}`, y > C + 2 && (F += `-\\u${i(s(y - 1))}`)), C = D(f[2] || f[1]);
      }
    ), C < 65535 && (F += `\\u${i(s(C + 1))}`, C < 65534 && (F += "-\\uFFFF")), F;
  }
  function d(h) {
    const F = "b!";
    return e[h][F] || (e[h][F] = o(e[h].bmp));
  }
  function x(h, F) {
    const C = e[h];
    let f = "";
    return C.bmp && !C.isBmpLast && (f = `[${C.bmp}]${C.astral ? "|" : ""}`), C.astral && (f += C.astral), C.isBmpLast && C.bmp && (f += `${C.astral ? "|" : ""}[${C.bmp}]`), F ? `(?:(?!${f})(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\0-￿]))` : `(?:${f})`;
  }
  function c(h, F) {
    const C = F ? "a!" : "a=";
    return e[h][C] || (e[h][C] = x(h, F));
  }
  u.addToken(
    // Use `*` instead of `+` to avoid capturing `^` as the token name in `\p{^}`
    /\\([pP])(?:{(\^?)(?:(\w+)=)?([^}]*)}|([A-Za-z]))/,
    (h, F, C) => {
      const f = "Invalid double negation ", y = "Unknown Unicode token ", B = "Unicode token missing data ", l = "Astral mode required for Unicode token ", p = "Astral mode does not support Unicode tokens within character classes", [
        E,
        A,
        b,
        w,
        P,
        q
      ] = h;
      let z = A === "P" || !!b;
      const k = C.includes("A");
      let I = a(q || P), O = e[I];
      if (A === "P" && b)
        throw new SyntaxError(f + E);
      if (!e.hasOwnProperty(I))
        throw new SyntaxError(y + E);
      if (w && !(t[w] && t[w][I]))
        throw new SyntaxError(y + E);
      if (O.inverseOf) {
        if (I = a(O.inverseOf), !e.hasOwnProperty(I))
          throw new ReferenceError(`${B + E} -> ${O.inverseOf}`);
        O = e[I], z = !z;
      }
      if (!(O.bmp || k))
        throw new SyntaxError(l + E);
      if (k) {
        if (F === "class")
          throw new SyntaxError(p);
        return c(I, z);
      }
      return F === "class" ? z ? d(I) : O.bmp : `${(z ? "[^" : "[") + O.bmp}]`;
    },
    {
      scope: "all",
      optionalFlags: "A",
      leadChar: "\\"
    }
  ), u.addUnicodeData = (h, F) => {
    const C = "Unicode token requires name", f = "Unicode token has no character data ";
    F && (t[F] = {});
    for (const y of h) {
      if (!y.name)
        throw new Error(C);
      if (!(y.inverseOf || y.bmp || y.astral))
        throw new Error(f + y.name);
      const B = a(y.name);
      if (e[B] = y, F && (t[F][B] = !0), y.alias) {
        const l = a(y.alias);
        e[l] = y, F && (t[F][l] = !0);
      }
    }
    u.cache.flush("patterns");
  }, u._getUnicodeProperty = (h) => {
    const F = a(h);
    return e[F];
  };
};
var Yt, Vn;
function xD() {
  return Vn || (Vn = 1, Yt = [
    {
      name: "C",
      alias: "Other",
      isBmpLast: !0,
      bmp: "\0--­͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-؅؜۝܎܏݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏-ࢗ࣢঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠎᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿​-‏‪-‮⁠-⁯⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽-＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￻￾￿",
      astral: "\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9D-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE49-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD28-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA\uDEAE\uDEAF\uDEB2-\uDEFF\uDF28-\uDF2F\uDF5A-\uDF6F\uDF8A-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC76-\uDC7E\uDCBD\uDCC3-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD48-\uDD4F\uDD77-\uDD7F\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5C\uDC62-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEBA-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF47-\uDFFF]|\uD806[\uDC3C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD47-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE5-\uDDFF\uDE48-\uDE4F\uDEA3-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF9-\uDFAF\uDFB1-\uDFBF\uDFF2-\uDFFE]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD832\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF3-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDEBF\uDECA-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE9B-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA0-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDF4F\uDFC4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD73-\uDD7A\uDDEB-\uDDFF\uDE46-\uDEDF\uDEF4-\uDEFF\uDF57-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD837[\uDC00-\uDEFF\uDF1F-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD50-\uDE8F\uDEAF-\uDEBF\uDEFA-\uDEFE\uDF00-\uDFFF]|\uD839[\uDC00-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCB5-\uDD00\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDDAE-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED8-\uDEDC\uDEED-\uDEEF\uDEFD-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFEF\uDFF1-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCB2-\uDCFF\uDE54-\uDE5F\uDE6E\uDE6F\uDE75-\uDE77\uDE7D-\uDE7F\uDE87-\uDE8F\uDEAD-\uDEAF\uDEBB-\uDEBF\uDEC6-\uDECF\uDEDA-\uDEDF\uDEE8-\uDEEF\uDEF7-\uDEFF\uDF93\uDFCB-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF39-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]"
    },
    {
      name: "Cc",
      alias: "Control",
      bmp: "\0--"
    },
    {
      name: "Cf",
      alias: "Format",
      bmp: "­؀-؅؜۝܏࢐࢑࣢᠎​-‏‪-‮⁠-⁤⁦-⁯\uFEFF￹-￻",
      astral: "\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC38]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]"
    },
    {
      name: "Cn",
      alias: "Unassigned",
      bmp: "͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-׿܎݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏࢒-ࢗ঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿⁥⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-퟿﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽﻾＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￸￾￿",
      astral: "\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9D-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE49-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD28-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA\uDEAE\uDEAF\uDEB2-\uDEFF\uDF28-\uDF2F\uDF5A-\uDF6F\uDF8A-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC76-\uDC7E\uDCC3-\uDCCC\uDCCE\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD48-\uDD4F\uDD77-\uDD7F\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5C\uDC62-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEBA-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF47-\uDFFF]|\uD806[\uDC3C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD47-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE5-\uDDFF\uDE48-\uDE4F\uDEA3-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF9-\uDFAF\uDFB1-\uDFBF\uDFF2-\uDFFE]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD832\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDB7F][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF3-\uDFFF]|\uD80D[\uDC2F\uDC39-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDEBF\uDECA-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE9B-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA4-\uDFFF]|\uD833[\uDC00-\uDEFF\uDF2E\uDF2F\uDF47-\uDF4F\uDFC4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDDEB-\uDDFF\uDE46-\uDEDF\uDEF4-\uDEFF\uDF57-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD837[\uDC00-\uDEFF\uDF1F-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD50-\uDE8F\uDEAF-\uDEBF\uDEFA-\uDEFE\uDF00-\uDFFF]|\uD839[\uDC00-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCB5-\uDD00\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDDAE-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED8-\uDEDC\uDEED-\uDEEF\uDEFD-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFEF\uDFF1-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCB2-\uDCFF\uDE54-\uDE5F\uDE6E\uDE6F\uDE75-\uDE77\uDE7D-\uDE7F\uDE87-\uDE8F\uDEAD-\uDEAF\uDEBB-\uDEBF\uDEC6-\uDECF\uDEDA-\uDEDF\uDEE8-\uDEEF\uDEF7-\uDEFF\uDF93\uDFCB-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF39-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00\uDC02-\uDC1F\uDC80-\uDCFF\uDDF0-\uDFFF]|[\uDBBF\uDBFF][\uDFFE\uDFFF]"
    },
    {
      name: "Co",
      alias: "Private_Use",
      bmp: "-",
      astral: "[\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uDBBF\uDBFF][\uDC00-\uDFFD]"
    },
    {
      name: "Cs",
      alias: "Surrogate",
      bmp: "\uD800-\uDFFF"
    },
    {
      name: "L",
      alias: "Letter",
      bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
      astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
    },
    {
      name: "LC",
      alias: "Cased_Letter",
      bmp: "A-Za-zµÀ-ÖØ-öø-ƺƼ-ƿǄ-ʓʕ-ʯͰ-ͳͶͷͻ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՠ-ֈႠ-ჅჇჍა-ჺჽ-ჿᎠ-Ᏽᏸ-ᏽᲀ-ᲈᲐ-ᲺᲽ-Ჿᴀ-ᴫᵫ-ᵷᵹ-ᶚḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℴℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⱻⱾ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭꙀ-ꙭꚀ-ꚛꜢ-ꝯꝱ-ꞇꞋ-ꞎꞐ-ꟊꟐꟑꟓꟕ-ꟙꟵꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚ",
      astral: "\uD801[\uDC00-\uDC4F\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]|\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD806[\uDCA0-\uDCDF]|\uD81B[\uDE40-\uDE7F]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD00-\uDD43]"
    },
    {
      name: "Ll",
      alias: "Lowercase_Letter",
      bmp: "a-zµß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʯͱͳͷͻ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᴫᵫ-ᵷᵹ-ᶚḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎↄⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱻⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯꝱ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
      astral: "\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD81B[\uDE60-\uDE7F]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD22-\uDD43]"
    },
    {
      name: "Lm",
      alias: "Modifier_Letter",
      bmp: "ʰ-ˁˆ-ˑˠ-ˤˬˮʹͺՙـۥۦߴߵߺࠚࠤࠨࣉॱๆໆჼៗᡃᪧᱸ-ᱽᴬ-ᵪᵸᶛ-ᶿⁱⁿₐ-ₜⱼⱽⵯⸯ々〱-〵〻ゝゞー-ヾꀕꓸ-ꓽꘌꙿꚜꚝꜗ-ꜟꝰꞈꟲ-ꟴꟸꟹꧏꧦꩰꫝꫳꫴꭜ-ꭟꭩｰﾞﾟ",
      astral: "\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD838[\uDD37-\uDD3D]|𞥋"
    },
    {
      name: "Lo",
      alias: "Other_Letter",
      bmp: "ªºƻǀ-ǃʔא-תׯ-ײؠ-ؿف-يٮٯٱ-ۓەۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪࠀ-ࠕࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣈऄ-हऽॐक़-ॡॲ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๅກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎᄀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៜᠠ-ᡂᡄ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱷᳩ-ᳬᳮ-ᳳᳵᳶᳺℵ-ℸⴰ-ⵧⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ〆〼ぁ-ゖゟァ-ヺヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꀔꀖ-ꒌꓐ-ꓷꔀ-ꘋꘐ-ꘟꘪꘫꙮꚠ-ꛥꞏꟷꟻ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧠ-ꧤꧧ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩯꩱ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛꫜꫠ-ꫪꫲꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎יִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼｦ-ｯｱ-ﾝﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
      astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF4A\uDF50]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|𝼊|\uD838[\uDD00-\uDD2C\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
    },
    {
      name: "Lt",
      alias: "Titlecase_Letter",
      bmp: "ǅǈǋǲᾈ-ᾏᾘ-ᾟᾨ-ᾯᾼῌῼ"
    },
    {
      name: "Lu",
      alias: "Uppercase_Letter",
      bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅↃⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
      astral: "\uD801[\uDC00-\uDC27\uDCB0-\uDCD3\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]"
    },
    {
      name: "M",
      alias: "Mark",
      bmp: "̀-ͯ҃-҉֑-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣঁ-ঃ়া-ৄেৈো-্ৗৢৣ৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑੰੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣஂா-ூெ-ைொ-்ௗఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣඁ-ඃ්ා-ුූෘ-ෟෲෳัิ-ฺ็-๎ັິ-ຼ່-ໍ༹༘༙༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏႚ-ႝ፝-፟ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤫᤰ-᤻ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼᪰-ᫎᬀ-ᬄ᬴-᭄᭫-᭳ᮀ-ᮂᮡ-ᮭ᯦-᯳ᰤ-᰷᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿⃐-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꙯-꙲ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀ꧥꨩ-ꨶꩃꩌꩍꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭ﬞ︀-️︠-︯",
      astral: "\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]"
    },
    {
      name: "Mc",
      alias: "Spacing_Mark",
      bmp: "ःऻा-ीॉ-ौॎॏংঃা-ীেৈোৌৗਃਾ-ੀઃા-ીૉોૌଂଃାୀେୈୋୌୗாிுூெ-ைொ-ௌௗఁ-ఃు-ౄಂಃಾೀ-ೄೇೈೊೋೕೖംഃാ-ീെ-ൈൊ-ൌൗංඃා-ෑෘ-ෟෲෳ༾༿ཿါာေးျြၖၗၢ-ၤၧ-ၭႃႄႇ-ႌႏႚ-ႜ᜕᜴ាើ-ៅះៈᤣ-ᤦᤩ-ᤫᤰᤱᤳ-ᤸᨙᨚᩕᩗᩡᩣᩤᩭ-ᩲᬄᬵᬻᬽ-ᭁᭃ᭄ᮂᮡᮦᮧ᮪ᯧᯪ-ᯬᯮ᯲᯳ᰤ-ᰫᰴᰵ᳡᳷〮〯ꠣꠤꠧꢀꢁꢴ-ꣃꥒ꥓ꦃꦴꦵꦺꦻꦾ-꧀ꨯꨰꨳꨴꩍꩻꩽꫫꫮꫯꫵꯣꯤꯦꯧꯩꯪ꯬",
      astral: "\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3E\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB0-\uDCB2\uDCB9\uDCBB-\uDCBE\uDCC1\uDDAF-\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF20\uDF21\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD30-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD65\uDD66\uDD6D-\uDD72]"
    },
    {
      name: "Me",
      alias: "Enclosing_Mark",
      bmp: "҈҉᪾⃝-⃠⃢-⃤꙰-꙲"
    },
    {
      name: "Mn",
      alias: "Nonspacing_Mark",
      bmp: "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ंऺ़ु-ै्॑-ॗॢॣঁ়ু-ৄ্ৢৣ৾ਁਂ਼ੁੂੇੈੋ-੍ੑੰੱੵઁં઼ુ-ૅેૈ્ૢૣૺ-૿ଁ଼ିୁ-ୄ୍୕ୖୢୣஂீ்ఀఄ఼ా-ీె-ైొ-్ౕౖౢౣಁ಼ಿೆೌ್ೢೣഀഁ഻഼ു-ൄ്ൢൣඁ්ි-ුූัิ-ฺ็-๎ັິ-ຼ່-ໍཱ༹༘༙༵༷-ཾྀ-྄྆྇ྍ-ྗྙ-ྼ࿆ိ-ူဲ-့္်ွှၘၙၞ-ၠၱ-ၴႂႅႆႍႝ፝-፟ᜒ-᜔ᜲᜳᝒᝓᝲᝳ឴឵ិ-ួំ៉-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤢᤧᤨᤲ᤹-᤻ᨘᨗᨛᩖᩘ-ᩞ᩠ᩢᩥ-ᩬᩳ-᩿᩼᪰-᪽ᪿ-ᫎᬀ-ᬃ᬴ᬶ-ᬺᬼᭂ᭫-᭳ᮀᮁᮢ-ᮥᮨᮩ᮫-ᮭ᯦ᯨᯩᯭᯯ-ᯱᰬ-ᰳᰶ᰷᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〭꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠥꠦ꠬꣄ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-ꥑꦀ-ꦂ꦳ꦶ-ꦹꦼꦽꧥꨩ-ꨮꨱꨲꨵꨶꩃꩌꩼꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫬꫭ꫶ꯥꯨ꯭ﬞ︀-️︠-︯",
      astral: "\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]"
    },
    {
      name: "N",
      alias: "Number",
      bmp: "0-9²³¹¼-¾٠-٩۰-۹߀-߉०-९০-৯৴-৹੦-੯૦-૯୦-୯୲-୷௦-௲౦-౯౸-౾೦-೯൘-൞൦-൸෦-෯๐-๙໐-໙༠-༳၀-၉႐-႙፩-፼ᛮ-ᛰ០-៩៰-៹᠐-᠙᥆-᥏᧐-᧚᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙⁰⁴-⁹₀-₉⅐-ↂↅ-↉①-⒛⓪-⓿❶-➓⳽〇〡-〩〸-〺㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꘠-꘩ꛦ-ꛯ꠰-꠵꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
      astral: "\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDD30-\uDD39\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2\uDD50-\uDD59]|\uD807[\uDC50-\uDC6C\uDD50-\uDD59\uDDA0-\uDDA9\uDFC0-\uDFD4]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59\uDF5B-\uDF61]|\uD81B[\uDE80-\uDE96]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]"
    },
    {
      name: "Nd",
      alias: "Decimal_Number",
      bmp: "0-9٠-٩۰-۹߀-߉०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯෦-෯๐-๙໐-໙༠-༩၀-၉႐-႙០-៩᠐-᠙᥆-᥏᧐-᧙᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙꘠-꘩꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
      astral: "\uD801[\uDCA0-\uDCA9]|\uD803[\uDD30-\uDD39]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9\uDD50-\uDD59]|\uD807[\uDC50-\uDC59\uDD50-\uDD59\uDDA0-\uDDA9]|\uD81A[\uDE60-\uDE69\uDEC0-\uDEC9\uDF50-\uDF59]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD83A[\uDD50-\uDD59]|\uD83E[\uDFF0-\uDFF9]"
    },
    {
      name: "Nl",
      alias: "Letter_Number",
      bmp: "ᛮ-ᛰⅠ-ↂↅ-ↈ〇〡-〩〸-〺ꛦ-ꛯ",
      astral: "\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]|\uD809[\uDC00-\uDC6E]"
    },
    {
      name: "No",
      alias: "Other_Number",
      bmp: "²³¹¼-¾৴-৹୲-୷௰-௲౸-౾൘-൞൰-൸༪-༳፩-፼៰-៹᧚⁰⁴-⁹₀-₉⅐-⅟↉①-⒛⓪-⓿❶-➓⳽㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꠰-꠵",
      astral: "\uD800[\uDD07-\uDD33\uDD75-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC65\uDDE1-\uDDF4]|\uD805[\uDF3A\uDF3B]|\uD806[\uDCEA-\uDCF2]|\uD807[\uDC5A-\uDC6C\uDFC0-\uDFD4]|\uD81A[\uDF5B-\uDF61]|\uD81B[\uDE80-\uDE96]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD83A[\uDCC7-\uDCCF]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]"
    },
    {
      name: "P",
      alias: "Punctuation",
      bmp: "!-#%-\\*,-\\/:;\\?@\\[-\\]_\\{\\}¡§«¶·»¿;·՚-՟։֊־׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔༺-༽྅࿐-࿔࿙࿚၊-၏჻፠-፨᐀᙮᚛᚜᛫-᛭᜵᜶។-៖៘-៚᠀-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‐-‧‰-⁃⁅-⁑⁓-⁞⁽⁾₍₎⌈-⌋〈〉❨-❵⟅⟆⟦-⟯⦃-⦘⧘-⧛⧼⧽⳹-⳼⳾⳿⵰⸀-⸮⸰-⹏⹒-⹝、-〃〈-】〔-〟〰〽゠・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫﴾﴿︐-︙︰-﹒﹔-﹡﹣﹨﹪﹫！-＃％-＊，-／：；？＠［-］＿｛｝｟-･",
      astral: "\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|𐕯|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|𛲟|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]"
    },
    {
      name: "Pc",
      alias: "Connector_Punctuation",
      bmp: "_‿⁀⁔︳︴﹍-﹏＿"
    },
    {
      name: "Pd",
      alias: "Dash_Punctuation",
      bmp: "\\-֊־᐀᠆‐-―⸗⸚⸺⸻⹀⹝〜〰゠︱︲﹘﹣－",
      astral: "𐺭"
    },
    {
      name: "Pe",
      alias: "Close_Punctuation",
      bmp: "\\)\\]\\}༻༽᚜⁆⁾₎⌉⌋〉❩❫❭❯❱❳❵⟆⟧⟩⟫⟭⟯⦄⦆⦈⦊⦌⦎⦐⦒⦔⦖⦘⧙⧛⧽⸣⸥⸧⸩⹖⹘⹚⹜〉》」』】〕〗〙〛〞〟﴾︘︶︸︺︼︾﹀﹂﹄﹈﹚﹜﹞）］｝｠｣"
    },
    {
      name: "Pf",
      alias: "Final_Punctuation",
      bmp: "»’”›⸃⸅⸊⸍⸝⸡"
    },
    {
      name: "Pi",
      alias: "Initial_Punctuation",
      bmp: "«‘‛“‟‹⸂⸄⸉⸌⸜⸠"
    },
    {
      name: "Po",
      alias: "Other_Punctuation",
      bmp: "!-#%-'\\*,\\.\\/:;\\?@\\¡§¶·¿;·՚-՟։׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔྅࿐-࿔࿙࿚၊-၏჻፠-፨᙮᛫-᛭᜵᜶។-៖៘-៚᠀-᠅᠇-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‖‗†-‧‰-‸※-‾⁁-⁃⁇-⁑⁓⁕-⁞⳹-⳼⳾⳿⵰⸀⸁⸆-⸈⸋⸎-⸖⸘⸙⸛⸞⸟⸪-⸮⸰-⸹⸼-⸿⹁⹃-⹏⹒-⹔、-〃〽・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫︐-︖︙︰﹅﹆﹉-﹌﹐-﹒﹔-﹗﹟-﹡﹨﹪﹫！-＃％-＇＊，．／：；？＠＼｡､･",
      astral: "\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|𐕯|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|𛲟|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]"
    },
    {
      name: "Ps",
      alias: "Open_Punctuation",
      bmp: "\\(\\[\\{༺༼᚛‚„⁅⁽₍⌈⌊〈❨❪❬❮❰❲❴⟅⟦⟨⟪⟬⟮⦃⦅⦇⦉⦋⦍⦏⦑⦓⦕⦗⧘⧚⧼⸢⸤⸦⸨⹂⹕⹗⹙⹛〈《「『【〔〖〘〚〝﴿︗︵︷︹︻︽︿﹁﹃﹇﹙﹛﹝（［｛｟｢"
    },
    {
      name: "S",
      alias: "Symbol",
      bmp: "\\$\\+<->\\^`\\|~¢-¦¨©¬®-±´¸×÷˂-˅˒-˟˥-˫˭˯-˿͵΄΅϶҂֍-֏؆-؈؋؎؏۞۩۽۾߶߾߿࢈৲৳৺৻૱୰௳-௺౿൏൹฿༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭៛᥀᧞-᧿᭡-᭪᭴-᭼᾽᾿-῁῍-῏῝-῟῭-`´῾⁄⁒⁺-⁼₊-₌₠-⃀℀℁℃-℆℈℉℔№-℘℞-℣℥℧℩℮℺℻⅀-⅄⅊-⅍⅏↊↋←-⌇⌌-⌨⌫-␦⑀-⑊⒜-ⓩ─-❧➔-⟄⟇-⟥⟰-⦂⦙-⧗⧜-⧻⧾-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿゛゜㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꜀-꜖꜠꜡꞉꞊꠨-꠫꠶-꠹꩷-꩹꭛꭪꭫﬩﮲-﯂﵀-﵏﷏﷼-﷿﹢﹤-﹦﹩＄＋＜-＞＾｀｜～￠-￦￨-￮￼�",
      astral: "\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|𑜿|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|𛲜|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA]"
    },
    {
      name: "Sc",
      alias: "Currency_Symbol",
      bmp: "\\$¢-¥֏؋߾߿৲৳৻૱௹฿៛₠-⃀꠸﷼﹩＄￠￡￥￦",
      astral: "\uD807[\uDFDD-\uDFE0]|𞋿|𞲰"
    },
    {
      name: "Sk",
      alias: "Modifier_Symbol",
      bmp: "\\^`¨¯´¸˂-˅˒-˟˥-˫˭˯-˿͵΄΅࢈᾽᾿-῁῍-῏῝-῟῭-`´῾゛゜꜀-꜖꜠꜡꞉꞊꭛꭪꭫﮲-﯂＾｀￣",
      astral: "\uD83C[\uDFFB-\uDFFF]"
    },
    {
      name: "Sm",
      alias: "Math_Symbol",
      bmp: "\\+<->\\|~¬±×÷϶؆-؈⁄⁒⁺-⁼₊-₌℘⅀-⅄⅋←-↔↚↛↠↣↦↮⇎⇏⇒⇔⇴-⋿⌠⌡⍼⎛-⎳⏜-⏡▷◁◸-◿♯⟀-⟄⟇-⟥⟰-⟿⤀-⦂⦙-⧗⧜-⧻⧾-⫿⬰-⭄⭇-⭌﬩﹢﹤-﹦＋＜-＞｜～￢￩-￬",
      astral: "\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD83B[\uDEF0\uDEF1]"
    },
    {
      name: "So",
      alias: "Other_Symbol",
      bmp: "¦©®°҂֍֎؎؏۞۩۽۾߶৺୰௳-௸௺౿൏൹༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭᥀᧞-᧿᭡-᭪᭴-᭼℀℁℃-℆℈℉℔№℗℞-℣℥℧℩℮℺℻⅊⅌⅍⅏↊↋↕-↙↜-↟↡↢↤↥↧-↭↯-⇍⇐⇑⇓⇕-⇳⌀-⌇⌌-⌟⌢-⌨⌫-⍻⍽-⎚⎴-⏛⏢-␦⑀-⑊⒜-ⓩ─-▶▸-◀◂-◷☀-♮♰-❧➔-➿⠀-⣿⬀-⬯⭅⭆⭍-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꠨-꠫꠶꠷꠹꩷-꩹﵀-﵏﷏﷽-﷿￤￨￭￮￼�",
      astral: "\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|𑜿|\uD807[\uDFD5-\uDFDC\uDFE1-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|𛲜|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|𞅏|\uD83B[\uDCAC\uDD2E]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFA]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA]"
    },
    {
      name: "Z",
      alias: "Separator",
      bmp: "    - \u2028\u2029  　"
    },
    {
      name: "Zl",
      alias: "Line_Separator",
      bmp: "\u2028"
    },
    {
      name: "Zp",
      alias: "Paragraph_Separator",
      bmp: "\u2029"
    },
    {
      name: "Zs",
      alias: "Space_Separator",
      bmp: "    -   　"
    }
  ]), Yt;
}
var yD = xD();
const vD = /* @__PURE__ */ ne(yD);
/*!
 * XRegExp Unicode Categories 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2010-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const bD = (u) => {
  if (!u.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Categories");
  u.addUnicodeData(vD);
};
var Zt, Wn;
function wD() {
  return Wn || (Wn = 1, Zt = [
    {
      name: "ASCII",
      bmp: "\0-"
    },
    {
      name: "Alphabetic",
      bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͅͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈְ-ׇֽֿׁׂׅׄא-תׯ-ײؐ-ؚؠ-ٗٙ-ٟٮ-ۓە-ۜۡ-ۭۨ-ۯۺ-ۼۿܐ-ܿݍ-ޱߊ-ߪߴߵߺࠀ-ࠗࠚ-ࠬࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉࣔ-ࣣࣟ-ࣰࣩ-ऻऽ-ौॎ-ॐॕ-ॣॱ-ঃঅ-ঌএঐও-নপ-রলশ-হঽ-ৄেৈোৌৎৗড়ঢ়য়-ৣৰৱৼਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਾ-ੂੇੈੋੌੑਖ਼-ੜਫ਼ੰ-ੵઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽ-ૅે-ૉોૌૐૠ-ૣૹ-ૼଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽ-ୄେୈୋୌୖୗଡ଼ଢ଼ୟ-ୣୱஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-ௌௐௗఀ-ఃఅ-ఌఎ-ఐఒ-నప-హఽ-ౄె-ైొ-ౌౕౖౘ-ౚౝౠ-ౣಀ-ಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽ-ೄೆ-ೈೊ-ೌೕೖೝೞೠ-ೣೱೲഀ-ഌഎ-ഐഒ-ഺഽ-ൄെ-ൈൊ-ൌൎൔ-ൗൟ-ൣൺ-ൿඁ-ඃඅ-ඖක-නඳ-රලව-ෆා-ුූෘ-ෟෲෳก-ฺเ-ๆํກຂຄຆ-ຊຌ-ຣລວ-ູົ-ຽເ-ໄໆໍໜ-ໟༀཀ-ཇཉ-ཬཱ-ཱྀྈ-ྗྙ-ྼက-ံးျ-ဿၐ-ႏႚ-ႝႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜓᜟ-ᜳᝀ-ᝓᝠ-ᝬᝮ-ᝰᝲᝳក-ឳា-ៈៗៜᠠ-ᡸᢀ-ᢪᢰ-ᣵᤀ-ᤞᤠ-ᤫᤰ-ᤸᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨛᨠ-ᩞᩡ-ᩴᪧᪿᫀᫌ-ᫎᬀ-ᬳᬵ-ᭃᭅ-ᭌᮀ-ᮩᮬ-ᮯᮺ-ᯥᯧ-ᯱᰀ-ᰶᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿᷧ-ᷴḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⒶ-ⓩⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⷠ-ⷿⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙴ-ꙻꙿ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠅꠇ-ꠧꡀ-ꡳꢀ-ꣃꣅꣲ-ꣷꣻꣽ-ꣿꤊ-ꤪꤰ-ꥒꥠ-ꥼꦀ-ꦲꦴ-ꦿꧏꧠ-ꧯꧺ-ꧾꨀ-ꨶꩀ-ꩍꩠ-ꩶꩺ-ꪾꫀꫂꫛ-ꫝꫠ-ꫯꫲ-ꫵꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯪ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
      astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD27\uDE80-\uDEA9\uDEAB\uDEAC\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC00-\uDC45\uDC71-\uDC75\uDC82-\uDCB8\uDCC2\uDCD0-\uDCE8\uDD00-\uDD32\uDD44-\uDD47\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDCE\uDDCF\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD805[\uDC00-\uDC41\uDC43-\uDC45\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE80-\uDEB5\uDEB8\uDF00-\uDF1A\uDF1D-\uDF2A\uDF40-\uDF46]|\uD806[\uDC00-\uDC38\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B\uDD3C\uDD3F-\uDD42\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDDF\uDDE1\uDDE3\uDDE4\uDE00-\uDE32\uDE35-\uDE3E\uDE50-\uDE97\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC3E\uDC40\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD41\uDD43\uDD46\uDD47\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD96\uDD98\uDEE0-\uDEF6\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF0\uDFF1]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD47\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
    },
    {
      name: "Any",
      isBmpLast: !0,
      bmp: "\0-￿",
      astral: "[\uD800-\uDBFF][\uDC00-\uDFFF]"
    },
    {
      name: "Default_Ignorable_Code_Point",
      bmp: "­͏؜ᅟᅠ឴឵᠋-᠏​-‏‪-‮⁠-⁯ㅤ︀-️\uFEFFﾠ￰-￸",
      astral: "\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|[\uDB40-\uDB43][\uDC00-\uDFFF]"
    },
    {
      name: "Lowercase",
      bmp: "a-zªµºß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʸˀˁˠ-ˤͅͱͳͷͺ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᶿḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷⁱⁿₐ-ₜℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎⅰ-ⅿↄⓐ-ⓩⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱽⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛ-ꚝꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟸ-ꟺꬰ-ꭚꭜ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
      astral: "\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDF80\uDF83-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD81B[\uDE60-\uDE7F]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E]|\uD83A[\uDD22-\uDD43]"
    },
    {
      name: "Noncharacter_Code_Point",
      bmp: "﷐-﷯￾￿",
      astral: "[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]"
    },
    {
      name: "Uppercase",
      bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅⅠ-ⅯↃⒶ-ⓏⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
      astral: "\uD801[\uDC00-\uDC27\uDCB0-\uDCD3\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]"
    },
    {
      name: "White_Space",
      bmp: "	-\r    - \u2028\u2029  　"
    }
  ]), Zt;
}
var jD = wD();
const _D = /* @__PURE__ */ ne(jD);
/*!
 * XRegExp Unicode Properties 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2012-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const SD = (u) => {
  if (!u.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Properties");
  const e = _D;
  e.push({
    name: "Assigned",
    // Since this is defined as the inverse of Unicode category Cn (Unassigned), the Unicode
    // Categories addon is required to use this property
    inverseOf: "Cn"
  }), u.addUnicodeData(e);
};
var Kt, qn;
function PD() {
  return qn || (qn = 1, Kt = [
    {
      name: "Adlam",
      astral: "\uD83A[\uDD00-\uDD4B\uDD50-\uDD59\uDD5E\uDD5F]"
    },
    {
      name: "Ahom",
      astral: "\uD805[\uDF00-\uDF1A\uDF1D-\uDF2B\uDF30-\uDF46]"
    },
    {
      name: "Anatolian_Hieroglyphs",
      astral: "\uD811[\uDC00-\uDE46]"
    },
    {
      name: "Arabic",
      bmp: "؀-؄؆-؋؍-ؚ؜-؞ؠ-ؿف-يٖ-ٯٱ-ۜ۞-ۿݐ-ݿࡰ-ࢎ࢐࢑࢘-ࣣ࣡-ࣿﭐ-﯂ﯓ-ﴽ﵀-ﶏﶒ-ﷇ﷏ﷰ-﷿ﹰ-ﹴﹶ-ﻼ",
      astral: "\uD803[\uDE60-\uDE7E]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]"
    },
    {
      name: "Armenian",
      bmp: "Ա-Ֆՙ-֊֍-֏ﬓ-ﬗ"
    },
    {
      name: "Avestan",
      astral: "\uD802[\uDF00-\uDF35\uDF39-\uDF3F]"
    },
    {
      name: "Balinese",
      bmp: "ᬀ-ᭌ᭐-᭾"
    },
    {
      name: "Bamum",
      bmp: "ꚠ-꛷",
      astral: "\uD81A[\uDC00-\uDE38]"
    },
    {
      name: "Bassa_Vah",
      astral: "\uD81A[\uDED0-\uDEED\uDEF0-\uDEF5]"
    },
    {
      name: "Batak",
      bmp: "ᯀ-᯳᯼-᯿"
    },
    {
      name: "Bengali",
      bmp: "ঀ-ঃঅ-ঌএঐও-নপ-রলশ-হ়-ৄেৈো-ৎৗড়ঢ়য়-ৣ০-৾"
    },
    {
      name: "Bhaiksuki",
      astral: "\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC45\uDC50-\uDC6C]"
    },
    {
      name: "Bopomofo",
      bmp: "˪˫ㄅ-ㄯㆠ-ㆿ"
    },
    {
      name: "Brahmi",
      astral: "\uD804[\uDC00-\uDC4D\uDC52-\uDC75\uDC7F]"
    },
    {
      name: "Braille",
      bmp: "⠀-⣿"
    },
    {
      name: "Buginese",
      bmp: "ᨀ-ᨛ᨞᨟"
    },
    {
      name: "Buhid",
      bmp: "ᝀ-ᝓ"
    },
    {
      name: "Canadian_Aboriginal",
      bmp: "᐀-ᙿᢰ-ᣵ",
      astral: "\uD806[\uDEB0-\uDEBF]"
    },
    {
      name: "Carian",
      astral: "\uD800[\uDEA0-\uDED0]"
    },
    {
      name: "Caucasian_Albanian",
      astral: "\uD801[\uDD30-\uDD63\uDD6F]"
    },
    {
      name: "Chakma",
      astral: "\uD804[\uDD00-\uDD34\uDD36-\uDD47]"
    },
    {
      name: "Cham",
      bmp: "ꨀ-ꨶꩀ-ꩍ꩐-꩙꩜-꩟"
    },
    {
      name: "Cherokee",
      bmp: "Ꭰ-Ᏽᏸ-ᏽꭰ-ꮿ"
    },
    {
      name: "Chorasmian",
      astral: "\uD803[\uDFB0-\uDFCB]"
    },
    {
      name: "Common",
      bmp: "\0-@\\[-`\\{-©«-¹»-¿×÷ʹ-˟˥-˩ˬ-˿ʹ;΅·؅،؛؟ـ۝࣢।॥฿࿕-࿘჻᛫-᛭᜵᜶᠂᠃᠅᳓᳡ᳩ-ᳬᳮ-ᳳᳵ-᳷ᳺ -​‎-⁤⁦-⁰⁴-⁾₀-₎₠-⃀℀-℥℧-℩ℬ-ℱℳ-⅍⅏-⅟↉-↋←-␦⑀-⑊①-⟿⤀-⭳⭶-⮕⮗-⯿⸀-⹝⿰-⿻　-〄〆〈-〠〰-〷〼-〿゛゜゠・ー㆐-㆟㇀-㇣㈠-㉟㉿-㋏㋿㍘-㏿䷀-䷿꜀-꜡ꞈ-꞊꠰-꠹꤮ꧏ꭛꭪꭫﴾﴿︐-︙︰-﹒﹔-﹦﹨-﹫\uFEFF！-＠［-｀｛-･ｰﾞﾟ￠-￦￨-￮￹-�",
      astral: "\uD800[\uDD00-\uDD02\uDD07-\uDD33\uDD37-\uDD3F\uDD90-\uDD9C\uDDD0-\uDDFC\uDEE1-\uDEFB]|\uD82F[\uDCA0-\uDCA3]|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD66\uDD6A-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDEE0-\uDEF3\uDF00-\uDF56\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDFCB\uDFCE-\uDFFF]|\uD83B[\uDC71-\uDCB4\uDD01-\uDD3D]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD00-\uDDAD\uDDE6-\uDDFF\uDE01\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDD-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6\uDF00-\uDF92\uDF94-\uDFCA\uDFF0-\uDFF9]|\uDB40[\uDC01\uDC20-\uDC7F]"
    },
    {
      name: "Coptic",
      bmp: "Ϣ-ϯⲀ-ⳳ⳹-⳿"
    },
    {
      name: "Cuneiform",
      astral: "\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC70-\uDC74\uDC80-\uDD43]"
    },
    {
      name: "Cypriot",
      astral: "\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F]"
    },
    {
      name: "Cypro_Minoan",
      astral: "\uD80B[\uDF90-\uDFF2]"
    },
    {
      name: "Cyrillic",
      bmp: "Ѐ-҄҇-ԯᲀ-ᲈᴫᵸⷠ-ⷿꙀ-ꚟ︮︯"
    },
    {
      name: "Deseret",
      astral: "\uD801[\uDC00-\uDC4F]"
    },
    {
      name: "Devanagari",
      bmp: "ऀ-ॐॕ-ॣ०-ॿ꣠-ꣿ"
    },
    {
      name: "Dives_Akuru",
      astral: "\uD806[\uDD00-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B-\uDD46\uDD50-\uDD59]"
    },
    {
      name: "Dogra",
      astral: "\uD806[\uDC00-\uDC3B]"
    },
    {
      name: "Duployan",
      astral: "\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]"
    },
    {
      name: "Egyptian_Hieroglyphs",
      astral: "\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E\uDC30-\uDC38]"
    },
    {
      name: "Elbasan",
      astral: "\uD801[\uDD00-\uDD27]"
    },
    {
      name: "Elymaic",
      astral: "\uD803[\uDFE0-\uDFF6]"
    },
    {
      name: "Ethiopic",
      bmp: "ሀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፝-፼ᎀ-᎙ⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮ",
      astral: "\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]"
    },
    {
      name: "Georgian",
      bmp: "Ⴀ-ჅჇჍა-ჺჼ-ჿᲐ-ᲺᲽ-Ჿⴀ-ⴥⴧⴭ"
    },
    {
      name: "Glagolitic",
      bmp: "Ⰰ-ⱟ",
      astral: "\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]"
    },
    {
      name: "Gothic",
      astral: "\uD800[\uDF30-\uDF4A]"
    },
    {
      name: "Grantha",
      astral: "\uD804[\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]"
    },
    {
      name: "Greek",
      bmp: "Ͱ-ͳ͵-ͷͺ-ͽͿ΄ΆΈ-ΊΌΎ-ΡΣ-ϡϰ-Ͽᴦ-ᴪᵝ-ᵡᵦ-ᵪᶿἀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ῄῆ-ΐῖ-Ί῝-`ῲ-ῴῶ-῾Ωꭥ",
      astral: "\uD800[\uDD40-\uDD8E\uDDA0]|\uD834[\uDE00-\uDE45]"
    },
    {
      name: "Gujarati",
      bmp: "ઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હ઼-ૅે-ૉો-્ૐૠ-ૣ૦-૱ૹ-૿"
    },
    {
      name: "Gunjala_Gondi",
      astral: "\uD807[\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD98\uDDA0-\uDDA9]"
    },
    {
      name: "Gurmukhi",
      bmp: "ਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹ਼ਾ-ੂੇੈੋ-੍ੑਖ਼-ੜਫ਼੦-੶"
    },
    {
      name: "Han",
      bmp: "⺀-⺙⺛-⻳⼀-⿕々〇〡-〩〸-〻㐀-䶿一-鿿豈-舘並-龎",
      astral: "\uD81B[\uDFE2\uDFE3\uDFF0\uDFF1]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]"
    },
    {
      name: "Hangul",
      bmp: "ᄀ-ᇿ〮〯ㄱ-ㆎ㈀-㈞㉠-㉾ꥠ-ꥼ가-힣ힰ-ퟆퟋ-ퟻﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ"
    },
    {
      name: "Hanifi_Rohingya",
      astral: "\uD803[\uDD00-\uDD27\uDD30-\uDD39]"
    },
    {
      name: "Hanunoo",
      bmp: "ᜠ-᜴"
    },
    {
      name: "Hatran",
      astral: "\uD802[\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDCFF]"
    },
    {
      name: "Hebrew",
      bmp: "֑-ׇא-תׯ-״יִ-זּטּ-לּמּנּסּףּפּצּ-ﭏ"
    },
    {
      name: "Hiragana",
      bmp: "ぁ-ゖゝ-ゟ",
      astral: "\uD82C[\uDC01-\uDD1F\uDD50-\uDD52]|🈀"
    },
    {
      name: "Imperial_Aramaic",
      astral: "\uD802[\uDC40-\uDC55\uDC57-\uDC5F]"
    },
    {
      name: "Inherited",
      bmp: "̀-ًͯ҅҆-ٰٕ॑-॔᪰-ᫎ᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿‌‍⃐-〪⃰-゙゚〭︀-️︠-︭",
      astral: "\uD800[\uDDFD\uDEE0]|𑌻|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uDB40[\uDD00-\uDDEF]"
    },
    {
      name: "Inscriptional_Pahlavi",
      astral: "\uD802[\uDF60-\uDF72\uDF78-\uDF7F]"
    },
    {
      name: "Inscriptional_Parthian",
      astral: "\uD802[\uDF40-\uDF55\uDF58-\uDF5F]"
    },
    {
      name: "Javanese",
      bmp: "ꦀ-꧍꧐-꧙꧞꧟"
    },
    {
      name: "Kaithi",
      astral: "\uD804[\uDC80-\uDCC2\uDCCD]"
    },
    {
      name: "Kannada",
      bmp: "ಀ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹ಼-ೄೆ-ೈೊ-್ೕೖೝೞೠ-ೣ೦-೯ೱೲ"
    },
    {
      name: "Katakana",
      bmp: "ァ-ヺヽ-ヿㇰ-ㇿ㋐-㋾㌀-㍗ｦ-ｯｱ-ﾝ",
      astral: "\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00\uDD20-\uDD22\uDD64-\uDD67]"
    },
    {
      name: "Kayah_Li",
      bmp: "꤀-꤭꤯"
    },
    {
      name: "Kharoshthi",
      astral: "\uD802[\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE38-\uDE3A\uDE3F-\uDE48\uDE50-\uDE58]"
    },
    {
      name: "Khitan_Small_Script",
      astral: "𖿤|\uD822[\uDF00-\uDFFF]|\uD823[\uDC00-\uDCD5]"
    },
    {
      name: "Khmer",
      bmp: "ក-៝០-៩៰-៹᧠-᧿"
    },
    {
      name: "Khojki",
      astral: "\uD804[\uDE00-\uDE11\uDE13-\uDE3E]"
    },
    {
      name: "Khudawadi",
      astral: "\uD804[\uDEB0-\uDEEA\uDEF0-\uDEF9]"
    },
    {
      name: "Lao",
      bmp: "ກຂຄຆ-ຊຌ-ຣລວ-ຽເ-ໄໆ່-ໍ໐-໙ໜ-ໟ"
    },
    {
      name: "Latin",
      bmp: "A-Za-zªºÀ-ÖØ-öø-ʸˠ-ˤᴀ-ᴥᴬ-ᵜᵢ-ᵥᵫ-ᵷᵹ-ᶾḀ-ỿⁱⁿₐ-ₜKÅℲⅎⅠ-ↈⱠ-ⱿꜢ-ꞇꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꟿꬰ-ꭚꭜ-ꭤꭦ-ꭩﬀ-ﬆＡ-Ｚａ-ｚ",
      astral: "\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD837[\uDF00-\uDF1E]"
    },
    {
      name: "Lepcha",
      bmp: "ᰀ-᰷᰻-᱉ᱍ-ᱏ"
    },
    {
      name: "Limbu",
      bmp: "ᤀ-ᤞᤠ-ᤫᤰ-᤻᥀᥄-᥏"
    },
    {
      name: "Linear_A",
      astral: "\uD801[\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]"
    },
    {
      name: "Linear_B",
      astral: "\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA]"
    },
    {
      name: "Lisu",
      bmp: "ꓐ-꓿",
      astral: "𑾰"
    },
    {
      name: "Lycian",
      astral: "\uD800[\uDE80-\uDE9C]"
    },
    {
      name: "Lydian",
      astral: "\uD802[\uDD20-\uDD39\uDD3F]"
    },
    {
      name: "Mahajani",
      astral: "\uD804[\uDD50-\uDD76]"
    },
    {
      name: "Makasar",
      astral: "\uD807[\uDEE0-\uDEF8]"
    },
    {
      name: "Malayalam",
      bmp: "ഀ-ഌഎ-ഐഒ-ൄെ-ൈൊ-൏ൔ-ൣ൦-ൿ"
    },
    {
      name: "Mandaic",
      bmp: "ࡀ-࡛࡞"
    },
    {
      name: "Manichaean",
      astral: "\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6]"
    },
    {
      name: "Marchen",
      astral: "\uD807[\uDC70-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]"
    },
    {
      name: "Masaram_Gondi",
      astral: "\uD807[\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]"
    },
    {
      name: "Medefaidrin",
      astral: "\uD81B[\uDE40-\uDE9A]"
    },
    {
      name: "Meetei_Mayek",
      bmp: "ꫠ-꫶ꯀ-꯭꯰-꯹"
    },
    {
      name: "Mende_Kikakui",
      astral: "\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6]"
    },
    {
      name: "Meroitic_Cursive",
      astral: "\uD802[\uDDA0-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDDFF]"
    },
    {
      name: "Meroitic_Hieroglyphs",
      astral: "\uD802[\uDD80-\uDD9F]"
    },
    {
      name: "Miao",
      astral: "\uD81B[\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F]"
    },
    {
      name: "Modi",
      astral: "\uD805[\uDE00-\uDE44\uDE50-\uDE59]"
    },
    {
      name: "Mongolian",
      bmp: "᠀᠁᠄᠆-᠙ᠠ-ᡸᢀ-ᢪ",
      astral: "\uD805[\uDE60-\uDE6C]"
    },
    {
      name: "Mro",
      astral: "\uD81A[\uDE40-\uDE5E\uDE60-\uDE69\uDE6E\uDE6F]"
    },
    {
      name: "Multani",
      astral: "\uD804[\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9]"
    },
    {
      name: "Myanmar",
      bmp: "က-႟ꧠ-ꧾꩠ-ꩿ"
    },
    {
      name: "Nabataean",
      astral: "\uD802[\uDC80-\uDC9E\uDCA7-\uDCAF]"
    },
    {
      name: "Nandinagari",
      astral: "\uD806[\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDE4]"
    },
    {
      name: "New_Tai_Lue",
      bmp: "ᦀ-ᦫᦰ-ᧉ᧐-᧚᧞᧟"
    },
    {
      name: "Newa",
      astral: "\uD805[\uDC00-\uDC5B\uDC5D-\uDC61]"
    },
    {
      name: "Nko",
      bmp: "߀-ߺ߽-߿"
    },
    {
      name: "Nushu",
      astral: "𖿡|\uD82C[\uDD70-\uDEFB]"
    },
    {
      name: "Nyiakeng_Puachue_Hmong",
      astral: "\uD838[\uDD00-\uDD2C\uDD30-\uDD3D\uDD40-\uDD49\uDD4E\uDD4F]"
    },
    {
      name: "Ogham",
      bmp: " -᚜"
    },
    {
      name: "Ol_Chiki",
      bmp: "᱐-᱿"
    },
    {
      name: "Old_Hungarian",
      astral: "\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDCFF]"
    },
    {
      name: "Old_Italic",
      astral: "\uD800[\uDF00-\uDF23\uDF2D-\uDF2F]"
    },
    {
      name: "Old_North_Arabian",
      astral: "\uD802[\uDE80-\uDE9F]"
    },
    {
      name: "Old_Permic",
      astral: "\uD800[\uDF50-\uDF7A]"
    },
    {
      name: "Old_Persian",
      astral: "\uD800[\uDFA0-\uDFC3\uDFC8-\uDFD5]"
    },
    {
      name: "Old_Sogdian",
      astral: "\uD803[\uDF00-\uDF27]"
    },
    {
      name: "Old_South_Arabian",
      astral: "\uD802[\uDE60-\uDE7F]"
    },
    {
      name: "Old_Turkic",
      astral: "\uD803[\uDC00-\uDC48]"
    },
    {
      name: "Old_Uyghur",
      astral: "\uD803[\uDF70-\uDF89]"
    },
    {
      name: "Oriya",
      bmp: "ଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହ଼-ୄେୈୋ-୍୕-ୗଡ଼ଢ଼ୟ-ୣ୦-୷"
    },
    {
      name: "Osage",
      astral: "\uD801[\uDCB0-\uDCD3\uDCD8-\uDCFB]"
    },
    {
      name: "Osmanya",
      astral: "\uD801[\uDC80-\uDC9D\uDCA0-\uDCA9]"
    },
    {
      name: "Pahawh_Hmong",
      astral: "\uD81A[\uDF00-\uDF45\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]"
    },
    {
      name: "Palmyrene",
      astral: "\uD802[\uDC60-\uDC7F]"
    },
    {
      name: "Pau_Cin_Hau",
      astral: "\uD806[\uDEC0-\uDEF8]"
    },
    {
      name: "Phags_Pa",
      bmp: "ꡀ-꡷"
    },
    {
      name: "Phoenician",
      astral: "\uD802[\uDD00-\uDD1B\uDD1F]"
    },
    {
      name: "Psalter_Pahlavi",
      astral: "\uD802[\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]"
    },
    {
      name: "Rejang",
      bmp: "ꤰ-꥓꥟"
    },
    {
      name: "Runic",
      bmp: "ᚠ-ᛪᛮ-ᛸ"
    },
    {
      name: "Samaritan",
      bmp: "ࠀ-࠭࠰-࠾"
    },
    {
      name: "Saurashtra",
      bmp: "ꢀ-ꣅ꣎-꣙"
    },
    {
      name: "Sharada",
      astral: "\uD804[\uDD80-\uDDDF]"
    },
    {
      name: "Shavian",
      astral: "\uD801[\uDC50-\uDC7F]"
    },
    {
      name: "Siddham",
      astral: "\uD805[\uDD80-\uDDB5\uDDB8-\uDDDD]"
    },
    {
      name: "SignWriting",
      astral: "\uD836[\uDC00-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]"
    },
    {
      name: "Sinhala",
      bmp: "ඁ-ඃඅ-ඖක-නඳ-රලව-ෆ්ා-ුූෘ-ෟ෦-෯ෲ-෴",
      astral: "\uD804[\uDDE1-\uDDF4]"
    },
    {
      name: "Sogdian",
      astral: "\uD803[\uDF30-\uDF59]"
    },
    {
      name: "Sora_Sompeng",
      astral: "\uD804[\uDCD0-\uDCE8\uDCF0-\uDCF9]"
    },
    {
      name: "Soyombo",
      astral: "\uD806[\uDE50-\uDEA2]"
    },
    {
      name: "Sundanese",
      bmp: "ᮀ-ᮿ᳀-᳇"
    },
    {
      name: "Syloti_Nagri",
      bmp: "ꠀ-꠬"
    },
    {
      name: "Syriac",
      bmp: "܀-܍܏-݊ݍ-ݏࡠ-ࡪ"
    },
    {
      name: "Tagalog",
      bmp: "ᜀ-᜕ᜟ"
    },
    {
      name: "Tagbanwa",
      bmp: "ᝠ-ᝬᝮ-ᝰᝲᝳ"
    },
    {
      name: "Tai_Le",
      bmp: "ᥐ-ᥭᥰ-ᥴ"
    },
    {
      name: "Tai_Tham",
      bmp: "ᨠ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪠-᪭"
    },
    {
      name: "Tai_Viet",
      bmp: "ꪀ-ꫂꫛ-꫟"
    },
    {
      name: "Takri",
      astral: "\uD805[\uDE80-\uDEB9\uDEC0-\uDEC9]"
    },
    {
      name: "Tamil",
      bmp: "ஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-்ௐௗ௦-௺",
      astral: "\uD807[\uDFC0-\uDFF1\uDFFF]"
    },
    {
      name: "Tangsa",
      astral: "\uD81A[\uDE70-\uDEBE\uDEC0-\uDEC9]"
    },
    {
      name: "Tangut",
      astral: "𖿠|[\uD81C-\uD820][\uDC00-\uDFFF]|\uD821[\uDC00-\uDFF7]|\uD822[\uDC00-\uDEFF]|\uD823[\uDD00-\uDD08]"
    },
    {
      name: "Telugu",
      bmp: "ఀ-ఌఎ-ఐఒ-నప-హ఼-ౄె-ైొ-్ౕౖౘ-ౚౝౠ-ౣ౦-౯౷-౿"
    },
    {
      name: "Thaana",
      bmp: "ހ-ޱ"
    },
    {
      name: "Thai",
      bmp: "ก-ฺเ-๛"
    },
    {
      name: "Tibetan",
      bmp: "ༀ-ཇཉ-ཬཱ-ྗྙ-ྼ྾-࿌࿎-࿔࿙࿚"
    },
    {
      name: "Tifinagh",
      bmp: "ⴰ-ⵧⵯ⵰⵿"
    },
    {
      name: "Tirhuta",
      astral: "\uD805[\uDC80-\uDCC7\uDCD0-\uDCD9]"
    },
    {
      name: "Toto",
      astral: "\uD838[\uDE90-\uDEAE]"
    },
    {
      name: "Ugaritic",
      astral: "\uD800[\uDF80-\uDF9D\uDF9F]"
    },
    {
      name: "Vai",
      bmp: "ꔀ-ꘫ"
    },
    {
      name: "Vithkuqi",
      astral: "\uD801[\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]"
    },
    {
      name: "Wancho",
      astral: "\uD838[\uDEC0-\uDEF9\uDEFF]"
    },
    {
      name: "Warang_Citi",
      astral: "\uD806[\uDCA0-\uDCF2\uDCFF]"
    },
    {
      name: "Yezidi",
      astral: "\uD803[\uDE80-\uDEA9\uDEAB-\uDEAD\uDEB0\uDEB1]"
    },
    {
      name: "Yi",
      bmp: "ꀀ-ꒌ꒐-꓆"
    },
    {
      name: "Zanabazar_Square",
      astral: "\uD806[\uDE00-\uDE47]"
    }
  ]), Kt;
}
var TD = PD();
const kD = /* @__PURE__ */ ne(TD);
/*!
 * XRegExp Unicode Scripts 5.1.2
 * <xregexp.com>
 * Steven Levithan (c) 2010-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
const ND = (u) => {
  if (!u.addUnicodeData)
    throw new ReferenceError("Unicode Base must be loaded before Unicode Scripts");
  u.addUnicodeData(kD, "Script");
};
mD(H);
gD(H);
BD(H);
bD(H);
SD(H);
ND(H);
const OD = H(
  // prettier-ignore
  /@\[(\d+)\]\(([^)]+)\)+/i
), $D = H(
  // prettier-ignore
  // eslint-disable-next-line no-useless-escape
  /@\[(urn:li:(organization|person):[A-Za-z0-9\_\-]+)\]\(([^)]+)\)+/i
), RD = H(
  // prettier-ignore
  /(?:@)([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/i
), ID = H(
  // prettier-ignore
  /(?:@)([A-Za-z0-9_](?:[A-Za-z0-9_.]{0,28}(?:[A-Za-z0-9_]))?)/i
), LD = H(
  // prettier-ignore
  /(#+[a-zA-Z0-9(_)]{1,})/i
);
function MD({
  host: u,
  tag: e,
  label: t
}) {
  return /* @__PURE__ */ r.jsx("a", { className: "sked-mention sked-mention-link", target: "_blank", rel: "noreferrer", href: `${u}${e}`, children: t }, t);
}
function zD({
  label: u
}) {
  return /* @__PURE__ */ r.jsx("span", { children: u }, `unknown-${u}`);
}
class UD extends Me {
  constructor(e, t) {
    super(e), this.targetPlatform = t;
  }
  match(e) {
    const t = e.match(LD);
    return !t || t.index === void 0 ? null : {
      index: t.index,
      length: t[0].length,
      match: t[0],
      urn: t[0],
      label: t[0],
      valid: !0
    };
  }
  replaceWith(e, t) {
    let {
      label: n
    } = t;
    const s = n.replace("#", "");
    let i;
    switch (this.targetPlatform) {
      case "IG":
        i = "https://www.instagram.com/explore/tags/";
        break;
      case "TW":
        i = "https://twitter.com/hashtag/";
        break;
      case "TH":
        i = "https://threads.net/search?q=", n = n.replace("#", "");
        break;
      case "LI":
        i = "https://www.linkedin.com/feed/hashtag/";
        break;
      case "TT":
        i = "https://www.tiktok.com/tag/";
        break;
      case "FB":
        i = "https://www.facebook.com/hashtag/";
        break;
      default:
        i = null;
    }
    return i ? uu.createElement(MD, {
      tag: s,
      host: i,
      label: n
    }, e) : uu.createElement(zD, {
      label: n
    }, e);
  }
  asTag() {
    return "a";
  }
}
function HD({
  host: u,
  username: e,
  label: t
}) {
  return /* @__PURE__ */ r.jsx("a", { className: "sked-mention sked-mention-link", target: "_blank", rel: "noreferrer", href: `${u}/${e}`, children: t }, t);
}
class VD extends Me {
  constructor(e, t) {
    if (super(e), this.targetPlatform = t, this.platformHosts = {
      IG: "https://instagram.com",
      TW: "https://twitter.com",
      TH: "https://threads.net",
      TT: "https://tiktok.com",
      PI: "https://pinterest.com"
    }, !this.platformHosts[t])
      throw new Error(`Unsupported "targetPlatform": ${t}`);
  }
  match(e) {
    const t = this.targetPlatform === "TT" ? ID : RD, n = e.match(t);
    if (!n || n.index === void 0)
      return null;
    const s = this.targetPlatform === "IG" ? n[0].replace("@", "") : n[0];
    return {
      index: n.index,
      length: n[0].length,
      match: n[0],
      urn: s,
      label: n[0],
      valid: !0
    };
  }
  replaceWith(e, t) {
    const {
      label: n
    } = t;
    if (!n)
      throw new Error("Username is required.");
    const s = this.platformHosts[this.targetPlatform], i = this.targetPlatform === "IG" ? n.replace(/^@/, "") : n;
    return uu.createElement(HD, {
      ...t,
      host: s,
      username: i
    }, e);
  }
  asTag() {
    return "a";
  }
}
function WD({
  urn: u,
  label: e,
  orgId: t,
  trackEvent: n
}) {
  return /* @__PURE__ */ r.jsx("span", { className: "sked-mention sked-mention-linkedin", title: `LinkedIn organization: ${u}`, onClick: () => {
    n && n("link-preview-clicked"), window.open(`https://www.linkedin.com/company/${t}`, "_blank");
  }, children: e }, u);
}
function qD({
  label: u,
  urn: e
}) {
  return /* @__PURE__ */ r.jsx("span", { className: "sked-mention sked-mention-linkedin", title: `Person mention for ${u}. Sked currently can't link you directly to the person's profile.`, children: u }, `unknown-${e}${u}`);
}
class GD extends Me {
  constructor(e, t, n) {
    super(e), this.targetPlatform = t, this.trackEvent = n;
  }
  match(e) {
    const t = e.match($D);
    return !t || t.index === void 0 ? null : {
      index: t.index,
      length: t[0].length,
      match: t[0],
      urn: t[1],
      label: t[3],
      valid: !0
    };
  }
  replaceWith(e, t) {
    const {
      urn: n,
      label: s
    } = t;
    if (this.targetPlatform === "LI" && n.includes("organization")) {
      const i = n.split(":").pop();
      return uu.createElement(WD, {
        urn: n,
        label: s,
        orgId: i,
        trackEvent: this.trackEvent
      }, e);
    } else
      return uu.createElement(qD, {
        urn: n,
        label: s,
        trackEvent: this.trackEvent
      }, e);
  }
  asTag() {
    return "span";
  }
}
function Gn({
  id: u,
  label: e
}) {
  return /* @__PURE__ */ r.jsx("a", { className: "sked-mention sked-mention-link sked-mention-facebook", target: "_blank", rel: "noreferrer", href: `https://www.facebook.com/${u}`, children: e }, e);
}
class YD extends Me {
  constructor(e, t) {
    super(e), this.targetPlatform = t;
  }
  match(e) {
    const t = e.match(OD);
    return !t || t.index === void 0 ? null : {
      index: t.index,
      length: t[0].length,
      match: t[0],
      id: t[1],
      label: t[2],
      valid: !0
    };
  }
  replaceWith(e, t) {
    return this.targetPlatform === "FB" ? uu.createElement(Gn, t, e) : uu.createElement(Gn, t, e);
  }
  asTag() {
    return "a";
  }
}
function ZD(u, e) {
  u === void 0 && (u = "");
  const t = [new oD("url"), new UD("hashtag", u)];
  switch (u) {
    case "IG":
    case "TW":
    case "TT":
    case "TH":
    case "PI":
      return [new VD("socialLink", u), ...t];
    default:
      return [new YD("fb", u), new GD("li", u, e), ...t];
  }
}
function vu({
  caption: u,
  targetPlatform: e,
  trackEvent: t
}) {
  const n = u, s = ZD(e, t);
  return /* @__PURE__ */ r.jsx(Xo, { content: n, matchers: s, newWindow: !0 });
}
function G2({
  caption: u,
  targetPlatform: e
}) {
  return /* @__PURE__ */ r.jsx(KD, { children: /* @__PURE__ */ r.jsx(vu, { caption: u, targetPlatform: e }) });
}
const KD = _.div`
  .sked-mention {
    color: hsl(214, 89%, 52%);

    &:hover {
      text-decoration: underline;
    }
  }
`;
var Jt, Yn;
function JD() {
  if (Yn) return Jt;
  Yn = 1, Jt = function(s, i, a) {
    var D = document.head || document.getElementsByTagName("head")[0], o = document.createElement("script");
    typeof i == "function" && (a = i, i = {}), i = i || {}, a = a || function() {
    }, o.type = i.type || "text/javascript", o.charset = i.charset || "utf8", o.async = "async" in i ? !!i.async : !0, o.src = s, i.attrs && u(o, i.attrs), i.text && (o.text = "" + i.text);
    var d = "onload" in o ? e : t;
    d(o, a), o.onload || e(o, a), D.appendChild(o);
  };
  function u(n, s) {
    for (var i in s)
      n.setAttribute(i, s[i]);
  }
  function e(n, s) {
    n.onload = function() {
      this.onerror = this.onload = null, s(null, n);
    }, n.onerror = function() {
      this.onerror = this.onload = null, s(new Error("Failed to load " + this.src), n);
    };
  }
  function t(n, s) {
    n.onreadystatechange = function() {
      this.readyState != "complete" && this.readyState != "loaded" || (this.onreadystatechange = null, s(null, n));
    };
  }
  return Jt;
}
var Xt, Zn;
function Ls() {
  if (Zn) return Xt;
  Zn = 1;
  var u = function(l) {
    return e(l) && !t(l);
  };
  function e(B) {
    return !!B && typeof B == "object";
  }
  function t(B) {
    var l = Object.prototype.toString.call(B);
    return l === "[object RegExp]" || l === "[object Date]" || i(B);
  }
  var n = typeof Symbol == "function" && Symbol.for, s = n ? Symbol.for("react.element") : 60103;
  function i(B) {
    return B.$$typeof === s;
  }
  function a(B) {
    return Array.isArray(B) ? [] : {};
  }
  function D(B, l) {
    return l.clone !== !1 && l.isMergeableObject(B) ? f(a(B), B, l) : B;
  }
  function o(B, l, p) {
    return B.concat(l).map(function(E) {
      return D(E, p);
    });
  }
  function d(B, l) {
    if (!l.customMerge)
      return f;
    var p = l.customMerge(B);
    return typeof p == "function" ? p : f;
  }
  function x(B) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(B).filter(function(l) {
      return Object.propertyIsEnumerable.call(B, l);
    }) : [];
  }
  function c(B) {
    return Object.keys(B).concat(x(B));
  }
  function h(B, l) {
    try {
      return l in B;
    } catch {
      return !1;
    }
  }
  function F(B, l) {
    return h(B, l) && !(Object.hasOwnProperty.call(B, l) && Object.propertyIsEnumerable.call(B, l));
  }
  function C(B, l, p) {
    var E = {};
    return p.isMergeableObject(B) && c(B).forEach(function(A) {
      E[A] = D(B[A], p);
    }), c(l).forEach(function(A) {
      F(B, A) || (h(B, A) && p.isMergeableObject(l[A]) ? E[A] = d(A, p)(B[A], l[A], p) : E[A] = D(l[A], p));
    }), E;
  }
  function f(B, l, p) {
    p = p || {}, p.arrayMerge = p.arrayMerge || o, p.isMergeableObject = p.isMergeableObject || u, p.cloneUnlessOtherwiseSpecified = D;
    var E = Array.isArray(l), A = Array.isArray(B), b = E === A;
    return b ? E ? p.arrayMerge(B, l, p) : C(B, l, p) : D(l, p);
  }
  f.all = function(l, p) {
    if (!Array.isArray(l))
      throw new Error("first argument should be an array");
    return l.reduce(function(E, A) {
      return f(E, A, p);
    }, {});
  };
  var y = f;
  return Xt = y, Xt;
}
var Qt, Kn;
function jt() {
  if (Kn) return Qt;
  Kn = 1;
  var u = Object.create, e = Object.defineProperty, t = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, s = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, a = (N, v) => {
    for (var S in v)
      e(N, S, { get: v[S], enumerable: !0 });
  }, D = (N, v, S, R) => {
    if (v && typeof v == "object" || typeof v == "function")
      for (let V of n(v))
        !i.call(N, V) && V !== S && e(N, V, { get: () => v[V], enumerable: !(R = t(v, V)) || R.enumerable });
    return N;
  }, o = (N, v, S) => (S = N != null ? u(s(N)) : {}, D(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !N || !N.__esModule ? e(S, "default", { value: N, enumerable: !0 }) : S,
    N
  )), d = (N) => D(e({}, "__esModule", { value: !0 }), N), x = {};
  a(x, {
    callPlayer: () => j,
    getConfig: () => I,
    getSDK: () => k,
    isBlobUrl: () => J,
    isMediaStream: () => M,
    lazy: () => C,
    omit: () => O,
    parseEndTime: () => b,
    parseStartTime: () => A,
    queryString: () => P,
    randomString: () => w,
    supportsWebKitPresentationMode: () => su
  }), Qt = d(x);
  var c = o(uu), h = o(JD()), F = o(Ls());
  const C = (N) => c.default.lazy(async () => {
    const v = await N();
    return typeof v.default == "function" ? v : v.default;
  }), f = /[?&#](?:start|t)=([0-9hms]+)/, y = /[?&#]end=([0-9hms]+)/, B = /(\d+)(h|m|s)/g, l = /^\d+$/;
  function p(N, v) {
    if (N instanceof Array)
      return;
    const S = N.match(v);
    if (S) {
      const R = S[1];
      if (R.match(B))
        return E(R);
      if (l.test(R))
        return parseInt(R);
    }
  }
  function E(N) {
    let v = 0, S = B.exec(N);
    for (; S !== null; ) {
      const [, R, V] = S;
      V === "h" && (v += parseInt(R, 10) * 60 * 60), V === "m" && (v += parseInt(R, 10) * 60), V === "s" && (v += parseInt(R, 10)), S = B.exec(N);
    }
    return v;
  }
  function A(N) {
    return p(N, f);
  }
  function b(N) {
    return p(N, y);
  }
  function w() {
    return Math.random().toString(36).substr(2, 5);
  }
  function P(N) {
    return Object.keys(N).map((v) => `${v}=${N[v]}`).join("&");
  }
  function q(N) {
    return window[N] ? window[N] : window.exports && window.exports[N] ? window.exports[N] : window.module && window.module.exports && window.module.exports[N] ? window.module.exports[N] : null;
  }
  const z = {}, k = function(v, S, R = null, V = () => !0, U = h.default) {
    const Z = q(S);
    return Z && V(Z) ? Promise.resolve(Z) : new Promise((Y, K) => {
      if (z[v]) {
        z[v].push({ resolve: Y, reject: K });
        return;
      }
      z[v] = [{ resolve: Y, reject: K }];
      const X = (L) => {
        z[v].forEach((W) => W.resolve(L));
      };
      if (R) {
        const L = window[R];
        window[R] = function() {
          L && L(), X(q(S));
        };
      }
      U(v, (L) => {
        L ? (z[v].forEach((W) => W.reject(L)), z[v] = null) : R || X(q(S));
      });
    });
  };
  function I(N, v) {
    return (0, F.default)(v.config, N.config);
  }
  function O(N, ...v) {
    const S = [].concat(...v), R = {}, V = Object.keys(N);
    for (const U of V)
      S.indexOf(U) === -1 && (R[U] = N[U]);
    return R;
  }
  function j(N, ...v) {
    if (!this.player || !this.player[N]) {
      let S = `ReactPlayer: ${this.constructor.displayName} player could not call %c${N}%c – `;
      return this.player ? this.player[N] || (S += "The method was not available") : S += "The player was not available", console.warn(S, "font-weight: bold", ""), null;
    }
    return this.player[N](...v);
  }
  function M(N) {
    return typeof window < "u" && typeof window.MediaStream < "u" && N instanceof window.MediaStream;
  }
  function J(N) {
    return /^blob:/.test(N);
  }
  function su(N = document.createElement("video")) {
    const v = /iPhone|iPod/.test(navigator.userAgent) === !1;
    return N.webkitSupportsPresentationMode && typeof N.webkitSetPresentationMode == "function" && v;
  }
  function nu(N) {
    return N;
  }
  return Qt;
}
var ur, Jn;
function XD() {
  if (Jn) return ur;
  Jn = 1;
  var u = Object.defineProperty, e = Object.getOwnPropertyDescriptor, t = Object.getOwnPropertyNames, n = Object.prototype.hasOwnProperty, s = (j, M) => {
    for (var J in M)
      u(j, J, { get: M[J], enumerable: !0 });
  }, i = (j, M, J, su) => {
    if (M && typeof M == "object" || typeof M == "function")
      for (let nu of t(M))
        !n.call(j, nu) && nu !== J && u(j, nu, { get: () => M[nu], enumerable: !(su = e(M, nu)) || su.enumerable });
    return j;
  }, a = (j) => i(u({}, "__esModule", { value: !0 }), j), D = {};
  s(D, {
    AUDIO_EXTENSIONS: () => w,
    DASH_EXTENSIONS: () => z,
    FLV_EXTENSIONS: () => k,
    HLS_EXTENSIONS: () => q,
    MATCH_URL_DAILYMOTION: () => p,
    MATCH_URL_FACEBOOK: () => F,
    MATCH_URL_FACEBOOK_WATCH: () => C,
    MATCH_URL_KALTURA: () => b,
    MATCH_URL_MIXCLOUD: () => E,
    MATCH_URL_MUX: () => h,
    MATCH_URL_SOUNDCLOUD: () => x,
    MATCH_URL_STREAMABLE: () => f,
    MATCH_URL_TWITCH_CHANNEL: () => l,
    MATCH_URL_TWITCH_VIDEO: () => B,
    MATCH_URL_VIDYARD: () => A,
    MATCH_URL_VIMEO: () => c,
    MATCH_URL_WISTIA: () => y,
    MATCH_URL_YOUTUBE: () => d,
    VIDEO_EXTENSIONS: () => P,
    canPlay: () => O
  }), ur = a(D);
  var o = /* @__PURE__ */ jt();
  const d = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//, x = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/, c = /vimeo\.com\/(?!progressive_redirect).+/, h = /stream\.mux\.com\/(?!\w+\.m3u8)(\w+)/, F = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/, C = /^https?:\/\/fb\.watch\/.+$/, f = /streamable\.com\/([a-z0-9]+)$/, y = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/, B = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/, l = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/, p = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/, E = /mixcloud\.com\/([^/]+\/[^/]+)/, A = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/, b = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/, w = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i, P = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, q = /\.(m3u8)($|\?)/i, z = /\.(mpd)($|\?)/i, k = /\.(flv)($|\?)/i, I = (j) => {
    if (j instanceof Array) {
      for (const M of j)
        if (typeof M == "string" && I(M) || I(M.src))
          return !0;
      return !1;
    }
    return (0, o.isMediaStream)(j) || (0, o.isBlobUrl)(j) ? !0 : w.test(j) || P.test(j) || q.test(j) || z.test(j) || k.test(j);
  }, O = {
    youtube: (j) => j instanceof Array ? j.every((M) => d.test(M)) : d.test(j),
    soundcloud: (j) => x.test(j) && !w.test(j),
    vimeo: (j) => c.test(j) && !P.test(j) && !q.test(j),
    mux: (j) => h.test(j),
    facebook: (j) => F.test(j) || C.test(j),
    streamable: (j) => f.test(j),
    wistia: (j) => y.test(j),
    twitch: (j) => B.test(j) || l.test(j),
    dailymotion: (j) => p.test(j),
    mixcloud: (j) => E.test(j),
    vidyard: (j) => A.test(j),
    kaltura: (j) => b.test(j),
    file: I
  };
  return ur;
}
var er, Xn;
function QD() {
  if (Xn) return er;
  Xn = 1;
  var u = Object.defineProperty, e = Object.getOwnPropertyDescriptor, t = Object.getOwnPropertyNames, n = Object.prototype.hasOwnProperty, s = (c, h) => {
    for (var F in h)
      u(c, F, { get: h[F], enumerable: !0 });
  }, i = (c, h, F, C) => {
    if (h && typeof h == "object" || typeof h == "function")
      for (let f of t(h))
        !n.call(c, f) && f !== F && u(c, f, { get: () => h[f], enumerable: !(C = e(h, f)) || C.enumerable });
    return c;
  }, a = (c) => i(u({}, "__esModule", { value: !0 }), c), D = {};
  s(D, {
    default: () => x
  }), er = a(D);
  var o = /* @__PURE__ */ jt(), d = /* @__PURE__ */ XD(), x = [
    {
      key: "youtube",
      name: "YouTube",
      canPlay: d.canPlay.youtube,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerYouTube' */
        "./YouTube-B45XmJOI.js"
      ).then((c) => c.Y))
    },
    {
      key: "soundcloud",
      name: "SoundCloud",
      canPlay: d.canPlay.soundcloud,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerSoundCloud' */
        "./SoundCloud-BqZ8iYLg.js"
      ).then((c) => c.S))
    },
    {
      key: "vimeo",
      name: "Vimeo",
      canPlay: d.canPlay.vimeo,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerVimeo' */
        "./Vimeo-exvXQInC.js"
      ).then((c) => c.V))
    },
    {
      key: "mux",
      name: "Mux",
      canPlay: d.canPlay.mux,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerMux' */
        "./Mux-EIdjYbCI.js"
      ).then((c) => c.M))
    },
    {
      key: "facebook",
      name: "Facebook",
      canPlay: d.canPlay.facebook,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerFacebook' */
        "./Facebook-CAB1DG7r.js"
      ).then((c) => c.F))
    },
    {
      key: "streamable",
      name: "Streamable",
      canPlay: d.canPlay.streamable,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerStreamable' */
        "./Streamable-B5Z792Jm.js"
      ).then((c) => c.S))
    },
    {
      key: "wistia",
      name: "Wistia",
      canPlay: d.canPlay.wistia,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerWistia' */
        "./Wistia-WISAI5gb.js"
      ).then((c) => c.W))
    },
    {
      key: "twitch",
      name: "Twitch",
      canPlay: d.canPlay.twitch,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerTwitch' */
        "./Twitch-DtXdtSaC.js"
      ).then((c) => c.T))
    },
    {
      key: "dailymotion",
      name: "DailyMotion",
      canPlay: d.canPlay.dailymotion,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerDailyMotion' */
        "./DailyMotion-zmhu0oT8.js"
      ).then((c) => c.D))
    },
    {
      key: "mixcloud",
      name: "Mixcloud",
      canPlay: d.canPlay.mixcloud,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerMixcloud' */
        "./Mixcloud-CJT3H0JH.js"
      ).then((c) => c.M))
    },
    {
      key: "vidyard",
      name: "Vidyard",
      canPlay: d.canPlay.vidyard,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerVidyard' */
        "./Vidyard-Yifp7uIs.js"
      ).then((c) => c.V))
    },
    {
      key: "kaltura",
      name: "Kaltura",
      canPlay: d.canPlay.kaltura,
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerKaltura' */
        "./Kaltura-Bs1BvsAK.js"
      ).then((c) => c.K))
    },
    {
      key: "file",
      name: "FilePlayer",
      canPlay: d.canPlay.file,
      canEnablePIP: (c) => d.canPlay.file(c) && (document.pictureInPictureEnabled || (0, o.supportsWebKitPresentationMode)()) && !d.AUDIO_EXTENSIONS.test(c),
      lazyPlayer: (0, o.lazy)(() => import(
        /* webpackChunkName: 'reactPlayerFilePlayer' */
        "./FilePlayer-CxyuYOJj.js"
      ).then((c) => c.F))
    }
  ];
  return er;
}
var Qn = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function ul(u, e) {
  return !!(u === e || Qn(u) && Qn(e));
}
function el(u, e) {
  if (u.length !== e.length)
    return !1;
  for (var t = 0; t < u.length; t++)
    if (!ul(u[t], e[t]))
      return !1;
  return !0;
}
function tl(u, e) {
  e === void 0 && (e = el);
  var t, n = [], s, i = !1;
  function a() {
    for (var D = [], o = 0; o < arguments.length; o++)
      D[o] = arguments[o];
    return i && t === this && e(D, n) || (s = u.apply(this, D), i = !0, t = this, n = D), s;
  }
  return a;
}
const rl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tl
}, Symbol.toStringTag, { value: "Module" })), nl = /* @__PURE__ */ $i(rl);
var tr, u0;
function Ms() {
  if (u0) return tr;
  u0 = 1;
  var u = typeof Element < "u", e = typeof Map == "function", t = typeof Set == "function", n = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function s(i, a) {
    if (i === a) return !0;
    if (i && a && typeof i == "object" && typeof a == "object") {
      if (i.constructor !== a.constructor) return !1;
      var D, o, d;
      if (Array.isArray(i)) {
        if (D = i.length, D != a.length) return !1;
        for (o = D; o-- !== 0; )
          if (!s(i[o], a[o])) return !1;
        return !0;
      }
      var x;
      if (e && i instanceof Map && a instanceof Map) {
        if (i.size !== a.size) return !1;
        for (x = i.entries(); !(o = x.next()).done; )
          if (!a.has(o.value[0])) return !1;
        for (x = i.entries(); !(o = x.next()).done; )
          if (!s(o.value[1], a.get(o.value[0]))) return !1;
        return !0;
      }
      if (t && i instanceof Set && a instanceof Set) {
        if (i.size !== a.size) return !1;
        for (x = i.entries(); !(o = x.next()).done; )
          if (!a.has(o.value[0])) return !1;
        return !0;
      }
      if (n && ArrayBuffer.isView(i) && ArrayBuffer.isView(a)) {
        if (D = i.length, D != a.length) return !1;
        for (o = D; o-- !== 0; )
          if (i[o] !== a[o]) return !1;
        return !0;
      }
      if (i.constructor === RegExp) return i.source === a.source && i.flags === a.flags;
      if (i.valueOf !== Object.prototype.valueOf && typeof i.valueOf == "function" && typeof a.valueOf == "function") return i.valueOf() === a.valueOf();
      if (i.toString !== Object.prototype.toString && typeof i.toString == "function" && typeof a.toString == "function") return i.toString() === a.toString();
      if (d = Object.keys(i), D = d.length, D !== Object.keys(a).length) return !1;
      for (o = D; o-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(a, d[o])) return !1;
      if (u && i instanceof Element) return !1;
      for (o = D; o-- !== 0; )
        if (!((d[o] === "_owner" || d[o] === "__v" || d[o] === "__o") && i.$$typeof) && !s(i[d[o]], a[d[o]]))
          return !1;
      return !0;
    }
    return i !== i && a !== a;
  }
  return tr = function(a, D) {
    try {
      return s(a, D);
    } catch (o) {
      if ((o.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw o;
    }
  }, tr;
}
var et = { exports: {} }, tt = { exports: {} }, Du = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e0;
function sl() {
  if (e0) return Du;
  e0 = 1;
  var u = typeof Symbol == "function" && Symbol.for, e = u ? Symbol.for("react.element") : 60103, t = u ? Symbol.for("react.portal") : 60106, n = u ? Symbol.for("react.fragment") : 60107, s = u ? Symbol.for("react.strict_mode") : 60108, i = u ? Symbol.for("react.profiler") : 60114, a = u ? Symbol.for("react.provider") : 60109, D = u ? Symbol.for("react.context") : 60110, o = u ? Symbol.for("react.async_mode") : 60111, d = u ? Symbol.for("react.concurrent_mode") : 60111, x = u ? Symbol.for("react.forward_ref") : 60112, c = u ? Symbol.for("react.suspense") : 60113, h = u ? Symbol.for("react.suspense_list") : 60120, F = u ? Symbol.for("react.memo") : 60115, C = u ? Symbol.for("react.lazy") : 60116, f = u ? Symbol.for("react.block") : 60121, y = u ? Symbol.for("react.fundamental") : 60117, B = u ? Symbol.for("react.responder") : 60118, l = u ? Symbol.for("react.scope") : 60119;
  function p(A) {
    if (typeof A == "object" && A !== null) {
      var b = A.$$typeof;
      switch (b) {
        case e:
          switch (A = A.type, A) {
            case o:
            case d:
            case n:
            case i:
            case s:
            case c:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case D:
                case x:
                case C:
                case F:
                case a:
                  return A;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  function E(A) {
    return p(A) === d;
  }
  return Du.AsyncMode = o, Du.ConcurrentMode = d, Du.ContextConsumer = D, Du.ContextProvider = a, Du.Element = e, Du.ForwardRef = x, Du.Fragment = n, Du.Lazy = C, Du.Memo = F, Du.Portal = t, Du.Profiler = i, Du.StrictMode = s, Du.Suspense = c, Du.isAsyncMode = function(A) {
    return E(A) || p(A) === o;
  }, Du.isConcurrentMode = E, Du.isContextConsumer = function(A) {
    return p(A) === D;
  }, Du.isContextProvider = function(A) {
    return p(A) === a;
  }, Du.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === e;
  }, Du.isForwardRef = function(A) {
    return p(A) === x;
  }, Du.isFragment = function(A) {
    return p(A) === n;
  }, Du.isLazy = function(A) {
    return p(A) === C;
  }, Du.isMemo = function(A) {
    return p(A) === F;
  }, Du.isPortal = function(A) {
    return p(A) === t;
  }, Du.isProfiler = function(A) {
    return p(A) === i;
  }, Du.isStrictMode = function(A) {
    return p(A) === s;
  }, Du.isSuspense = function(A) {
    return p(A) === c;
  }, Du.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === n || A === d || A === i || A === s || A === c || A === h || typeof A == "object" && A !== null && (A.$$typeof === C || A.$$typeof === F || A.$$typeof === a || A.$$typeof === D || A.$$typeof === x || A.$$typeof === y || A.$$typeof === B || A.$$typeof === l || A.$$typeof === f);
  }, Du.typeOf = p, Du;
}
var lu = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var t0;
function il() {
  return t0 || (t0 = 1, process.env.NODE_ENV !== "production" && function() {
    var u = typeof Symbol == "function" && Symbol.for, e = u ? Symbol.for("react.element") : 60103, t = u ? Symbol.for("react.portal") : 60106, n = u ? Symbol.for("react.fragment") : 60107, s = u ? Symbol.for("react.strict_mode") : 60108, i = u ? Symbol.for("react.profiler") : 60114, a = u ? Symbol.for("react.provider") : 60109, D = u ? Symbol.for("react.context") : 60110, o = u ? Symbol.for("react.async_mode") : 60111, d = u ? Symbol.for("react.concurrent_mode") : 60111, x = u ? Symbol.for("react.forward_ref") : 60112, c = u ? Symbol.for("react.suspense") : 60113, h = u ? Symbol.for("react.suspense_list") : 60120, F = u ? Symbol.for("react.memo") : 60115, C = u ? Symbol.for("react.lazy") : 60116, f = u ? Symbol.for("react.block") : 60121, y = u ? Symbol.for("react.fundamental") : 60117, B = u ? Symbol.for("react.responder") : 60118, l = u ? Symbol.for("react.scope") : 60119;
    function p($) {
      return typeof $ == "string" || typeof $ == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      $ === n || $ === d || $ === i || $ === s || $ === c || $ === h || typeof $ == "object" && $ !== null && ($.$$typeof === C || $.$$typeof === F || $.$$typeof === a || $.$$typeof === D || $.$$typeof === x || $.$$typeof === y || $.$$typeof === B || $.$$typeof === l || $.$$typeof === f);
    }
    function E($) {
      if (typeof $ == "object" && $ !== null) {
        var du = $.$$typeof;
        switch (du) {
          case e:
            var xu = $.type;
            switch (xu) {
              case o:
              case d:
              case n:
              case i:
              case s:
              case c:
                return xu;
              default:
                var Fu = xu && xu.$$typeof;
                switch (Fu) {
                  case D:
                  case x:
                  case C:
                  case F:
                  case a:
                    return Fu;
                  default:
                    return du;
                }
            }
          case t:
            return du;
        }
      }
    }
    var A = o, b = d, w = D, P = a, q = e, z = x, k = n, I = C, O = F, j = t, M = i, J = s, su = c, nu = !1;
    function N($) {
      return nu || (nu = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), v($) || E($) === o;
    }
    function v($) {
      return E($) === d;
    }
    function S($) {
      return E($) === D;
    }
    function R($) {
      return E($) === a;
    }
    function V($) {
      return typeof $ == "object" && $ !== null && $.$$typeof === e;
    }
    function U($) {
      return E($) === x;
    }
    function Z($) {
      return E($) === n;
    }
    function Y($) {
      return E($) === C;
    }
    function K($) {
      return E($) === F;
    }
    function X($) {
      return E($) === t;
    }
    function L($) {
      return E($) === i;
    }
    function W($) {
      return E($) === s;
    }
    function tu($) {
      return E($) === c;
    }
    lu.AsyncMode = A, lu.ConcurrentMode = b, lu.ContextConsumer = w, lu.ContextProvider = P, lu.Element = q, lu.ForwardRef = z, lu.Fragment = k, lu.Lazy = I, lu.Memo = O, lu.Portal = j, lu.Profiler = M, lu.StrictMode = J, lu.Suspense = su, lu.isAsyncMode = N, lu.isConcurrentMode = v, lu.isContextConsumer = S, lu.isContextProvider = R, lu.isElement = V, lu.isForwardRef = U, lu.isFragment = Z, lu.isLazy = Y, lu.isMemo = K, lu.isPortal = X, lu.isProfiler = L, lu.isStrictMode = W, lu.isSuspense = tu, lu.isValidElementType = p, lu.typeOf = E;
  }()), lu;
}
var r0;
function zs() {
  return r0 || (r0 = 1, process.env.NODE_ENV === "production" ? tt.exports = sl() : tt.exports = il()), tt.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var rr, n0;
function al() {
  if (n0) return rr;
  n0 = 1;
  var u = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, D = 0; D < 10; D++)
        a["_" + String.fromCharCode(D)] = D;
      var o = Object.getOwnPropertyNames(a).map(function(x) {
        return a[x];
      });
      if (o.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(x) {
        d[x] = x;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return rr = s() ? Object.assign : function(i, a) {
    for (var D, o = n(i), d, x = 1; x < arguments.length; x++) {
      D = Object(arguments[x]);
      for (var c in D)
        e.call(D, c) && (o[c] = D[c]);
      if (u) {
        d = u(D);
        for (var h = 0; h < d.length; h++)
          t.call(D, d[h]) && (o[d[h]] = D[d[h]]);
      }
    }
    return o;
  }, rr;
}
var nr, s0;
function un() {
  if (s0) return nr;
  s0 = 1;
  var u = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return nr = u, nr;
}
var sr, i0;
function Us() {
  return i0 || (i0 = 1, sr = Function.call.bind(Object.prototype.hasOwnProperty)), sr;
}
var ir, a0;
function ol() {
  if (a0) return ir;
  a0 = 1;
  var u = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ un(), t = {}, n = /* @__PURE__ */ Us();
    u = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function s(i, a, D, o, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var x in i)
        if (n(i, x)) {
          var c;
          try {
            if (typeof i[x] != "function") {
              var h = Error(
                (o || "React class") + ": " + D + " type `" + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[x] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            c = i[x](a, x, o, D, null, e);
          } catch (C) {
            c = C;
          }
          if (c && !(c instanceof Error) && u(
            (o || "React class") + ": type specification of " + D + " `" + x + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), c instanceof Error && !(c.message in t)) {
            t[c.message] = !0;
            var F = d ? d() : "";
            u(
              "Failed " + D + " type: " + c.message + (F ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, ir = s, ir;
}
var ar, o0;
function Dl() {
  if (o0) return ar;
  o0 = 1;
  var u = zs(), e = al(), t = /* @__PURE__ */ un(), n = /* @__PURE__ */ Us(), s = /* @__PURE__ */ ol(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(D) {
    var o = "Warning: " + D;
    typeof console < "u" && console.error(o);
    try {
      throw new Error(o);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return ar = function(D, o) {
    var d = typeof Symbol == "function" && Symbol.iterator, x = "@@iterator";
    function c(v) {
      var S = v && (d && v[d] || v[x]);
      if (typeof S == "function")
        return S;
    }
    var h = "<<anonymous>>", F = {
      array: B("array"),
      bigint: B("bigint"),
      bool: B("boolean"),
      func: B("function"),
      number: B("number"),
      object: B("object"),
      string: B("string"),
      symbol: B("symbol"),
      any: l(),
      arrayOf: p,
      element: E(),
      elementType: A(),
      instanceOf: b,
      node: z(),
      objectOf: P,
      oneOf: w,
      oneOfType: q,
      shape: I,
      exact: O
    };
    function C(v, S) {
      return v === S ? v !== 0 || 1 / v === 1 / S : v !== v && S !== S;
    }
    function f(v, S) {
      this.message = v, this.data = S && typeof S == "object" ? S : {}, this.stack = "";
    }
    f.prototype = Error.prototype;
    function y(v) {
      if (process.env.NODE_ENV !== "production")
        var S = {}, R = 0;
      function V(Z, Y, K, X, L, W, tu) {
        if (X = X || h, W = W || K, tu !== t) {
          if (o) {
            var $ = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw $.name = "Invariant Violation", $;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var du = X + ":" + K;
            !S[du] && // Avoid spamming the console because they are often not actionable except for lib authors
            R < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + W + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), S[du] = !0, R++);
          }
        }
        return Y[K] == null ? Z ? Y[K] === null ? new f("The " + L + " `" + W + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new f("The " + L + " `" + W + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : v(Y, K, X, L, W);
      }
      var U = V.bind(null, !1);
      return U.isRequired = V.bind(null, !0), U;
    }
    function B(v) {
      function S(R, V, U, Z, Y, K) {
        var X = R[V], L = J(X);
        if (L !== v) {
          var W = su(X);
          return new f(
            "Invalid " + Z + " `" + Y + "` of type " + ("`" + W + "` supplied to `" + U + "`, expected ") + ("`" + v + "`."),
            { expectedType: v }
          );
        }
        return null;
      }
      return y(S);
    }
    function l() {
      return y(a);
    }
    function p(v) {
      function S(R, V, U, Z, Y) {
        if (typeof v != "function")
          return new f("Property `" + Y + "` of component `" + U + "` has invalid PropType notation inside arrayOf.");
        var K = R[V];
        if (!Array.isArray(K)) {
          var X = J(K);
          return new f("Invalid " + Z + " `" + Y + "` of type " + ("`" + X + "` supplied to `" + U + "`, expected an array."));
        }
        for (var L = 0; L < K.length; L++) {
          var W = v(K, L, U, Z, Y + "[" + L + "]", t);
          if (W instanceof Error)
            return W;
        }
        return null;
      }
      return y(S);
    }
    function E() {
      function v(S, R, V, U, Z) {
        var Y = S[R];
        if (!D(Y)) {
          var K = J(Y);
          return new f("Invalid " + U + " `" + Z + "` of type " + ("`" + K + "` supplied to `" + V + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(v);
    }
    function A() {
      function v(S, R, V, U, Z) {
        var Y = S[R];
        if (!u.isValidElementType(Y)) {
          var K = J(Y);
          return new f("Invalid " + U + " `" + Z + "` of type " + ("`" + K + "` supplied to `" + V + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(v);
    }
    function b(v) {
      function S(R, V, U, Z, Y) {
        if (!(R[V] instanceof v)) {
          var K = v.name || h, X = N(R[V]);
          return new f("Invalid " + Z + " `" + Y + "` of type " + ("`" + X + "` supplied to `" + U + "`, expected ") + ("instance of `" + K + "`."));
        }
        return null;
      }
      return y(S);
    }
    function w(v) {
      if (!Array.isArray(v))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function S(R, V, U, Z, Y) {
        for (var K = R[V], X = 0; X < v.length; X++)
          if (C(K, v[X]))
            return null;
        var L = JSON.stringify(v, function(tu, $) {
          var du = su($);
          return du === "symbol" ? String($) : $;
        });
        return new f("Invalid " + Z + " `" + Y + "` of value `" + String(K) + "` " + ("supplied to `" + U + "`, expected one of " + L + "."));
      }
      return y(S);
    }
    function P(v) {
      function S(R, V, U, Z, Y) {
        if (typeof v != "function")
          return new f("Property `" + Y + "` of component `" + U + "` has invalid PropType notation inside objectOf.");
        var K = R[V], X = J(K);
        if (X !== "object")
          return new f("Invalid " + Z + " `" + Y + "` of type " + ("`" + X + "` supplied to `" + U + "`, expected an object."));
        for (var L in K)
          if (n(K, L)) {
            var W = v(K, L, U, Z, Y + "." + L, t);
            if (W instanceof Error)
              return W;
          }
        return null;
      }
      return y(S);
    }
    function q(v) {
      if (!Array.isArray(v))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var S = 0; S < v.length; S++) {
        var R = v[S];
        if (typeof R != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + nu(R) + " at index " + S + "."
          ), a;
      }
      function V(U, Z, Y, K, X) {
        for (var L = [], W = 0; W < v.length; W++) {
          var tu = v[W], $ = tu(U, Z, Y, K, X, t);
          if ($ == null)
            return null;
          $.data && n($.data, "expectedType") && L.push($.data.expectedType);
        }
        var du = L.length > 0 ? ", expected one of type [" + L.join(", ") + "]" : "";
        return new f("Invalid " + K + " `" + X + "` supplied to " + ("`" + Y + "`" + du + "."));
      }
      return y(V);
    }
    function z() {
      function v(S, R, V, U, Z) {
        return j(S[R]) ? null : new f("Invalid " + U + " `" + Z + "` supplied to " + ("`" + V + "`, expected a ReactNode."));
      }
      return y(v);
    }
    function k(v, S, R, V, U) {
      return new f(
        (v || "React class") + ": " + S + " type `" + R + "." + V + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + U + "`."
      );
    }
    function I(v) {
      function S(R, V, U, Z, Y) {
        var K = R[V], X = J(K);
        if (X !== "object")
          return new f("Invalid " + Z + " `" + Y + "` of type `" + X + "` " + ("supplied to `" + U + "`, expected `object`."));
        for (var L in v) {
          var W = v[L];
          if (typeof W != "function")
            return k(U, Z, Y, L, su(W));
          var tu = W(K, L, U, Z, Y + "." + L, t);
          if (tu)
            return tu;
        }
        return null;
      }
      return y(S);
    }
    function O(v) {
      function S(R, V, U, Z, Y) {
        var K = R[V], X = J(K);
        if (X !== "object")
          return new f("Invalid " + Z + " `" + Y + "` of type `" + X + "` " + ("supplied to `" + U + "`, expected `object`."));
        var L = e({}, R[V], v);
        for (var W in L) {
          var tu = v[W];
          if (n(v, W) && typeof tu != "function")
            return k(U, Z, Y, W, su(tu));
          if (!tu)
            return new f(
              "Invalid " + Z + " `" + Y + "` key `" + W + "` supplied to `" + U + "`.\nBad object: " + JSON.stringify(R[V], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(v), null, "  ")
            );
          var $ = tu(K, W, U, Z, Y + "." + W, t);
          if ($)
            return $;
        }
        return null;
      }
      return y(S);
    }
    function j(v) {
      switch (typeof v) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !v;
        case "object":
          if (Array.isArray(v))
            return v.every(j);
          if (v === null || D(v))
            return !0;
          var S = c(v);
          if (S) {
            var R = S.call(v), V;
            if (S !== v.entries) {
              for (; !(V = R.next()).done; )
                if (!j(V.value))
                  return !1;
            } else
              for (; !(V = R.next()).done; ) {
                var U = V.value;
                if (U && !j(U[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function M(v, S) {
      return v === "symbol" ? !0 : S ? S["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && S instanceof Symbol : !1;
    }
    function J(v) {
      var S = typeof v;
      return Array.isArray(v) ? "array" : v instanceof RegExp ? "object" : M(S, v) ? "symbol" : S;
    }
    function su(v) {
      if (typeof v > "u" || v === null)
        return "" + v;
      var S = J(v);
      if (S === "object") {
        if (v instanceof Date)
          return "date";
        if (v instanceof RegExp)
          return "regexp";
      }
      return S;
    }
    function nu(v) {
      var S = su(v);
      switch (S) {
        case "array":
        case "object":
          return "an " + S;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + S;
        default:
          return S;
      }
    }
    function N(v) {
      return !v.constructor || !v.constructor.name ? h : v.constructor.name;
    }
    return F.checkPropTypes = s, F.resetWarningCache = s.resetWarningCache, F.PropTypes = F, F;
  }, ar;
}
var or, D0;
function ll() {
  if (D0) return or;
  D0 = 1;
  var u = /* @__PURE__ */ un();
  function e() {
  }
  function t() {
  }
  return t.resetWarningCache = e, or = function() {
    function n(a, D, o, d, x, c) {
      if (c !== u) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    n.isRequired = n;
    function s() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: s,
      element: n,
      elementType: n,
      instanceOf: s,
      node: n,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: t,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, or;
}
var l0;
function cl() {
  if (l0) return et.exports;
  if (l0 = 1, process.env.NODE_ENV !== "production") {
    var u = zs(), e = !0;
    et.exports = /* @__PURE__ */ Dl()(u.isElement, e);
  } else
    et.exports = /* @__PURE__ */ ll()();
  return et.exports;
}
var Dr, c0;
function Hs() {
  if (c0) return Dr;
  c0 = 1;
  var u = Object.create, e = Object.defineProperty, t = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, s = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, a = (P, q) => {
    for (var z in q)
      e(P, z, { get: q[z], enumerable: !0 });
  }, D = (P, q, z, k) => {
    if (q && typeof q == "object" || typeof q == "function")
      for (let I of n(q))
        !i.call(P, I) && I !== z && e(P, I, { get: () => q[I], enumerable: !(k = t(q, I)) || k.enumerable });
    return P;
  }, o = (P, q, z) => (z = P != null ? u(s(P)) : {}, D(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !P || !P.__esModule ? e(z, "default", { value: P, enumerable: !0 }) : z,
    P
  )), d = (P) => D(e({}, "__esModule", { value: !0 }), P), x = {};
  a(x, {
    defaultProps: () => w,
    propTypes: () => A
  }), Dr = d(x);
  var c = o(/* @__PURE__ */ cl());
  const { string: h, bool: F, number: C, array: f, oneOfType: y, shape: B, object: l, func: p, node: E } = c.default, A = {
    url: y([h, f, l]),
    playing: F,
    loop: F,
    controls: F,
    volume: C,
    muted: F,
    playbackRate: C,
    width: y([h, C]),
    height: y([h, C]),
    style: l,
    progressInterval: C,
    playsinline: F,
    pip: F,
    stopOnUnmount: F,
    light: y([F, h, l]),
    playIcon: E,
    previewTabIndex: C,
    previewAriaLabel: h,
    fallback: E,
    oEmbedUrl: h,
    wrapper: y([
      h,
      p,
      B({ render: p.isRequired })
    ]),
    config: B({
      soundcloud: B({
        options: l
      }),
      youtube: B({
        playerVars: l,
        embedOptions: l,
        onUnstarted: p
      }),
      facebook: B({
        appId: h,
        version: h,
        playerId: h,
        attributes: l
      }),
      dailymotion: B({
        params: l
      }),
      vimeo: B({
        playerOptions: l,
        title: h
      }),
      mux: B({
        attributes: l,
        version: h
      }),
      file: B({
        attributes: l,
        tracks: f,
        forceVideo: F,
        forceAudio: F,
        forceHLS: F,
        forceSafariHLS: F,
        forceDisableHls: F,
        forceDASH: F,
        forceFLV: F,
        hlsOptions: l,
        hlsVersion: h,
        dashVersion: h,
        flvVersion: h
      }),
      wistia: B({
        options: l,
        playerId: h,
        customControls: f
      }),
      mixcloud: B({
        options: l
      }),
      twitch: B({
        options: l,
        playerId: h
      }),
      vidyard: B({
        options: l
      })
    }),
    onReady: p,
    onStart: p,
    onPlay: p,
    onPause: p,
    onBuffer: p,
    onBufferEnd: p,
    onEnded: p,
    onError: p,
    onDuration: p,
    onSeek: p,
    onPlaybackRateChange: p,
    onPlaybackQualityChange: p,
    onProgress: p,
    onClickPreview: p,
    onEnablePIP: p,
    onDisablePIP: p
  }, b = () => {
  }, w = {
    playing: !1,
    loop: !1,
    controls: !1,
    volume: null,
    muted: !1,
    playbackRate: 1,
    width: "640px",
    height: "360px",
    style: {},
    progressInterval: 1e3,
    playsinline: !1,
    pip: !1,
    stopOnUnmount: !0,
    light: !1,
    fallback: null,
    wrapper: "div",
    previewTabIndex: 0,
    previewAriaLabel: "",
    oEmbedUrl: "https://noembed.com/embed?url={url}",
    config: {
      soundcloud: {
        options: {
          visual: !0,
          // Undocumented, but makes player fill container and look better
          buying: !1,
          liking: !1,
          download: !1,
          sharing: !1,
          show_comments: !1,
          show_playcount: !1
        }
      },
      youtube: {
        playerVars: {
          playsinline: 1,
          showinfo: 0,
          rel: 0,
          iv_load_policy: 3,
          modestbranding: 1
        },
        embedOptions: {},
        onUnstarted: b
      },
      facebook: {
        appId: "1309697205772819",
        version: "v3.3",
        playerId: null,
        attributes: {}
      },
      dailymotion: {
        params: {
          api: 1,
          "endscreen-enable": !1
        }
      },
      vimeo: {
        playerOptions: {
          autopause: !1,
          byline: !1,
          portrait: !1,
          title: !1
        },
        title: null
      },
      mux: {
        attributes: {},
        version: "2"
      },
      file: {
        attributes: {},
        tracks: [],
        forceVideo: !1,
        forceAudio: !1,
        forceHLS: !1,
        forceDASH: !1,
        forceFLV: !1,
        hlsOptions: {},
        hlsVersion: "1.1.4",
        dashVersion: "3.1.3",
        flvVersion: "1.5.0",
        forceDisableHls: !1
      },
      wistia: {
        options: {},
        playerId: null,
        customControls: null
      },
      mixcloud: {
        options: {
          hide_cover: 1
        }
      },
      twitch: {
        options: {},
        playerId: null
      },
      vidyard: {
        options: {}
      }
    },
    onReady: b,
    onStart: b,
    onPlay: b,
    onPause: b,
    onBuffer: b,
    onBufferEnd: b,
    onEnded: b,
    onError: b,
    onDuration: b,
    onSeek: b,
    onPlaybackRateChange: b,
    onPlaybackQualityChange: b,
    onProgress: b,
    onClickPreview: b,
    onEnablePIP: b,
    onDisablePIP: b
  };
  return Dr;
}
var lr, F0;
function Fl() {
  if (F0) return lr;
  F0 = 1;
  var u = Object.create, e = Object.defineProperty, t = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, s = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, a = (p, E, A) => E in p ? e(p, E, { enumerable: !0, configurable: !0, writable: !0, value: A }) : p[E] = A, D = (p, E) => {
    for (var A in E)
      e(p, A, { get: E[A], enumerable: !0 });
  }, o = (p, E, A, b) => {
    if (E && typeof E == "object" || typeof E == "function")
      for (let w of n(E))
        !i.call(p, w) && w !== A && e(p, w, { get: () => E[w], enumerable: !(b = t(E, w)) || b.enumerable });
    return p;
  }, d = (p, E, A) => (A = p != null ? u(s(p)) : {}, o(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !p || !p.__esModule ? e(A, "default", { value: p, enumerable: !0 }) : A,
    p
  )), x = (p) => o(e({}, "__esModule", { value: !0 }), p), c = (p, E, A) => (a(p, typeof E != "symbol" ? E + "" : E, A), A), h = {};
  D(h, {
    default: () => l
  }), lr = x(h);
  var F = d(uu), C = d(Ms()), f = /* @__PURE__ */ Hs(), y = /* @__PURE__ */ jt();
  const B = 5e3;
  class l extends F.Component {
    constructor() {
      super(...arguments), c(this, "mounted", !1), c(this, "isReady", !1), c(this, "isPlaying", !1), c(this, "isLoading", !0), c(this, "loadOnReady", null), c(this, "startOnPlay", !0), c(this, "seekOnPlay", null), c(this, "onDurationCalled", !1), c(this, "handlePlayerMount", (E) => {
        if (this.player) {
          this.progress();
          return;
        }
        this.player = E, this.player.load(this.props.url), this.progress();
      }), c(this, "getInternalPlayer", (E) => this.player ? this.player[E] : null), c(this, "progress", () => {
        if (this.props.url && this.player && this.isReady) {
          const E = this.getCurrentTime() || 0, A = this.getSecondsLoaded(), b = this.getDuration();
          if (b) {
            const w = {
              playedSeconds: E,
              played: E / b
            };
            A !== null && (w.loadedSeconds = A, w.loaded = A / b), (w.playedSeconds !== this.prevPlayed || w.loadedSeconds !== this.prevLoaded) && this.props.onProgress(w), this.prevPlayed = w.playedSeconds, this.prevLoaded = w.loadedSeconds;
          }
        }
        this.progressTimeout = setTimeout(this.progress, this.props.progressFrequency || this.props.progressInterval);
      }), c(this, "handleReady", () => {
        if (!this.mounted)
          return;
        this.isReady = !0, this.isLoading = !1;
        const { onReady: E, playing: A, volume: b, muted: w } = this.props;
        E(), !w && b !== null && this.player.setVolume(b), this.loadOnReady ? (this.player.load(this.loadOnReady, !0), this.loadOnReady = null) : A && this.player.play(), this.handleDurationCheck();
      }), c(this, "handlePlay", () => {
        this.isPlaying = !0, this.isLoading = !1;
        const { onStart: E, onPlay: A, playbackRate: b } = this.props;
        this.startOnPlay && (this.player.setPlaybackRate && b !== 1 && this.player.setPlaybackRate(b), E(), this.startOnPlay = !1), A(), this.seekOnPlay && (this.seekTo(this.seekOnPlay), this.seekOnPlay = null), this.handleDurationCheck();
      }), c(this, "handlePause", (E) => {
        this.isPlaying = !1, this.isLoading || this.props.onPause(E);
      }), c(this, "handleEnded", () => {
        const { activePlayer: E, loop: A, onEnded: b } = this.props;
        E.loopOnEnded && A && this.seekTo(0), A || (this.isPlaying = !1, b());
      }), c(this, "handleError", (...E) => {
        this.isLoading = !1, this.props.onError(...E);
      }), c(this, "handleDurationCheck", () => {
        clearTimeout(this.durationCheckTimeout);
        const E = this.getDuration();
        E ? this.onDurationCalled || (this.props.onDuration(E), this.onDurationCalled = !0) : this.durationCheckTimeout = setTimeout(this.handleDurationCheck, 100);
      }), c(this, "handleLoaded", () => {
        this.isLoading = !1;
      });
    }
    componentDidMount() {
      this.mounted = !0;
    }
    componentWillUnmount() {
      clearTimeout(this.progressTimeout), clearTimeout(this.durationCheckTimeout), this.isReady && this.props.stopOnUnmount && (this.player.stop(), this.player.disablePIP && this.player.disablePIP()), this.mounted = !1;
    }
    componentDidUpdate(E) {
      if (!this.player)
        return;
      const { url: A, playing: b, volume: w, muted: P, playbackRate: q, pip: z, loop: k, activePlayer: I, disableDeferredLoading: O } = this.props;
      if (!(0, C.default)(E.url, A)) {
        if (this.isLoading && !I.forceLoad && !O && !(0, y.isMediaStream)(A)) {
          console.warn(`ReactPlayer: the attempt to load ${A} is being deferred until the player has loaded`), this.loadOnReady = A;
          return;
        }
        this.isLoading = !0, this.startOnPlay = !0, this.onDurationCalled = !1, this.player.load(A, this.isReady);
      }
      !E.playing && b && !this.isPlaying && this.player.play(), E.playing && !b && this.isPlaying && this.player.pause(), !E.pip && z && this.player.enablePIP && this.player.enablePIP(), E.pip && !z && this.player.disablePIP && this.player.disablePIP(), E.volume !== w && w !== null && this.player.setVolume(w), E.muted !== P && (P ? this.player.mute() : (this.player.unmute(), w !== null && setTimeout(() => this.player.setVolume(w)))), E.playbackRate !== q && this.player.setPlaybackRate && this.player.setPlaybackRate(q), E.loop !== k && this.player.setLoop && this.player.setLoop(k);
    }
    getDuration() {
      return this.isReady ? this.player.getDuration() : null;
    }
    getCurrentTime() {
      return this.isReady ? this.player.getCurrentTime() : null;
    }
    getSecondsLoaded() {
      return this.isReady ? this.player.getSecondsLoaded() : null;
    }
    seekTo(E, A, b) {
      if (!this.isReady) {
        E !== 0 && (this.seekOnPlay = E, setTimeout(() => {
          this.seekOnPlay = null;
        }, B));
        return;
      }
      if (A ? A === "fraction" : E > 0 && E < 1) {
        const P = this.player.getDuration();
        if (!P) {
          console.warn("ReactPlayer: could not seek using fraction – duration not yet available");
          return;
        }
        this.player.seekTo(P * E, b);
        return;
      }
      this.player.seekTo(E, b);
    }
    render() {
      const E = this.props.activePlayer;
      return E ? /* @__PURE__ */ F.default.createElement(
        E,
        {
          ...this.props,
          onMount: this.handlePlayerMount,
          onReady: this.handleReady,
          onPlay: this.handlePlay,
          onPause: this.handlePause,
          onEnded: this.handleEnded,
          onLoaded: this.handleLoaded,
          onError: this.handleError
        }
      ) : null;
    }
  }
  return c(l, "displayName", "Player"), c(l, "propTypes", f.propTypes), c(l, "defaultProps", f.defaultProps), lr;
}
var cr, d0;
function dl() {
  if (d0) return cr;
  d0 = 1;
  var u = Object.create, e = Object.defineProperty, t = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, s = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, a = (k, I, O) => I in k ? e(k, I, { enumerable: !0, configurable: !0, writable: !0, value: O }) : k[I] = O, D = (k, I) => {
    for (var O in I)
      e(k, O, { get: I[O], enumerable: !0 });
  }, o = (k, I, O, j) => {
    if (I && typeof I == "object" || typeof I == "function")
      for (let M of n(I))
        !i.call(k, M) && M !== O && e(k, M, { get: () => I[M], enumerable: !(j = t(I, M)) || j.enumerable });
    return k;
  }, d = (k, I, O) => (O = k != null ? u(s(k)) : {}, o(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !k || !k.__esModule ? e(O, "default", { value: k, enumerable: !0 }) : O,
    k
  )), x = (k) => o(e({}, "__esModule", { value: !0 }), k), c = (k, I, O) => (a(k, typeof I != "symbol" ? I + "" : I, O), O), h = {};
  D(h, {
    createReactPlayer: () => z
  }), cr = x(h);
  var F = d(uu), C = d(Ls()), f = d(nl), y = d(Ms()), B = /* @__PURE__ */ Hs(), l = /* @__PURE__ */ jt(), p = d(/* @__PURE__ */ Fl());
  const E = (0, l.lazy)(() => import(
    /* webpackChunkName: 'reactPlayerPreview' */
    "./Preview-DLwnfinm.js"
  ).then((k) => k.P)), A = typeof window < "u" && window.document && typeof document < "u", b = typeof Rt < "u" && Rt.window && Rt.window.document, w = Object.keys(B.propTypes), P = A || b ? F.Suspense : () => null, q = [], z = (k, I) => {
    var O;
    return O = class extends F.Component {
      constructor() {
        super(...arguments), c(this, "state", {
          showPreview: !!this.props.light
        }), c(this, "references", {
          wrapper: (j) => {
            this.wrapper = j;
          },
          player: (j) => {
            this.player = j;
          }
        }), c(this, "handleClickPreview", (j) => {
          this.setState({ showPreview: !1 }), this.props.onClickPreview(j);
        }), c(this, "showPreview", () => {
          this.setState({ showPreview: !0 });
        }), c(this, "getDuration", () => this.player ? this.player.getDuration() : null), c(this, "getCurrentTime", () => this.player ? this.player.getCurrentTime() : null), c(this, "getSecondsLoaded", () => this.player ? this.player.getSecondsLoaded() : null), c(this, "getInternalPlayer", (j = "player") => this.player ? this.player.getInternalPlayer(j) : null), c(this, "seekTo", (j, M, J) => {
          if (!this.player)
            return null;
          this.player.seekTo(j, M, J);
        }), c(this, "handleReady", () => {
          this.props.onReady(this);
        }), c(this, "getActivePlayer", (0, f.default)((j) => {
          for (const M of [...q, ...k])
            if (M.canPlay(j))
              return M;
          return I || null;
        })), c(this, "getConfig", (0, f.default)((j, M) => {
          const { config: J } = this.props;
          return C.default.all([
            B.defaultProps.config,
            B.defaultProps.config[M] || {},
            J,
            J[M] || {}
          ]);
        })), c(this, "getAttributes", (0, f.default)((j) => (0, l.omit)(this.props, w))), c(this, "renderActivePlayer", (j) => {
          if (!j)
            return null;
          const M = this.getActivePlayer(j);
          if (!M)
            return null;
          const J = this.getConfig(j, M.key);
          return /* @__PURE__ */ F.default.createElement(
            p.default,
            {
              ...this.props,
              key: M.key,
              ref: this.references.player,
              config: J,
              activePlayer: M.lazyPlayer || M,
              onReady: this.handleReady
            }
          );
        });
      }
      shouldComponentUpdate(j, M) {
        return !(0, y.default)(this.props, j) || !(0, y.default)(this.state, M);
      }
      componentDidUpdate(j) {
        const { light: M } = this.props;
        !j.light && M && this.setState({ showPreview: !0 }), j.light && !M && this.setState({ showPreview: !1 });
      }
      renderPreview(j) {
        if (!j)
          return null;
        const { light: M, playIcon: J, previewTabIndex: su, oEmbedUrl: nu, previewAriaLabel: N } = this.props;
        return /* @__PURE__ */ F.default.createElement(
          E,
          {
            url: j,
            light: M,
            playIcon: J,
            previewTabIndex: su,
            previewAriaLabel: N,
            oEmbedUrl: nu,
            onClick: this.handleClickPreview
          }
        );
      }
      render() {
        const { url: j, style: M, width: J, height: su, fallback: nu, wrapper: N } = this.props, { showPreview: v } = this.state, S = this.getAttributes(j), R = typeof N == "string" ? this.references.wrapper : void 0;
        return /* @__PURE__ */ F.default.createElement(N, { ref: R, style: { ...M, width: J, height: su }, ...S }, /* @__PURE__ */ F.default.createElement(P, { fallback: nu }, v ? this.renderPreview(j) : this.renderActivePlayer(j)));
      }
    }, c(O, "displayName", "ReactPlayer"), c(O, "propTypes", B.propTypes), c(O, "defaultProps", B.defaultProps), c(O, "addCustomPlayer", (j) => {
      q.push(j);
    }), c(O, "removeCustomPlayers", () => {
      q.length = 0;
    }), c(O, "canPlay", (j) => {
      for (const M of [...q, ...k])
        if (M.canPlay(j))
          return !0;
      return !1;
    }), c(O, "canEnablePIP", (j) => {
      for (const M of [...q, ...k])
        if (M.canEnablePIP && M.canEnablePIP(j))
          return !0;
      return !1;
    }), O;
  };
  return cr;
}
var Fr, p0;
function pl() {
  if (p0) return Fr;
  p0 = 1;
  var u = Object.create, e = Object.defineProperty, t = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, s = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, a = (f, y) => {
    for (var B in y)
      e(f, B, { get: y[B], enumerable: !0 });
  }, D = (f, y, B, l) => {
    if (y && typeof y == "object" || typeof y == "function")
      for (let p of n(y))
        !i.call(f, p) && p !== B && e(f, p, { get: () => y[p], enumerable: !(l = t(y, p)) || l.enumerable });
    return f;
  }, o = (f, y, B) => (B = f != null ? u(s(f)) : {}, D(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !f || !f.__esModule ? e(B, "default", { value: f, enumerable: !0 }) : B,
    f
  )), d = (f) => D(e({}, "__esModule", { value: !0 }), f), x = {};
  a(x, {
    default: () => C
  }), Fr = d(x);
  var c = o(/* @__PURE__ */ QD()), h = /* @__PURE__ */ dl();
  const F = c.default[c.default.length - 1];
  var C = (0, h.createReactPlayer)(c.default, F);
  return Fr;
}
var El = /* @__PURE__ */ pl();
const ku = /* @__PURE__ */ ne(El), Vs = _.a`
  display: ${(u) => u.$isFlex ? "flex" : "inline-flex"};
  width: 100%;
  margin: auto;
`, en = Ti({
  post: null
}), E0 = (u) => u || void 0, Cl = ({
  contextVideoCoverPreview: u,
  videoCoverPreviewOverride: e,
  fallbackToContext: t = !0
}) => {
  const n = E0(e), s = E0(u);
  return t ? n ?? s : n;
}, tn = (u = {}) => {
  const [e, t] = Au(!1), [n, s] = Au(!1), [i, a] = Au(0), {
    videoCoverPreview: D,
    post: o
  } = k0(en), {
    usePostTypeCheck: d = !0,
    videoCoverPreviewOverride: x,
    fallbackToContext: c = !0
  } = u, h = Cl({
    contextVideoCoverPreview: D,
    videoCoverPreviewOverride: x,
    fallbackToContext: c
  });
  Xu(() => {
    h && (t(!1), s(!1), a((B) => B + 1));
  }, [h]);
  const F = d ? h !== void 0 && (o?.type === "reel" || o?.storyType === "reel") : h !== void 0;
  return {
    isPlaying: e,
    hasPlayed: n,
    vid: i,
    videoCoverPreview: h,
    showVideoCover: F,
    resetVideo: () => {
      t(!1), s(!1), a((B) => B + 1);
    },
    handlePlay: () => {
      t(!0), s(!0);
    },
    handlePause: () => {
      t(!1);
    },
    showResetButton: F && !e && n
  };
}, Ws = (u) => /* @__PURE__ */ m.createElement("svg", { width: 36, height: 34, viewBox: "0 0 36 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("path", { d: "M2.33301 13.6667C2.33301 13.6667 5.67464 9.1137 8.3894 6.39707C11.1042 3.68045 14.8557 2 18.9997 2C27.2839 2 33.9997 8.71573 33.9997 17C33.9997 25.2843 27.2839 32 18.9997 32C12.1612 32 6.39153 27.4238 4.58595 21.1667M2.33301 13.6667V3.66667M2.33301 13.6667H12.333", stroke: "white", strokeWidth: 3.33333, strokeLinecap: "round", strokeLinejoin: "round" })), fl = _.div`
  position: absolute;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  margin-left: -28px;
  margin-top: -28px;
  cursor: pointer;
  z-index: 99;
`, qs = _.div`
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100% !important;

  .react-player video {
    object-fit: ${(u) => u.$videoObjectFit || "contain"};
  }

  ${(u) => u.$showVideoCover && is([".react-player__preview{width:100%;height:100%;background-size:cover !important;background-position:center !important;background-repeat:no-repeat !important;}"])}
`, Gs = _.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 2;
  pointer-events: none;
`, Al = _.div`
  align-items: center;
  overflow: hidden;
  border-radius: 15px;
  max-height: 711px;
  width: 100%;
  height: 100%;
  background: grey;
  display: flex;
`, Ys = ({
  onClick: u
}) => /* @__PURE__ */ r.jsx(fl, { onClick: u, children: /* @__PURE__ */ r.jsx(Ws, {}) }), hl = _.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`, ml = _.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(u) => u.$visible ? 1 : 0};
  transition: opacity 0.2s ease;
  pointer-events: none;
`, gl = () => /* @__PURE__ */ r.jsx("svg", { width: "24", height: "28", viewBox: "0 0 24 28", fill: "none", children: /* @__PURE__ */ r.jsx("path", { d: "M22 14L2 26V2L22 14Z", fill: "white" }) }), Bl = () => /* @__PURE__ */ r.jsxs("svg", { width: "20", height: "24", viewBox: "0 0 20 24", fill: "none", children: [
  /* @__PURE__ */ r.jsx("rect", { x: "1", y: "1", width: "6", height: "22", rx: "1", fill: "white" }),
  /* @__PURE__ */ r.jsx("rect", { x: "13", y: "1", width: "6", height: "22", rx: "1", fill: "white" })
] }), Zs = ({
  playing: u,
  onToggle: e
}) => /* @__PURE__ */ r.jsx(hl, { onClick: e, children: /* @__PURE__ */ r.jsx(ml, { $visible: !u, children: u ? /* @__PURE__ */ r.jsx(Bl, {}) : /* @__PURE__ */ r.jsx(gl, {}) }) }), xl = ({
  src: u,
  imageObjectFit: e,
  fillContainer: t = !1
}) => /* @__PURE__ */ r.jsx(vl, { $isFlex: !0, $fillContainer: t, href: u, children: /* @__PURE__ */ r.jsx(bl, { src: u, $imageObjectFit: e, $fillContainer: t }) }), yl = ({
  url: u,
  thumbnailUrl: e,
  isActiveSlide: t = !0,
  videoRef: n,
  containerStyles: s,
  controls: i = !0,
  videoObjectFit: a
}) => {
  const {
    vid: D,
    videoCoverPreview: o,
    showVideoCover: d,
    resetVideo: x,
    handlePlay: c,
    handlePause: h,
    showResetButton: F
  } = tn({
    usePostTypeCheck: !0,
    videoCoverPreviewOverride: e,
    fallbackToContext: !e
  }), [C, f] = Au(!1), y = !i, B = y && d && !C, l = () => {
    f(!1), x();
  };
  if (!t)
    return null;
  const p = {
    playsInline: !0,
    preload: "metadata",
    ...e ? {
      poster: e
    } : {}
  }, E = /* @__PURE__ */ r.jsxs(qs, { ref: n, style: s, $showVideoCover: d, $videoObjectFit: a, children: [
    F && /* @__PURE__ */ r.jsx(Ys, { onClick: l }),
    B && o && /* @__PURE__ */ r.jsx(Gs, { src: o, alt: "" }),
    y && /* @__PURE__ */ r.jsx(Zs, { playing: C, onToggle: () => f((A) => !A) }),
    /* @__PURE__ */ r.jsx(ku, { playing: y ? C : !!o, onPlay: c, onPause: h, light: !y && d ? o : void 0, controls: i, url: u, config: {
      file: {
        attributes: p
      }
    }, className: "sp-relative sp-w-full react-player", width: "100%", height: "100%", style: d ? {
      minHeight: "500px",
      background: "grey",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    } : {
      display: "flex",
      position: "absolute",
      top: 0,
      left: 0
    } }, D)
  ] });
  return d ? /* @__PURE__ */ r.jsx(Al, { children: E }) : E;
}, fe = ({
  media: u,
  isActiveSlide: e = !0,
  videoRef: t,
  videoContainerStyles: n,
  controls: s,
  videoObjectFit: i,
  imageObjectFit: a,
  fillContainer: D = !1
}) => u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(yl, { videoRef: t, url: u.url, thumbnailUrl: u.thumbnailUrl, isActiveSlide: e, containerStyles: n, controls: s, videoObjectFit: i }) : /* @__PURE__ */ r.jsx(xl, { src: u.url, imageObjectFit: a, fillContainer: D }), vl = _(Vs)`
  height: ${(u) => u.$fillContainer ? "100%" : "auto"};
  align-items: center;
  justify-content: center;
`, bl = _.img`
  display: block;
  object-fit: ${(u) => u.$imageObjectFit || "cover"};
  position: relative;
  width: 100%;
  height: ${(u) => u.$fillContainer ? "100%" : "auto"};
`, wl = (u) => /* @__PURE__ */ m.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...u }, /* @__PURE__ */ m.createElement("path", { d: "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z" })), jl = (u) => /* @__PURE__ */ m.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...u }, /* @__PURE__ */ m.createElement("path", { d: "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z" })), Ae = ({
  direction: u,
  onClick: e
}) => /* @__PURE__ */ r.jsx(_l, { direction: u, role: "button", "aria-label": u === "left" ? "Previous slide" : "Next slide", onClick: e, children: u === "left" ? /* @__PURE__ */ r.jsx(wl, { className: "sp-w-full sp-h-full sp-shadow-around sp-rounded-full sp-bg-grey sp-cursor-pointer" }) : /* @__PURE__ */ r.jsx(jl, { className: "sp-w-full sp-h-full sp-shadow-around sp-rounded-full sp-bg-grey sp-cursor-pointer" }) }), _l = _.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(u) => u.direction === "left" ? "left: 1rem;" : "right: 1rem;"};
  fill: white;
  opacity: 0.8;
  width: 34px;
  height: 34px;
  z-index: 1000;
  border-radius: 9000px;
  background-color: rgba(84, 84, 84, 0.5);
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0.2);

  &:hover,
  &:active {
    opacity: 1;
  }

  @media (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`, Sl = ({
  media: u,
  slideNo: e,
  isActiveSlide: t
}) => {
  const n = {
    order: e,
    flex: "1 0 100%"
  }, s = u.isVideo || u.url?.includes(".mp4");
  return /* @__PURE__ */ r.jsx("div", { style: n, children: s ? /* @__PURE__ */ r.jsx("div", { className: "sp-relative sp-w-full sp-aspect-[2/3] sp-bg-[#f2f2f2] [@supports_not_(aspect-ratio:1/1)]:sp-h-0 [@supports_not_(aspect-ratio:1/1)]:sp-pb-[150%]", children: /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-inset-0", children: /* @__PURE__ */ r.jsx(fe, { media: u, isActiveSlide: t, videoObjectFit: "cover" }) }) }) : /* @__PURE__ */ r.jsx(fe, { media: u, isActiveSlide: t, videoObjectFit: "cover" }) });
}, Pl = ({
  medias: u,
  currentSlide: e
}) => u.map((t, n) => /* @__PURE__ */ r.jsx(Sl, { media: t, slideNo: n + 1, isActiveSlide: e === n + 1 }, n)), Tl = ({
  current: u
}) => /* @__PURE__ */ r.jsx("div", { className: `${u ? "sp-bg-blue-600" : "sp-bg-gray-500"}
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out` }), kl = ({
  count: u,
  current: e
}) => /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center sp-z-50 sp-py-4", style: {
  marginBottom: "-42px",
  height: "42px"
}, children: [...Array(u)].map((t, n) => /* @__PURE__ */ r.jsx(Tl, { current: n + 1 === e }, n)) }), Nl = ({
  medias: u,
  count: e,
  getIsFirstSlide: t
}) => {
  const [n, s] = Au(1);
  Xu(() => {
    n > u.length && s(u.length);
  }, [u.length]);
  const i = {
    left: "100%",
    transform: `translateX(${n * -100}%)`
  };
  return Xu(() => {
    t && t(n === 1);
  }, [n]), /* @__PURE__ */ r.jsxs("div", { className: "sp-relative", children: [
    /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden", children: [
      n !== 1 && /* @__PURE__ */ r.jsx(Ae, { direction: "left", onClick: () => s(n - 1) }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-relative sp-items-center", style: i, children: /* @__PURE__ */ r.jsx(Pl, { medias: u, currentSlide: n }) }),
      n !== u.length && /* @__PURE__ */ r.jsx(Ae, { direction: "right", onClick: () => s(n + 1) })
    ] }),
    /* @__PURE__ */ r.jsx(kl, { count: e, current: n })
  ] });
}, Ol = () => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-w-full sp-justify-center sp-p-4 sp-text-gray-800", children: [
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-grow sp-items-center", children: [
    /* @__PURE__ */ r.jsx(rt, { icon: "icon-instagram-heart", className: "sp-mr-6" }),
    /* @__PURE__ */ r.jsx(rt, { icon: "icon-instagram-comment", className: "sp-mr-6" }),
    /* @__PURE__ */ r.jsx(rt, { icon: "icon-instagram-share", className: "sp-mr-6" })
  ] }),
  /* @__PURE__ */ r.jsx(rt, { icon: "icon-instagram-bookmark" })
] }), rt = ({
  icon: u,
  className: e
}) => /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-items-center sp-justify-center ${e}`, children: /* @__PURE__ */ r.jsx("div", { className: `sp-text-2xl sp-font-normal ${u}` }) }), $l = _.button`
  border: none;
  display: flex;
  align-items: center;
  background: #504e4c;
  border-radius: 4px;
  padding: 9px 7px;
  cursor: pointer;
  position: absolute;
  z-index: 2;
  top: 8px;
  left: 8px;
  min-width: 100px;
  justify-content: center;

  svg {
    margin-right: 6px;
    width: 16px;
    height: 16px;
  }

  p {
    margin: 0;
    font-weight: 500;
    color: white;
    font-size: 12px;
  }
`, Rl = _.div`
  position: absolute;
  z-index: 2;
  top: ${(u) => u.top && u.top}%;
  left: ${(u) => u.left && u.left}%;
  font-family: Helvetica Neue;
  background: #504e4c;
  color: white;
  font-weight: 500;
  font-size: 14px;
  padding: 9px 13px;
  border-radius: 4px;

  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    top: 0;
    left: 5px;
    margin-top: -5px;
    border-width: 0 5px 5px;
    border-bottom-color: #504e4c;
  }

  .sked-mention.sked-mention-link {
    color: white;
  }
`, Il = ({
  medias: u,
  storyType: e,
  productTags: t,
  userTags: n
}) => {
  const s = u.collection, i = s.length, a = i > 1, [D, o] = Au(!0);
  let d = t && t.length > 0 ? "productTags" : void 0;
  n && n.length > 0 && (d = "userTags");
  const x = d === "productTags" ? t : n, [c, h] = Au(!1);
  return /* @__PURE__ */ r.jsxs("div", { children: [
    /* @__PURE__ */ r.jsxs("div", { className: "sp-relative", children: [
      e && e === "reel" && /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-bg-black sp-px-8 sp-py-6 sp-m-12 sp-z-50 sp-flex sp-flex-row sp-items-center sp-rounded-lg sp-bg-opacity-50", children: [
        /* @__PURE__ */ r.jsx("div", { className: "sp-h-10 sp-w-10 sp-pr-2", children: /* @__PURE__ */ r.jsx(ko, {}) }),
        /* @__PURE__ */ r.jsxs(te, { $variant: "caption", className: "sp-text-2xl sp-text-white", children: [
          " ",
          " Reel"
        ] })
      ] }),
      e && e === "igtv" && /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-bg-black sp-px-8 sp-py-6 sp-m-12 sp-z-50 sp-flex sp-flex-row sp-items-center sp-rounded-lg sp-bg-opacity-50", children: [
        /* @__PURE__ */ r.jsx("div", { className: "sp-h-10 sp-w-10 sp-pr-2", children: /* @__PURE__ */ r.jsx(To, {}) }),
        /* @__PURE__ */ r.jsxs(te, { $variant: "caption", className: "sp-text-2xl sp-text-white", children: [
          " ",
          " IGTV"
        ] })
      ] }),
      D && x.length > 0 && /* @__PURE__ */ r.jsxs($l, { onClick: () => h((F) => !F), children: [
        d === "productTags" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(Po, {}),
          /* @__PURE__ */ r.jsxs("p", { children: [
            c ? "Hide" : "Show",
            " product tags"
          ] })
        ] }),
        d === "userTags" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(No, {}),
          /* @__PURE__ */ r.jsxs("p", { children: [
            c ? "Hide" : "Show",
            " user tags"
          ] })
        ] })
      ] }),
      x.length > 0 && c && /* @__PURE__ */ r.jsx("div", { children: x.map(({
        top: F,
        left: C,
        value: f
      }) => /* @__PURE__ */ r.jsx(Rl, { top: F, left: C, children: d === "userTags" ? /* @__PURE__ */ r.jsx(vu, { caption: `@${f}`, targetPlatform: "IG" }) : f }, f)) }),
      /* @__PURE__ */ r.jsx("div", { onClick: () => h(!1), children: a ? /* @__PURE__ */ r.jsx(Nl, { medias: s, count: i, getIsFirstSlide: (F) => {
        o(F);
      } }) : /* @__PURE__ */ r.jsx(fe, { media: s[0] }) })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ r.jsx(Ol, {}) })
  ] });
}, Ll = ({
  post: u
}) => {
  const e = u.comment?.trim();
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-flex sp-flex-col", children: [
    /* @__PURE__ */ r.jsx(Cs, { collabs: u.collaboratingIgUsers, username: u.username, profilePicture: u.profilePicture, locationName: u.locationName }),
    /* @__PURE__ */ r.jsx(Il, { medias: u.medias, storyType: u.storyType || null, productTags: u.providedPost.productTags || [], userTags: u.providedPost.tags || [] }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-px-4 sp-pb-8", children: [
      /* @__PURE__ */ r.jsxs(te, { $variant: "caption", className: "sp-whitespace-pre-line sp-mb-2 sp-break-words", children: [
        /* @__PURE__ */ r.jsx("span", { className: "sp-font-bold sp-mr-1", children: u.username }),
        /* @__PURE__ */ r.jsx(vu, { caption: u.caption, targetPlatform: "IG" })
      ] }),
      e && /* @__PURE__ */ r.jsxs(te, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
        /* @__PURE__ */ r.jsx("span", { className: "sp-font-bold sp-mr-1", children: u.username }),
        /* @__PURE__ */ r.jsx(vu, { caption: e, targetPlatform: "IG" })
      ] })
    ] })
  ] });
}, Ml = (u) => /* @__PURE__ */ m.createElement("svg", { viewBox: "0 0 33 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("path", { d: "M13 0.463379L9 4.36582H3.23171C1.71834 4.36582 0.5 5.58417 0.5 7.09753L0.500002 27C0.500002 28.5134 1.71834 29.7317 3.23171 29.7317H29.7683C31.2817 29.7317 32.5 28.5134 32.5 27L32.5 7.09753C32.5 5.58417 31.2817 4.36582 29.7683 4.36582H24L20 0.463379H13ZM16.5 8.30487C21.0122 8.30487 24.6951 11.9878 24.6951 16.5C24.6951 21.0122 21.0122 24.6951 16.5 24.6951C11.9878 24.6951 8.30488 21.0122 8.30488 16.5C8.30488 11.9878 11.9879 8.30487 16.5 8.30487ZM16.5 10.6463C13.2533 10.6463 10.6463 13.2533 10.6463 16.5C10.6463 19.7467 13.2533 22.3537 16.5 22.3537C19.7468 22.3537 22.3537 19.7467 22.3537 16.5C22.3537 13.2533 19.7468 10.6463 16.5 10.6463Z", fill: "white" })), zl = (u) => /* @__PURE__ */ m.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 26", fill: "#1a9bfb", ...u }, /* @__PURE__ */ m.createElement("path", { d: "M 19.625 0.15625 C 17.996094 0.234375 16.429688 0.945313 15.21875 2.15625 L 10.46875 6.90625 C 11.214844 6.15625 13.984375 6.671875 14.65625 7.34375 L 17.53125 4.46875 C 18.167969 3.832031 18.964844 3.441406 19.78125 3.40625 C 20.335938 3.378906 21.121094 3.496094 21.8125 4.1875 C 22.457031 4.832031 22.59375 5.582031 22.59375 6.09375 C 22.59375 6.949219 22.203125 7.800781 21.53125 8.46875 L 16.53125 13.5 C 15.273438 14.757813 13.359375 14.859375 12.25 13.75 C 11.617188 13.117188 10.574219 13.113281 9.9375 13.75 C 9.300781 14.386719 9.300781 15.425781 9.9375 16.0625 C 11.078125 17.203125 12.578125 17.78125 14.125 17.78125 C 15.796875 17.78125 17.503906 17.097656 18.8125 15.78125 L 23.84375 10.78125 C 25.121094 9.507813 25.84375 7.804688 25.84375 6.09375 C 25.84375 4.503906 25.242188 2.992188 24.125 1.875 C 22.929688 0.679688 21.324219 0.078125 19.625 0.15625 Z M 11.875 8.21875 C 10.203125 8.21875 8.46875 8.90625 7.15625 10.21875 L 2.15625 15.21875 C 0.878906 16.492188 0.15625 18.195313 0.15625 19.90625 C 0.15625 21.496094 0.757813 23.007813 1.875 24.125 C 3.070313 25.320313 4.675781 25.921875 6.375 25.84375 C 8.003906 25.765625 9.570313 25.054688 10.78125 23.84375 L 15.53125 19.09375 C 14.78125 19.84375 12.015625 19.328125 11.34375 18.65625 L 8.46875 21.53125 C 7.832031 22.167969 7.035156 22.554688 6.21875 22.59375 C 5.664063 22.621094 4.878906 22.503906 4.1875 21.8125 C 3.542969 21.167969 3.40625 20.414063 3.40625 19.90625 C 3.40625 19.050781 3.796875 18.199219 4.46875 17.53125 L 9.46875 12.5 C 10.726563 11.242188 12.640625 11.144531 13.75 12.25 C 14.386719 12.886719 15.429688 12.886719 16.0625 12.25 C 16.699219 11.613281 16.699219 10.574219 16.0625 9.9375 C 14.921875 8.796875 13.417969 8.21875 11.875 8.21875 Z", fill: "#1a9bfb" })), Ul = 92, Hl = (u) => {
  try {
    const {
      hostname: e
    } = new URL(u);
    return e;
  } catch {
    return "Error";
  }
}, Vl = () => /* @__PURE__ */ r.jsx("div", { className: "sp-w-full sp-h-2 sp-overflow-hidden", style: {
  backgroundColor: "rgba(181, 180, 176, 0.4)"
}, children: /* @__PURE__ */ r.jsx("span", { className: "sp-block sp-bg-gray-400 sp-h-full sp-opacity-75", style: {
  width: "33%"
}, children: " " }) }), Wl = ({
  username: u,
  profilePicture: e,
  locationName: t
}) => /* @__PURE__ */ r.jsxs("section", { className: "sp-absolute sp-top-0 sp-left-0 sp-w-full sp-z-50", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-my-3 sp-mx-2", children: /* @__PURE__ */ r.jsx(Vl, {}) }),
  /* @__PURE__ */ r.jsx(Cs, { username: u, profilePicture: e, locationName: t, small: !0 })
] }), ql = () => /* @__PURE__ */ r.jsx("section", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-mb-6 sp-mx-4 sp-w-full sp-text-white", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-w-full", children: [
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-grow sp-rounded-full sp-p-2 sp-border-2 sp-border-solid sp-border-gray-600 sp-flex sp-items-center sp-mr-3", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-justify-center sp-items-center sp-rounded-full sp-p-3 sp-mr-2", style: {
      backgroundColor: "rgba(74, 85, 104, 0.7)"
    }, children: /* @__PURE__ */ r.jsx(Ml, { className: "sp-h-20px sp-w-20px" }) }),
    /* @__PURE__ */ r.jsx(te, { $variant: "caption", className: "sp-font-bold sp-pl-4", children: "Send message" })
  ] }),
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-mx-8", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-fill-current sp-mr-3 icon-instagram-share sp-flex sp-text-4xl sp-mr-8" }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex sp-mr-3 sp-mr-4", children: [...Array(3)].map((u, e) => /* @__PURE__ */ r.jsx(s1, {}, e)) })
  ] })
] }) }), Gl = ({
  url: u,
  label: e,
  height: t
}) => /* @__PURE__ */ r.jsx(u1, { className: "sp-bg-white sp-rounded-lg sp-absolute sp-z-10", height: t * 100, children: /* @__PURE__ */ r.jsx(e1, { href: u, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ r.jsxs(t1, { children: [
  /* @__PURE__ */ r.jsx(n1, { children: /* @__PURE__ */ r.jsx(zl, {}) }),
  /* @__PURE__ */ r.jsx(r1, { children: e || Hl(u) })
] }) }) }), Ks = 6.5, Yl = _.div`
  top: calc(
    ${(u) => u.height ? `${u.height + Ks}% - ${u.height > 60 ? "140px" : "110px"}` : "0"}
  );
  position: absolute;
  z-index: 10;
  width: 100%;
  display: flex;
  flex-direction: ${(u) => u.height > 60 ? "column-reverse" : "column"};
`, Zl = _.div`
  width: 100%;
  height: 145px;
  background: rgba(255, 255, 255, 0.2);
  align-items: center;
  display: flex;
  border-top: 1px dashed rgba(255, 255, 255, 0.2);
  border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
  div {
    width: 100%;
    height: 100px;
    background: rgba(255, 255, 255, 0.2);
    border-top: 1px dashed rgba(255, 255, 255, 0.2);
    border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
  }
`, Kl = _.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10px;
  margin: 10px 0;
`, Jl = _.p`
  color: white;
  font-size: 10px;
  font-family: Inter;
  font-weight: 600;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.9);
  text-transform: uppercase;
  margin: 0;
`, Xl = _.div`
  width: 18px;
  height: 18px;
  background: #333;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
  font-family: Inter;
  font-weight: 600;
  margin-left: 8px;
  position: relative;
  :hover {
    cursor: pointer;
    div {
      visibility: visible;
    }
  }
`, Ql = _.div`
  visibility: hidden;
  width: 340px;
  background-color: rgba(51, 51, 51, 1);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: ${(u) => u.height > 60 ? "-38px" : "28px"};
  right: -62px;
  &::after {
    content: "";
    position: absolute;
    bottom: ${(u) => u.height > 60 ? "-10px" : "29px"};
    right: 66px;
    rotate: ${(u) => u.height > 60 ? "180deg" : "0"};
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 1) transparent;
  }
`, u1 = _.div`
  top: calc(${(u) => u.height && u.height + Ks}% - 60px);
  left: 50%;
  transform: translateX(-50%);
  width: fit-content;
  max-width: 95%;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 8px 16px;
`, e1 = _.a`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  &:hover {
    text-decoration: none;
  }
`, t1 = _.div`
  max-width: 100%;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`, r1 = _.div`
  flex: 1 1 auto;
  min-width: 0;
  display: block;
  color: #1a9bfb;
  font-size: clamp(20px, 2.4vw, 28px);
  line-height: 1.1;
  font-family: Aveny, "Apple Color Emoji", "Segoe UI Emoji", Arial, sans-serif;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transform: translateY(4px);
`, n1 = _.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 25px;
  width: 25px;
`, s1 = _.div`
  width: 5px;
  height: 5px;
  border-radius: 9999px;
  background-color: white;
  margin-left: 0.2rem;
`, Js = ({
  post: u,
  media: e,
  isActiveSlide: t,
  env: n,
  showNote: s = !0
}) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-column sp-justify-center", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-relative sp-min-h-670px sp-w-full md:sp-min-h-710px sp-bg-black sp-overflow-hidden", children: [
    /* @__PURE__ */ r.jsx(Wl, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName }),
    /* @__PURE__ */ r.jsxs(i1, { children: [
      u.storyUrl && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        n === "schedugram-client" && /* @__PURE__ */ r.jsxs(Yl, { height: (u.storyStickerHeight || 0.8) * 100, children: [
          /* @__PURE__ */ r.jsx(Zl, { children: /* @__PURE__ */ r.jsx("div", {}) }),
          /* @__PURE__ */ r.jsxs(Kl, { children: [
            /* @__PURE__ */ r.jsx(Jl, { children: "Approx. Sticker placement area" }),
            /* @__PURE__ */ r.jsxs(Xl, { children: [
              "?",
              /* @__PURE__ */ r.jsx(Ql, { height: (u.storyStickerHeight || 0.8) * 100, children: "Sticker position is approximate, to be used as a guide only." })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ r.jsx(Gl, { url: u.storyUrl, label: u.storyLabel, height: u.storyStickerHeight || 0.8 })
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-h-full sp-w-full sp-flex-col sp-justify-center sp-bg-black", children: /* @__PURE__ */ r.jsx(fe, { media: e, isActiveSlide: t, imageObjectFit: "contain", fillContainer: !0, videoObjectFit: "cover" }) })
    ] }),
    /* @__PURE__ */ r.jsx(ql, {})
  ] }) }),
  s && u.caption && /* @__PURE__ */ r.jsxs(Xs, { children: [
    /* @__PURE__ */ r.jsx("strong", { children: "Notes for manual Publishing: " }),
    u.caption
  ] })
] }), Xs = _.p`
  max-width: 358px;
  margin: 14px auto 0;
  font-size: 14px;
`, i1 = _.div`
  position: absolute;
  inset: 0 0 ${Ul}px 0;
  overflow: hidden;
  background: #000;
`, a1 = ({
  post: u,
  media: e,
  slideNo: t,
  isActiveSlide: n,
  env: s
}) => {
  const i = {
    order: t,
    flex: "1 0 100%"
  };
  return /* @__PURE__ */ r.jsx("div", { style: i, children: /* @__PURE__ */ r.jsx(Js, { post: u, media: e, isActiveSlide: n, env: s, showNote: !1 }) });
}, o1 = ({
  post: u,
  stories: e,
  currentSlide: t,
  env: n
}) => e.map((s, i) => /* @__PURE__ */ r.jsx(a1, { post: u, media: s, slideNo: i + 1, isActiveSlide: t === i + 1, env: n }, i)), D1 = ({
  post: u,
  stories: e,
  count: t,
  env: n
}) => {
  const [s, i] = Au(1), a = 1, D = t;
  Xu(() => {
    i(1);
  }, [u]);
  const o = {
    left: "100%",
    transform: `translateX(${s * -100}%)`
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden", children: [
      a === s || /* @__PURE__ */ r.jsx(Ae, { direction: "left", onClick: () => i(s - 1) }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-relative", style: o, children: /* @__PURE__ */ r.jsx(o1, { post: u, stories: e, currentSlide: s, env: n }) }),
      D === s || /* @__PURE__ */ r.jsx(Ae, { direction: "right", onClick: () => i(s + 1) })
    ] }),
    u.caption && /* @__PURE__ */ r.jsxs(Xs, { children: [
      /* @__PURE__ */ r.jsx("strong", { children: "Notes for manual Publishing: " }),
      u.caption
    ] })
  ] });
}, l1 = ({
  post: u,
  env: e
}) => {
  const t = u.medias.collection, n = t.length;
  return /* @__PURE__ */ r.jsx("div", { className: "sp-pb-8", children: n > 1 ? /* @__PURE__ */ r.jsx(D1, { post: u, stories: t, count: n, env: e }) : /* @__PURE__ */ r.jsx(Js, { post: u, media: t[0], env: e }) });
}, c1 = _.div`
  display: flex;
  flex-direction: ${({
  $direction: u = "row"
}) => u};
  justify-content: ${({
  $justify: u = "flex-start"
}) => u};
  align-items: ${({
  $align: u = "flex-start"
}) => u};
  gap: ${({
  $gap: u = 7
}) => `${u}px`};
  margin-top: ${({
  $marginTop: u = 0
}) => u === "auto" ? "auto" : `${u}px`};
  margin-bottom: ${({
  $marginBottom: u = 0
}) => u === "auto" ? "auto" : `${u}px`};
  margin-left: ${({
  $marginLeft: u = 0
}) => u === "auto" ? "auto" : `${u}px`};
  margin-right: ${({
  $marginRight: u = 0
}) => u === "auto" ? "auto" : `${u}px`};
  width: ${({
  $width: u = "auto"
}) => u};
`, F1 = ({
  media: u,
  slideNo: e,
  isActiveSlide: t
}) => {
  const n = {
    order: e,
    flex: "1 0 100%"
  };
  return /* @__PURE__ */ r.jsx("div", { style: n, className: "sp-h-full", children: /* @__PURE__ */ r.jsx(fe, { media: u, isActiveSlide: t, videoContainerStyles: {
    position: "relative"
  }, videoObjectFit: "cover", imageObjectFit: "contain", fillContainer: !0 }) });
}, d1 = ({
  medias: u,
  currentSlide: e
}) => {
  const t = u.map((n, s) => /* @__PURE__ */ r.jsx(F1, { media: n, slideNo: s + 1, isActiveSlide: e === s + 1 }, `slide-${s}`));
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: t });
}, p1 = ({
  current: u
}) => /* @__PURE__ */ r.jsx("div", { className: `${u ? "sp-bg-blue-600" : "sp-bg-gray-500"}
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out` }), E1 = ({
  count: u,
  current: e
}) => /* @__PURE__ */ r.jsx(f1, { className: "sp-flex sp-items-center sp-justify-center", children: [...Array(u)].map((t, n) => /* @__PURE__ */ r.jsx(p1, { current: n + 1 === e }, `dot-${n}`)) }), C1 = ({
  medias: u,
  count: e
}) => {
  const [t, n] = Au(1);
  Xu(() => {
    t > u.length && n(u.length);
  }, [u.length, t]);
  const s = {
    left: "100%",
    transform: `translateX(${t * -100}%)`
  };
  return /* @__PURE__ */ r.jsxs(c1, { $width: "100%", $direction: "column", $justify: "center", $align: "stretch", $gap: "0", className: "sp-relative", children: [
    /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-flex-1 sp-relative sp-overflow-hidden", children: [
      t !== 1 && /* @__PURE__ */ r.jsx(Ae, { direction: "left", onClick: () => n(t - 1) }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-relative sp-items-stretch sp-h-full", style: s, children: /* @__PURE__ */ r.jsx(d1, { medias: u, currentSlide: t }) }),
      t !== u.length && /* @__PURE__ */ r.jsx(Ae, { direction: "right", onClick: () => n(t + 1) })
    ] }),
    /* @__PURE__ */ r.jsx(E1, { count: e, current: t })
  ] });
}, f1 = _.div`
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 100%;
`, Qs = ({
  medias: u
}) => {
  const e = u.collection, t = e.length, n = t > 1;
  if (t === 0)
    return null;
  const s = e[0], i = !!s?.isVideo || s?.url?.includes(".mp4");
  return n ? /* @__PURE__ */ r.jsx(C1, { medias: e, count: t }) : /* @__PURE__ */ r.jsx(fe, { media: s, controls: i, videoObjectFit: "cover", imageObjectFit: "contain", fillContainer: !0 });
}, ht = _.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, A1 = (u) => /* @__PURE__ */ m.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 14", ...u }, /* @__PURE__ */ m.createElement("path", { d: "M0.285317 6.39974C0.194867 6.47853 0.123111 6.5721 0.0741546 6.6751C0.0251977 6.7781 6.52568e-07 6.8885 6.47695e-07 7C6.42821e-07 7.1115 0.0251977 7.2219 0.0741545 7.3249C0.123111 7.42789 0.194867 7.52146 0.285317 7.60026L7.33835 13.7514C7.52089 13.9106 7.76847 14 8.02663 14C8.28478 14 8.53236 13.9106 8.71491 13.7514C8.89745 13.5922 9 13.3762 9 13.1511C9 12.926 8.89745 12.71 8.71491 12.5508L2.35015 7L8.71491 1.44916C8.80529 1.37033 8.87699 1.27675 8.92591 1.17376C8.97482 1.07077 9 0.960378 9 0.848899C9 0.73742 8.97482 0.627033 8.92591 0.52404C8.87699 0.421046 8.80529 0.327465 8.71491 0.248637C8.62452 0.169809 8.51722 0.10728 8.39912 0.0646186C8.28103 0.0219574 8.15445 -3.86212e-08 8.02663 -4.25475e-08C7.8988 -4.64737e-08 7.77223 0.0219574 7.65413 0.0646186C7.53604 0.10728 7.42873 0.169809 7.33835 0.248637L0.285317 6.39974Z", fill: "white" })), h1 = (u) => /* @__PURE__ */ m.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 21 17", ...u }, /* @__PURE__ */ m.createElement("g", { filter: "url(#filter0_d_0_85)" }, /* @__PURE__ */ m.createElement("path", { d: "M13.2308 23C11.4549 23 10 21.6081 10 19.9091V11.6667C10 9.96768 11.4549 8.57576 13.2308 8.57576H15.9567L17.0841 6.42661C17.1514 6.2982 17.2547 6.19026 17.3825 6.11491C17.5103 6.03955 17.6576 5.99976 17.8077 6H23.1923C23.3424 5.99976 23.4897 6.03955 23.6175 6.11491C23.7453 6.19026 23.8486 6.2982 23.9159 6.42661L25.0433 8.57576H27.7692C29.5451 8.57576 31 9.96768 31 11.6667V19.9091C31 21.6081 29.5451 23 27.7692 23H13.2308ZM13.2308 21.4545H27.7692C28.6781 21.4545 29.3846 20.7786 29.3846 19.9091V11.6667C29.3846 10.7972 28.6781 10.1212 27.7692 10.1212H24.5385C24.3883 10.1215 24.2411 10.0817 24.1133 10.0063C23.9855 9.93097 23.8822 9.82303 23.8149 9.69462L22.6875 7.54545H18.3125L17.1851 9.69462C17.1178 9.82303 17.0145 9.93097 16.8867 10.0063C16.7589 10.0817 16.6117 10.1215 16.4615 10.1212H13.2308C12.3219 10.1212 11.6154 10.7972 11.6154 11.6667V19.9091C11.6154 20.7786 12.3219 21.4545 13.2308 21.4545ZM20.5 20.1667C17.9818 20.1667 15.9231 18.1971 15.9231 15.7879C15.9231 13.3787 17.9818 11.4091 20.5 11.4091C23.0182 11.4091 25.0769 13.3787 25.0769 15.7879C25.0769 18.1971 23.0182 20.1667 20.5 20.1667ZM20.5 18.6212C22.1452 18.6212 23.4615 17.3618 23.4615 15.7879C23.4615 14.2139 22.1452 12.9546 20.5 12.9546C18.8549 12.9546 17.5385 14.2139 17.5385 15.7879C17.5385 17.3618 18.8549 18.6212 20.5 18.6212Z", fill: "white" })), /* @__PURE__ */ m.createElement("defs", null, /* @__PURE__ */ m.createElement("filter", { id: "filter0_d_0_85", x: 0, y: 0, width: 41, height: 37, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ m.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ m.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ m.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ m.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ m.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ m.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_85" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_85", result: "shape" })))), m1 = (u) => /* @__PURE__ */ m.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 8 8", ...u }, /* @__PURE__ */ m.createElement("g", { filter: "url(#filter0_d_0_80)" }, /* @__PURE__ */ m.createElement("rect", { x: 10, y: 8, width: 2, height: 5, rx: 1, fill: "white" }), /* @__PURE__ */ m.createElement("rect", { x: 16, y: 8, width: 2, height: 5, rx: 1, fill: "white" }), /* @__PURE__ */ m.createElement("rect", { x: 13, y: 6, width: 2, height: 8, rx: 1, fill: "white" })), /* @__PURE__ */ m.createElement("defs", null, /* @__PURE__ */ m.createElement("filter", { id: "filter0_d_0_80", x: 0, y: 0, width: 28, height: 28, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ m.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ m.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ m.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ m.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ m.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ m.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_80" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_80", result: "shape" })))), g1 = _.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`, B1 = _.div`
  background: url(${(u) => u.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 6px;
`, ui = ({
  profilePicture: u,
  username: e
}) => /* @__PURE__ */ r.jsxs(g1, { children: [
  /* @__PURE__ */ r.jsx(B1, { $profilePicture: u }),
  /* @__PURE__ */ r.jsxs(ht, { className: "sp-font-bold", children: [
    e,
    " • Follow"
  ] })
] }), x1 = (u) => /* @__PURE__ */ m.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 20 18", ...u }, /* @__PURE__ */ m.createElement("g", { filter: "url(#filter0_d_0_66)" }, /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.383 6C21.3618 6 20.0001 8.32683 20.0001 8.32683C20.0001 8.32683 18.6384 6 15.6171 6C12.5107 6 10.0001 8.80976 10.0001 12.278C10.0001 15.7463 12.5958 17.722 15.1916 20.0927C19.1064 23.6927 19.3618 24 20.0001 24C20.6384 24 20.8937 23.6927 24.8086 20.0927C27.4469 17.678 30.0001 15.7024 30.0001 12.278C30.0001 8.80976 27.4894 6 24.383 6ZM23.9575 19.0829C21.6596 21.1902 20.4256 22.3756 20.0001 22.639C19.5745 22.3317 18.0426 20.9268 16.0426 19.0829C13.7022 16.9317 11.2767 15.1317 11.2767 12.2341C11.2767 9.5122 13.2341 7.27317 15.6171 7.27317C17.3618 7.27317 18.2979 8.15122 18.9788 9.11707C20.5107 11.3561 19.4894 11.3561 21.0213 9.11707C21.7022 8.15122 22.6384 7.27317 24.383 7.27317C26.766 7.27317 28.7235 9.5122 28.7235 12.2341C28.7235 15.1756 26.2979 16.9756 23.9575 19.0829Z", fill: "white" })), /* @__PURE__ */ m.createElement("defs", null, /* @__PURE__ */ m.createElement("filter", { id: "filter0_d_0_66", x: 610352e-10, y: 0, width: 40, height: 38, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ m.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ m.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ m.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ m.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ m.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ m.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_66" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_66", result: "shape" })))), y1 = (u) => /* @__PURE__ */ m.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 20 20", ...u }, /* @__PURE__ */ m.createElement("g", { filter: "url(#filter0_d_0_65)" }, /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.9868 25.3914L28.7961 20.7137C29.5615 19.3103 29.9868 17.6944 29.9868 15.9934C29.9868 10.4651 25.5216 6 19.9934 6C14.4651 6 10 10.4651 10 15.9934C10 21.5216 14.4651 25.9868 19.9934 25.9868C21.6944 25.9868 23.3103 25.5615 24.7137 24.7961L29.3914 25.9868C29.7316 26.0718 30.0718 25.7316 29.9868 25.3914ZM28.711 15.9934C28.711 17.6944 28.2858 18.9701 27.6054 20.2459C27.5203 20.416 27.4778 20.6286 27.5203 20.8412L28.4134 24.4134L24.8838 23.5203C24.6711 23.4778 24.4585 23.4778 24.2884 23.6054C23.523 24.0306 22.0771 24.711 20.0359 24.711C15.1881 24.711 11.2758 20.7987 11.2758 15.9934C11.2758 11.1881 15.1881 7.27575 19.9934 7.27575C24.7987 7.27575 28.711 11.1881 28.711 15.9934Z", fill: "white" })), /* @__PURE__ */ m.createElement("defs", null, /* @__PURE__ */ m.createElement("filter", { id: "filter0_d_0_65", x: 0, y: 0, width: 40, height: 40, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ m.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ m.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ m.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ m.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ m.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ m.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_65" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_65", result: "shape" })))), v1 = (u) => /* @__PURE__ */ m.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 20 17", ...u }, /* @__PURE__ */ m.createElement("g", { filter: "url(#filter0_d_0_64)" }, /* @__PURE__ */ m.createElement("path", { d: "M29.5574 6H10.419C10.0363 6 9.86616 6.45544 10.1213 6.70386L16.9261 13.2456L19.2652 22.6856C19.3503 23.0582 19.8606 23.0996 20.0307 22.8098L29.9401 6.62105C30.1102 6.33123 29.8976 6 29.5574 6ZM12.503 7.2421H26.7504L17.9043 12.0035C17.7341 12.0863 17.5215 12.0449 17.3939 11.9207L12.503 7.2421ZM20.0307 20.4084L18.3295 13.5354C18.287 13.3698 18.3721 13.1628 18.5422 13.08L27.4309 8.27719L20.0307 20.4084Z", fill: "white" })), /* @__PURE__ */ m.createElement("defs", null, /* @__PURE__ */ m.createElement("filter", { id: "filter0_d_0_64", x: 0, y: 0, width: 40, height: 37, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ m.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ m.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ m.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ m.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ m.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ m.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_64" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_64", result: "shape" })))), b1 = (u) => /* @__PURE__ */ m.createElement("svg", { width: 16, height: 4, viewBox: "0 0 16 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("circle", { cx: 2, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ m.createElement("circle", { cx: 8, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ m.createElement("circle", { cx: 14, cy: 2, r: 2, fill: "white" })), w1 = _.div`
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 4;

  svg {
    width: 20px;

    &.more {
      position: relative;
      ${({
  $vertical: u
}) => u && "top: -10px;"};
    }
  }

  ${({
  $vertical: u
}) => u ? `
      flex-direction: column;
      right: 14px;
      bottom: 145px;
      gap: 40px;
      ` : `
      flex-direction: row;
      gap: 14px;
      left: 14px;
      bottom: 80px;
      `}
`, ei = ({
  vertical: u
}) => /* @__PURE__ */ r.jsxs(w1, { $vertical: u, children: [
  /* @__PURE__ */ r.jsx(x1, {}),
  /* @__PURE__ */ r.jsx(y1, {}),
  /* @__PURE__ */ r.jsx(v1, {}),
  /* @__PURE__ */ r.jsx(b1, { className: "more" })
] }), j1 = ({
  post: u,
  className: e
}) => {
  const t = u?.medias?.collection?.length > 1, n = u.comment?.trim(), [s, i] = Au(!1);
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(_1, { className: e, children: [
      /* @__PURE__ */ r.jsxs(T1, { children: [
        /* @__PURE__ */ r.jsx(A1, { className: "arrow-back" }),
        /* @__PURE__ */ r.jsx(ht, { children: "Reels" }),
        /* @__PURE__ */ r.jsx(h1, { className: "camera" })
      ] }),
      /* @__PURE__ */ r.jsx(ei, { vertical: !0 }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-w-full sp-h-64 sp-bg-gradient-to-t sp-from-black/60 sp-via-black/20 sp-to-transparent sp-pointer-events-none sp-z-[1]" }),
      /* @__PURE__ */ r.jsxs(S1, { $isMultipleMedia: t, $expanded: s, children: [
        /* @__PURE__ */ r.jsx(ui, { profilePicture: u.profilePicture, username: u.username }),
        /* @__PURE__ */ r.jsx("div", { className: s ? "sp-max-h-[300px] sp-overflow-y-auto" : "sp-line-clamp-2 sp-overflow-hidden", style: s ? {
          scrollbarWidth: "none"
        } : void 0, children: /* @__PURE__ */ r.jsx(ht, { children: /* @__PURE__ */ r.jsx(vu, { caption: u.caption, targetPlatform: "IG" }) }) }),
        u.caption && /* @__PURE__ */ r.jsx("button", { onClick: (a) => {
          a.stopPropagation(), i(!s);
        }, className: "sp-text-white/70 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0", children: s ? "less" : "more" }),
        /* @__PURE__ */ r.jsxs(k1, { children: [
          /* @__PURE__ */ r.jsx(m1, {}),
          /* @__PURE__ */ r.jsx("span", { children: "Audio will be auto-matched after publishing" })
        ] })
      ] }),
      /* @__PURE__ */ r.jsx(Qs, { medias: u.medias })
    ] }),
    n && /* @__PURE__ */ r.jsxs(P1, { id: "post-preview-notes", children: [
      /* @__PURE__ */ r.jsxs("strong", { children: [
        u.username,
        " "
      ] }),
      /* @__PURE__ */ r.jsx(vu, { caption: n, targetPlatform: "IG" })
    ] })
  ] });
}, _1 = _.div`
  box-shadow: 0 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
  height: 711px;
  background: #333;
  display: flex;
  overflow: hidden;
`, S1 = _.div`
  position: absolute;
  bottom: ${(u) => u.$isMultipleMedia ? "85px" : "55px"};
  z-index: 4;
  padding: ${(u) => u.$expanded ? "12px" : "0 0 0 12px"};
  right: 60px;
  overflow-wrap: break-word;
  word-break: break-word;
  border-radius: ${(u) => u.$expanded ? "12px" : "0"};
  background: ${(u) => u.$expanded ? "rgba(0, 0, 0, 0.5)" : "transparent"};
  transition:
    background 0.2s ease,
    padding 0.2s ease;

  a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
  }
`, P1 = _.div`
  margin: 14px 5px;
  font-size: 14px;
  line-height: 17px;
`, T1 = _.div`
  position: absolute;
  top: 25px;
  display: flex;
  align-items: center;
  z-index: 4;
  justify-content: space-between;
  width: 100%;

  p {
    font-weight: 700;
  }

  .arrow-back {
    width: 14px;
    margin-left: 12px;
  }

  .camera {
    width: 21px;
    margin-right: 12px;
  }
`, k1 = _.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    width: 8px;
    flex-shrink: 0;
  }
`, N1 = _.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
`, O1 = _.div`
  position: absolute;
  top: 20px;
  z-index: 2;
  width: 100%;

  .section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    box-sizing: border-box;
    margin-bottom: 10px;

    p {
      width: 280px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-size: 16px;
    }

    svg.close {
      width: 17px;
    }
  }
`, $1 = ({
  post: u
}) => /* @__PURE__ */ r.jsxs(N1, { children: [
  /* @__PURE__ */ r.jsxs(O1, { children: [
    u.caption && /* @__PURE__ */ r.jsx("div", { className: "section", children: /* @__PURE__ */ r.jsx(ht, { children: u.caption }) }),
    /* @__PURE__ */ r.jsx("div", { className: "section", children: /* @__PURE__ */ r.jsx(ui, { profilePicture: u.profilePicture, username: u.username }) })
  ] }),
  /* @__PURE__ */ r.jsx(ei, {}),
  /* @__PURE__ */ r.jsx(Qs, { medias: u.medias })
] }), R1 = ({
  post: u,
  className: e,
  env: t
}) => {
  let n = u.type;
  switch (n === "story" && u.storyType && u.storyType !== "story" && (u.storyType === "reel" ? (n = "reel", u.locationName = "Reel") : u.storyType === "igtv" && (n = "igtv", u.locationName = "IGTV")), n) {
    case "image":
    case "multiMedia":
      return /* @__PURE__ */ r.jsx(Ll, { post: u });
    // videos now get previewed as reels
    case "video":
    case "reel":
      return /* @__PURE__ */ r.jsx(j1, { post: u, className: e });
    case "igtv":
      return /* @__PURE__ */ r.jsx($1, { post: u });
    case "story":
      return /* @__PURE__ */ r.jsx(l1, { post: u, env: t });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, he = _.div`
  font-family: Helvetica;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 16px;
          letter-spacing: -0.02em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};

  .sked-mention.sked-mention-facebook {
    color: hsl(214, 89%, 52%);

    &:hover {
      text-decoration: underline;
    }
  }
`, I1 = ({
  username: u,
  profilePicture: e,
  small: t,
  scheduled: n
}) => {
  let s = new Iu(n).format("MMM D [at] HH:mm");
  return s === "Invalid date" && (s = null), /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-m-4", style: {
      width: "40px",
      height: "40px",
      minWidth: "40px",
      minHeight: "40px"
    }, children: /* @__PURE__ */ r.jsx($u, { src: e, alt: u }) }),
    /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${t ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsxs("div", { className: "", children: [
      /* @__PURE__ */ r.jsx(he, { $variant: "heading", className: "sp-mb-1", children: u }),
      s && /* @__PURE__ */ r.jsx(he, { $variant: "subheading", children: s })
    ] }) })
  ] });
}, Mu = ({
  children: u,
  href: e,
  target: t = "_blank",
  $isFlex: n = !1
}) => /* @__PURE__ */ r.jsx(Vs, { $isFlex: n, href: e, target: t, rel: "noreferrer", children: u });
function ti(u) {
  var e, t, n = "";
  if (typeof u == "string" || typeof u == "number") n += u;
  else if (typeof u == "object") if (Array.isArray(u)) {
    var s = u.length;
    for (e = 0; e < s; e++) u[e] && (t = ti(u[e])) && (n && (n += " "), n += t);
  } else for (t in u) u[t] && (n && (n += " "), n += t);
  return n;
}
function L1() {
  for (var u, e, t = 0, n = "", s = arguments.length; t < s; t++) (u = arguments[t]) && (e = ti(u)) && (n && (n += " "), n += e);
  return n;
}
const M1 = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, z1 = _.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, U1 = ({
  src: u,
  forCarousel: e,
  showOverlay: t,
  showAll: n,
  setShowAll: s,
  mediaCount: i
}) => e ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx(Mu, { href: u, $isFlex: !0, children: /* @__PURE__ */ r.jsx(z1, { src: u, className: "" }) }),
  !n && t && /* @__PURE__ */ r.jsxs("div", { className: "sp-cursor-pointer", onClick: () => s(!0), children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      i - 4
    ] })
  ] })
] }) : /* @__PURE__ */ r.jsx(Mu, { href: u, children: /* @__PURE__ */ r.jsx(M1, { src: u }) }), H1 = ({
  url: u,
  isActiveSlide: e,
  isCarouselPost: t,
  controls: n = !0
}) => {
  const {
    vid: s,
    videoCoverPreview: i,
    showVideoCover: a,
    resetVideo: D,
    handlePlay: o,
    handlePause: d,
    showResetButton: x
  } = tn({
    usePostTypeCheck: !1
  }), [c, h] = Au(!1), F = !n, C = F && a && !c, f = () => {
    h(!1), D();
  };
  return e ? /* @__PURE__ */ r.jsx("div", { className: L1("sp-w-full sp-h-full", {
    "sp-relative": !t
  }, {
    "sp-absolute": t
  }), children: /* @__PURE__ */ r.jsxs(qs, { $showVideoCover: a, children: [
    x && /* @__PURE__ */ r.jsx(Ys, { onClick: f }),
    C && i && /* @__PURE__ */ r.jsx(Gs, { src: i, alt: "" }),
    F && /* @__PURE__ */ r.jsx(Zs, { playing: c, onToggle: () => h((y) => !y) }),
    /* @__PURE__ */ r.jsx(ku, { url: u, controls: n, playing: F ? c : !!i, onPlay: o, onPause: d, light: !F && a ? i : void 0, className: "sp-overflow-hidden sp-my-auto", width: "100%", height: "100%" }, s)
  ] }) }) : null;
}, rn = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showOverlay: n,
  showAll: s,
  setShowAll: i,
  mediaCount: a,
  isActiveSlide: D = !0,
  controls: o
}) => e && s === !1 ? null : u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(H1, { url: u.url, isActiveSlide: D, isCarouselPost: t, controls: o }) : /* @__PURE__ */ r.jsx(U1, { src: u.url, forCarousel: t, showOverlay: n, showAll: s, setShowAll: i, mediaCount: a }), V1 = _.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;
  overflow: hidden;
  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, W1 = ({
  medias: u
}) => {
  const [e, t] = Au(!1);
  return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: u.map((n, s) => !e && s > 3 ? null : /* @__PURE__ */ r.jsx(V1, { className: "sp-relative", children: /* @__PURE__ */ r.jsx(rn, { media: n, forCarousel: !0, hidden: s > 3, isActiveSlide: s === 0, mediaCount: u.length, showOverlay: s === 3 && u.length > 4, showAll: e, setShowAll: t }) }, `fb-media-key-${s}`)) });
}, q1 = () => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-w-full sp-justify-center sp-py-2 sp-text-gray-700", children: [
  /* @__PURE__ */ r.jsx(dr, { icon: "icon-facebook-like", text: "Like" }),
  /* @__PURE__ */ r.jsx(dr, { icon: "icon-facebook-comment", text: "Comment" }),
  /* @__PURE__ */ r.jsx(dr, { icon: "icon-facebook-share", text: "Share" })
] }), dr = ({
  icon: u,
  text: e
}) => /* @__PURE__ */ r.jsxs(he, { $variant: "icons", className: "sp-flex sp-items-center sp-justify-center sp-w-1/3 ", children: [
  /* @__PURE__ */ r.jsx("div", { className: `sp-mr-2 sp-text-xl ${u}` }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-text-gray-700", children: e })
] }), G1 = ({
  medias: u
}) => {
  const e = u.collection, t = e.length, n = t > 1;
  return /* @__PURE__ */ r.jsxs("div", { children: [
    t > 0 && /* @__PURE__ */ r.jsx(r.Fragment, { children: n ? /* @__PURE__ */ r.jsx(W1, { medias: e }) : /* @__PURE__ */ r.jsx(rn, { media: e[0], showOverlay: !1, showAll: !0, setShowAll: () => {
    }, isActiveSlide: !0, mediaCount: t }) }),
    /* @__PURE__ */ r.jsx(q1, {})
  ] });
}, Y1 = "JgUARf2HjedOQkin6wQs2Ll11upPpWG5gJ1NTX9c", _t = ({
  url: u
}) => /* @__PURE__ */ r.jsx(Oi, { url: u, apiKey: Y1, size: "large", className: "sp-shadow-lg" }), Z1 = ({
  post: u
}) => {
  let e = u.caption;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
    /* @__PURE__ */ r.jsx(I1, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName, scheduled: u.scheduledFor }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-col sp-mx-4 sp-pb-4", style: u.type === "text" && u.redirectUrl === "" ? {
      borderBottom: "1px solid #BFBEBE"
    } : {}, children: /* @__PURE__ */ r.jsxs(he, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ r.jsx(vu, { caption: e, targetPlatform: "FB" }),
      u.redirectUrl && u.type !== "text" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        " ",
        /* @__PURE__ */ r.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: u.redirectUrl, target: "_blank", children: u.redirectUrl })
      ] })
    ] }) }),
    u.type === "text" && u.redirectUrl && /* @__PURE__ */ r.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ r.jsx(_t, { url: u.redirectUrl }) }),
    /* @__PURE__ */ r.jsx(G1, { medias: u.medias }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-col sp-px-4 sp-pb-8", children: u.comment && u.comment.trim() !== "" && /* @__PURE__ */ r.jsxs(he, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ r.jsx("span", { className: "sp-font-bold sp-mr-1", children: u.username }),
      /* @__PURE__ */ r.jsx(vu, { caption: u.comment, targetPlatform: "FB" })
    ] }) })
  ] });
}, K1 = ({
  post: u,
  media: e
}) => {
  const [t, n] = Au(!1);
  return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-column sp-justify-center sp-h-full", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-column sp-justify-center sp-relative sp-h-full sp-w-full", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-min-h-670px sp-w-full md:sp-min-h-710px sp-flex sp-flex-col sp-justify-center sp-bg-black", children: /* @__PURE__ */ r.jsx(rn, { media: e, controls: !1 }) }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-top-8 sp-flex sp-items-center sp-justify-between sp-w-full  sp-text-white sp-text-24px", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-mx-16px sp-w-full sp-flex sp-items-center sp-justify-between", children: [
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ r.jsx("i", { className: "fa-regular fa-xmark" }) }),
      /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-gap-16px", children: [
        /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ r.jsx("i", { className: "fa-regular fa-magnifying-glass" }) }),
        /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ r.jsx("i", { className: "fa-regular fa-circle-user" }) })
      ] })
    ] }) }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-bottom-[50px] sp-right-[16px] sp-flex sp-flex-col sp-gap-[40px] sp-items-center sp-text-white sp-text-24px sp-z-10", children: [
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ r.jsx("i", { className: "fa-regular fa-thumbs-up" }) }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ r.jsx("i", { className: "fa-regular fa-message" }) }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ r.jsx("i", { className: "fa-regular fa-share" }) }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ r.jsx("i", { className: "fa-regular fa-comment-lines" }) }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ r.jsx("i", { className: "fa-regular fa-ellipsis" }) })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-w-full sp-h-64 sp-bg-gradient-to-t sp-from-black/60 sp-via-black/20 sp-to-transparent sp-pointer-events-none sp-z-[5]" }),
    /* @__PURE__ */ r.jsxs("div", { className: `sp-absolute sp-bottom-[50px] sp-flex sp-flex-col sp-gap-3 sp-z-10 sp-transition-all sp-duration-200 ${t ? "sp-left-0 sp-right-0 sp-px-5 sp-bg-black/50 sp-p-3" : "sp-left-5 sp-max-w-[320px]"}`, children: [
      /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-gap-3", children: [
        /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-gap-[8px]", children: [
          /* @__PURE__ */ r.jsx("div", { className: "sp-w-[40px] sp-h-[40px] sp-rounded-full sp-overflow-hidden sp-bg-[#333] sp-flex sp-items-center sp-justify-center", children: /* @__PURE__ */ r.jsx("img", { src: u.profilePicture, className: "sp-w-full sp-h-full sp-object-cover" }) }),
          /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-gap-1", children: /* @__PURE__ */ r.jsx("span", { className: "sp-text-white sp-font-semibold sp-text-[16px] sp-max-w-[180px] sp-overflow-hidden sp-whitespace-nowrap sp-text-ellipsis sp-inline-block", children: u.username }) }),
          /* @__PURE__ */ r.jsx("div", { className: "sp-w-3 sp-h-3 sp-text-white sp-text-12px", children: /* @__PURE__ */ r.jsx("i", { className: "fa-regular fa-earth-americas" }) })
        ] }),
        /* @__PURE__ */ r.jsx("div", { className: "sp-flex-shrink-0 sp-ml-[12px]", children: /* @__PURE__ */ r.jsx("button", { className: "sp-bg-transparent  sp-border-[1px] sp-border-white/30 sp-border-solid sp-rounded-[9px] sp-text-white sp-text-[15px] sp-px-[12px] sp-py-[4px]", children: "Follow" }) })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: "sp-text-white sp-text-[16px] sp-leading-6", children: [
        /* @__PURE__ */ r.jsx("div", { className: t ? "sp-max-h-[300px] sp-overflow-y-auto sp-break-words" : "sp-line-clamp-2 sp-overflow-hidden sp-break-words", style: t ? {
          scrollbarWidth: "none"
        } : void 0, children: /* @__PURE__ */ r.jsx("span", { children: u.caption }) }),
        u.caption && /* @__PURE__ */ r.jsx("button", { onClick: (s) => {
          s.stopPropagation(), n(!t);
        }, className: "sp-text-gray-400 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0", children: t ? "less" : "more" })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-gap-1.5 sp-text-white/70 sp-text-[11px] sp-mt-2", children: [
        /* @__PURE__ */ r.jsx("i", { className: "fa-solid fa-music sp-text-[10px]" }),
        /* @__PURE__ */ r.jsx("span", { className: "sp-truncate", children: "Audio will be auto-matched after publishing" })
      ] })
    ] })
  ] }) });
}, C0 = ({
  post: u
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-pb-8", children: [
  /* @__PURE__ */ r.jsx(K1, { post: u, media: u.medias.collection[0] }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-col sp-px-4 sp-py-8", children: u.comment && u.comment.trim() !== "" && /* @__PURE__ */ r.jsxs(he, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
    /* @__PURE__ */ r.jsx("span", { className: "sp-font-bold sp-mr-1", children: u.username }),
    /* @__PURE__ */ r.jsx(vu, { caption: u.comment, targetPlatform: "FB" })
  ] }) })
] }), J1 = ({
  post: u
}) => {
  const e = u.type, t = u.providedPost?.videoPostType;
  if (e === "video" && t === "reel")
    return /* @__PURE__ */ r.jsx(C0, { post: u });
  switch (e) {
    case "image":
    case "video":
    case "multiMedia":
    case "text":
      return /* @__PURE__ */ r.jsx(Z1, { post: u });
    case "story":
    case "fb-reel":
      return /* @__PURE__ */ r.jsx(C0, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, Lr = _.div`
  font-family: Helvetica;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.025em;
          white-space: pre-line;
        `;
  }
}};
`, X1 = ({
  username: u,
  profilePicture: e,
  small: t
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
    width: "49px",
    height: "49px"
  }, children: /* @__PURE__ */ r.jsx($u, { src: e, alt: u }) }),
  /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-grow sp-leading-tight ${t ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsxs("div", { className: "sp-font-sans", children: [
    /* @__PURE__ */ r.jsx(Lr, { $variant: "heading", className: "sp-mb-1", children: u }),
    /* @__PURE__ */ r.jsxs(Lr, { $variant: "subheading", className: "sp-text-gray-600", children: [
      "@",
      u
    ] })
  ] }) }),
  /* @__PURE__ */ r.jsx("div", { className: "icon-twitter-down sp-mr-4 sp-text-2xl sp-text-gray-600", children: " " })
] }), Q1 = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, uc = _.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, ec = ({
  src: u,
  forCarousel: e,
  showOverlay: t,
  showAll: n,
  setShowAll: s,
  mediaCount: i
}) => e ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx(Mu, { href: u, $isFlex: !0, children: /* @__PURE__ */ r.jsx(uc, { src: u, className: "" }) }),
  !n && t && /* @__PURE__ */ r.jsxs("div", { className: "sp-cursor-pointer", onClick: () => s(!0), children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      i - 4
    ] })
  ] })
] }) : /* @__PURE__ */ r.jsx(Mu, { href: u, children: /* @__PURE__ */ r.jsx(Q1, { src: u }) }), tc = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-bg-black sp-flex sp-items-center", children: /* @__PURE__ */ r.jsx(ku, { url: u, controls: !0, playing: !1, className: "sp-relative", width: "100%", height: "auto" }) }) : null, ri = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showOverlay: n,
  showAll: s,
  setShowAll: i,
  mediaCount: a,
  isActiveSlide: D = !0
}) => e && s === !1 ? null : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  (u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(tc, { url: u.url, forCarousel: t, isActiveSlide: D }),
  !(u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(ec, { src: u.url, forCarousel: t, showOverlay: n, showAll: s, setShowAll: i, mediaCount: a })
] }), rc = () => /* @__PURE__ */ r.jsx("div", { className: "sp-py-4 sp-px-2 sp-w-full", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-w-full sp-justify-center sp-text-gray-600 sp-py-2", style: {
  borderTop: "0.5px solid #ebebe4",
  borderBottom: "0.5px solid #ebebe4"
}, children: [
  /* @__PURE__ */ r.jsx(nt, { icon: "icon-twitter-reply" }),
  /* @__PURE__ */ r.jsx(nt, { icon: "icon-twitter-retweet" }),
  /* @__PURE__ */ r.jsx(nt, { icon: "icon-twitter-heart" }),
  /* @__PURE__ */ r.jsx(nt, { icon: "icon-twitter-share" })
] }) }), nt = ({
  icon: u
}) => /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center sp-w-1/4 ", children: /* @__PURE__ */ r.jsx("div", { className: `sp-text-xl ${u}` }) }), nc = _.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, sc = ({
  medias: u
}) => {
  const [e, t] = Au(!1);
  return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: u.map((n, s) => !e && s > 3 ? null : /* @__PURE__ */ r.jsx(nc, { className: "sp-relative", children: /* @__PURE__ */ r.jsx(ri, { media: n, forCarousel: !0, hidden: s > 3, mediaCount: u.length, showOverlay: s === 3 && u.length > 4, showAll: e, setShowAll: t }) }, `fb-media-key-${s}`)) });
}, ic = ({
  medias: u
}) => {
  const e = u.collection, t = e.length, n = t > 1;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-px-4", children: [
    t > 0 && /* @__PURE__ */ r.jsx(r.Fragment, { children: n ? /* @__PURE__ */ r.jsx(sc, { medias: e, count: t }) : /* @__PURE__ */ r.jsx(ri, { media: e[0] }) }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ r.jsx(rc, {}) })
  ] });
}, ac = ({
  post: u
}) => {
  let e = u.caption;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
    /* @__PURE__ */ r.jsx(X1, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-col sp-m-4", children: /* @__PURE__ */ r.jsxs(Lr, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ r.jsx(vu, { caption: e, targetPlatform: "TW" }),
      u.redirectUrl && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        " ",
        /* @__PURE__ */ r.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: u.redirectUrl, target: "_blank", children: u.redirectUrl })
      ] })
    ] }) }),
    u.type === "text" && u.redirectUrl && /* @__PURE__ */ r.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ r.jsx(_t, { url: u.redirectUrl }) }),
    /* @__PURE__ */ r.jsx(ic, { medias: u.medias })
  ] });
}, oc = ({
  post: u
}) => {
  switch (u.type) {
    case "image":
    case "video":
    case "multiMedia":
    case "text":
      return /* @__PURE__ */ r.jsx(ac, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, Ie = _.div`
  font-family: Helvetica;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          letter-spacing: 0.045em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.015em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 28px;
          letter-spacing: 0.035em;
        `;
  }
}};

  .sked-mention.sked-mention-linkedin {
    color: #0a66c2; // copied from LI home feed - in caption creator they're black but feed are #0a66c2
    cursor: pointer;
    font-weight: bold; // LI mentions are bold

    &:hover {
      text-decoration: underline;
    }
  }
`, Dc = ({
  username: u,
  profilePicture: e,
  locationName: t,
  small: n
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
    width: "48px",
    height: "48px"
  }, children: /* @__PURE__ */ r.jsx($u, { src: e, alt: u }) }),
  /* @__PURE__ */ r.jsxs("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${n ? "sp-text-white" : ""}`, children: [
    /* @__PURE__ */ r.jsx(Ie, { $variant: "heading", children: u }),
    t && /* @__PURE__ */ r.jsx(Ie, { $variant: "subheading", className: "sp-text-gray-600", children: t })
  ] })
] }), lc = _.div`
  width: auto;
  margin: 0 auto;
  position: relative;
  text-align: left;
  z-index: 999;

  &:after {
    content: "";
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
  &:before {
    content: "";
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    background: ${(u) => u.backgroundColor || "var(--white)"};
    position: absolute;
    z-index: 998;
    border-radius: 2px;
  }

  &.arrow-top:before {
    left: calc(50% - 10px);
    top: -4px;
  }
  &.arrow-right:before {
    top: calc(50% - 10px);
    right: -4px;
  }
  &.arrow-bottom:before {
    left: calc(50% - 10px);
    bottom: -4px;
  }
  &.arrow-left:before {
    top: calc(50% - 10px);
    left: -4px;
  }
`, cc = _.div`
  width: ${(u) => u.width || "auto"};
  margin: 0 auto;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${(u) => u.backgroundColor || "var(--white)"};
  color: white;
  position: relative;
  z-index: 998;
  box-sizing: border-box;
  font-family: Helvetica;
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
`, Fc = ({
  backgroundColor: u,
  arrowPosition: e,
  children: t,
  width: n,
  ...s
}) => /* @__PURE__ */ r.jsx(lc, { backgroundColor: u, className: `arrow-${e}`, children: /* @__PURE__ */ r.jsx(cc, { backgroundColor: u, width: n, ...s, children: t }) }), dc = (u) => /* @__PURE__ */ m.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("g", { clipPath: "url(#clip0_4697_272)" }, /* @__PURE__ */ m.createElement("path", { d: "M7.99967 10.6666V7.99992M7.99967 5.33325H8.00634M14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992Z", stroke: "white", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ m.createElement("defs", null, /* @__PURE__ */ m.createElement("clipPath", { id: "clip0_4697_272" }, /* @__PURE__ */ m.createElement("rect", { width: 16, height: 16, fill: "white" }))));
function pc(u) {
  throw new Error('Could not dynamically require "' + u + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Ft = { exports: {} }, Ec = Ft.exports, f0;
function Cc() {
  return f0 || (f0 = 1, function(u, e) {
    (function(t, n) {
      typeof pc == "function" ? u.exports = n() : t.pluralize = n();
    })(Ec, function() {
      var t = [], n = [], s = {}, i = {}, a = {};
      function D(f) {
        return typeof f == "string" ? new RegExp("^" + f + "$", "i") : f;
      }
      function o(f, y) {
        return f === y ? y : f === f.toLowerCase() ? y.toLowerCase() : f === f.toUpperCase() ? y.toUpperCase() : f[0] === f[0].toUpperCase() ? y.charAt(0).toUpperCase() + y.substr(1).toLowerCase() : y.toLowerCase();
      }
      function d(f, y) {
        return f.replace(/\$(\d{1,2})/g, function(B, l) {
          return y[l] || "";
        });
      }
      function x(f, y) {
        return f.replace(y[0], function(B, l) {
          var p = d(y[1], arguments);
          return o(B === "" ? f[l - 1] : B, p);
        });
      }
      function c(f, y, B) {
        if (!f.length || s.hasOwnProperty(f))
          return y;
        for (var l = B.length; l--; ) {
          var p = B[l];
          if (p[0].test(y)) return x(y, p);
        }
        return y;
      }
      function h(f, y, B) {
        return function(l) {
          var p = l.toLowerCase();
          return y.hasOwnProperty(p) ? o(l, p) : f.hasOwnProperty(p) ? o(l, f[p]) : c(p, l, B);
        };
      }
      function F(f, y, B, l) {
        return function(p) {
          var E = p.toLowerCase();
          return y.hasOwnProperty(E) ? !0 : f.hasOwnProperty(E) ? !1 : c(E, E, B) === E;
        };
      }
      function C(f, y, B) {
        var l = y === 1 ? C.singular(f) : C.plural(f);
        return (B ? y + " " : "") + l;
      }
      return C.plural = h(
        a,
        i,
        t
      ), C.isPlural = F(
        a,
        i,
        t
      ), C.singular = h(
        i,
        a,
        n
      ), C.isSingular = F(
        i,
        a,
        n
      ), C.addPluralRule = function(f, y) {
        t.push([D(f), y]);
      }, C.addSingularRule = function(f, y) {
        n.push([D(f), y]);
      }, C.addUncountableRule = function(f) {
        if (typeof f == "string") {
          s[f.toLowerCase()] = !0;
          return;
        }
        C.addPluralRule(f, "$0"), C.addSingularRule(f, "$0");
      }, C.addIrregularRule = function(f, y) {
        y = y.toLowerCase(), f = f.toLowerCase(), a[f] = y, i[y] = f;
      }, [
        // Pronouns.
        ["I", "we"],
        ["me", "us"],
        ["he", "they"],
        ["she", "they"],
        ["them", "them"],
        ["myself", "ourselves"],
        ["yourself", "yourselves"],
        ["itself", "themselves"],
        ["herself", "themselves"],
        ["himself", "themselves"],
        ["themself", "themselves"],
        ["is", "are"],
        ["was", "were"],
        ["has", "have"],
        ["this", "these"],
        ["that", "those"],
        // Words ending in with a consonant and `o`.
        ["echo", "echoes"],
        ["dingo", "dingoes"],
        ["volcano", "volcanoes"],
        ["tornado", "tornadoes"],
        ["torpedo", "torpedoes"],
        // Ends with `us`.
        ["genus", "genera"],
        ["viscus", "viscera"],
        // Ends with `ma`.
        ["stigma", "stigmata"],
        ["stoma", "stomata"],
        ["dogma", "dogmata"],
        ["lemma", "lemmata"],
        ["schema", "schemata"],
        ["anathema", "anathemata"],
        // Other irregular rules.
        ["ox", "oxen"],
        ["axe", "axes"],
        ["die", "dice"],
        ["yes", "yeses"],
        ["foot", "feet"],
        ["eave", "eaves"],
        ["goose", "geese"],
        ["tooth", "teeth"],
        ["quiz", "quizzes"],
        ["human", "humans"],
        ["proof", "proofs"],
        ["carve", "carves"],
        ["valve", "valves"],
        ["looey", "looies"],
        ["thief", "thieves"],
        ["groove", "grooves"],
        ["pickaxe", "pickaxes"],
        ["passerby", "passersby"]
      ].forEach(function(f) {
        return C.addIrregularRule(f[0], f[1]);
      }), [
        [/s?$/i, "s"],
        [/[^\u0000-\u007F]$/i, "$0"],
        [/([^aeiou]ese)$/i, "$1"],
        [/(ax|test)is$/i, "$1es"],
        [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
        [/(e[mn]u)s?$/i, "$1s"],
        [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
        [/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
        [/(seraph|cherub)(?:im)?$/i, "$1im"],
        [/(her|at|gr)o$/i, "$1oes"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
        [/sis$/i, "ses"],
        [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
        [/([^aeiouy]|qu)y$/i, "$1ies"],
        [/([^ch][ieo][ln])ey$/i, "$1ies"],
        [/(x|ch|ss|sh|zz)$/i, "$1es"],
        [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
        [/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
        [/(pe)(?:rson|ople)$/i, "$1ople"],
        [/(child)(?:ren)?$/i, "$1ren"],
        [/eaux$/i, "$0"],
        [/m[ae]n$/i, "men"],
        ["thou", "you"]
      ].forEach(function(f) {
        return C.addPluralRule(f[0], f[1]);
      }), [
        [/s$/i, ""],
        [/(ss)$/i, "$1"],
        [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
        [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
        [/ies$/i, "y"],
        [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
        [/\b(mon|smil)ies$/i, "$1ey"],
        [/\b((?:tit)?m|l)ice$/i, "$1ouse"],
        [/(seraph|cherub)im$/i, "$1"],
        [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
        [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
        [/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
        [/(test)(?:is|es)$/i, "$1is"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
        [/(alumn|alg|vertebr)ae$/i, "$1a"],
        [/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
        [/(matr|append)ices$/i, "$1ix"],
        [/(pe)(rson|ople)$/i, "$1rson"],
        [/(child)ren$/i, "$1"],
        [/(eau)x?$/i, "$1"],
        [/men$/i, "man"]
      ].forEach(function(f) {
        return C.addSingularRule(f[0], f[1]);
      }), [
        // Singular words with no plurals.
        "adulthood",
        "advice",
        "agenda",
        "aid",
        "aircraft",
        "alcohol",
        "ammo",
        "analytics",
        "anime",
        "athletics",
        "audio",
        "bison",
        "blood",
        "bream",
        "buffalo",
        "butter",
        "carp",
        "cash",
        "chassis",
        "chess",
        "clothing",
        "cod",
        "commerce",
        "cooperation",
        "corps",
        "debris",
        "diabetes",
        "digestion",
        "elk",
        "energy",
        "equipment",
        "excretion",
        "expertise",
        "firmware",
        "flounder",
        "fun",
        "gallows",
        "garbage",
        "graffiti",
        "hardware",
        "headquarters",
        "health",
        "herpes",
        "highjinks",
        "homework",
        "housework",
        "information",
        "jeans",
        "justice",
        "kudos",
        "labour",
        "literature",
        "machinery",
        "mackerel",
        "mail",
        "media",
        "mews",
        "moose",
        "music",
        "mud",
        "manga",
        "news",
        "only",
        "personnel",
        "pike",
        "plankton",
        "pliers",
        "police",
        "pollution",
        "premises",
        "rain",
        "research",
        "rice",
        "salmon",
        "scissors",
        "series",
        "sewage",
        "shambles",
        "shrimp",
        "software",
        "species",
        "staff",
        "swine",
        "tennis",
        "traffic",
        "transportation",
        "trout",
        "tuna",
        "wealth",
        "welfare",
        "whiting",
        "wildebeest",
        "wildlife",
        "you",
        /pok[eé]mon$/i,
        // Regexes.
        /[^aeiou]ese$/i,
        // "chinese", "japanese"
        /deer$/i,
        // "deer", "reindeer"
        /fish$/i,
        // "fish", "blowfish", "angelfish"
        /measles$/i,
        /o[iu]s$/i,
        // "carnivorous"
        /pox$/i,
        // "chickpox", "smallpox"
        /sheep$/i
      ].forEach(C.addUncountableRule), C;
    });
  }(Ft)), Ft.exports;
}
var fc = Cc();
const Ac = /* @__PURE__ */ ne(fc), hc = ({
  preferVideoCoverPreviewOverride: u,
  thumbnailUrl: e,
  contextVideoCoverPreview: t
}) => u && t ? t : e, mc = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, gc = _.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, A0 = ({
  src: u,
  forCarousel: e,
  showOverlay: t,
  showAll: n,
  setShowAll: s,
  mediaCount: i,
  url: a
  // override for the url we link to
}) => e ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx(Mu, { href: a || u, $isFlex: !0, children: /* @__PURE__ */ r.jsx(gc, { src: u, className: "" }) }),
  !n && t && /* @__PURE__ */ r.jsxs("div", { className: "sp-cursor-pointer", onClick: () => s(!0), children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      i - 4
    ] })
  ] })
] }) : /* @__PURE__ */ r.jsx(Mu, { href: a || u, children: /* @__PURE__ */ r.jsx(mc, { src: u, title: "Click to see the full file in a new window." }) }), Bc = ({
  url: u,
  thumbnailUrl: e,
  isActiveSlide: t,
  shouldUseVideoCoverPreviewOverride: n,
  width: s,
  height: i
}) => {
  const [a, D] = Au(!1), {
    videoCoverPreview: o,
    preferVideoCoverPreviewOverride: d
  } = k0(en), x = hc({
    preferVideoCoverPreviewOverride: d && n,
    thumbnailUrl: e,
    contextVideoCoverPreview: o
  }), {
    videoCoverPreview: c,
    showVideoCover: h
  } = tn({
    usePostTypeCheck: !1,
    videoCoverPreviewOverride: x
  }), F = s && i && s > 0 && i > 0 ? `${s} / ${i}` : null;
  if (!t)
    return null;
  const C = (y) => {
    console.error("Error loading video", y), D(!0);
  };
  return /* @__PURE__ */ r.jsxs(yc, { className: "sp-flex sp-items-center sp-h-full", style: F ? {
    aspectRatio: F
  } : void 0, children: [
    a && /* @__PURE__ */ r.jsx("div", { className: "sp-text-xl sp-text-red-500 sp-mx-auto", children: "Failed to load this video." }),
    !a && /* @__PURE__ */ r.jsx(ku, { url: u, controls: !0, light: h ? c : void 0, playing: !!c, onError: (y) => C(y), className: "sp-relative react-player", width: "100%", height: "100%" })
  ] });
}, ni = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showOverlay: n,
  showAll: s,
  setShowAll: i,
  mediaCount: a,
  isActiveSlide: D = !0,
  shouldUseVideoCoverPreviewOverride: o = !1
}) => e && s === !1 ? null : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  (u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(Bc, { url: u.url, thumbnailUrl: u.thumbnailUrl, isActiveSlide: D, shouldUseVideoCoverPreviewOverride: o, width: u.width, height: u.height }),
  !(u.isVideo || u.url.includes(".mp4") || u.url.includes(".pdf")) && /* @__PURE__ */ r.jsx(A0, { src: u.url, forCarousel: t, showOverlay: n ?? !1, showAll: s ?? !1, setShowAll: i, mediaCount: a }),
  u.url.includes(".pdf") && /* @__PURE__ */ r.jsxs("div", { children: [
    /* @__PURE__ */ r.jsxs(vc, { children: [
      /* @__PURE__ */ r.jsx("span", { className: "filename", title: u.fileName, children: u.fileName }),
      /* @__PURE__ */ r.jsx("span", { className: "dot", children: "●" }),
      /* @__PURE__ */ r.jsx("span", { className: "pages", children: Ac("page", u.pages, !0) }),
      /* @__PURE__ */ r.jsxs(bc, { children: [
        /* @__PURE__ */ r.jsx(dc, {}),
        /* @__PURE__ */ r.jsx(wc, { id: "tooltip", children: /* @__PURE__ */ r.jsxs(Fc, { arrowPosition: "bottom", backgroundColor: "#1A1A1A", width: "250px", children: [
          "Previewing Page 1 of ",
          u.pages,
          ". The complete document will be posted to LinkedIn."
        ] }) })
      ] })
    ] }),
    u.thumbnailUrl !== void 0 && /* @__PURE__ */ r.jsx(A0, { src: u.thumbnailUrl, url: u.url, forCarousel: !1, mediaCount: a, showAll: s ?? !1, setShowAll: i, showOverlay: n ?? !1 }),
    /* @__PURE__ */ r.jsx(xc, { children: /* @__PURE__ */ r.jsx("a", { href: u.url, target: "_blank", rel: "noreferrer", children: "Click to download and view the full document in a new tab." }) })
  ] })
] }), xc = _.span`
  background: rgba(0, 0, 0, 0.4);
  padding: 6px 8px;
  a {
    color: #fff;
    text-decoration: none;
  }
  font-family: Inter, Helvetica, Arial, sans-serif;
  font-size: 12px;
  display: flex;
`, yc = _.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #000;

  .react-player {
    width: 100% !important;
    height: 100% !important;
  }

  .react-player > div {
    width: 100% !important;
    height: 100% !important;
  }

  .react-player__preview {
    width: 100%;
    height: 100%;
    background-size: cover !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }
`, vc = _.div`
  background: rgba(0, 0, 0, 0.4);
  padding: 4px 8px;
  color: #fff;
  display: flex;
  align-items: center;

  .filename {
    font-family: Inter, Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    max-width: 80%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: default;
  }

  .dot {
    padding: 0 4px 0 6px;
    font-size: 6px;
    position: relative;
    top: 1px;
    line-height: 16px;
  }

  .pages {
    font-family: Inter, Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    white-space: nowrap;
  }

  svg {
    position: relative;
    top: 2px;
    margin-left: 4px;
  }
`, bc = _.div`
  position: relative;
  display: inline-block;
  line-height: normal;

  svg {
    &:hover + #tooltip {
      display: block;
    }
  }
`, wc = _.div`
  display: none;
  position: absolute;
  top: -60px;
  left: calc(-250px / 2 + 12px);
`, jc = _.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, _c = ({
  medias: u
}) => {
  const [e, t] = Au(!1);
  return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: u.map((n, s) => !e && s > 3 ? null : /* @__PURE__ */ r.jsx(jc, { className: "sp-relative", children: /* @__PURE__ */ r.jsx(ni, { media: n, forCarousel: !0, hidden: s > 3, mediaCount: u.length, shouldUseVideoCoverPreviewOverride: s === 0, showOverlay: s === 3 && u.length > 4, showAll: e, setShowAll: t }) }, `fb-media-key-${s}`)) });
}, Sc = () => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-w-full sp-items-center sp-justify-center sp-py-4 sp-text-gray-700 sp-font-bold", children: [
  /* @__PURE__ */ r.jsx(pr, { icon: "icon-linkedin-like", text: "Like", className: "sp-justify-start sp-ml-2" }, "ico-like"),
  /* @__PURE__ */ r.jsx(pr, { icon: "icon-linkedin-comment", text: "Comment", className: "sp-justify-center" }, "ico-comment"),
  /* @__PURE__ */ r.jsx(pr, { icon: "icon-linkedin-share", text: "Share", className: "sp-justify-end sp-mr-2" }, "ico-share")
] }), pr = ({
  icon: u,
  text: e,
  className: t = ""
}) => /* @__PURE__ */ r.jsxs(Ie, { $variant: "icons", className: `sp-flex sp-items-center sp-w-1/3 ${t}`, children: [
  /* @__PURE__ */ r.jsx("div", { className: `sp-mr-1 sp-text-2xl ${u}` }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-text-gray-700 sp-text-xl", children: e })
] }), Pc = ({
  medias: u,
  postType: e
}) => {
  let t = u?.collection || [];
  if (e === "document")
    if (t.length === 0)
      t.push({});
    else {
      const i = u?.medias?.[0];
      i && (t[0].thumbnailUrl = i.thumbnailUrl, t[0].fileName = i.fileName, t[0].pages = i.meta?.pages, t[0].url = i.url);
    }
  e === "multiMedia" && t.length > 0 && (t = t.filter((i) => !i.url.includes(".pdf")));
  const n = t.length, s = n > 1;
  return /* @__PURE__ */ r.jsxs("div", { children: [
    n > 0 && /* @__PURE__ */ r.jsx(r.Fragment, { children: s ? /* @__PURE__ */ r.jsx(_c, { medias: t }) : /* @__PURE__ */ r.jsx(ni, { media: t[0], mediaCount: n, shouldUseVideoCoverPreviewOverride: !0, setShowAll: () => {
    }, forCarousel: !1, showAll: !1, hidden: !1, isActiveSlide: !0, showOverlay: !1 }) }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ r.jsx(Sc, {}) })
  ] });
}, Tc = ({
  post: u,
  trackEvent: e
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
  /* @__PURE__ */ r.jsx(Dc, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName }),
  u.caption && /* @__PURE__ */ r.jsxs(Ie, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words sp-flex sp-flex-col sp-m-8", children: [
    /* @__PURE__ */ r.jsx(vu, { caption: u.caption, targetPlatform: "LI", trackEvent: e }),
    u.redirectUrl && u.type !== "text" && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      " ",
      /* @__PURE__ */ r.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: u.redirectUrl, target: "_blank", children: u.redirectUrl })
    ] })
  ] }),
  u.type === "text" && u.redirectUrl && /* @__PURE__ */ r.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ r.jsx(_t, { url: u.redirectUrl }) }),
  /* @__PURE__ */ r.jsx(Pc, { medias: u.medias, postType: u.type }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-col sp-px-4 sp-pb-8", children: u.comment && /* @__PURE__ */ r.jsxs(Ie, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
    /* @__PURE__ */ r.jsx("span", { className: "sp-font-bold sp-mr-1", children: u.username }),
    /* @__PURE__ */ r.jsx(vu, { caption: u.comment, targetPlatform: "LI" })
  ] }) })
] }), kc = ({
  post: u,
  trackEvent: e
}) => {
  switch (u.type) {
    case "image":
    case "text":
    case "video":
    case "multiMedia":
    case "document":
      return /* @__PURE__ */ r.jsx(Tc, { post: u, trackEvent: e });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, Yu = _.span`
  font-family: Roboto, arial, sans-serif;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "buttonlabel":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
  }
}};
`, de = _.div`
  font-family: Roboto, arial, sans-serif;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          color: rgba(0,0,0,.54);
          line-height: 16px;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.015em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 28px;
          letter-spacing: 0.035em;
        `;
    case "title":
      return `
          font-style: normal;
          font-weight: medium;
          font-size: 20px;
          line-height: 28px;
        `;
    case "subtitle":
      return `
          font-weight: normal;
          font-size: 14px;
          line-height: 24px;
        `;
  }
}};
`, Nc = _($u)`
  display: inherit;

  img {
    border-radius: 50%;
  }
`, Oc = ({
  username: u,
  profilePicture: e
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-pb-4", children: [
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-mr-1", style: {
    width: "38x",
    height: "38px"
  }, children: [
    /* @__PURE__ */ r.jsx(Nc, { src: e, alt: u }),
    /* @__PURE__ */ r.jsx("div", { style: {
      position: "relative",
      top: "25px",
      right: "25%",
      marginLeft: "auto",
      fill: "#1a73e8",
      lineHeight: "18px",
      height: "18px"
    }, children: /* @__PURE__ */ r.jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", style: {
      height: "18px"
    }, children: /* @__PURE__ */ r.jsx("path", { stroke: "#fff", d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" }) }) })
  ] }),
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-justify-center sp-leading-tight ", style: {
    width: "auto",
    height: "36px"
  }, children: [
    /* @__PURE__ */ r.jsx(de, { $variant: "heading", className: "", children: u }),
    /* @__PURE__ */ r.jsx(de, { $variant: "subheading", className: "", children: "a minute ago" })
  ] })
] });
var Er = {}, Cr = { exports: {} }, fr = { exports: {} }, h0;
function $c() {
  return h0 || (h0 = 1, function(u) {
    function e(t) {
      "@babel/helpers - typeof";
      return u.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, u.exports.__esModule = !0, u.exports.default = u.exports, e(t);
    }
    u.exports = e, u.exports.__esModule = !0, u.exports.default = u.exports;
  }(fr)), fr.exports;
}
var m0;
function Mr() {
  return m0 || (m0 = 1, function(u) {
    var e = $c().default;
    function t(n, s) {
      if (typeof WeakMap == "function") var i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
      return (u.exports = t = function(o, d) {
        if (!d && o && o.__esModule) return o;
        var x, c, h = {
          __proto__: null,
          default: o
        };
        if (o === null || e(o) != "object" && typeof o != "function") return h;
        if (x = d ? a : i) {
          if (x.has(o)) return x.get(o);
          x.set(o, h);
        }
        for (var F in o) F !== "default" && {}.hasOwnProperty.call(o, F) && ((c = (x = Object.defineProperty) && Object.getOwnPropertyDescriptor(o, F)) && (c.get || c.set) ? x(h, F, c) : h[F] = o[F]);
        return h;
      }, u.exports.__esModule = !0, u.exports.default = u.exports)(n, s);
    }
    u.exports = t, u.exports.__esModule = !0, u.exports.default = u.exports;
  }(Cr)), Cr.exports;
}
var Ar = { exports: {} }, g0;
function si() {
  return g0 || (g0 = 1, function(u) {
    function e(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }
    u.exports = e, u.exports.__esModule = !0, u.exports.default = u.exports;
  }(Ar)), Ar.exports;
}
var hr = { exports: {} }, B0;
function ii() {
  return B0 || (B0 = 1, function(u) {
    function e() {
      return u.exports = e = Object.assign ? Object.assign.bind() : function(t) {
        for (var n = 1; n < arguments.length; n++) {
          var s = arguments[n];
          for (var i in s) ({}).hasOwnProperty.call(s, i) && (t[i] = s[i]);
        }
        return t;
      }, u.exports.__esModule = !0, u.exports.default = u.exports, e.apply(null, arguments);
    }
    u.exports = e, u.exports.__esModule = !0, u.exports.default = u.exports;
  }(hr)), hr.exports;
}
var mr = {}, gr = {}, x0;
function Rc() {
  return x0 || (x0 = 1, function(u) {
    Object.defineProperty(u, "__esModule", {
      value: !0
    }), u.translate = a, u.infiniteIndex = D, u.clampNumber = o, u.default = h;
    var e = "linear", t = 50, n = "transitionend", s = Math.abs, i = {
      passive: !1
    };
    function a(F, C, f) {
      f === void 0 && (f = 100);
      var y = F * f * -1, B = C ? "calc(" + y + "% - " + C + "px)" : y + "%";
      return "translate3d(" + B + ", 0, 0)";
    }
    function D(F, C) {
      return F < 0 ? C - 1 : F >= C ? 0 : F;
    }
    function o(F, C, f) {
      return Math.min(Math.max(F, C), f);
    }
    function d(F) {
      return F.targetTouches ? F.targetTouches[0] : F.touches[0];
    }
    function x(F, C, f, y, B) {
      var l = C !== "" ? "transition-timing-function: " + C + ";" : "", p = F ? "transition-duration: " + F + "ms;" : "";
      return "" + l + p + "transform: " + a(f, y, B) + ";";
    }
    function c(F) {
      for (; F.childElementCount > 1; )
        F !== null && F.removeChild(F.lastChild);
      return !0;
    }
    function h(F, C) {
      var f = C.doAfterSlide, y = C.doBeforeSlide, B = C.ease, l = C.infiniteLoop, p = C.initialSlide, E = C.numOfSlides, A = C.onNext, b = C.onPrev, w = C.slidesDOMEl, P = C.slideSpeed, q = C.items;
      if (F === null) return;
      var z = p, k = !1, I = 0, O = 0, j = 0, M = 0;
      function J(L, W, tu) {
        W === void 0 && (W = ""), tu === void 0 && (tu = 0);
        var $ = 100 / E;
        w.style.cssText = x(L, W, z, tu, $);
      }
      function su(L) {
        var W = L === !0 ? 1 : -1, tu = z + 1 * W;
        l && (tu = D(tu, q)), tu = o(tu, 0, q - 1), U(tu);
      }
      function nu() {
      }
      function N(L) {
        var W = d(L);
        k = void 0, j = W.pageX, M = W.pageY;
      }
      function v(L) {
        if (!(L.touches.length > 1 || L.scale && L.scale !== 1)) {
          var W = d(L);
          if (I = W.pageX - j, O = W.pageY - M, typeof k > "u") {
            k = s(I) < s(O), k || (document.ontouchmove = function(tu) {
              return tu.preventDefault();
            });
            return;
          }
          k || (L.preventDefault(), J(0, e, I * -1));
        }
      }
      function S() {
        if (document.ontouchmove = function() {
          return !0;
        }, !k) {
          var L = s(I) > t, W = I < 0, tu = W === !1 && z === 0 || W === !0 && z === q - 1;
          L === !0 && tu === !1 ? su(W) : J(P, e);
        }
        I = O = j = M = 0;
      }
      function R() {
        w.addEventListener(n, nu), F.addEventListener("touchstart", N, i), F.addEventListener("touchmove", v, i), F.addEventListener("touchend", S, i), z !== 0 && J(0);
      }
      function V() {
        return c(w);
      }
      function U(L) {
        L !== z && (L <= q && (y({
          currentSlide: z,
          nextSlide: L
        }), L > z ? A(L) : b(L), z = L), J(P, B), w.addEventListener(n, function W(tu) {
          f({
            currentSlide: z
          }), tu.currentTarget.removeEventListener(tu.type, W);
        }));
      }
      function Z(L) {
        L.preventDefault(), L.stopPropagation(), su(!1);
      }
      function Y(L) {
        L.preventDefault(), L.stopPropagation(), su(!0);
      }
      function K(L) {
        q = L;
      }
      function X() {
        F.removeEventListener("touchstart", N, i), F.removeEventListener("touchmove", v, i), F.removeEventListener("touchend", S, i), w.removeEventListener(n, nu);
      }
      return R(), {
        clean: V,
        destroy: X,
        goTo: U,
        next: Y,
        prev: Z,
        slide: su,
        updateItems: K
      };
    }
  }(gr)), gr;
}
var y0;
function Ic() {
  return y0 || (y0 = 1, function(u) {
    var e = Mr(), t = si();
    Object.defineProperty(u, "__esModule", {
      value: !0
    }), u.default = h;
    var n = t(ii()), s = e(uu), i = t(Rc()), a = Ur();
    s.default.createElement;
    function D(F) {
    }
    function o(F) {
      return Array.isArray(F) ? F : [F];
    }
    function d(F) {
      var C = F.index, f = F.maxIndex, y = F.items, B = F.itemsToPreload, l = F.numOfSlides, p = Math.max(B, l);
      if (C >= y.length - l) {
        var E = y.length > l ? y.slice(0, l - 1) : [];
        return [].concat(y.slice(0, f + p), E);
      } else
        return y.slice(0, f + p);
    }
    function x(F, C) {
      F && F.clean() && F.destroy(), C();
    }
    var c = function(C) {
      return function(f, y) {
        var B = C !== 1 ? {
          width: 100 / C + "%"
        } : {};
        return /* @__PURE__ */ (0, a.jsx)("li", {
          style: B,
          children: f
        }, y);
      };
    };
    function h(F) {
      var C = F.ArrowLeft, f = F.ArrowRight, y = F.children, B = F.classNameBase, l = F.doAfterDestroy, p = F.doAfterInit, E = F.doAfterSlide, A = F.doBeforeSlide, b = F.ease, w = F.infiniteLoop, P = F.initialSlide, q = F.itemsToPreload, z = F.keyboardNavigation, k = F.numOfSlides, I = F.showArrows, O = F.slide, j = F.slideSpeed, M = (0, s.useState)({
        goTo: D,
        next: D,
        prev: D,
        updateItems: D
      }), J = M[0], su = M[1], nu = (0, s.useState)(P), N = nu[0], v = nu[1], S = (0, s.useState)(P), R = S[0], V = S[1], U = (0, s.useRef)(null), Z = (0, s.useRef)(null), Y = o(y);
      (0, s.useEffect)(
        function() {
          O !== N && J.goTo(O);
        },
        [O]
        // eslint-disable-line
      ), (0, s.useEffect)(
        function() {
          var $, du = (0, i.default)(U.current, {
            ease: b,
            doAfterSlide: E,
            doBeforeSlide: A,
            numOfSlides: k,
            slideSpeed: j,
            infiniteLoop: w,
            slidesDOMEl: Z.current,
            initialSlide: N,
            items: Y.length,
            onNext: function(Fu) {
              return v(Fu), Fu > R && V(Fu), Fu;
            },
            onPrev: function(Fu) {
              return v(Fu), Fu;
            }
          });
          return su(du), p(), z && ($ = function(Fu) {
            Fu.keyCode === 39 ? du.next(Fu) : Fu.keyCode === 37 && du.prev(Fu);
          }, document.addEventListener("keydown", $)), function() {
            x(du, l), z && document.removeEventListener("keydown", $);
          };
        },
        []
        // eslint-disable-line
      ), (0, s.useEffect)(function() {
        J && J.updateItems(Y.length);
      });
      var K = d({
        index: N,
        maxIndex: R,
        items: Y,
        itemsToPreload: q,
        numOfSlides: k
      }), X = function(du) {
        return J.prev(du);
      }, L = function(du) {
        return Y.length > k && J.next(du);
      }, W = function() {
        var du = N === 0 && !w, xu = {
          disabled: du,
          onClick: X
        }, Fu = B + "-arrow " + B + "-arrowLeft";
        return C ? /* @__PURE__ */ (0, a.jsx)(C, (0, n.default)({}, xu, {
          className: Fu
        })) : /* @__PURE__ */ (0, a.jsx)("span", (0, n.default)({
          "aria-label": "Previous",
          className: Fu + " " + B + "-prev",
          role: "button"
        }, xu));
      }, tu = function() {
        var du = (Y.length <= k || N === Y.length - 1) && !w, xu = {
          disabled: du,
          onClick: L
        }, Fu = B + "-arrow " + B + "-arrowRight";
        return f ? /* @__PURE__ */ (0, a.jsx)(f, (0, n.default)({}, xu, {
          className: Fu
        })) : /* @__PURE__ */ (0, a.jsx)("span", (0, n.default)({
          "aria-label": "Next",
          className: Fu + " " + B + "-next",
          role: "button"
        }, xu));
      };
      return /* @__PURE__ */ (0, a.jsxs)(a.Fragment, {
        children: [I && /* @__PURE__ */ (0, a.jsxs)(a.Fragment, {
          children: [W(), tu()]
        }), /* @__PURE__ */ (0, a.jsx)("div", {
          ref: U,
          children: /* @__PURE__ */ (0, a.jsx)("ul", {
            ref: Z,
            children: K.map(c(k))
          })
        })]
      });
    }
  }(mr)), mr;
}
var v0 = {}, b0;
function Lc() {
  return b0 || (b0 = 1, function() {
    if (typeof window != "object")
      return;
    if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
      "isIntersecting" in window.IntersectionObserverEntry.prototype || Object.defineProperty(
        window.IntersectionObserverEntry.prototype,
        "isIntersecting",
        {
          get: function() {
            return this.intersectionRatio > 0;
          }
        }
      );
      return;
    }
    var u = window.document, e = [], t = null, n = null;
    function s(l) {
      this.time = l.time, this.target = l.target, this.rootBounds = F(l.rootBounds), this.boundingClientRect = F(l.boundingClientRect), this.intersectionRect = F(l.intersectionRect || h()), this.isIntersecting = !!l.intersectionRect;
      var p = this.boundingClientRect, E = p.width * p.height, A = this.intersectionRect, b = A.width * A.height;
      E ? this.intersectionRatio = Number((b / E).toFixed(4)) : this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
    function i(l, p) {
      var E = p || {};
      if (typeof l != "function")
        throw new Error("callback must be a function");
      if (E.root && E.root.nodeType != 1)
        throw new Error("root must be an Element");
      this._checkForIntersections = D(
        this._checkForIntersections.bind(this),
        this.THROTTLE_TIMEOUT
      ), this._callback = l, this._observationTargets = [], this._queuedEntries = [], this._rootMarginValues = this._parseRootMargin(E.rootMargin), this.thresholds = this._initThresholds(E.threshold), this.root = E.root || null, this.rootMargin = this._rootMarginValues.map(function(A) {
        return A.value + A.unit;
      }).join(" "), this._monitoringDocuments = [], this._monitoringUnsubscribes = [];
    }
    i.prototype.THROTTLE_TIMEOUT = 100, i.prototype.POLL_INTERVAL = null, i.prototype.USE_MUTATION_OBSERVER = !0, i._setupCrossOriginUpdater = function() {
      return t || (t = function(l, p) {
        !l || !p ? n = h() : n = C(l, p), e.forEach(function(E) {
          E._checkForIntersections();
        });
      }), t;
    }, i._resetCrossOriginUpdater = function() {
      t = null, n = null;
    }, i.prototype.observe = function(l) {
      var p = this._observationTargets.some(function(E) {
        return E.element == l;
      });
      if (!p) {
        if (!(l && l.nodeType == 1))
          throw new Error("target must be an Element");
        this._registerInstance(), this._observationTargets.push({ element: l, entry: null }), this._monitorIntersections(l.ownerDocument), this._checkForIntersections();
      }
    }, i.prototype.unobserve = function(l) {
      this._observationTargets = this._observationTargets.filter(function(p) {
        return p.element != l;
      }), this._unmonitorIntersections(l.ownerDocument), this._observationTargets.length == 0 && this._unregisterInstance();
    }, i.prototype.disconnect = function() {
      this._observationTargets = [], this._unmonitorAllIntersections(), this._unregisterInstance();
    }, i.prototype.takeRecords = function() {
      var l = this._queuedEntries.slice();
      return this._queuedEntries = [], l;
    }, i.prototype._initThresholds = function(l) {
      var p = l || [0];
      return Array.isArray(p) || (p = [p]), p.sort().filter(function(E, A, b) {
        if (typeof E != "number" || isNaN(E) || E < 0 || E > 1)
          throw new Error("threshold must be a number between 0 and 1 inclusively");
        return E !== b[A - 1];
      });
    }, i.prototype._parseRootMargin = function(l) {
      var p = l || "0px", E = p.split(/\s+/).map(function(A) {
        var b = /^(-?\d*\.?\d+)(px|%)$/.exec(A);
        if (!b)
          throw new Error("rootMargin must be specified in pixels or percent");
        return { value: parseFloat(b[1]), unit: b[2] };
      });
      return E[1] = E[1] || E[0], E[2] = E[2] || E[0], E[3] = E[3] || E[1], E;
    }, i.prototype._monitorIntersections = function(l) {
      var p = l.defaultView;
      if (p && this._monitoringDocuments.indexOf(l) == -1) {
        var E = this._checkForIntersections, A = null, b = null;
        if (this.POLL_INTERVAL ? A = p.setInterval(E, this.POLL_INTERVAL) : (o(p, "resize", E, !0), o(l, "scroll", E, !0), this.USE_MUTATION_OBSERVER && "MutationObserver" in p && (b = new p.MutationObserver(E), b.observe(l, {
          attributes: !0,
          childList: !0,
          characterData: !0,
          subtree: !0
        }))), this._monitoringDocuments.push(l), this._monitoringUnsubscribes.push(function() {
          var P = l.defaultView;
          P && (A && P.clearInterval(A), d(P, "resize", E, !0)), d(l, "scroll", E, !0), b && b.disconnect();
        }), l != (this.root && this.root.ownerDocument || u)) {
          var w = B(l);
          w && this._monitorIntersections(w.ownerDocument);
        }
      }
    }, i.prototype._unmonitorIntersections = function(l) {
      var p = this._monitoringDocuments.indexOf(l);
      if (p != -1) {
        var E = this.root && this.root.ownerDocument || u, A = this._observationTargets.some(function(P) {
          var q = P.element.ownerDocument;
          if (q == l)
            return !0;
          for (; q && q != E; ) {
            var z = B(q);
            if (q = z && z.ownerDocument, q == l)
              return !0;
          }
          return !1;
        });
        if (!A) {
          var b = this._monitoringUnsubscribes[p];
          if (this._monitoringDocuments.splice(p, 1), this._monitoringUnsubscribes.splice(p, 1), b(), l != E) {
            var w = B(l);
            w && this._unmonitorIntersections(w.ownerDocument);
          }
        }
      }
    }, i.prototype._unmonitorAllIntersections = function() {
      var l = this._monitoringUnsubscribes.slice(0);
      this._monitoringDocuments.length = 0, this._monitoringUnsubscribes.length = 0;
      for (var p = 0; p < l.length; p++)
        l[p]();
    }, i.prototype._checkForIntersections = function() {
      if (!(!this.root && t && !n)) {
        var l = this._rootIsInDom(), p = l ? this._getRootRect() : h();
        this._observationTargets.forEach(function(E) {
          var A = E.element, b = c(A), w = this._rootContainsTarget(A), P = E.entry, q = l && w && this._computeTargetAndRootIntersection(A, b, p), z = E.entry = new s({
            time: a(),
            target: A,
            boundingClientRect: b,
            rootBounds: t && !this.root ? null : p,
            intersectionRect: q
          });
          P ? l && w ? this._hasCrossedThreshold(P, z) && this._queuedEntries.push(z) : P && P.isIntersecting && this._queuedEntries.push(z) : this._queuedEntries.push(z);
        }, this), this._queuedEntries.length && this._callback(this.takeRecords(), this);
      }
    }, i.prototype._computeTargetAndRootIntersection = function(l, p, E) {
      if (window.getComputedStyle(l).display != "none") {
        for (var A = p, b = y(l), w = !1; !w && b; ) {
          var P = null, q = b.nodeType == 1 ? window.getComputedStyle(b) : {};
          if (q.display == "none") return null;
          if (b == this.root || b.nodeType == /* DOCUMENT */
          9)
            if (w = !0, b == this.root || b == u)
              t && !this.root ? !n || n.width == 0 && n.height == 0 ? (b = null, P = null, A = null) : P = n : P = E;
            else {
              var z = y(b), k = z && c(z), I = z && this._computeTargetAndRootIntersection(z, k, E);
              k && I ? (b = z, P = C(k, I)) : (b = null, A = null);
            }
          else {
            var O = b.ownerDocument;
            b != O.body && b != O.documentElement && q.overflow != "visible" && (P = c(b));
          }
          if (P && (A = x(P, A)), !A) break;
          b = b && y(b);
        }
        return A;
      }
    }, i.prototype._getRootRect = function() {
      var l;
      if (this.root)
        l = c(this.root);
      else {
        var p = u.documentElement, E = u.body;
        l = {
          top: 0,
          left: 0,
          right: p.clientWidth || E.clientWidth,
          width: p.clientWidth || E.clientWidth,
          bottom: p.clientHeight || E.clientHeight,
          height: p.clientHeight || E.clientHeight
        };
      }
      return this._expandRectByRootMargin(l);
    }, i.prototype._expandRectByRootMargin = function(l) {
      var p = this._rootMarginValues.map(function(A, b) {
        return A.unit == "px" ? A.value : A.value * (b % 2 ? l.width : l.height) / 100;
      }), E = {
        top: l.top - p[0],
        right: l.right + p[1],
        bottom: l.bottom + p[2],
        left: l.left - p[3]
      };
      return E.width = E.right - E.left, E.height = E.bottom - E.top, E;
    }, i.prototype._hasCrossedThreshold = function(l, p) {
      var E = l && l.isIntersecting ? l.intersectionRatio || 0 : -1, A = p.isIntersecting ? p.intersectionRatio || 0 : -1;
      if (E !== A)
        for (var b = 0; b < this.thresholds.length; b++) {
          var w = this.thresholds[b];
          if (w == E || w == A || w < E != w < A)
            return !0;
        }
    }, i.prototype._rootIsInDom = function() {
      return !this.root || f(u, this.root);
    }, i.prototype._rootContainsTarget = function(l) {
      return f(this.root || u, l) && (!this.root || this.root.ownerDocument == l.ownerDocument);
    }, i.prototype._registerInstance = function() {
      e.indexOf(this) < 0 && e.push(this);
    }, i.prototype._unregisterInstance = function() {
      var l = e.indexOf(this);
      l != -1 && e.splice(l, 1);
    };
    function a() {
      return window.performance && performance.now && performance.now();
    }
    function D(l, p) {
      var E = null;
      return function() {
        E || (E = setTimeout(function() {
          l(), E = null;
        }, p));
      };
    }
    function o(l, p, E, A) {
      typeof l.addEventListener == "function" ? l.addEventListener(p, E, A) : typeof l.attachEvent == "function" && l.attachEvent("on" + p, E);
    }
    function d(l, p, E, A) {
      typeof l.removeEventListener == "function" ? l.removeEventListener(p, E, A) : typeof l.detatchEvent == "function" && l.detatchEvent("on" + p, E);
    }
    function x(l, p) {
      var E = Math.max(l.top, p.top), A = Math.min(l.bottom, p.bottom), b = Math.max(l.left, p.left), w = Math.min(l.right, p.right), P = w - b, q = A - E;
      return P >= 0 && q >= 0 && {
        top: E,
        bottom: A,
        left: b,
        right: w,
        width: P,
        height: q
      } || null;
    }
    function c(l) {
      var p;
      try {
        p = l.getBoundingClientRect();
      } catch {
      }
      return p ? (p.width && p.height || (p = {
        top: p.top,
        right: p.right,
        bottom: p.bottom,
        left: p.left,
        width: p.right - p.left,
        height: p.bottom - p.top
      }), p) : h();
    }
    function h() {
      return {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: 0,
        height: 0
      };
    }
    function F(l) {
      return !l || "x" in l ? l : {
        top: l.top,
        y: l.top,
        bottom: l.bottom,
        left: l.left,
        x: l.left,
        right: l.right,
        width: l.width,
        height: l.height
      };
    }
    function C(l, p) {
      var E = p.top - l.top, A = p.left - l.left;
      return {
        top: E,
        left: A,
        height: p.height,
        width: p.width,
        bottom: E + p.height,
        right: A + p.width
      };
    }
    function f(l, p) {
      for (var E = p; E; ) {
        if (E == l) return !0;
        E = y(E);
      }
      return !1;
    }
    function y(l) {
      var p = l.parentNode;
      return l.nodeType == /* DOCUMENT */
      9 && l != u ? B(l) : p && p.nodeType == 11 && p.host ? p.host : p && p.assignedSlot ? p.assignedSlot.parentNode : p;
    }
    function B(l) {
      try {
        return l.defaultView && l.defaultView.frameElement || null;
      } catch {
        return null;
      }
    }
    window.IntersectionObserver = i, window.IntersectionObserverEntry = s;
  }()), v0;
}
var w0;
function Mc() {
  return w0 || (w0 = 1, function(u) {
    var e = Mr(), t = si();
    Object.defineProperty(u, "__esModule", {
      value: !0
    }), u.default = void 0;
    var n = t(ii()), s = t(Mr()), i = e(uu), a = t(Ic()), D = Ur();
    i.default.createElement;
    function o() {
    }
    var d = {
      contain: "react-Slidy--contain",
      cover: "react-Slidy--cover",
      fullHeight: "react-Slidy--fullHeight",
      fullWidth: "react-Slidy--fullWidth"
    }, x = function(F) {
      var C = F.ArrowLeft, f = F.ArrowRight, y = F.children, B = F.classNameBase, l = B === void 0 ? "react-Slidy" : B, p = F.doAfterDestroy, E = p === void 0 ? o : p, A = F.doAfterInit, b = A === void 0 ? o : A, w = F.doAfterSlide, P = w === void 0 ? o : w, q = F.doBeforeSlide, z = q === void 0 ? o : q, k = F.imageObjectFit, I = F.infiniteLoop, O = I === void 0 ? !1 : I, j = F.itemsToPreload, M = j === void 0 ? 1 : j, J = F.initialSlide, su = J === void 0 ? 0 : J, nu = F.ease, N = nu === void 0 ? "ease" : nu, v = F.lazyLoadSlider, S = v === void 0 ? !0 : v, R = F.lazyLoadConfig, V = R === void 0 ? {
        offset: 150
      } : R, U = F.keyboardNavigation, Z = U === void 0 ? !1 : U, Y = F.numOfSlides, K = Y === void 0 ? 1 : Y, X = F.sanitize, L = X === void 0 ? !0 : X, W = F.slide, tu = W === void 0 ? 0 : W, $ = F.slideSpeed, du = $ === void 0 ? 500 : $, xu = F.showArrows, Fu = xu === void 0 ? !0 : xu, zu = F.useFullHeight, Ue = zu === void 0 ? !1 : zu, Be = F.useFullWidth, ae = Be === void 0 ? !0 : Be, He = (0, i.useState)(!S), St = He[0], xe = He[1], Ve = (0, i.useRef)(null);
      (0, i.useEffect)(
        function() {
          var Wu;
          if (S) {
            var qu = function() {
              var Uu = V.offset, Tt = Uu === void 0 ? 0 : Uu;
              Wu = new window.IntersectionObserver(Pt, {
                rootMargin: Tt + "px 0px 0px"
              }), Wu.observe(Ve.current);
            };
            "IntersectionObserver" in window ? qu() : Promise.resolve().then(function() {
              return (0, s.default)(Lc());
            }).then(qu);
          }
          return function() {
            return Wu && Wu.disconnect();
          };
        },
        []
        // eslint-disable-line
      );
      var Pt = function(qu, ye) {
        var Uu = qu[0];
        (Uu.isIntersecting || Uu.intersectionRatio > 0) && (ye.unobserve(Uu.target), xe(!0));
      }, We = Math.min(K, i.default.Children.count(y)), qe = [l, Ue && d.fullHeight, ae && d.fullWidth, k && d[k]].filter(Boolean).join(" "), Ge = {
        ArrowLeft: C,
        ArrowRight: f,
        children: y,
        classNameBase: l,
        doAfterDestroy: E,
        doAfterInit: b,
        doAfterSlide: P,
        doBeforeSlide: z,
        ease: N,
        infiniteLoop: O,
        initialSlide: su,
        itemsToPreload: M,
        keyboardNavigation: Z,
        numOfSlides: K,
        showArrows: Fu,
        slide: tu,
        slideSpeed: du
      };
      return /* @__PURE__ */ (0, D.jsx)("div", {
        className: qe,
        ref: Ve,
        children: St && /* @__PURE__ */ (0, D.jsx)(a.default, (0, n.default)({}, Ge, {
          numOfSlides: L ? We : K,
          children: y
        }))
      });
    }, c = x;
    u.default = c;
  }(Er)), Er;
}
var zc = Mc();
const Uc = /* @__PURE__ */ ne(zc), Hc = _.img`
  object-fit: contain;
  position: relative;
  width: 100%;
  max-height: 290px;
`, ai = ({
  src: u
}) => /* @__PURE__ */ r.jsx(Mu, { href: u, children: /* @__PURE__ */ r.jsx(Hc, { src: u }) }), oi = ({
  url: u
}) => /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-h-full", children: /* @__PURE__ */ r.jsx(ku, { url: u, playing: !1, loop: !0, controls: !0, className: "sp-w-full", width: "100%", height: "auto" }) }), Vc = ({
  media: u
}) => {
  const [e, t] = Au(0), n = u.length, s = ({
    currentSlide: i
  }) => {
    t(i);
  };
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-relative", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-text-white sp-bg-black sp-rounded-lg sp-p-2 sp-text-xl sp-w-auto sp-text-center", style: {
      opacity: 0.7,
      position: "absolute",
      right: "25px",
      zIndex: 100,
      top: "10px"
    }, children: /* @__PURE__ */ r.jsxs(Yu, { children: [
      e + 1,
      " / ",
      n
    ] }) }),
    /* @__PURE__ */ r.jsx(Uc, { imageObjectFit: "cover", useFullWidth: !0, numOfSlides: 1.1, itemsToPreload: 2, slideSpeed: 100, doAfterSlide: s, slide: e, children: u.map((i, a) => i.isVideo || i.url.includes(".mp4") ? /* @__PURE__ */ r.jsx("div", { className: "sp-p-2", children: /* @__PURE__ */ r.jsx(oi, { url: i.url }) }, `item-${a}`) : /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(ai, { src: i.url }, `item-${a}`) }, `item-${a}`)) })
  ] });
}, Wc = ({
  media: u
}) => u.length === 1 ? u[0].isVideo || u[0].url.includes(".mp4") ? /* @__PURE__ */ r.jsx(oi, { url: u[0].url }) : /* @__PURE__ */ r.jsx(ai, { src: u[0].url }) : /* @__PURE__ */ r.jsx(Vc, { media: u }), qc = ({
  medias: u
}) => {
  const e = u.collection, t = e.length;
  if (e && e.length > 0)
    return /* @__PURE__ */ r.jsx("div", { className: "sp-h-full sp-py-4", children: t && /* @__PURE__ */ r.jsx(Wc, { media: e }) });
}, Gc = (u) => {
  switch (u) {
    case "BOOK":
      return "Book now";
    case "ORDER":
      return "Order online";
    case "SHOP":
      return "Buy";
    case "LEARN_MORE":
      return "Learn more";
    case "SIGN_UP":
      return "Sign up";
    case "CALL":
      return "Call now";
    default:
      return null;
  }
}, Yc = ({
  post: u
}) => {
  let e = null, t = null;
  u.event && u.event.startDate && (e = new Iu(u.event.startDate), t = new Iu(u.event.endDate));
  let n = u.caption;
  const s = Gc(u.callToAction.actionType);
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-pt-4 sp-pb-6 sp-px-6", children: [
    /* @__PURE__ */ r.jsx(Oc, { username: u.username, profilePicture: u.profilePicture }),
    u.medias && u.medias.count > 0 && /* @__PURE__ */ r.jsx(qc, { medias: u.medias }),
    u.event && u.event.title && /* @__PURE__ */ r.jsxs(de, { $variant: "title", children: [
      u.event.title,
      " ",
      u.topicType === "OFFER" && /* @__PURE__ */ r.jsx("span", { style: {
        display: "inline-block",
        height: "20px",
        width: "20px"
      }, children: /* @__PURE__ */ r.jsx("svg", { focusable: "false", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "#f4b400", style: {
        height: "20px"
      }, children: /* @__PURE__ */ r.jsx("path", { d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" }) }) })
    ] }),
    e && u.topicType === "EVENT" && /* @__PURE__ */ r.jsx(de, { $variant: "subtitle", className: "sp-text-googlegray-500 sp-font-light", children: `${Iu(e).format("MMM D, LT")} -  ${Iu(t).format("MMM D, LT")}` }),
    e && u.topicType === "OFFER" && /* @__PURE__ */ r.jsx(de, { $variant: "subtitle", className: "", children: `Valid ${Iu(e).format("MMM D")} -  ${Iu(t).format("MMM D")}` }),
    n && /* @__PURE__ */ r.jsx(de, { $variant: "caption", className: `sp-flex sp-flex-col sp-mt-6 sp-pb-6 ${e ? "sp-text-googlegray-500 sp-font-light" : null}`, style: {
      fontSize: e ? "13px" : ""
    }, children: /* @__PURE__ */ r.jsx(vu, { caption: n }) }),
    u.topicType === "OFFER" && u.offer && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      u.offer.couponCode && /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-items-center sp-justify-center sp-mb-6 sp-bg-googlegray-100 sp-border-dashed sp-border-googlegray-200 sp-p-6", children: [
        /* @__PURE__ */ r.jsx(Yu, { className: "sp-text-googlegray-500 sp-text-xl sp-pb-2", children: "Show this code at the shop" }),
        /* @__PURE__ */ r.jsx(Yu, { className: "sp-font-medium sp-text-5xl sp-pb-2", children: u.offer.couponCode }),
        /* @__PURE__ */ r.jsx(Yu, { className: "sp-text-lg sp-font-bold", children: `Valid ${Iu(e).format("l, LT")} - ${Iu(t).format("l, LT")}` })
      ] }),
      u.offer.redeemOnlineUrl && /* @__PURE__ */ r.jsx("a", { href: u.offer.redeemOnlineUrl, className: "sp-text-blue-700 sp-no-underline sp-text-2xl", target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ r.jsx(Yu, { children: "Redeem online" }) })
    ] }),
    u.callToAction && s && /* @__PURE__ */ r.jsx("div", { className: "sp-mb-2 sp-pt-4 sp-my-2", children: /* @__PURE__ */ r.jsx("a", { href: u.callToAction.url, target: "_blank", className: "sp-no-underline sp-inline", children: /* @__PURE__ */ r.jsx(Yu, { $variant: "buttonlabel", style: {
      width: "auto"
    }, className: " sp-text-white sp-bg-googleblue-500 sp-py-4 sp-px-6 sp-text-xl sp-no-underline hover:sp-bg-googleblue-600 sp-rounded hover:sp-shadow-lg", children: s }) }) }),
    u.topicType === "OFFER" && u.offer && u.offer.termsConditions && /* @__PURE__ */ r.jsx("div", { className: "sp-border-googlegray-300 sp-border-solid sp-mt-4 sp-pt-4", style: {
      borderWidth: 0,
      borderTopWidth: "1px"
    }, children: /* @__PURE__ */ r.jsx(Yu, { className: "sp-text-base sp-text-googlegray-400", children: u.offer.termsConditions }) })
  ] });
}, Zc = ({
  post: u
}) => {
  switch (u.type) {
    case "image":
    case "text":
    case "video":
    case "multiMedia":
    case "gmb":
      return /* @__PURE__ */ r.jsx(Yc, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, zr = _.div`
  font-family: Helvetica;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 20px;
          letter-spacing: 0.01em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 16px;
          letter-spacing: -0.02em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, Kc = ({
  username: u,
  profilePicture: e,
  small: t,
  description: n
}) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-m-4", style: {
      width: "40px",
      height: "40px",
      minWidth: "40px",
      minHeight: "40px"
    }, children: /* @__PURE__ */ r.jsx($u, { src: e, alt: u }) }),
    /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${t ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsx("div", { className: "", children: /* @__PURE__ */ r.jsx(zr, { $variant: "subheading", className: "sp-mb-1", children: u }) }) })
  ] }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-ml-8 sp-mr-4", style: {
    paddingLeft: "40px"
  }, children: /* @__PURE__ */ r.jsx(zr, { $variant: "caption", className: "sp-mb-1", children: /* @__PURE__ */ r.jsx(vu, { caption: n }) }) })
] }), Jc = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-bg-black sp-relative", style: {}, children: /* @__PURE__ */ r.jsx(ku, { url: u, controls: !0, playing: !1, width: "100%", height: "auto", className: "" }) }) : null, Di = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showAll: n,
  isActiveSlide: s = !0
}) => e && n === !1 ? null : /* @__PURE__ */ r.jsx(r.Fragment, { children: (u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(Jc, { url: u.url, forCarousel: t, isActiveSlide: s }) }), Xc = _.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, Qc = ({
  medias: u
}) => {
  const [e, t] = Au(!1);
  return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: u.map((n, s) => !e && s > 3 ? null : /* @__PURE__ */ r.jsx(Xc, { className: "sp-relative", children: /* @__PURE__ */ r.jsx(Di, { media: n, forCarousel: !0, hidden: s > 3, mediaCount: u.length, showOverlay: s === 3 && u.length > 4, showAll: e, setShowAll: t }) }, `fb-media-key-${s}`)) });
}, uF = ({
  medias: u
}) => {
  const e = u.collection, t = e.length, n = t > 1;
  return /* @__PURE__ */ r.jsx("div", { children: t > 0 && /* @__PURE__ */ r.jsx(r.Fragment, { children: n ? /* @__PURE__ */ r.jsx(Qc, { medias: e, count: t }) : /* @__PURE__ */ r.jsx(Di, { media: e[0] }) }) });
}, eF = ({
  post: u
}) => {
  let e = u.ytTitle;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-pb-4", children: [
    /* @__PURE__ */ r.jsx(uF, { medias: u.medias }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-mt-2 sp-mb-2 sp-flex sp-flex-col sp-border-0 sp-border-b sp-border-solid sp-border-gray-300", children: [
      /* @__PURE__ */ r.jsx("div", { className: "sp-mt-4 sp-mb-6 sp-m-2", children: /* @__PURE__ */ r.jsx(zr, { $variant: "heading", className: "sp-whitespace-pre-line sp-break-words", children: e }) }),
      /* @__PURE__ */ r.jsx("div", {})
    ] }),
    /* @__PURE__ */ r.jsx(Kc, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName, description: u.caption })
  ] });
}, tF = ({
  post: u
}) => {
  switch (u.type) {
    case "video":
      return /* @__PURE__ */ r.jsx(eF, { post: u });
    case "image":
    case "multiMedia":
    case "text":
    case "story":
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, Br = _.div`
  font-family: "Helvetica", sans-serif;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 1.5rem;
          line-height: 2rem;
          text-decoration: none !important;
          color: inherit !important;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 1rem;
          line-height: 16px;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 1rem;
          line-height: 1.5rem;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, _e = _.span`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 20px;
        `;
    case "bold":
      return `
          font-style: normal;
          font-weight: bold;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 1.2rem;
          line-height: 1.3rem;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, rF = ({
  username: u,
  boardTitle: e,
  boardSectionTitle: t,
  profilePicture: n,
  small: s,
  description: i,
  url: a,
  title: D
}) => {
  let o = null;
  if (a)
    try {
      const {
        hostname: d
      } = new URL(a);
      o = d;
    } catch {
    }
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("div", { className: "sp-p-2 sp-px-4", children: [
      a && o && /* @__PURE__ */ r.jsx("div", { className: "sp-pb-2", children: /* @__PURE__ */ r.jsxs(Br, { $variant: "caption", children: [
        "Article from",
        " ",
        /* @__PURE__ */ r.jsx("a", { href: a, target: "_blank", style: {
          color: "inherit",
          textDecoration: "none"
        }, rel: "noreferrer", children: /* @__PURE__ */ r.jsx(_e, { $variant: "bold", children: o }) })
      ] }) }),
      D && /* @__PURE__ */ r.jsx("div", { className: "sp-pb-2", children: /* @__PURE__ */ r.jsx(nF, { url: a, children: /* @__PURE__ */ r.jsx(Br, { $variant: "heading", children: D }) }) }),
      i && /* @__PURE__ */ r.jsx(Br, { $variant: "caption", children: /* @__PURE__ */ r.jsx(vu, { caption: i, targetPlatform: "PI" }) })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-px-4", children: [
      /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-mr-2", style: {
        width: "40px",
        height: "40px",
        minWidth: "40px",
        minHeight: "40px"
      }, children: /* @__PURE__ */ r.jsx($u, { src: n, alt: u }) }),
      /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${s ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsxs("div", { className: "", children: [
        /* @__PURE__ */ r.jsxs(_e, { $variant: "bold", className: "sp-mb-1", children: [
          u,
          " "
        ] }),
        /* @__PURE__ */ r.jsx(_e, { children: "saved to " }),
        t && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(_e, { $variant: "bold", className: "sp-mb-1", children: t }),
          " ",
          "in "
        ] }),
        /* @__PURE__ */ r.jsx(_e, { $variant: "bold", className: "sp-mb-1", children: e })
      ] }) })
    ] })
  ] });
}, nF = ({
  url: u,
  children: e
}) => u ? /* @__PURE__ */ r.jsx("a", { href: u, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: e }) : /* @__PURE__ */ r.jsx("div", { children: e }), sF = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
  border-radius: 20px;
`, iF = ({
  src: u
}) => /* @__PURE__ */ r.jsx(sF, { src: u }), aF = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-bg-black sp-relative", style: {
  borderRadius: "10px"
}, children: /* @__PURE__ */ r.jsx(ku, { url: u, controls: !0, playing: !1, width: "100%", height: "auto", className: "" }) }) : null, oF = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showAll: n,
  isActiveSlide: s = !0
}) => e && n === !1 ? null : u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(aF, { url: u.url, forCarousel: t, isActiveSlide: s }) : /* @__PURE__ */ r.jsx(iF, { src: u.url }), DF = ({
  medias: u
}) => {
  const e = u.collection, t = e.length;
  return /* @__PURE__ */ r.jsx(lF, { children: t > 0 && /* @__PURE__ */ r.jsx(oF, { media: e[0] }) });
}, lF = _.div`
  border-radius: 20px;
  overflow: hidden;
`, cF = ({
  url: u,
  children: e
}) => u ? /* @__PURE__ */ r.jsx("a", { href: u, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: e }) : /* @__PURE__ */ r.jsx("div", { children: e }), FF = ({
  post: u
}) => /* @__PURE__ */ r.jsxs(dF, { className: "sp-bg-white md:sp-shadow-around sp-pb-4", style: {
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px"
}, children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-pb-2", children: /* @__PURE__ */ r.jsx(cF, { url: u.redirectUrl, children: /* @__PURE__ */ r.jsx(DF, { medias: u.medias }) }) }),
  /* @__PURE__ */ r.jsx(rF, { username: u.username, small: !1, profilePicture: u.profilePicture, description: u.caption, title: u.piTitle, boardTitle: u.boardTitle, boardSectionTitle: u.boardSectionTitle, url: u.redirectUrl })
] }), dF = _.div`
  padding: 35px 28px 28px;
`, pF = ({
  post: u
}) => {
  switch (u.type) {
    case "video":
    case "image":
    case "multiMedia":
    case "text":
    case "story":
      return /* @__PURE__ */ r.jsx(FF, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, EF = _.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`, CF = _.img`
  display: block;
  object-fit: cover;
  position: relative;
  width: 100%;
`, fF = ({
  src: u
}) => /* @__PURE__ */ r.jsx(CF, { src: u }), AF = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-relative", children: /* @__PURE__ */ r.jsx(ku, { controls: !0, url: u, playing: !1, width: "100%", height: "auto", style: {
  display: "grid",
  placeContent: "center",
  minHeight: "600px",
  background: "grey"
} }) }) : null, hF = ({
  media: u,
  hidden: e = !1,
  showAll: t,
  isActiveSlide: n = !0
}) => e && t === !1 ? null : u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(AF, { url: u.url, isActiveSlide: n }) : /* @__PURE__ */ r.jsx(EF, { children: /* @__PURE__ */ r.jsx(fF, { src: u.url }) }), mF = ({
  medias: u
}) => {
  const e = u.collection, t = e.length;
  return /* @__PURE__ */ r.jsx(gF, { children: t > 0 && /* @__PURE__ */ r.jsx(hF, { media: e[0] }) });
}, gF = _.div`
  overflow: hidden;
  border-radius: 15px;
  max-height: 867px;
  height: calc(100vh - 270px - 1rem);
  background: grey;
`, li = _.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, BF = (u) => /* @__PURE__ */ m.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "10 6 14 14", ...u }, /* @__PURE__ */ m.createElement("g", { filter: "url(#filter0_d_0_89)" }, /* @__PURE__ */ m.createElement("path", { d: "M23.6165 19.615C23.3689 19.8635 23.04 20 22.6891 20C22.3391 20 22.0093 19.8635 21.7617 19.615L19.4195 17.2735C18.4363 17.9069 17.2914 18.2435 16.1219 18.243C14.9112 18.2432 13.7277 17.8843 12.721 17.2118C11.7143 16.5392 10.9296 15.5832 10.4662 14.4647C10.0028 13.3462 9.88143 12.1153 10.1175 10.9278C10.3536 9.74027 10.9365 8.64946 11.7925 7.79325C12.6485 6.93706 13.7392 6.35396 14.9265 6.11769C16.1139 5.88142 17.3447 6.00259 18.4632 6.46589C19.5817 6.92919 20.5378 7.71379 21.2104 8.72049C21.883 9.72718 22.242 10.9107 22.242 12.1215C22.2426 13.2902 21.907 14.4344 21.2752 15.4176L23.6165 17.76C23.8621 18.0062 24 18.3398 24 18.6875C24 19.0352 23.8621 19.3688 23.6165 19.615ZM16.1219 8.625C15.6628 8.625 15.2081 8.71545 14.7839 8.89116C14.3598 9.06687 13.9743 9.32442 13.6497 9.6491C13.325 9.97378 13.0675 10.3592 12.8918 10.7834C12.7161 11.2077 12.6257 11.6623 12.6257 12.1215C12.6257 12.5807 12.7161 13.0353 12.8918 13.4595C13.0675 13.8838 13.325 14.2692 13.6497 14.5939C13.9743 14.9186 14.3598 15.1761 14.7839 15.3519C15.2081 15.5276 15.6628 15.618 16.1219 15.618C17.0493 15.618 17.9387 15.2496 18.5944 14.5938C19.2502 13.938 19.6186 13.0485 19.6186 12.1211C19.6186 11.1936 19.2502 10.3042 18.5944 9.64836C17.9387 8.99256 17.0493 8.62412 16.1219 8.62412V8.625Z", fill: "white" })), /* @__PURE__ */ m.createElement("defs", null, /* @__PURE__ */ m.createElement("filter", { id: "filter0_d_0_89", x: 0, y: 0, width: 34, height: 34, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ m.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ m.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ m.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ m.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ m.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ m.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_89" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_89", result: "shape" })))), xF = (u) => /* @__PURE__ */ m.createElement("svg", { width: 16, height: 13, viewBox: "0 0 16 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("path", { d: "M14.0463 1.18364C13.2625 0.399877 12.2228 0 11.1831 0C10.1435 0 9.11978 0.399877 8.32003 1.18364L7.64823 1.85543L6.97644 1.18364C6.19268 0.399877 5.153 0 4.11332 0C2.46583 0 0.834332 0.991695 0.178533 2.95909C-0.253334 4.28668 0.114553 5.75823 1.10625 6.74992L7.15239 12.7961C7.4243 13.068 7.84018 13.068 8.11209 12.7961L14.0143 6.89388C15.6298 5.32636 15.6298 2.75115 14.0463 1.18364Z", fill: "white" })), yF = (u) => /* @__PURE__ */ m.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("path", { d: "M1.68328 11.6584C0.823728 12.0881 -0.0881374 11.1763 0.34164 10.3167L1.5049 7.99021C2.12365 6.7527 2.05895 5.2833 1.33382 4.10496L0.201123 2.26433C-0.314794 1.42596 0.56357 0.425049 1.46184 0.827721L11.0744 5.13679C11.8442 5.48188 11.8671 6.56645 11.1125 6.94373L1.68328 11.6584Z", fill: "white" })), vF = (u) => /* @__PURE__ */ m.createElement("svg", { width: 16, height: 4, viewBox: "0 0 16 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("circle", { cx: 2, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ m.createElement("circle", { cx: 8, cy: 2, r: 2, fill: "white" }), /* @__PURE__ */ m.createElement("circle", { cx: 14, cy: 2, r: 2, fill: "white" })), bF = (u) => /* @__PURE__ */ m.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "10 6 14 8", ...u }, /* @__PURE__ */ m.createElement("g", { filter: "url(#filter0_d_0_103)" }, /* @__PURE__ */ m.createElement("path", { d: "M21 7C20.7545 7 20.5556 7.19899 20.5556 7.44444V9.55555H18.4444C18.199 9.55555 18 9.75453 18 10C18 10.2455 18.199 10.4444 18.4444 10.4444H20.5556V12.5556C20.5556 12.801 20.7545 13 21 13C21.2455 13 21.4444 12.801 21.4444 12.5556V10.4444H23.5555C23.801 10.4444 24 10.2455 24 10C24 9.75453 23.801 9.55555 23.5555 9.55555H21.4444V7.44444C21.4444 7.19899 21.2455 7 21 7Z", fill: "white" }), /* @__PURE__ */ m.createElement("path", { d: "M10.8872 14C11.0037 14.0002 11.1191 13.9808 11.2267 13.9429C11.3343 13.9051 11.432 13.8495 11.5141 13.7794L13.5 12.0955L15.4782 13.7729C15.6019 13.8802 15.7606 13.9537 15.9339 13.984C16.1072 14.0143 16.2872 13.9999 16.4508 13.9427C16.6144 13.8856 16.7541 13.7883 16.852 13.6633C16.9498 13.5383 17.0014 13.3913 17 13.2413V7.16129C17 6.8533 16.8557 6.55792 16.5988 6.34013C16.342 6.12235 15.9936 6 15.6304 6H11.3696C11.0063 6 10.658 6.12235 10.4011 6.34013C10.1443 6.55792 10 6.8533 10 7.16129V13.2477C10.0004 13.4471 10.094 13.6383 10.2603 13.7793C10.4266 13.9203 10.652 13.9997 10.8872 14ZM10.913 7.16129C10.913 7.05863 10.9611 6.96017 11.0468 6.88757C11.1324 6.81498 11.2485 6.77419 11.3696 6.77419H15.6304C15.7515 6.77419 15.8676 6.81498 15.9532 6.88757C16.0388 6.96017 16.0869 7.05863 16.0869 7.16129V13.1948L13.5 11.0013L10.913 13.1948V7.16129Z", fill: "white" })), /* @__PURE__ */ m.createElement("defs", null, /* @__PURE__ */ m.createElement("filter", { id: "filter0_d_0_103", x: 0, y: 0, width: 34, height: 28, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ m.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ m.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ m.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ m.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ m.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ m.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_103" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_103", result: "shape" })))), wF = _.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
`, jF = _(li)`
  position: absolute;
  top: 17px;
  z-index: 2;
  display: flex;
  align-items: center;

  span {
    font-weight: bold;
    font-size: 16px;
  }

  svg {
    position: relative;
    left: -50%;
    width: 14px;
  }
`, _F = _.div`
  position: absolute;
  right: 7px;
  bottom: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    width: 15px;
  }
`, xr = _.div`
  width: 32px;
  display: grid;
  place-content: center;
  height: 32px;
`, yr = _.div`
  width: 32px;
  height: 32px;
  opacity: 0.2;
  border-radius: 50%;
  box-shadow: 0px 4px 10px 0px #00000026;
  background: white;
  position: absolute;
`, SF = _.div`
  background: url(${(u) => u.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 22px;
  height: 22px;
  border-radius: 50%;
`, PF = _.div`
  position: absolute;
  z-index: 2;
  padding: 7px;
  display: flex;
  align-items: center;
  height: 22px;
  gap: 4px;
  bottom: 45px;

  p {
    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  }

  .bookmarkIconWrap {
    position: relative;
    top: -2px;
    left: 4px;
    height: 8px;

    svg {
      height: 8px;
    }
  }
`, TF = ({
  url: u,
  children: e
}) => u ? /* @__PURE__ */ r.jsx("a", { href: u, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: e }) : /* @__PURE__ */ r.jsx("div", { children: e }), kF = ({
  medias: u,
  profilePicture: e,
  username: t
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-relative", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-justify-center", children: /* @__PURE__ */ r.jsxs(jF, { children: [
    /* @__PURE__ */ r.jsx(BF, {}),
    /* @__PURE__ */ r.jsx("span", { children: "Spotlight You" })
  ] }) }),
  /* @__PURE__ */ r.jsx(mF, { medias: u }),
  /* @__PURE__ */ r.jsxs(_F, { children: [
    /* @__PURE__ */ r.jsxs(xr, { children: [
      /* @__PURE__ */ r.jsx(yr, {}),
      /* @__PURE__ */ r.jsx(xF, {})
    ] }),
    /* @__PURE__ */ r.jsxs(xr, { children: [
      /* @__PURE__ */ r.jsx(yr, {}),
      /* @__PURE__ */ r.jsx(yF, {})
    ] }),
    /* @__PURE__ */ r.jsxs(xr, { children: [
      /* @__PURE__ */ r.jsx(yr, {}),
      /* @__PURE__ */ r.jsx(vF, {})
    ] })
  ] }),
  /* @__PURE__ */ r.jsxs(PF, { children: [
    /* @__PURE__ */ r.jsx(SF, { $profilePicture: e }),
    /* @__PURE__ */ r.jsxs(li, { className: "sp-font-bold sp-mb-2", children: [
      "@",
      t
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: "bookmarkIconWrap", children: /* @__PURE__ */ r.jsx(bF, {}) })
  ] })
] }), NF = ({
  post: u
}) => /* @__PURE__ */ r.jsx(wF, { children: /* @__PURE__ */ r.jsx(TF, { url: u.redirectUrl, children: /* @__PURE__ */ r.jsx(kF, { medias: u.medias, username: u.username, profilePicture: u.profilePicture }) }) }), OF = ({
  post: u
}) => {
  switch (u.type) {
    case "video":
    case "image":
    case "multiMedia":
    case "text":
    case "story":
      return /* @__PURE__ */ r.jsx(NF, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, $F = _.img`
  display: block;
  object-fit: contain;
  position: relative;
  width: 100%;
`, RF = ({
  url: u,
  isActiveSlide: e,
  videoCoverPreview: t
}) => {
  const [n, s] = Au(!1), [i, a] = Au(!1), [D, o] = Au(0);
  return Xu(() => {
    t && (s(!1), a(!1), o((d) => d + 1));
  }, [t]), e ? /* @__PURE__ */ r.jsxs(IF, { className: "sp-relative", style: {
    minHeight: "500px",
    width: "100%"
  }, children: [
    !n && i && /* @__PURE__ */ r.jsx(LF, { children: /* @__PURE__ */ r.jsx(Ws, { onClick: () => {
      s(!1), a(!1), o((d) => d + 1);
    } }) }),
    /* @__PURE__ */ r.jsx(ku, { playing: !!t, onPlay: () => {
      s(!0), a(!0);
    }, onPause: () => s(!1), controls: !0, light: t, url: u, width: "100%", height: "auto", style: {
      display: t ? "flex" : "grid",
      placeContent: "center",
      minHeight: "500px",
      background: "grey"
    } }, D)
  ] }) : null;
}, IF = _.div`
  min-height: 500px;
  width: 100%;

  .react-player__preview {
    height: calc(-270px - 1rem + 100vh) !important;
    background-repeat: no-repeat !important;
  }
`, LF = _.div`
  position: absolute;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  margin-left: -28px;
  margin-top: -28px;
  cursor: pointer;
  z-index: 99;
`, ci = ({
  media: u,
  hidden: e = !1,
  showAll: t,
  isActiveSlide: n = !0,
  videoCoverPreview: s
}) => e && t === !1 ? null : u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(RF, { url: u.url, isActiveSlide: n, videoCoverPreview: s }) : /* @__PURE__ */ r.jsx($F, { src: u.url }), MF = ({
  current: u,
  ...e
}) => /* @__PURE__ */ r.jsx("div", { style: {
  backgroundColor: `${u ? "#FFFFFF" : "#C4C4C4"}`
}, className: `
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out
    sp-cursor-pointer
    `, ...e }), zF = ({
  count: u,
  current: e,
  titleCaptionHeight: t,
  onChange: n,
  isMultipleLinesDetected: s
}) => /* @__PURE__ */ r.jsx("div", { className: "sp-absolute", style: {
  bottom: t - 3,
  left: 0,
  right: 0,
  backgroundColor: s ? "black" : void 0,
  height: 40
}, children: /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-center sp-z-50 sp-py-4 sp-absolute", style: {
  left: "50%",
  transform: "translateX(-50%)",
  bottom: 0
}, id: "dottt", children: [...Array(u)].map((i, a) => /* @__PURE__ */ r.jsx(MF, { current: a + 1 === e, onClick: () => {
  n(a + 1);
} }, a)) }) }), UF = ({
  medias: u,
  count: e,
  titleCaptionHeight: t,
  isMultipleLinesDetected: n
}) => {
  const [s, i] = Au(1);
  Xu(() => {
    s > u.length && i(u.length);
  }, [u.length]);
  const a = e > 1 ? 35 : 10;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-w-full sp-relative", style: {
      transform: n ? `translateY(-${(t + a) / 2}px)` : void 0
    }, children: /* @__PURE__ */ r.jsx(ci, { media: u[s - 1] }) }),
    e > 1 && /* @__PURE__ */ r.jsx(zF, { count: e, current: s, titleCaptionHeight: t, onChange: (D) => i(D), isMultipleLinesDetected: n })
  ] });
}, HF = ({
  medias: u,
  videoCoverPreview: e,
  postType: t,
  titleCaptionHeight: n,
  isMultipleLinesDetected: s
}) => {
  const i = u.collection, a = i.length;
  return t === "multiMedia" || t?.toLowerCase() === "image" ? /* @__PURE__ */ r.jsx(j0, { children: /* @__PURE__ */ r.jsx(UF, { medias: i, count: a, isMultipleLinesDetected: s, titleCaptionHeight: n }) }) : /* @__PURE__ */ r.jsx(j0, { children: a > 0 && /* @__PURE__ */ r.jsx(ci, { videoCoverPreview: e, media: i[0] }) });
}, j0 = _.div`
  overflow: hidden;
  border-radius: 15px;
  align-items: center;
  overflow: hidden;
  border-radius: 15px;
  max-height: 867px;
  height: calc((100vh - 270px) - 1rem);
  background: black;
  display: flex;
  overflow: hidden;
`, vr = _.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, VF = (u) => /* @__PURE__ */ m.createElement("svg", { width: 52, height: 49, viewBox: "0 0 52 49", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("g", { filter: "url(#filter0_d_0_24)" }, /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1429 6C23.7143 6 26 9.01299 26 9.01299C26 9.01299 28.2857 6 32.8571 6C38.1905 6 42 10.1428 42 15.4156C42 21.4416 37.0188 26.8133 32.4762 30.8571C29.6716 33.3537 27.5238 35 26 35C24.4762 35 22.2674 33.3412 19.5238 30.8571C15.0583 26.814 10 21.4416 10 15.4156C10 10.1428 13.8095 6 19.1429 6Z", fill: "white" })), /* @__PURE__ */ m.createElement("defs", null, /* @__PURE__ */ m.createElement("filter", { id: "filter0_d_0_24", x: 0, y: 0, width: 52, height: 49, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ m.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ m.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ m.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ m.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ m.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ m.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_24" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_24", result: "shape" })))), WF = (u) => /* @__PURE__ */ m.createElement("svg", { width: 51, height: 50, viewBox: "0 0 51 50", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("g", { opacity: 0.9, filter: "url(#filter0_d_0_25)" }, /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36.1286 29.6848C39.2029 26.6131 41 23.4136 41 19.6882C41 12.1283 34.0609 6 25.5 6C16.9391 6 10 12.1283 10 19.6884C10 27.2485 17.1636 32.4385 25.7246 32.4385V34.9456C25.7246 35.74 26.5504 36.2512 27.2507 35.8726C29.4385 34.6901 33.4926 32.3184 36.1286 29.6848ZM17.9706 17.8423C19.1941 17.8423 20.1859 18.8244 20.1859 20.0341C20.1859 21.2463 19.1941 22.2284 17.9706 22.2284C16.7492 22.2284 15.7573 21.2463 15.7573 20.0341C15.7573 18.8244 16.7492 17.8423 17.9706 17.8423ZM27.7144 20.0341C27.7144 18.8244 26.7229 17.8423 25.5 17.8423C24.2772 17.8423 23.2858 18.8244 23.2858 20.0341C23.2858 21.2463 24.2773 22.2284 25.5 22.2284C26.7229 22.2284 27.7144 21.2463 27.7144 20.0341ZM33.0291 17.8423C34.2524 17.8423 35.2428 18.8244 35.2428 20.0341C35.2428 21.2463 34.2524 22.2284 33.0291 22.2284C31.8058 22.2284 30.814 21.2463 30.8142 20.0341C30.8142 18.8244 31.8058 17.8423 33.0291 17.8423Z", fill: "white" })), /* @__PURE__ */ m.createElement("defs", null, /* @__PURE__ */ m.createElement("filter", { id: "filter0_d_0_25", x: 0, y: 0, width: 51, height: 50, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ m.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ m.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ m.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ m.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ m.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ m.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_25" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_25", result: "shape" })))), qF = (u) => /* @__PURE__ */ m.createElement("svg", { width: 51, height: 44, viewBox: "0 0 51 44", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("g", { opacity: 0.9, filter: "url(#filter0_d_0_23)" }, /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.2228 7.13786C27.2228 6.13946 28.4318 5.62698 29.1629 6.31551L40.2873 16.7934C41.2662 17.7155 41.2321 19.2704 40.2135 20.1494L29.1259 29.7178C28.3833 30.3588 27.2228 29.8372 27.2228 28.8623V24.5263C27.2228 24.5263 15.318 22.4052 11.4993 29.3377C11.1432 29.984 9.75548 30.2101 10.0376 26.9853C11.2172 21.05 13.628 11.7838 27.2228 11.7838V7.13786Z", fill: "white" })), /* @__PURE__ */ m.createElement("defs", null, /* @__PURE__ */ m.createElement("filter", { id: "filter0_d_0_23", x: 0, y: 0, width: 51, height: 44, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ m.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ m.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ m.createElement("feOffset", { dy: 4 }), /* @__PURE__ */ m.createElement("feGaussianBlur", { stdDeviation: 5 }), /* @__PURE__ */ m.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ m.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_0_23" }), /* @__PURE__ */ m.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_0_23", result: "shape" })))), GF = (u) => /* @__PURE__ */ m.createElement("svg", { width: 14, height: 15, viewBox: "0 0 14 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.1249 1.87579C12.1249 1.63512 11.9014 1.45676 11.6668 1.51012L5.6712 2.87348C5.5005 2.91229 5.37934 3.06409 5.37934 3.23914V12.0902H5.37897C5.3889 12.9029 4.5507 13.7484 3.35438 14.0689C2.01898 14.4267 0.743054 13.9951 0.504513 13.1048C0.265968 12.2146 1.15513 11.2028 2.49052 10.845C2.97713 10.7146 3.45585 10.6891 3.87934 10.7523V3.23914C3.87934 2.36382 4.48504 1.60493 5.33861 1.41083L11.3342 0.0474661C12.5075 -0.219354 13.6249 0.672475 13.6249 1.87579V10.2609C13.6564 11.0828 12.8123 11.9454 11.6011 12.2699C10.2657 12.6277 8.98976 12.1961 8.75123 11.3058C8.51269 10.4156 9.40185 9.4038 10.7372 9.04598C11.2234 8.91574 11.7017 8.89009 12.1249 8.95313V1.87579Z", fill: "white" })), YF = (u) => /* @__PURE__ */ m.createElement("svg", { width: 30, height: 30, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("path", { d: "M27.4365 8.78874L27.2831 7.33075C27.1539 6.10359 26.1191 5.172 24.8852 5.172H5.11487C3.88093 5.172 2.84612 6.1036 2.71695 7.33075L2.56348 8.78874", stroke: "white", strokeWidth: 2.5, strokeLinecap: "round" }), /* @__PURE__ */ m.createElement("path", { d: "M11.25 1L15.625 5.375", stroke: "white", strokeWidth: 1.875, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ m.createElement("path", { d: "M19.375 1L15 5.375", stroke: "white", strokeWidth: 1.875, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ m.createElement("path", { d: "M2.5 23.8585L2.71692 25.9193C2.8461 27.1465 3.88091 28.0781 5.11484 28.0781H24.8851C26.1191 28.0781 27.1539 27.1465 27.283 25.9193L27.5 23.8585", stroke: "white", strokeWidth: 2.5, strokeLinecap: "round" }), /* @__PURE__ */ m.createElement("path", { d: "M1.28897 21.25V11.6692H3.3146V19.5799H7.42201V21.25H1.28897ZM10.7891 11.6692V21.25H8.76346V11.6692H10.7891ZM14.1866 11.6692L16.5023 18.9484H16.5912L18.9115 11.6692H21.157L17.8542 21.25H15.2438L11.9364 11.6692H14.1866ZM22.3102 21.25V11.6692H28.766V13.3393H24.3358V15.6222H28.4339V17.2923H24.3358V19.5799H28.7847V21.25H22.3102Z", fill: "white" })), ZF = (u) => /* @__PURE__ */ m.createElement("svg", { width: 23, height: 23, viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("circle", { cx: 9.04035, cy: 9.04035, r: 8.04035, stroke: "white", strokeWidth: 2 }), /* @__PURE__ */ m.createElement("path", { d: "M21.2621 21.9124C21.6526 22.3029 22.2858 22.3029 22.6763 21.9124C23.0668 21.5219 23.0668 20.8887 22.6763 20.4982L21.2621 21.9124ZM14.1996 14.8499L21.2621 21.9124L22.6763 20.4982L15.6138 13.4357L14.1996 14.8499Z", fill: "white" })), KF = (u) => /* @__PURE__ */ m.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...u }, /* @__PURE__ */ m.createElement("circle", { cx: 10, cy: 10, r: 10, fill: "#FF0505" }), /* @__PURE__ */ m.createElement("rect", { x: 9, y: 5, width: 2, height: 9, rx: 1, fill: "white" }), /* @__PURE__ */ m.createElement("rect", { x: 5.5, y: 10.5, width: 2, height: 9, rx: 1, transform: "rotate(-90 5.5 10.5)", fill: "white" })), JF = _.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  ${(u) => u.$env === "schedugram-client" && `
    margin: 0 50px;
    @media (max-width: 1279px) {
      margin: 0;
    }
  `}
`, XF = _.div`
  position: absolute;
  top: 42px;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
`, QF = _.div`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-weight: 600;
    color: white;
    font-family: "Inter";
  }
`, u2 = _.p`
  opacity: 0.6;
  margin: 0;
`, e2 = _.p`
  margin: 0 0 -2px 15px;
`, t2 = _.span`
  display: block;
  height: 2px;
  width: 30px;
  background-color: white;
  margin: 0 auto;
`, r2 = _.div`
  z-index: 10;
  position: absolute;
  right: 10px;
  bottom: 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    width: 45px;
    height: 45px;
  }
`, n2 = _.div`
  background: url(${(u) => u.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 50px;
  height: 50px;
  border: 3px solid white;
  border-radius: 50%;
  position: relative;
  display: grid;
  place-items: center;
  margin-bottom: 20px;

  svg {
    position: absolute;
    bottom: -10px;
    height: auto;
  }
`, s2 = _.div`
  position: absolute;
  bottom: 0px;
  z-index: 2;
  padding: 10px;
  left: 0px;
  right: 0px;
  padding-bottom: 8px;
  overflow-wrap: break-word;
  word-break: break-word;
  ${({
  $isTakingUpSpace: u
}) => u ? "background-color: black;" : ""}

  a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
  }

  .description {
    line-height: 20px;
    width: 210px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  svg.musicIcon {
    width: 14px;
    height: 15px;
    flex-shrink: 0;
  }
`, i2 = ({
  url: u,
  ContentItem: e
}) => u ? /* @__PURE__ */ r.jsx("a", { href: u, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: e }) : /* @__PURE__ */ r.jsx("div", { children: e }), a2 = ({
  medias: u,
  profilePicture: e,
  username: t,
  description: n,
  videoCoverPreview: s,
  title: i,
  postType: a
}) => {
  const [D, o] = uu.useState(!1), [d, x] = uu.useState(0);
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-relative", children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-justify-center", children: /* @__PURE__ */ r.jsxs(XF, { children: [
      /* @__PURE__ */ r.jsx(YF, {}),
      /* @__PURE__ */ r.jsxs(QF, { children: [
        /* @__PURE__ */ r.jsx(u2, { children: "Following" }),
        /* @__PURE__ */ r.jsxs(e2, { children: [
          "For You ",
          /* @__PURE__ */ r.jsx(t2, {})
        ] })
      ] }),
      /* @__PURE__ */ r.jsx(ZF, {})
    ] }) }),
    /* @__PURE__ */ r.jsx(HF, { medias: u, videoCoverPreview: s, postType: a, isMultipleLinesDetected: D, titleCaptionHeight: d }),
    /* @__PURE__ */ r.jsx(c2, { profilePicture: e }),
    /* @__PURE__ */ r.jsx(l2, { username: t, title: i, description: n, onMultipleLinesDetected: o, onHeightDetected: x, isTakingUpSpace: D && o2(a) })
  ] });
}, o2 = (u) => u === "multiMedia" || u?.toLowerCase() === "image";
function D2(u, e = 50) {
  return u && u.clientHeight > e;
}
const l2 = ({
  username: u,
  title: e,
  description: t,
  onMultipleLinesDetected: n,
  onHeightDetected: s,
  isTakingUpSpace: i
}) => {
  const a = uu.useRef(null), [D, o] = uu.useState(!1);
  return n = n || (() => {
  }), s = s || (() => {
  }), ki(() => {
    if (a.current) {
      s(a.current.clientHeight);
      const d = a.current.querySelector(".title-caption");
      if (D2(d)) {
        n(!0);
        return;
      }
      n(!1);
    }
  }, [e, t, u]), /* @__PURE__ */ r.jsxs(s2, { ref: a, $isTakingUpSpace: i, children: [
    /* @__PURE__ */ r.jsxs(vr, { className: "sp-font-bold sp-mb-2", children: [
      "@",
      u
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: "title-caption", children: [
      e && /* @__PURE__ */ r.jsx(vr, { className: "title sp-font-bold sp-mb-1 sp-mt-4 sp-text-2xl", children: e }),
      /* @__PURE__ */ r.jsx("div", { className: D ? "sp-max-h-[200px] sp-overflow-y-auto sp-leading-5" : "description", children: /* @__PURE__ */ r.jsx(vr, { children: /* @__PURE__ */ r.jsx(vu, { caption: t, targetPlatform: "TT" }) }) }),
      t && /* @__PURE__ */ r.jsx("button", { onClick: (d) => {
        d.preventDefault(), d.stopPropagation(), o(!D);
      }, className: "sp-text-white/60 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0", children: D ? "less" : "more" })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center sp-gap-1.5 sp-mt-3.5 sp-text-white/70 sp-text-[11px]", children: [
      /* @__PURE__ */ r.jsx(GF, { className: "musicIcon" }),
      /* @__PURE__ */ r.jsx("span", { className: "sp-truncate", children: "Audio will be auto-matched after publishing" })
    ] })
  ] });
}, c2 = ({
  profilePicture: u
}) => /* @__PURE__ */ r.jsxs(r2, { children: [
  /* @__PURE__ */ r.jsx(n2, { $profilePicture: u, children: /* @__PURE__ */ r.jsx(KF, { className: "sp-w-8" }) }),
  /* @__PURE__ */ r.jsx(VF, {}),
  /* @__PURE__ */ r.jsx(WF, {}),
  /* @__PURE__ */ r.jsx(qF, {})
] }), Fi = ({
  post: u,
  env: e,
  videoCoverPreview: t
}) => /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsx(JF, { $env: e, children: /* @__PURE__ */ r.jsx(i2, { ContentItem: /* @__PURE__ */ r.jsx(a2, { medias: u.medias, username: u.username, profilePicture: u.profilePicture, description: u.caption, videoCoverPreview: t, title: u.postOptions?.title, postType: u.type }), url: u.redirectUrl }) }) }), F2 = Fi, d2 = ({
  post: u,
  env: e,
  videoCoverPreview: t
}) => {
  switch (u.type) {
    case "image":
    case "multiMedia":
      return /* @__PURE__ */ r.jsx(F2, { post: u, env: e, videoCoverPreview: t });
    case "video":
    case "text":
    case "story":
      return /* @__PURE__ */ r.jsx(Fi, { post: u, env: e, videoCoverPreview: t });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, di = _.div`
  font-family: Helvetica;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: 0.015em;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          letter-spacing: -0.025em;
          white-space: pre-line;
        `;
  }
}};
`, p2 = ({
  username: u,
  profilePicture: e,
  small: t
}) => /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-items-center", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden sp-m-4", style: {
    width: "49px",
    height: "49px"
  }, children: /* @__PURE__ */ r.jsx($u, { src: e, alt: u }) }),
  /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-grow sp-leading-tight ${t ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsx("div", { className: "sp-font-sans", children: /* @__PURE__ */ r.jsx(di, { $variant: "heading", className: "sp-mb-1", children: u }) }) })
] }), E2 = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, C2 = _.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, f2 = ({
  src: u,
  forCarousel: e,
  showOverlay: t,
  showAll: n,
  setShowAll: s,
  mediaCount: i
}) => e ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx(Mu, { href: u, $isFlex: !0, children: /* @__PURE__ */ r.jsx(C2, { src: u, className: "" }) }),
  !n && t && /* @__PURE__ */ r.jsxs("div", { className: "sp-cursor-pointer", onClick: () => s(!0), children: [
    /* @__PURE__ */ r.jsx("div", { className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ", children: " " }),
    /* @__PURE__ */ r.jsxs("div", { className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl", children: [
      "+",
      i - 4
    ] })
  ] })
] }) : /* @__PURE__ */ r.jsx(Mu, { href: u, children: /* @__PURE__ */ r.jsx(E2, { src: u }) }), A2 = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-bg-black sp-flex sp-items-center", children: /* @__PURE__ */ r.jsx(ku, { url: u, controls: !0, playing: !1, className: "sp-relative", width: "100%", height: "auto" }) }) : null, pi = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showOverlay: n,
  showAll: s,
  setShowAll: i,
  mediaCount: a,
  isActiveSlide: D = !0
}) => e && s === !1 ? null : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  (u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(A2, { url: u.url, forCarousel: t, isActiveSlide: D }),
  !(u.isVideo || u.url.includes(".mp4")) && /* @__PURE__ */ r.jsx(f2, { src: u.url, forCarousel: t, showOverlay: n, showAll: s, setShowAll: i, mediaCount: a })
] }), h2 = () => /* @__PURE__ */ r.jsx("div", { className: "sp-py-2 sp-w-full", children: /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-w-full sp-justify-start sp-text-black sp-py-4 sp-pl-0", children: [
  /* @__PURE__ */ r.jsx(st, { icon: "icon-instagram-heart" }),
  /* @__PURE__ */ r.jsx(st, { icon: "icon-instagram-comment" }),
  /* @__PURE__ */ r.jsx(st, { icon: "icon-twitter-retweet" }),
  /* @__PURE__ */ r.jsx(st, { icon: "icon-instagram-share" })
] }) }), st = ({
  icon: u
}) => /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-start sp-pr-4 ", children: /* @__PURE__ */ r.jsx("div", { className: `sp-text-xl ${u}` }) }), m2 = _.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, g2 = ({
  medias: u
}) => {
  const [e, t] = Au(!1);
  return /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-wrap sp-w-full", children: u.map((n, s) => !e && s > 3 ? null : /* @__PURE__ */ r.jsx(m2, { className: "sp-relative", children: /* @__PURE__ */ r.jsx(pi, { media: n, forCarousel: !0, hidden: s > 3, mediaCount: u.length, showOverlay: s === 3 && u.length > 4, showAll: e, setShowAll: t }) }, `fb-media-key-${s}`)) });
}, B2 = ({
  medias: u
}) => {
  const e = u.collection, t = e.length, n = t > 1;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-px-4", children: [
    t > 0 && /* @__PURE__ */ r.jsx(r.Fragment, { children: n ? /* @__PURE__ */ r.jsx(g2, { medias: e, count: t }) : /* @__PURE__ */ r.jsx(pi, { media: e[0] }) }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-items-center sp-justify-between", children: /* @__PURE__ */ r.jsx(h2, {}) })
  ] });
}, x2 = ({
  post: u
}) => {
  let e = u.caption;
  return /* @__PURE__ */ r.jsxs("div", { className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0", children: [
    /* @__PURE__ */ r.jsx(p2, { username: u.username, profilePicture: u.profilePicture, locationName: u.locationName }),
    /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-flex-col sp-m-4", children: /* @__PURE__ */ r.jsxs(di, { $variant: "caption", className: "sp-whitespace-pre-line sp-break-words", children: [
      /* @__PURE__ */ r.jsx(vu, { caption: e, targetPlatform: "TH" }),
      u.redirectUrl && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        " ",
        /* @__PURE__ */ r.jsx("a", { className: "sp-text-blue-400 sp-break-words", href: u.redirectUrl, target: "_blank", children: u.redirectUrl })
      ] })
    ] }) }),
    u.type === "text" && u.redirectUrl && /* @__PURE__ */ r.jsx("div", { className: "sp-p-4", children: /* @__PURE__ */ r.jsx(_t, { url: u.redirectUrl }) }),
    /* @__PURE__ */ r.jsx(B2, { medias: u.medias })
  ] });
}, y2 = ({
  post: u
}) => {
  switch (u.type) {
    case "image":
    case "video":
    case "multiMedia":
    case "text":
      return /* @__PURE__ */ r.jsx(x2, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
}, _0 = _.div`
  font-family: "Helvetica", sans-serif;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 2.5rem;
          line-height: 3rem;
          text-decoration: none !important;
          color: inherit !important;
        `;
    case "subheading":
      return `
          font-style: normal;
          font-weight: bold;
          font-size: 1.5rem;
          line-height: 16px;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 1.3rem;
          line-height: 1.8rem;
          white-space: pre-line;
        `;
    case "link":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 1.3rem;
          line-height: 1.8rem;
          white-space: pre-line;
          font-weight: bold;
          color: black;
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, v2 = _.span`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;

  ${({
  $variant: u
}) => {
  switch (u) {
    case "heading":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 20px;
        `;
    case "bold":
      return `
          font-style: normal;
          font-weight: bold;
        `;
    case "caption":
      return `
          font-style: normal;
          font-weight: normal;
          font-size: 1.8rem;
          line-height: 2rem;
          letter-spacing: 0.005em;
          white-space: pre-line;
        `;
    case "icons":
      return `
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: bold;
          font-size: 15px;
          line-height: 18px;
          letter-spacing: 0.01em;
        `;
  }
}};
`, b2 = ({
  username: u,
  profilePicture: e,
  small: t,
  description: n,
  url: s
}) => /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsxs("div", { className: "sp-pt-4 sp-pb-2 sp-px-0 sp-flex sp-flex-row", children: [
  /* @__PURE__ */ r.jsx("div", { className: "sp-flex sp-px-1", children: /* @__PURE__ */ r.jsx("div", { className: "sp-rounded-full sp-overflow-hidden  sp-mr-4", style: {
    width: "40px",
    height: "40px",
    minWidth: "40px",
    minHeight: "40px"
  }, children: /* @__PURE__ */ r.jsx($u, { src: e, alt: u }) }) }),
  /* @__PURE__ */ r.jsxs("div", { children: [
    /* @__PURE__ */ r.jsx("div", { className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${t ? "sp-text-white" : ""}`, children: /* @__PURE__ */ r.jsx("div", { className: "", children: /* @__PURE__ */ r.jsxs(v2, { $variant: "bold", className: "sp-mb-1", children: [
      u,
      " "
    ] }) }) }),
    n && /* @__PURE__ */ r.jsx(_0, { $variant: "caption", children: /* @__PURE__ */ r.jsx(vu, { caption: n }) }),
    s && /* @__PURE__ */ r.jsxs("div", { className: "sp-py-2", children: [
      " ",
      /* @__PURE__ */ r.jsx("a", { href: s, target: "_blank", rel: "noreferrer", children: /* @__PURE__ */ r.jsx(_0, { $variant: "link", children: "URL for post" }) })
    ] })
  ] })
] }) }), w2 = _.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, j2 = ({
  src: u
}) => /* @__PURE__ */ r.jsx(w2, { src: u }), _2 = ({
  url: u,
  isActiveSlide: e
}) => e ? /* @__PURE__ */ r.jsx("div", { className: "sp-relative", style: {}, children: /* @__PURE__ */ r.jsx(ku, { url: u, controls: !0, playing: !1, width: "100%", height: "auto", className: "" }) }) : null, S2 = ({
  media: u,
  hidden: e = !1,
  forCarousel: t = !1,
  showAll: n,
  isActiveSlide: s = !0
}) => e && n === !1 ? null : u.isVideo || u.url.includes(".mp4") ? /* @__PURE__ */ r.jsx(_2, { url: u.url, forCarousel: t, isActiveSlide: s }) : /* @__PURE__ */ r.jsx(j2, { src: u.url }), P2 = ({
  medias: u
}) => {
  const e = u.collection, t = e.length;
  return /* @__PURE__ */ r.jsx(T2, { children: t > 0 && /* @__PURE__ */ r.jsx(S2, { media: e[0] }) });
}, T2 = _.div`
  overflow: hidden;
`, k2 = ({
  url: u,
  children: e
}) => u ? /* @__PURE__ */ r.jsx("a", { href: u, target: "_blank", style: {
  color: "inherit",
  textDecoration: "none"
}, rel: "noreferrer", children: e }) : /* @__PURE__ */ r.jsx("div", { children: e }), N2 = ({
  post: u
}) => /* @__PURE__ */ r.jsxs(O2, { className: "sp-bg-white md:sp-shadow-around sp-pb-6", style: {
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px"
}, children: [
  /* @__PURE__ */ r.jsx(b2, { username: u.username, profilePicture: u.profilePicture, description: u.caption, small: !1, url: u.redirectUrl }),
  /* @__PURE__ */ r.jsx("div", { className: "sp-pb-2", style: {
    paddingLeft: "47px"
  }, children: /* @__PURE__ */ r.jsx(k2, { url: u.redirectUrl, children: /* @__PURE__ */ r.jsx(P2, { medias: u.medias }) }) })
] }), O2 = _.div`
  padding: 1.1em;
`, $2 = ({
  post: u
}) => {
  switch (u.type) {
    case "video":
    case "image":
    case "multiMedia":
    case "text":
    case "story":
      return /* @__PURE__ */ r.jsx(N2, { post: u });
    default:
      return /* @__PURE__ */ r.jsx(r.Fragment, {});
  }
};
class R2 extends Ni {
  constructor(e) {
    super(e), this.state = {
      hasError: !1
    }, this.post = e.post;
  }
  // @ts-expect-error not sure why this is here but it's not used
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(e) {
    return {
      hasError: !0
    };
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidCatch(e, t) {
    console.log(e);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ r.jsxs("div", { className: "sp-flex sp-flex-col sp-items-center sp-justify-center sp-w-full sp-border-2 sp-border-solid sp-border-gray-300 sp-rounded-lg sp-p-8 sp-h-500px sp-shadow-lg", children: [
      /* @__PURE__ */ r.jsx("div", { className: "sp-text-4xl sp-mb-8 sp-text-red-500 sp-font-bold", children: "Failed to load preview" }),
      /* @__PURE__ */ r.jsx("div", { className: "sp-text-3xl sp-text-red-500", children: "Please contact Sked support" })
    ] }) : this.props.children;
  }
}
const I2 = (u) => {
  if (u === null)
    return null;
  if (u.type !== "fb-reel")
    return u;
  switch (u.platform) {
    case "FB":
      return u;
    case "IG":
      return {
        ...u,
        type: "reel"
      };
    default:
      return {
        ...u,
        type: "video"
      };
  }
}, Y2 = ({
  post: u,
  trackEvent: e,
  className: t,
  env: n,
  videoCoverPreview: s,
  preferVideoCoverPreviewOverride: i
}) => {
  const a = I2(u);
  return /* @__PURE__ */ r.jsx(M2, { children: /* @__PURE__ */ r.jsx(R2, { post: u || {}, children: /* @__PURE__ */ r.jsx(en.Provider, { value: {
    post: u,
    className: t,
    env: n,
    videoCoverPreview: s,
    preferVideoCoverPreviewOverride: i
  }, children: /* @__PURE__ */ r.jsx(L2, { post: a, trackEvent: e, className: t, videoCoverPreview: s, env: n, preferVideoCoverPreviewOverride: i }, u?.id) }) }) });
}, L2 = ({
  post: u,
  trackEvent: e,
  className: t,
  env: n,
  videoCoverPreview: s
}) => {
  if (u === null)
    throw new Error("PreviewBuilder: null post, unknown platform");
  const i = u.platform;
  switch (i) {
    case "IG":
      return /* @__PURE__ */ r.jsx(R1, { post: u, className: t, env: n });
    case "FB":
      return /* @__PURE__ */ r.jsx(J1, { post: u });
    case "TW":
      return /* @__PURE__ */ r.jsx(oc, { post: u });
    case "LI":
      return /* @__PURE__ */ r.jsx(kc, { post: u, trackEvent: e });
    case "GMB":
      return /* @__PURE__ */ r.jsx(Zc, { post: u });
    case "YT":
      return /* @__PURE__ */ r.jsx(tF, { post: u });
    case "PI":
      return /* @__PURE__ */ r.jsx(pF, { post: u });
    case "SC":
      return /* @__PURE__ */ r.jsx(OF, { post: u });
    case "TT":
      return /* @__PURE__ */ r.jsx(d2, { post: u, env: n, videoCoverPreview: s });
    case "TH":
      return /* @__PURE__ */ r.jsx(y2, { post: u });
    case "OT":
      return /* @__PURE__ */ r.jsx($2, { post: u });
    default:
      throw new Error(`PreviewBuilder: unknown platform ${i}`);
  }
}, M2 = _.div`
  font-family:
    "Gotham SSm A", "Gotham SSm B", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`, S0 = /^https?:\/\/sked-customer-uploads\.s3(\.[a-z0-9-]+)?\.amazonaws\.com\/(.+)$/, P0 = "https://s3.amazonaws.com/sked-customer-uploads", T0 = "https://customer-uploads.skedsocial.com";
function mt(u) {
  return !u || typeof u != "string" ? u : S0.test(u) ? u.replace(S0, T0 + "/$2") : u.startsWith(P0) ? u.replace(P0, T0) : u;
}
class Ei {
  constructor(e) {
    this.medias = [e], e.mediaFiles && e.mediaFiles.length > 0 && (this.medias = e.mediaFiles.map((t, n) => n !== 0 || !e.thumbnailUrl || !z2(t) || !U2(e) ? t : {
      ...t,
      thumbnailUrl: e.thumbnailUrl
    })), this.collection = this.buildCollection(this.medias), this.count = this.collection.length;
  }
  buildCollection(e) {
    let t = e.map((n) => {
      if (n.url) {
        const i = (n.url.toLowerCase().endsWith(".heic") || n.url.toLowerCase().endsWith(".heif")) && n.thumbnailUrl ? n.thumbnailUrl : n.url;
        return {
          thumbnailUrl: mt(n.thumbnailUrl),
          fileName: n.fileName,
          pages: n.meta?.pages,
          width: n.meta?.width,
          height: n.meta?.height,
          url: mt(i),
          type: n.type,
          isVideo: n.isVideo
        };
      }
    });
    return t[0] ? t : [];
  }
}
function z2(u) {
  return u?.isVideo === !0;
}
function U2(u) {
  return u?.platform === "LI" || u?.platformType === "LI" || u?.platforms?.[0]?.platformType === "LI";
}
class Z2 {
  constructor(e, t, n, s) {
    this.providedPost = e, this.id = e.post_id, this.stage = e.post_stage, this.caption = e.caption, this.currentStatusKey = e.post_status_key, this.rejectionReason = "", this.scheduledFor = e.when, this.image_url = mt(e.url), this.comment = e.firstcomment || e.first_comment, this.locationName = e.location && e.location.name, this.redirectUrl = e.redirectUrl ? e.redirectUrl : "", this.storyUrl = e.storyUrl ? e.storyUrl : "", this.storyLabel = e.storyLabel ? e.storyLabel : "", this.storyStickerHeight = e.storyStickerHeight ? e.storyStickerHeight : null, this.medias = new Ei(e), this.callToAction = e.gmbCallToAction ? e.gmbCallToAction : "", this.event = e.gmbEvent ? e.gmbEvent : "", this.topicType = e.gmbTopicType ? e.gmbTopicType : null, this.offer = e.gmbOffer ? e.gmbOffer : null, e.gmbOffer && (this.offer.redeemOnlineUrl = e.gmbOffer.redeemOnlineUrl || e.redirectUrl), this.platform = e.platform, this.type = e.type, this.storyType = e.storyType || null, this.ytTitle = e.ytTitle || null, this.ytCategoryId = e.ytCategoryId || null, this.ytTags = e.ytTags || "", t && t.username ? (this.username = t.username, this.profilePicture = t.profile_picture_url) : e.username || e.profilePicture ? (this.username = e.username, this.profilePicture = e.profilePicture) : (this.username = "Failed to find account", this.profilePicture = "https://picsum.photos/id/1/200/200"), this.approvedKey = n, this.rejectedKey = s;
    let i = null, a = null;
    if (e.piBoards && e.piBoards.length > 0 && t.boards && t.boards.length > 0) {
      let D = t.boards.find((o) => o.id === e.piBoards[0]);
      if (D && (i = D.name, D.sections && D.sections.length > 0 && e.piSectionId)) {
        let o = D.sections.find((d) => d.id === e.piSectionId);
        o && (a = o.title);
      }
    }
    this.boardTitle = i || null, this.boardSectionTitle = a || null, this.piTitle = e.piTitle || null, this.postOptions = e.postOptions || null;
  }
  get status() {
    switch (this.currentStatusKey) {
      case this.approvedKey:
        return "approved";
      case this.rejectedKey:
        return "rejected";
      default:
        return "initial";
    }
  }
  approve() {
    this.currentStatusKey = this.approvedKey;
  }
  reject(e) {
    this.currentStatusKey = this.rejectedKey, this.rejectionReason = e;
  }
}
class K2 {
  constructor(e, t) {
    const n = e.schedule ? e.schedule : e;
    this.providedPost = n, this.id = n._id, this.stage = "draft", n.scheduledFor ? this.stage = "scheduled" : n.queued && (this.stage = "queued"), this.caption = n.caption || "", this.currentStatusKey = n.normalizedPost_status_key, this.rejectionReason = "", this.scheduledFor = n.when, this.image_url = mt(n.url), this.comment = n.firstcomment || "", this.locationName = n.location && n.location.name, this.redirectUrl = n.redirectUrl ? n.redirectUrl : "", this.storyUrl = n.storyUrl ? n.storyUrl : "", this.storyLabel = n.storyLabel ? n.storyLabel : "", this.storyStickerHeight = n.storyStickerHeight ? n.storyStickerHeight : null, this.callToAction = n.gmbCallToAction ? n.gmbCallToAction : "", this.event = n.gmbEvent ? n.gmbEvent : "", this.topicType = n.gmbTopicType ? n.gmbTopicType : null, this.offer = n.gmbOffer ? n.gmbOffer : null, n.gmbOffer && (this.offer.redeemOnlineUrl = n.gmbOffer.redeemOnlineUrl || n.redirectUrl), this.medias = new Ei(n), this.platform = n.platformType || "IG", n.platforms && n.platforms.length > 0 && (this.platform = n.platforms[0].platformType), this.type = n.type, this.storyType = n.storyType || null, this.username = t.login, this.profilePicture = t.profilePictureUrl || "", this.ytTitle = n.ytTitle || null, this.ytCategoryId = n.ytCategoryId || null, this.ytTags = n.ytTags || "";
    let s = "", i = null;
    if (n.piBoards && n.piBoards.length > 0 && t.boards && t.boards.length > 0) {
      let a = t.boards.find((D) => D.id === n.piBoards[0]);
      if (a && (s = a.name, a.sections && a.sections.length > 0 && n.piSectionId)) {
        let D = a.sections.find((o) => o.id === n.piSectionId);
        D && (i = D.title);
      }
    }
    this.boardTitle = s || null, this.boardSectionTitle = i || null, this.piTitle = n.piTitle || null, this.postOptions = n.postOptions || null;
  }
}
export {
  Z2 as P,
  vu as R,
  G2 as S,
  XD as a,
  K2 as b,
  Y2 as c,
  ne as g,
  jt as r
};
//# sourceMappingURL=sked-preview-CfTNgW5G.js.map
